(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.app = factory());
})(this, (function () { 'use strict';

    function noop() { }
    function assign(tar, src) {
        // @ts-ignore
        for (const k in src)
            tar[k] = src[k];
        return tar;
    }
    function add_location(element, file, line, column, char) {
        element.__svelte_meta = {
            loc: { file, line, column, char }
        };
    }
    function run(fn) {
        return fn();
    }
    function blank_object() {
        return Object.create(null);
    }
    function run_all(fns) {
        fns.forEach(run);
    }
    function is_function(thing) {
        return typeof thing === 'function';
    }
    function safe_not_equal(a, b) {
        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
    }
    let src_url_equal_anchor;
    function src_url_equal(element_src, url) {
        if (!src_url_equal_anchor) {
            src_url_equal_anchor = document.createElement('a');
        }
        src_url_equal_anchor.href = url;
        return element_src === src_url_equal_anchor.href;
    }
    function is_empty(obj) {
        return Object.keys(obj).length === 0;
    }
    function append(target, node) {
        target.appendChild(node);
    }
    function insert(target, node, anchor) {
        target.insertBefore(node, anchor || null);
    }
    function detach(node) {
        node.parentNode.removeChild(node);
    }
    function destroy_each(iterations, detaching) {
        for (let i = 0; i < iterations.length; i += 1) {
            if (iterations[i])
                iterations[i].d(detaching);
        }
    }
    function element(name) {
        return document.createElement(name);
    }
    function svg_element(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    function text(data) {
        return document.createTextNode(data);
    }
    function space() {
        return text(' ');
    }
    function empty() {
        return text('');
    }
    function listen(node, event, handler, options) {
        node.addEventListener(event, handler, options);
        return () => node.removeEventListener(event, handler, options);
    }
    function attr(node, attribute, value) {
        if (value == null)
            node.removeAttribute(attribute);
        else if (node.getAttribute(attribute) !== value)
            node.setAttribute(attribute, value);
    }
    function set_attributes(node, attributes) {
        // @ts-ignore
        const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
        for (const key in attributes) {
            if (attributes[key] == null) {
                node.removeAttribute(key);
            }
            else if (key === 'style') {
                node.style.cssText = attributes[key];
            }
            else if (key === '__value') {
                node.value = node[key] = attributes[key];
            }
            else if (descriptors[key] && descriptors[key].set) {
                node[key] = attributes[key];
            }
            else {
                attr(node, key, attributes[key]);
            }
        }
    }
    function set_svg_attributes(node, attributes) {
        for (const key in attributes) {
            attr(node, key, attributes[key]);
        }
    }
    function children(element) {
        return Array.from(element.childNodes);
    }
    function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
        const e = document.createEvent('CustomEvent');
        e.initCustomEvent(type, bubbles, cancelable, detail);
        return e;
    }
    function attribute_to_object(attributes) {
        const result = {};
        for (const attribute of attributes) {
            result[attribute.name] = attribute.value;
        }
        return result;
    }

    let current_component;
    function set_current_component(component) {
        current_component = component;
    }
    function get_current_component() {
        if (!current_component)
            throw new Error('Function called outside component initialization');
        return current_component;
    }
    function onMount(fn) {
        get_current_component().$$.on_mount.push(fn);
    }

    const dirty_components = [];
    const binding_callbacks = [];
    const render_callbacks = [];
    const flush_callbacks = [];
    const resolved_promise = Promise.resolve();
    let update_scheduled = false;
    function schedule_update() {
        if (!update_scheduled) {
            update_scheduled = true;
            resolved_promise.then(flush);
        }
    }
    function add_render_callback(fn) {
        render_callbacks.push(fn);
    }
    // flush() calls callbacks in this order:
    // 1. All beforeUpdate callbacks, in order: parents before children
    // 2. All bind:this callbacks, in reverse order: children before parents.
    // 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
    //    for afterUpdates called during the initial onMount, which are called in
    //    reverse order: children before parents.
    // Since callbacks might update component values, which could trigger another
    // call to flush(), the following steps guard against this:
    // 1. During beforeUpdate, any updated components will be added to the
    //    dirty_components array and will cause a reentrant call to flush(). Because
    //    the flush index is kept outside the function, the reentrant call will pick
    //    up where the earlier call left off and go through all dirty components. The
    //    current_component value is saved and restored so that the reentrant call will
    //    not interfere with the "parent" flush() call.
    // 2. bind:this callbacks cannot trigger new flush() calls.
    // 3. During afterUpdate, any updated components will NOT have their afterUpdate
    //    callback called a second time; the seen_callbacks set, outside the flush()
    //    function, guarantees this behavior.
    const seen_callbacks = new Set();
    let flushidx = 0; // Do *not* move this inside the flush() function
    function flush() {
        const saved_component = current_component;
        do {
            // first, call beforeUpdate functions
            // and update components
            while (flushidx < dirty_components.length) {
                const component = dirty_components[flushidx];
                flushidx++;
                set_current_component(component);
                update(component.$$);
            }
            set_current_component(null);
            dirty_components.length = 0;
            flushidx = 0;
            while (binding_callbacks.length)
                binding_callbacks.pop()();
            // then, once components are updated, call
            // afterUpdate functions. This may cause
            // subsequent updates...
            for (let i = 0; i < render_callbacks.length; i += 1) {
                const callback = render_callbacks[i];
                if (!seen_callbacks.has(callback)) {
                    // ...so guard against infinite loops
                    seen_callbacks.add(callback);
                    callback();
                }
            }
            render_callbacks.length = 0;
        } while (dirty_components.length);
        while (flush_callbacks.length) {
            flush_callbacks.pop()();
        }
        update_scheduled = false;
        seen_callbacks.clear();
        set_current_component(saved_component);
    }
    function update($$) {
        if ($$.fragment !== null) {
            $$.update();
            run_all($$.before_update);
            const dirty = $$.dirty;
            $$.dirty = [-1];
            $$.fragment && $$.fragment.p($$.ctx, dirty);
            $$.after_update.forEach(add_render_callback);
        }
    }
    const outroing = new Set();
    function transition_in(block, local) {
        if (block && block.i) {
            outroing.delete(block);
            block.i(local);
        }
    }

    const globals = (typeof window !== 'undefined'
        ? window
        : typeof globalThis !== 'undefined'
            ? globalThis
            : global);

    function get_spread_update(levels, updates) {
        const update = {};
        const to_null_out = {};
        const accounted_for = { $$scope: 1 };
        let i = levels.length;
        while (i--) {
            const o = levels[i];
            const n = updates[i];
            if (n) {
                for (const key in o) {
                    if (!(key in n))
                        to_null_out[key] = 1;
                }
                for (const key in n) {
                    if (!accounted_for[key]) {
                        update[key] = n[key];
                        accounted_for[key] = 1;
                    }
                }
                levels[i] = n;
            }
            else {
                for (const key in o) {
                    accounted_for[key] = 1;
                }
            }
        }
        for (const key in to_null_out) {
            if (!(key in update))
                update[key] = undefined;
        }
        return update;
    }
    function mount_component(component, target, anchor, customElement) {
        const { fragment, on_mount, on_destroy, after_update } = component.$$;
        fragment && fragment.m(target, anchor);
        if (!customElement) {
            // onMount happens before the initial afterUpdate
            add_render_callback(() => {
                const new_on_destroy = on_mount.map(run).filter(is_function);
                if (on_destroy) {
                    on_destroy.push(...new_on_destroy);
                }
                else {
                    // Edge case - component was destroyed immediately,
                    // most likely as a result of a binding initialising
                    run_all(new_on_destroy);
                }
                component.$$.on_mount = [];
            });
        }
        after_update.forEach(add_render_callback);
    }
    function destroy_component(component, detaching) {
        const $$ = component.$$;
        if ($$.fragment !== null) {
            run_all($$.on_destroy);
            $$.fragment && $$.fragment.d(detaching);
            // TODO null out other refs, including component.$$ (but need to
            // preserve final state?)
            $$.on_destroy = $$.fragment = null;
            $$.ctx = [];
        }
    }
    function make_dirty(component, i) {
        if (component.$$.dirty[0] === -1) {
            dirty_components.push(component);
            schedule_update();
            component.$$.dirty.fill(0);
        }
        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
    }
    function init(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [-1]) {
        const parent_component = current_component;
        set_current_component(component);
        const $$ = component.$$ = {
            fragment: null,
            ctx: null,
            // state
            props,
            update: noop,
            not_equal,
            bound: blank_object(),
            // lifecycle
            on_mount: [],
            on_destroy: [],
            on_disconnect: [],
            before_update: [],
            after_update: [],
            context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
            // everything else
            callbacks: blank_object(),
            dirty,
            skip_bound: false,
            root: options.target || parent_component.$$.root
        };
        append_styles && append_styles($$.root);
        let ready = false;
        $$.ctx = instance
            ? instance(component, options.props || {}, (i, ret, ...rest) => {
                const value = rest.length ? rest[0] : ret;
                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                    if (!$$.skip_bound && $$.bound[i])
                        $$.bound[i](value);
                    if (ready)
                        make_dirty(component, i);
                }
                return ret;
            })
            : [];
        $$.update();
        ready = true;
        run_all($$.before_update);
        // `false` as a special case of no DOM component
        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
        if (options.target) {
            if (options.hydrate) {
                const nodes = children(options.target);
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.l(nodes);
                nodes.forEach(detach);
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.c();
            }
            if (options.intro)
                transition_in(component.$$.fragment);
            mount_component(component, options.target, options.anchor, options.customElement);
            flush();
        }
        set_current_component(parent_component);
    }
    let SvelteElement;
    if (typeof HTMLElement === 'function') {
        SvelteElement = class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({ mode: 'open' });
            }
            connectedCallback() {
                const { on_mount } = this.$$;
                this.$$.on_disconnect = on_mount.map(run).filter(is_function);
                // @ts-ignore todo: improve typings
                for (const key in this.$$.slotted) {
                    // @ts-ignore todo: improve typings
                    this.appendChild(this.$$.slotted[key]);
                }
            }
            attributeChangedCallback(attr, _oldValue, newValue) {
                this[attr] = newValue;
            }
            disconnectedCallback() {
                run_all(this.$$.on_disconnect);
            }
            $destroy() {
                destroy_component(this, 1);
                this.$destroy = noop;
            }
            $on(type, callback) {
                // TODO should this delegate to addEventListener?
                const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
                callbacks.push(callback);
                return () => {
                    const index = callbacks.indexOf(callback);
                    if (index !== -1)
                        callbacks.splice(index, 1);
                };
            }
            $set($$props) {
                if (this.$$set && !is_empty($$props)) {
                    this.$$.skip_bound = true;
                    this.$$set($$props);
                    this.$$.skip_bound = false;
                }
            }
        };
    }

    function dispatch_dev(type, detail) {
        document.dispatchEvent(custom_event(type, Object.assign({ version: '3.48.0' }, detail), { bubbles: true }));
    }
    function append_dev(target, node) {
        dispatch_dev('SvelteDOMInsert', { target, node });
        append(target, node);
    }
    function insert_dev(target, node, anchor) {
        dispatch_dev('SvelteDOMInsert', { target, node, anchor });
        insert(target, node, anchor);
    }
    function detach_dev(node) {
        dispatch_dev('SvelteDOMRemove', { node });
        detach(node);
    }
    function listen_dev(node, event, handler, options, has_prevent_default, has_stop_propagation) {
        const modifiers = options === true ? ['capture'] : options ? Array.from(Object.keys(options)) : [];
        if (has_prevent_default)
            modifiers.push('preventDefault');
        if (has_stop_propagation)
            modifiers.push('stopPropagation');
        dispatch_dev('SvelteDOMAddEventListener', { node, event, handler, modifiers });
        const dispose = listen(node, event, handler, options);
        return () => {
            dispatch_dev('SvelteDOMRemoveEventListener', { node, event, handler, modifiers });
            dispose();
        };
    }
    function attr_dev(node, attribute, value) {
        attr(node, attribute, value);
        if (value == null)
            dispatch_dev('SvelteDOMRemoveAttribute', { node, attribute });
        else
            dispatch_dev('SvelteDOMSetAttribute', { node, attribute, value });
    }
    function set_data_dev(text, data) {
        data = '' + data;
        if (text.wholeText === data)
            return;
        dispatch_dev('SvelteDOMSetData', { node: text, data });
        text.data = data;
    }
    function validate_each_argument(arg) {
        if (typeof arg !== 'string' && !(arg && typeof arg === 'object' && 'length' in arg)) {
            let msg = '{#each} only iterates over array-like objects.';
            if (typeof Symbol === 'function' && arg && Symbol.iterator in arg) {
                msg += ' You can use a spread to convert this iterable into an array.';
            }
            throw new Error(msg);
        }
    }
    function validate_slots(name, slot, keys) {
        for (const slot_key of Object.keys(slot)) {
            if (!~keys.indexOf(slot_key)) {
                console.warn(`<${name}> received an unexpected slot "${slot_key}".`);
            }
        }
    }

    var img$e = "data:image/svg+xml,%3csvg width='136' height='69' viewBox='0 0 136 69' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cellipse cx='68' cy='56' rx='68' ry='13' fill='url(%23paint0_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' d='M78.0091 51.4975C85.0458 45.3466 85.0458 35.3741 78.0091 29.2232C70.9725 23.0723 59.5638 23.0723 52.5271 29.2232C45.4905 35.3741 45.4905 45.3466 52.5271 51.4975C59.5638 57.6484 70.9725 57.6484 78.0091 51.4975Z' fill='url(%23paint1_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M61.1533 60.3968V42.7813L46.2261 35.5039L46.4996 51.8202L61.1533 60.3968Z' fill='url(%23paint2_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M61.1533 42.7814V60.3969L87.9805 55.3036L88.3543 38.4214L61.1533 42.7814Z' fill='url(%23paint3_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M49.3264 45.1001C48.9981 44.7096 48.5878 44.032 48.4419 43.3784C48.3598 43.0277 48.3598 42.7567 48.4327 42.5893C48.606 42.1589 49.1349 42.4299 49.3081 43.0755C49.4632 42.6053 49.992 42.8763 50.1835 43.506C50.2565 43.7451 50.2656 44.0241 50.1835 44.303C50.0468 44.8132 49.6455 45.0603 49.3355 45.1081L49.3264 45.1001ZM52.2808 46.6863C51.9617 46.2878 51.5513 45.6103 51.3963 44.9407C51.3142 44.59 51.3234 44.303 51.3872 44.1357C51.5605 43.6893 52.0893 43.9683 52.2626 44.6219C52.4176 44.1357 52.9465 44.4146 53.138 45.0523C53.2109 45.2914 53.2109 45.5863 53.138 45.8574C53.0012 46.3755 52.6 46.6305 52.2808 46.6783V46.6863ZM55.2353 48.2725C54.9161 47.874 54.5058 47.1885 54.3599 46.511C54.2778 46.1523 54.2869 45.8653 54.3599 45.6979C54.5331 45.2436 55.062 45.5226 55.2353 46.1842C55.3994 45.69 55.9283 45.9689 56.1107 46.6146C56.1836 46.8617 56.1836 47.1486 56.1107 47.4356C55.9739 47.9696 55.5635 48.2247 55.2535 48.2805L55.2353 48.2725ZM58.1897 49.8587C57.8706 49.4522 57.4602 48.7587 57.3143 48.0732C57.2414 47.7066 57.2414 47.4196 57.3143 47.2443C57.4876 46.782 58.0165 47.0609 58.1897 47.7305C58.3539 47.2363 58.8827 47.5073 59.0651 48.1609C59.129 48.408 59.1381 48.7029 59.0651 48.9899C58.9283 49.5239 58.518 49.7949 58.1988 49.8587H58.1897ZM47.9039 48.8942C47.5847 48.4957 47.1744 47.8182 47.0193 47.1566C46.9373 46.8139 46.9373 46.5428 47.0102 46.3755C47.1835 45.945 47.7033 46.24 47.8765 46.8776C48.0315 46.4153 48.5604 46.7023 48.7428 47.332C48.8157 47.5711 48.8248 47.8501 48.7428 48.1131C48.606 48.6153 48.2139 48.8464 47.8947 48.8863L47.9039 48.8942ZM50.8492 50.5522C50.53 50.1457 50.1197 49.4602 49.9647 48.7906C49.8826 48.4399 49.8826 48.1609 49.9556 47.9935C50.1288 47.5551 50.6577 47.8501 50.8218 48.5037C50.9769 48.0334 51.5057 48.3203 51.6881 48.958C51.7611 49.1971 51.7611 49.4841 51.6881 49.7551C51.5513 50.2652 51.1501 50.5043 50.8401 50.5522H50.8492ZM53.7945 52.2101C53.4754 51.8036 53.065 51.1101 52.9191 50.4326C52.8371 50.0739 52.8462 49.7949 52.91 49.6276C53.0833 49.1812 53.6122 49.4681 53.7854 50.1297C53.9404 49.6515 54.4693 49.9384 54.6517 50.584C54.7246 50.8311 54.7246 51.1181 54.6517 51.3971C54.5149 51.9152 54.1137 52.1702 53.7945 52.2101ZM56.7399 53.868C56.4207 53.4535 56.0104 52.7521 55.8645 52.0666C55.7915 51.7079 55.7915 51.421 55.8645 51.2536C56.0377 50.7993 56.5666 51.0862 56.7307 51.7558C56.8949 51.2616 57.4146 51.5485 57.597 52.2101C57.6608 52.4572 57.67 52.7521 57.597 53.0311C57.4602 53.5651 57.059 53.8122 56.7399 53.868ZM59.6852 55.526C59.366 55.1115 58.9648 54.4021 58.8189 53.7086C58.746 53.342 58.746 53.055 58.8189 52.8796C59.0013 52.4173 59.5211 52.7043 59.6852 53.3818C59.8493 52.8796 60.3782 53.1666 60.5515 53.8361C60.6153 54.0912 60.6244 54.3861 60.5515 54.6731C60.4056 55.2071 60.0043 55.4702 59.6852 55.526ZM47.7762 39.7437C47.4479 39.3611 47.0376 38.6996 46.8826 38.0539C46.8005 37.7112 46.8005 37.4402 46.8643 37.2728C47.0376 36.8424 47.5665 37.0974 47.7397 37.7351C47.8947 37.2568 48.4327 37.5199 48.6151 38.1416C48.6881 38.3807 48.6972 38.6597 48.6151 38.9307C48.4783 39.4408 48.0771 39.6879 47.758 39.7437H47.7762ZM50.7489 41.2582C50.4206 40.8756 50.0103 40.206 49.8553 39.5445C49.7732 39.2017 49.7823 38.9148 49.8461 38.7474C50.0194 38.301 50.5483 38.5641 50.7215 39.2097C50.8766 38.7235 51.4146 38.9865 51.5969 39.6162C51.6699 39.8553 51.679 40.1423 51.5969 40.4133C51.4601 40.9314 51.0589 41.1865 50.7398 41.2502L50.7489 41.2582ZM53.7216 42.7726C53.3933 42.39 52.983 41.7125 52.8371 41.043C52.755 40.6923 52.7641 40.4053 52.8279 40.2379C53.0012 39.7836 53.5392 40.0466 53.7125 40.7002C53.8766 40.206 54.4055 40.4771 54.5879 41.1067C54.6608 41.3538 54.6608 41.6408 54.5879 41.9198C54.4511 42.4458 54.0407 42.7089 53.7216 42.7726ZM56.6943 44.2871C56.3751 43.8965 55.9557 43.211 55.8098 42.5335C55.7277 42.1748 55.7368 41.8879 55.8098 41.7125C55.983 41.2502 56.521 41.5133 56.6851 42.1748C56.8493 41.6727 57.3782 41.9357 57.5605 42.5813C57.6335 42.8284 57.6335 43.1234 57.5605 43.4023C57.4146 43.9364 57.0134 44.2074 56.6943 44.2791V44.2871ZM59.667 45.8016C59.3478 45.403 58.9375 44.7175 58.7916 44.032C58.7186 43.6654 58.7186 43.3784 58.7916 43.1951C58.9739 42.7248 59.5028 42.9879 59.667 43.6574C59.8311 43.1473 60.36 43.4103 60.5423 44.0639C60.6153 44.311 60.6153 44.6139 60.5423 44.9009C60.3964 45.4429 59.9861 45.7298 59.667 45.7936V45.8016ZM46.3628 43.5378C46.682 43.49 47.0741 43.2509 47.2108 42.7567C47.2838 42.4857 47.2747 42.2067 47.2108 41.9756C47.0285 41.3618 46.4905 41.0828 46.3354 41.5451C46.3446 42.2067 46.3537 42.8763 46.3719 43.5458L46.3628 43.5378ZM47.3476 51.0942C47.1652 50.4645 46.6364 50.1616 46.4813 50.6239C46.4813 51.0304 46.4905 51.4369 46.4996 51.8355C46.7276 51.963 46.9555 52.0985 47.1744 52.234C47.2473 52.1384 47.3111 52.0188 47.3476 51.8753C47.4206 51.6123 47.4115 51.3333 47.3476 51.0942ZM60.287 49.6515C60.4329 50.3449 60.8341 51.0464 61.1624 51.4529V49.3007C60.9983 48.6232 60.4603 48.3442 60.287 48.8145C60.2232 48.9899 60.2141 49.2848 60.287 49.6594V49.6515ZM61.1624 59.0969C60.9983 58.4034 60.4694 58.1085 60.2961 58.5628C60.2323 58.7382 60.2232 59.0331 60.2961 59.4077C60.3326 59.607 60.3964 59.8143 60.4785 60.0056C60.7065 60.1411 60.9344 60.2686 61.1624 60.4041V59.0889V59.0969ZM50.293 53.5811C50.3659 53.3101 50.3568 53.0311 50.293 52.784C50.1106 52.1463 49.5817 51.8434 49.4267 52.3137C49.2534 51.6601 48.7337 51.3652 48.5604 51.7876C48.4966 51.955 48.4966 52.226 48.5695 52.5768C48.6151 52.7681 48.6789 52.9673 48.7519 53.1507C49.2078 53.4137 49.6638 53.6847 50.1106 53.9477C50.1835 53.8521 50.2474 53.7325 50.2838 53.5811H50.293ZM51.4875 53.4854C51.4237 53.6528 51.4237 53.9318 51.4966 54.2825C51.5422 54.4818 51.606 54.6731 51.679 54.8644C52.1349 55.1274 52.5817 55.3984 53.0377 55.6615C53.1106 55.5578 53.1745 55.4383 53.2109 55.2868C53.2839 55.0158 53.2748 54.7289 53.2109 54.4818C53.0286 53.8361 52.4997 53.5333 52.3447 54.0115C52.1714 53.3499 51.6516 53.047 51.4784 53.4854H51.4875ZM54.4237 55.1832C54.3599 55.3586 54.3599 55.6376 54.4237 55.9962C54.4693 56.1955 54.5331 56.3948 54.6061 56.5861C55.062 56.8491 55.518 57.1201 55.9648 57.3832C56.0377 57.2795 56.1016 57.152 56.138 57.0006C56.211 56.7216 56.2019 56.4346 56.138 56.1796C55.9557 55.526 55.4359 55.2231 55.2718 55.7093C55.1076 55.0397 54.5787 54.7368 54.4055 55.1832H54.4237ZM57.3599 56.881C57.2961 57.0564 57.287 57.3433 57.3599 57.71C57.4055 57.9092 57.4694 58.1085 57.5423 58.3078C57.9982 58.5708 58.4451 58.8418 58.901 59.1049C58.9739 59.0012 59.0378 58.8737 59.0834 58.7223C59.1563 58.4433 59.1563 58.1484 59.0834 57.8853C58.901 57.2317 58.3812 56.9209 58.2171 57.415C58.0529 56.7375 57.5241 56.4346 57.3508 56.889L57.3599 56.881Z' fill='url(%23paint4_radial_4318_875)'/%3e%3cpath opacity='0.75' fill-rule='evenodd' clip-rule='evenodd' d='M63.8704 46.0815C63.2776 45.946 62.539 45.5793 62.2746 45.0054C62.1378 44.7025 62.1469 44.3997 62.2746 44.1685C62.6029 43.5468 63.5786 43.3953 63.8795 43.9373C64.1804 43.2917 65.147 43.1403 65.4752 43.6504C65.6029 43.8417 65.6029 44.1366 65.4752 44.4873C65.2108 45.1489 64.4631 45.7547 63.8795 46.0895L63.8704 46.0815ZM69.296 45.1808C68.7124 45.0453 67.9646 44.6866 67.7093 44.1127C67.5725 43.8098 67.5817 43.5149 67.7093 43.2837C68.0376 42.67 69.0133 42.5106 69.3142 43.0526C69.6151 42.4149 70.5908 42.2555 70.91 42.7656C71.0285 42.9569 71.0376 43.2519 70.9009 43.5946C70.6364 44.2482 69.8796 44.862 69.296 45.1888V45.1808ZM74.7216 44.2721C74.138 44.1366 73.3994 43.7859 73.1349 43.22C72.9982 42.925 73.0073 42.6301 73.1349 42.399C73.4723 41.7932 74.4389 41.6338 74.7398 42.1599C75.0499 41.5302 76.0164 41.3707 76.3356 41.8729C76.4541 42.0642 76.4632 42.3511 76.3265 42.6939C76.0529 43.3475 75.3052 43.9453 74.7216 44.2721ZM80.1472 43.3714C79.5636 43.2439 78.825 42.8932 78.5697 42.3272C78.4329 42.0323 78.4511 41.7374 78.5697 41.5142C78.9071 40.9084 79.8736 40.749 80.1746 41.2751C80.4846 40.6454 81.4603 40.4939 81.7794 40.9881C81.898 41.1794 81.9071 41.4664 81.7612 41.8012C81.4876 42.4468 80.7399 43.0446 80.1472 43.3714ZM85.5637 42.4707C84.9801 42.3432 84.2506 41.9925 83.9953 41.4425C83.8585 41.1476 83.8767 40.8606 83.9953 40.6295C84.3327 40.0316 85.2992 39.8722 85.591 40.3983C85.9102 39.7766 86.8768 39.6251 87.1959 40.1114C87.3145 40.2947 87.3145 40.5816 87.1777 40.9164C86.9041 41.562 86.1473 42.1519 85.5546 42.4707H85.5637ZM66.5604 50.4973C65.9768 50.3618 65.2382 50.0111 64.9737 49.4372C64.8369 49.1343 64.8461 48.8394 64.9737 48.6003C65.302 47.9865 66.2686 47.8191 66.5695 48.3532C66.8795 47.7075 67.837 47.5481 68.1653 48.0503C68.2929 48.2416 68.2929 48.5365 68.1653 48.8872C67.9008 49.5488 67.1531 50.1626 66.5695 50.4973H66.5604ZM71.9586 49.5488C71.375 49.4213 70.6455 49.0706 70.3811 48.4967C70.2443 48.1938 70.2534 47.8988 70.3811 47.6677C70.7094 47.0539 71.6851 46.8865 71.9769 47.4206C72.2869 46.7829 73.2535 46.6235 73.5726 47.1177C73.6912 47.309 73.7003 47.5959 73.5635 47.9467C73.2991 48.6003 72.5513 49.2061 71.9586 49.5408V49.5488ZM77.366 48.6082C76.7824 48.4807 76.0529 48.13 75.7976 47.572C75.6608 47.2691 75.6699 46.9822 75.7976 46.751C76.135 46.1453 77.1016 45.9779 77.3934 46.5039C77.7034 45.8743 78.67 45.7069 78.9891 46.2011C79.1077 46.3844 79.1168 46.6793 78.9709 47.022C78.6973 47.6677 77.9496 48.2735 77.366 48.6082ZM82.7643 47.6597C82.1807 47.5322 81.4512 47.1894 81.205 46.6315C81.0682 46.3366 81.0864 46.0496 81.205 45.8185C81.5423 45.2127 82.5089 45.0533 82.8007 45.5714C83.1108 44.9417 84.0773 44.7822 84.3965 45.2685C84.515 45.4518 84.5242 45.7387 84.3783 46.0815C84.1047 46.7271 83.357 47.3249 82.7643 47.6517V47.6597ZM63.8521 55.8457C63.2685 55.7182 62.5299 55.3675 62.2746 54.7936C62.1378 54.4907 62.1469 54.1958 62.2746 53.9567C62.6029 53.3349 63.5603 53.1596 63.8612 53.7016C64.1622 53.056 65.1196 52.8886 65.4479 53.3907C65.5755 53.582 65.5755 53.877 65.4479 54.2277C65.1834 54.8972 64.4448 55.511 63.8612 55.8537L63.8521 55.8457ZM69.2321 54.8574C68.6485 54.7298 67.9099 54.3791 67.6546 53.8132C67.5178 53.5103 67.5269 53.2154 67.6546 52.9842C67.9829 52.3705 68.9495 52.1951 69.2413 52.7292C69.5422 52.0915 70.5088 51.9161 70.8279 52.4183C70.9465 52.6096 70.9556 52.8965 70.8188 53.2473C70.5543 53.9088 69.8157 54.5226 69.2321 54.8653V54.8574ZM74.6122 53.869C74.0286 53.7414 73.2991 53.3987 73.0437 52.8328C72.907 52.5379 72.9161 52.2429 73.0437 52.0118C73.372 51.398 74.3386 51.2306 74.6304 51.7567C74.9313 51.127 75.8979 50.9517 76.217 51.4459C76.3356 51.6292 76.3447 51.9241 76.1988 52.2668C75.9344 52.9205 75.1866 53.5342 74.603 53.869H74.6122ZM79.9922 52.8806C79.4086 52.761 78.6882 52.4183 78.4329 51.8603C78.2961 51.5654 78.3143 51.2785 78.4329 51.0473C78.7703 50.4336 79.7277 50.2662 80.0195 50.7843C80.3296 50.1546 81.287 49.9792 81.6062 50.4734C81.7247 50.6567 81.7247 50.9437 81.5879 51.2864C81.3235 51.9321 80.5667 52.5458 79.9831 52.8806H79.9922ZM85.3722 51.8922C84.7977 51.7727 84.0682 51.4299 83.822 50.8799C83.6944 50.585 83.7035 50.2981 83.822 50.0749C84.1594 49.4691 85.1169 49.3017 85.4087 49.8198C85.7187 49.1901 86.6853 49.0227 86.9953 49.5089C87.1139 49.6923 87.1139 49.9792 86.9771 50.314C86.7035 50.9596 85.9558 51.5654 85.3631 51.9002L85.3722 51.8922ZM62.7396 58.7392C62.4205 58.237 61.4539 58.4123 61.1621 59.066V60.3811C61.5724 60.3014 61.9919 60.2217 62.4022 60.142C62.539 59.9667 62.6576 59.7754 62.7305 59.5841C62.8673 59.2333 62.8582 58.9384 62.7305 58.7392H62.7396ZM61.1621 51.4219C61.7457 51.0872 62.4843 50.4654 62.7488 49.8039C62.8855 49.4531 62.8764 49.1582 62.7488 48.959C62.4205 48.4568 61.4539 48.6162 61.1621 49.2618V51.414V51.4219ZM86.6215 44.8779C86.4938 45.1091 86.4756 45.396 86.6123 45.683C86.8585 46.2329 87.588 46.5757 88.1716 46.6952C88.1899 46.0098 88.199 45.3163 88.2172 44.6308C87.9254 44.1127 86.9588 44.2801 86.6215 44.8779ZM88.0075 54.0284C87.7157 53.5183 86.7582 53.6936 86.4208 54.2994C86.2932 54.5306 86.2749 54.8175 86.4117 55.1045C86.4847 55.2639 86.6032 55.3994 86.7309 55.5189C87.1412 55.4392 87.5607 55.3595 87.9801 55.2798C87.9801 54.8653 87.9984 54.4429 88.0075 54.0204V54.0284ZM64.9464 58.3247C64.8187 58.5638 64.8096 58.8587 64.9464 59.1616C65.0193 59.329 65.1379 59.4725 65.2746 59.6C66.1044 59.4406 66.9342 59.2891 67.764 59.1297C67.9008 58.9544 68.0194 58.7631 68.0923 58.5718C68.2291 58.221 68.2291 57.9261 68.1014 57.7348C67.7823 57.2406 66.8248 57.416 66.5148 58.0616C66.223 57.5276 65.2564 57.7109 64.9372 58.3326L64.9464 58.3247ZM70.3173 57.3124C70.1896 57.5515 70.1805 57.8464 70.3173 58.1413C70.3902 58.3008 70.5088 58.4522 70.6455 58.5718C71.4753 58.4123 72.3051 58.2529 73.1349 58.0935C73.2808 57.9182 73.3903 57.7348 73.4723 57.5435C73.6091 57.1928 73.6091 56.9059 73.4814 56.7146C73.1623 56.2204 72.2048 56.4037 71.8948 57.0414C71.603 56.5153 70.6364 56.6907 70.3081 57.3044L70.3173 57.3124ZM75.6882 56.3081C75.5605 56.5472 75.5514 56.8341 75.6882 57.129C75.7611 57.2885 75.8797 57.4319 76.0164 57.5515C76.8462 57.3921 77.676 57.2406 78.5058 57.0812C78.6517 56.9059 78.7612 56.7225 78.8432 56.5312C78.9891 56.1805 78.98 55.9015 78.8615 55.7102C78.5423 55.224 77.5848 55.3994 77.2748 56.037C76.983 55.511 76.0256 55.6943 75.6973 56.3001L75.6882 56.3081ZM81.0591 55.3037C80.9314 55.5349 80.9223 55.8218 81.0591 56.1168C81.132 56.2762 81.2506 56.4196 81.3782 56.5392C82.208 56.3798 83.0378 56.2204 83.8676 56.061C84.0135 55.8856 84.1229 55.7023 84.205 55.5189C84.3509 55.1762 84.3509 54.8892 84.2232 54.7059C83.9132 54.2277 82.9466 54.3951 82.6366 55.0327C82.3448 54.5146 81.3873 54.69 81.0499 55.3037H81.0591Z' fill='url(%23paint5_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:multiply' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M49.0619 52.8959C47.3293 51.772 46.7275 50.9669 46.4722 49.7314L46.4995 51.8118L61.1532 60.3884V58.0131C60.8523 58.6667 59.8128 58.7305 58.9556 58.4037C56.2747 57.3755 51.4601 54.4502 49.0528 52.8879L49.0619 52.8959Z' fill='url(%23paint6_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:multiply' fill-rule='evenodd' clip-rule='evenodd' d='M61.1533 58.0215V60.3968L87.9805 55.3034L88.0534 51.8521C87.6522 53.231 86.8589 54.0201 84.5883 54.9128C80.2296 56.6345 71.0744 58.4599 66.3145 58.9062C63.9528 59.1294 61.5181 59.0896 61.1533 58.0215Z' fill='url(%23paint7_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:multiply' opacity='0.4' fill-rule='evenodd' clip-rule='evenodd' d='M46.2534 37.2098L46.2261 35.4961L61.1533 42.7735V45.89C60.1503 42.9408 49.1076 36.5004 46.2534 37.2098Z' fill='url(%23paint8_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:multiply' opacity='0.75' fill-rule='evenodd' clip-rule='evenodd' d='M61.1533 45.898C63.7065 41.9126 82.719 38.9714 88.327 39.8641L88.3543 38.4214L61.1533 42.7814V45.89V45.898Z' fill='url(%23paint9_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M61.0713 42.7802L88.254 38.4122L72.1596 31.5015L46.2261 35.5028L61.0713 42.7802Z' fill='url(%23paint10_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M72.0869 41.0111L88.3546 38.4206L72.1599 31.502L72.0869 31.8925V41.0111Z' fill='url(%23paint11_radial_4318_875)'/%3e%3cpath d='M72.0863 31.8927L86.9315 38.2375L61.1439 42.3823L47.4203 35.6868L72.0954 31.8927M72.1684 31.4941L46.2349 35.4955L61.0892 42.7888L88.3631 38.4208L72.1593 31.5021L72.1684 31.4941Z' fill='%23FF80DB'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M96.7708 7H37.4082L47.3293 35.687L61.0529 42.3825L86.8497 38.2376L96.7708 7Z' fill='url(%23paint12_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M84.4515 7H49.7275L54.3689 39.1224L60.9891 42.3506L80.1566 39.3137L84.4515 7Z' fill='url(%23paint13_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' d='M80.7105 52.2677C88.235 45.6904 88.235 35.0264 80.7105 28.4491C73.186 21.8717 60.9863 21.8717 53.4618 28.4491C45.9372 35.0264 45.9372 45.6904 53.4618 52.2677C60.9863 58.8451 73.186 58.8451 80.7105 52.2677Z' fill='url(%23paint14_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M52.3447 7H41.9585L50.0194 37.0022L56.6304 40.1985L52.3447 7Z' fill='url(%23paint15_linear_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M73.9192 7H81.5606L77.5758 39.7282L71.2383 40.7484L73.9192 7Z' fill='url(%23paint16_linear_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M65.6303 7H56.4478L58.8095 41.2825L60.9889 42.3506L64.4266 41.8086L65.6303 7Z' fill='url(%23paint17_linear_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M91.8104 7H88.09L81.5884 39.0825L83.0291 38.8514L91.8104 7Z' fill='url(%23paint18_linear_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M95.5399 17.4663L85.3999 38.4694L86.8498 38.2383L95.5399 17.4663Z' fill='url(%23paint19_linear_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.35' fill-rule='evenodd' clip-rule='evenodd' d='M38.6392 14.9155L48.9341 36.4686L47.3293 35.6875L38.6392 14.9155Z' fill='url(%23paint20_linear_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.15' fill-rule='evenodd' clip-rule='evenodd' d='M57.9891 27.7228C60.0499 38.6827 60.0499 47.8093 57.9891 48.1042C55.9282 48.3991 52.5908 39.7587 50.53 28.7989C48.4692 17.839 48.4692 8.71241 50.53 8.41749C52.5908 8.12257 55.9282 16.7629 57.9891 27.7228Z' fill='url(%23paint21_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M83.2934 34.7615C85.2448 24.3995 85.3907 15.7989 83.6217 15.5439C81.8527 15.2888 78.8344 23.4828 76.8921 33.8369C74.9407 44.199 74.7948 52.7995 76.5638 53.0546C78.3329 53.3096 81.3511 45.1156 83.2934 34.7615Z' fill='url(%23paint22_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.25' fill-rule='evenodd' clip-rule='evenodd' d='M51.9067 32.5692C55.0253 41.8073 56.5755 49.555 55.3718 49.8579C54.1681 50.1687 50.6757 42.9232 47.5571 33.6851C44.4385 24.4469 42.8883 16.6993 44.092 16.3964C45.2957 16.0855 48.7881 23.331 51.9067 32.5692Z' fill='url(%23paint23_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M76.6913 36.6731C75.4785 46.9236 73.4815 55.1415 72.2414 55.0299C71.0013 54.9183 70.9739 46.5171 72.1867 36.2666C73.3995 26.0161 75.3965 17.7982 76.6366 17.9098C77.8767 18.0214 77.9041 26.4226 76.6913 36.6731Z' fill='url(%23paint24_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M62.6851 40.5893C62.0377 40.9639 61.1623 40.8045 60.7337 40.2306C60.3051 39.6647 60.4875 38.8995 61.1441 38.5249C61.7915 38.1502 62.6669 38.3096 63.0955 38.8835C63.524 39.4495 63.3417 40.2147 62.6851 40.5893Z' fill='url(%23paint25_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.8' fill-rule='evenodd' clip-rule='evenodd' d='M69.0864 39.3705C68.594 39.6494 67.9374 39.5299 67.6091 39.0994C67.29 38.669 67.4268 38.0951 67.9192 37.8082C68.4116 37.5292 69.0681 37.6488 69.3964 38.0792C69.7156 38.5096 69.5788 39.0835 69.0864 39.3705Z' fill='url(%23paint26_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.8' fill-rule='evenodd' clip-rule='evenodd' d='M60.1319 27.0627C59.7306 27.2939 59.1835 27.1982 58.9191 26.8395C58.6546 26.4888 58.7641 26.0106 59.1744 25.7794C59.5756 25.5483 60.1227 25.6439 60.3872 26.0026C60.6516 26.3533 60.5422 26.8316 60.1319 27.0627Z' fill='url(%23paint27_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.8' fill-rule='evenodd' clip-rule='evenodd' d='M72.6884 31.1122C72.196 31.3911 71.5395 31.2716 71.2112 30.8411C70.892 30.4107 71.0288 29.8368 71.5212 29.5499C72.0136 29.2709 72.6702 29.3905 72.9984 29.8209C73.3176 30.2513 73.1808 30.8252 72.6884 31.1122Z' fill='url(%23paint28_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M67.3629 26.7907C66.8887 27.0617 66.2413 26.9501 65.9312 26.5277C65.6212 26.1132 65.7489 25.5472 66.2322 25.2762C66.7063 25.0052 67.3538 25.1168 67.6638 25.5393C67.9738 25.9538 67.8462 26.5197 67.3629 26.7907Z' fill='url(%23paint29_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M66.8707 36.7157C65.7218 37.3773 64.1716 37.0903 63.4147 36.086C62.6579 35.0817 62.9862 33.7266 64.1351 33.0651C65.2841 32.4035 66.8343 32.6904 67.5911 33.6948C68.348 34.6991 68.0197 36.0541 66.8707 36.7157Z' fill='url(%23paint30_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M73.5729 35.503C72.7248 35.9893 71.585 35.782 71.0196 35.0407C70.4634 34.2994 70.7005 33.3031 71.5485 32.8089C72.3965 32.3227 73.5364 32.5299 74.0926 33.2712C74.6489 34.0125 74.4118 35.0088 73.5637 35.503H73.5729Z' fill='url(%23paint31_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M77.7221 27.8189C77.1111 28.1696 76.2905 28.0182 75.8892 27.4842C75.488 26.9501 75.6613 26.2327 76.2722 25.882C76.8832 25.5313 77.7039 25.6827 78.1051 26.2168C78.5063 26.7508 78.333 27.4682 77.7221 27.8189Z' fill='url(%23paint32_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.75' fill-rule='evenodd' clip-rule='evenodd' d='M53.0194 35.7984C52.0073 36.3802 50.6395 36.1331 49.9738 35.2484C49.3081 34.3636 49.5908 33.168 50.603 32.5861C51.6152 32.0043 52.983 32.2514 53.6486 33.1361C54.3143 34.0209 54.0316 35.2165 53.0194 35.7984Z' fill='url(%23paint33_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.75' fill-rule='evenodd' clip-rule='evenodd' d='M76.1535 32.0693C76.7826 31.7106 77.6216 31.8621 78.041 32.412C78.4514 32.962 78.2781 33.6954 77.6489 34.062C77.0197 34.4207 76.1808 34.2692 75.7613 33.7193C75.351 33.1693 75.5243 32.436 76.1535 32.0693Z' fill='url(%23paint34_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M65.7493 33.9739C65.3024 34.2289 64.7097 34.1173 64.4179 33.7347C64.1261 33.3521 64.2538 32.8261 64.6915 32.571C65.1383 32.3159 65.731 32.4275 66.0228 32.8101C66.3146 33.2007 66.187 33.7188 65.7493 33.9739Z' fill='url(%23paint35_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M69.2779 31.9486C68.6305 32.3233 67.7551 32.1639 67.3356 31.5979C66.9162 31.032 67.0894 30.2668 67.7368 29.9001C68.3843 29.5335 69.2597 29.6849 69.6791 30.2509C70.1077 30.8168 69.9253 31.582 69.2779 31.9486Z' fill='url(%23paint36_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M82.491 36.7473C82.0441 37.0024 81.4514 36.8908 81.1596 36.5082C80.8678 36.1256 80.9955 35.5995 81.4332 35.3444C81.88 35.0894 82.4727 35.201 82.7645 35.5836C83.0563 35.9662 82.9287 36.4922 82.491 36.7473Z' fill='url(%23paint37_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M63.588 30.7374C62.7947 31.1917 61.7369 31.0004 61.2263 30.307C60.7065 29.6135 60.9253 28.6889 61.7187 28.2425C62.512 27.7882 63.5698 27.9795 64.0804 28.673C64.6002 29.3664 64.3813 30.291 63.588 30.7374Z' fill='url(%23paint38_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M67.7005 38.9539C67.4998 39.0655 67.2354 39.0177 67.1077 38.8423C66.9801 38.6669 67.0348 38.4358 67.2354 38.3242C67.436 38.2126 67.7005 38.2604 67.8281 38.4358C67.9558 38.6111 67.9011 38.8423 67.7005 38.9539Z' fill='url(%23paint39_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M74.5032 37.4329C74.3026 37.5445 74.0381 37.4967 73.9105 37.3213C73.7828 37.1459 73.8375 36.9148 74.0381 36.8032C74.2387 36.6916 74.5032 36.7394 74.6308 36.9148C74.7585 37.0901 74.7038 37.3213 74.5032 37.4329Z' fill='url(%23paint40_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M76.6644 33.7015C76.9379 33.5421 77.3118 33.6138 77.4942 33.8529C77.6765 34.0921 77.5945 34.4189 77.3209 34.5783C77.0474 34.7377 76.6735 34.666 76.4911 34.4268C76.3087 34.1877 76.3908 33.8609 76.6644 33.7015Z' fill='url(%23paint41_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M68.22 30.2757C68.0194 30.3873 67.7549 30.3394 67.6273 30.1641C67.4996 29.9887 67.5543 29.7576 67.7549 29.646C67.9555 29.5344 68.22 29.5822 68.3476 29.7576C68.4753 29.9329 68.4206 30.1641 68.22 30.2757Z' fill='url(%23paint42_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M64.8736 22.7265C65.0742 22.6149 65.3386 22.6628 65.4663 22.8381C65.594 23.0135 65.5392 23.2446 65.3386 23.3562C65.138 23.4678 64.8736 23.42 64.7459 23.2446C64.6183 23.0693 64.673 22.8381 64.8736 22.7265Z' fill='url(%23paint43_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M56.8674 31.9256C56.6668 32.0372 56.4024 31.9893 56.2747 31.814C56.1471 31.6386 56.2018 31.4075 56.4024 31.2959C56.603 31.1843 56.8674 31.2321 56.9951 31.4075C57.1228 31.5828 57.0681 31.814 56.8674 31.9256Z' fill='url(%23paint44_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M68.448 19.3466C68.0742 19.5618 67.5635 19.4742 67.3173 19.1394C67.0711 18.8046 67.1714 18.3662 67.5544 18.151C67.9283 17.9358 68.4389 18.0235 68.6851 18.3583C68.9313 18.6851 68.831 19.1314 68.448 19.3466Z' fill='url(%23paint45_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M55.5908 28.6157C54.9525 28.9824 54.0862 28.823 53.6668 28.265C53.2473 27.7071 53.4297 26.9498 54.068 26.5832C54.7063 26.2165 55.5726 26.3759 55.992 26.9339C56.4115 27.4918 56.2291 28.2491 55.5908 28.6157Z' fill='url(%23paint46_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.75' fill-rule='evenodd' clip-rule='evenodd' d='M55.6912 29.4761C55.2626 29.7232 54.679 29.6195 54.3963 29.2369C54.1137 28.8543 54.2322 28.3522 54.6699 28.1051C55.1076 27.858 55.6821 27.9616 55.9647 28.3442C56.2474 28.7188 56.1289 29.229 55.6912 29.4761Z' fill='url(%23paint47_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M72.1505 24.8868C71.8131 25.0781 71.3572 24.9984 71.1384 24.7035C70.9195 24.4086 71.0107 24.01 71.3481 23.8187C71.6855 23.6274 72.1414 23.7071 72.3603 24.002C72.5791 24.297 72.4879 24.6955 72.1505 24.8868Z' fill='url(%23paint48_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M77.9681 30.6413C77.7401 30.7689 77.4301 30.7131 77.2842 30.5138C77.1383 30.3145 77.2021 30.0435 77.4301 29.916C77.6581 29.7884 77.9681 29.8442 78.114 30.0435C78.2599 30.2428 78.1961 30.5138 77.9681 30.6413Z' fill='url(%23paint49_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M54.2231 34.3479C53.603 34.7066 52.7732 34.5551 52.3629 34.0131C51.9525 33.4711 52.1258 32.7458 52.7459 32.3871C53.3659 32.0284 54.1957 32.1798 54.6061 32.7219C55.0164 33.2639 54.8432 33.9892 54.2231 34.3479Z' fill='url(%23paint50_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M64.2534 30.0515C63.9251 30.2428 63.4783 30.1631 63.2595 29.8682C63.0406 29.5813 63.1318 29.1907 63.4692 28.9994C63.7975 28.8081 64.2443 28.8878 64.4631 29.1827C64.682 29.4776 64.5908 29.8602 64.2534 30.0515Z' fill='url(%23paint51_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M71.5758 35.6075C71.1837 35.8307 70.6548 35.7351 70.3995 35.3923C70.1442 35.0496 70.2536 34.5873 70.6457 34.3641C71.0378 34.1409 71.5667 34.2366 71.822 34.5793C72.0773 34.9221 71.9679 35.3844 71.5758 35.6075Z' fill='url(%23paint52_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M70.044 29.0071C69.7431 29.1825 69.3418 29.1027 69.1412 28.8397C68.9406 28.5767 69.0318 28.226 69.3327 28.0506C69.6336 27.8752 70.0349 27.9549 70.2355 28.218C70.4361 28.481 70.3449 28.8317 70.044 29.0071Z' fill='url(%23paint53_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M82.9013 35.7669C82.6734 35.8944 82.3724 35.8386 82.2265 35.6473C82.0806 35.456 82.1445 35.185 82.3633 35.0575C82.5913 34.9299 82.8922 34.9857 83.0381 35.177C83.184 35.3683 83.1202 35.6393 82.9013 35.7669Z' fill='url(%23paint54_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.75' fill-rule='evenodd' clip-rule='evenodd' d='M58.9101 33.9971C57.8979 34.579 56.5301 34.3319 55.8644 33.4471C55.1988 32.5624 55.4814 31.3667 56.4936 30.7849C57.5058 30.203 58.8736 30.4501 59.5393 31.3349C60.2049 32.2196 59.9222 33.4152 58.9101 33.9971Z' fill='url(%23paint55_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M58.9738 31.4231C58.6 31.6383 58.1075 31.5427 57.8613 31.2239C57.6151 30.8971 57.7246 30.4666 58.0893 30.2514C58.4632 30.0362 58.9556 30.1319 59.2018 30.4507C59.448 30.7775 59.3386 31.2079 58.9738 31.4231Z' fill='url(%23paint56_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:multiply' fill-rule='evenodd' clip-rule='evenodd' d='M54.7157 56.7614L57.7796 41.2103L56.7218 40.7002L50.5576 54.2825L54.7157 56.7614Z' fill='url(%23paint57_linear_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M47.1106 26.3838L53.594 33.709L41.2017 57.741L35.7031 48.8615L47.1106 26.3838Z' fill='url(%23paint58_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M53.5937 33.7095L60.5057 35.9413L53.5299 28.4647L47.1104 26.3843L53.5937 33.7095Z' fill='url(%23paint59_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M60.5059 35.9403L53.5939 33.7085L41.2017 57.7405L48.1501 59.8368L60.5059 35.9403Z' fill='url(%23paint60_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M36.624 50.1853C36.8064 49.9302 36.9432 49.6512 37.0252 49.4041C37.2258 48.7745 37.0252 48.4556 36.6878 48.91C36.9067 48.2643 36.7061 47.9455 36.3778 48.3679C36.2501 48.5274 36.1134 48.7904 35.9857 49.1411C35.9766 49.181 35.9583 49.2128 35.9492 49.2447C36.1589 49.5795 36.3687 49.9223 36.5784 50.257C36.5966 50.2331 36.6149 50.2092 36.6331 50.1853H36.624ZM37.472 50.1295C37.3444 50.2889 37.1985 50.5599 37.0708 50.9186C37.0617 50.9505 37.0435 50.9903 37.0343 51.0143C37.2441 51.349 37.4538 51.6918 37.6635 52.0265C37.6818 52.0106 37.7 51.9787 37.7182 51.9628C37.9097 51.6918 38.0465 51.4128 38.1195 51.1657C38.3201 50.528 38.1195 50.2092 37.7821 50.6715C38.01 50.0179 37.8094 49.6991 37.472 50.1215V50.1295ZM38.5754 51.891C38.4477 52.0505 38.3018 52.3294 38.1742 52.6881C38.1559 52.728 38.1468 52.7599 38.1377 52.7917C38.3474 53.1265 38.5572 53.4693 38.7669 53.804C38.7851 53.7881 38.8034 53.7562 38.8216 53.7323C39.0131 53.4613 39.1499 53.1823 39.2319 52.9352C39.4417 52.2896 39.2411 51.9707 38.8946 52.441C39.1225 51.7794 38.9219 51.4686 38.5845 51.899L38.5754 51.891ZM39.6788 53.6526C39.5511 53.82 39.4052 54.099 39.2684 54.4576C39.2593 54.4895 39.2411 54.5294 39.2319 54.5613C39.4417 54.896 39.6514 55.2388 39.8611 55.5736C39.8794 55.5496 39.8976 55.5257 39.9158 55.5018C40.1073 55.2308 40.2532 54.9439 40.3353 54.6968C40.545 54.0432 40.3535 53.7323 39.9979 54.2026C40.235 53.533 40.0344 53.2142 39.6879 53.6526H39.6788ZM40.7821 55.4141C40.6545 55.5815 40.4994 55.8685 40.3627 56.2351C40.3535 56.267 40.3353 56.3069 40.3262 56.3388C40.5359 56.6735 40.7456 57.0163 40.9554 57.3511C40.9736 57.3271 40.9918 57.3032 41.0101 57.2793C41.2016 57.0003 41.3475 56.7134 41.4387 56.4583C41.6575 55.7967 41.4569 55.4859 41.0922 55.9721C41.3292 55.2946 41.1377 54.9837 40.7821 55.4221V55.4141ZM43.0344 54.1468C43.3992 53.4454 43.7639 52.736 44.1287 52.0345C44.3658 51.357 44.1651 51.0541 43.8004 51.5084C43.6636 51.6758 43.5177 51.9628 43.3809 52.3294C43.1256 53.0149 43.0344 53.7323 43.0344 54.1468ZM41.9037 52.4171C42.1408 52.3773 42.542 52.1381 42.9068 51.62C43.0983 51.3411 43.2442 51.0541 43.3262 50.807C43.536 50.1534 43.3262 49.8505 42.9706 50.3367C43.2077 49.6672 42.998 49.3643 42.6514 49.8027C42.5147 49.9701 42.3688 50.257 42.232 50.6157C41.9767 51.2932 41.8946 52.0026 41.8946 52.4171H41.9037ZM40.773 50.6875C41.0101 50.6476 41.4113 50.4164 41.7669 49.9063C41.9584 49.6353 42.1043 49.3484 42.1773 49.1013C42.387 48.4556 42.1773 48.1527 41.8216 48.631C42.0496 47.9694 41.8399 47.6665 41.5025 48.1049C41.3748 48.2723 41.2289 48.5513 41.0922 48.902C40.8459 49.5795 40.7639 50.2809 40.7639 50.6954L40.773 50.6875ZM39.6423 48.9578C39.8794 48.9259 40.2715 48.6947 40.6271 48.1926C40.8186 47.9295 40.9554 47.6426 41.0374 47.3955C41.2381 46.7578 41.0374 46.4549 40.6909 46.9173C40.9098 46.2636 40.7092 45.9608 40.3627 46.3912C40.235 46.5506 40.0891 46.8296 39.9614 47.1803C39.7152 47.8498 39.6423 48.5433 39.6514 48.9498L39.6423 48.9578ZM39.4873 46.4789C39.6696 46.2158 39.8155 45.9368 39.8885 45.6977C40.0891 45.068 39.8885 44.7651 39.542 45.2274C39.7608 44.5818 39.542 44.2789 39.2137 44.7014C39.086 44.8608 38.9401 45.1318 38.8216 45.4825C38.5845 46.1441 38.5116 46.8296 38.5207 47.2361C38.7578 47.2042 39.1408 46.989 39.4873 46.4868V46.4789ZM38.3474 44.7651C38.5298 44.5021 38.6666 44.2311 38.7395 43.992C38.931 43.3623 38.7395 43.0673 38.393 43.5137C38.0556 44.1753 37.7274 44.8369 37.39 45.4905C37.6179 45.4586 38.0009 45.2513 38.3474 44.7572V44.7651ZM40.5359 40.1022C40.2988 40.7558 40.235 41.4333 40.2532 41.8319C40.4903 41.792 40.8824 41.5688 41.2289 41.0746C41.4113 40.8116 41.5572 40.5326 41.6302 40.2935C41.8216 39.6718 41.6119 39.3769 41.2654 39.8392C41.4751 39.1935 41.2654 38.9066 40.928 39.329C40.8004 39.4884 40.6545 39.7595 40.5359 40.1022ZM41.7122 41.7522C41.4751 42.4058 41.4022 43.0913 41.4204 43.4978C41.6575 43.4579 42.0496 43.2268 42.4052 42.7246C42.5967 42.4616 42.7335 42.1746 42.8156 41.9355C43.0162 41.3058 42.7973 41.0188 42.4508 41.4812C42.6697 40.8355 42.4508 40.5406 42.1134 40.971C41.9858 41.1304 41.8399 41.4094 41.7122 41.7601V41.7522ZM42.8885 43.4021C42.6423 44.0717 42.5694 44.7572 42.5785 45.1637C42.8247 45.1238 43.2168 44.8847 43.5816 44.3746C43.773 44.1036 43.9189 43.8246 43.9919 43.5775C44.1925 42.9398 43.9919 42.6449 43.6271 43.1231C43.8551 42.4695 43.6271 42.1746 43.2898 42.613C43.153 42.7804 43.0162 43.0594 42.8885 43.4101V43.4021ZM44.0648 45.0521C43.8186 45.7296 43.7366 46.4231 43.7457 46.8296C43.9919 46.7817 44.3931 46.5426 44.7579 46.0245C44.9494 45.7455 45.0953 45.4586 45.1773 45.2115C45.387 44.5659 45.1773 44.2789 44.8126 44.7572C45.0405 44.0956 44.8217 43.8007 44.4752 44.247C44.3384 44.4144 44.1925 44.7014 44.0648 45.0521ZM45.6606 45.881C45.5238 46.0564 45.3779 46.3354 45.2411 46.702C44.9858 47.3875 44.9038 48.081 44.9129 48.4955C45.1591 48.4476 45.5694 48.2006 45.9342 47.6745C46.1257 47.3955 46.2807 47.1006 46.3627 46.8535C46.5725 46.1999 46.3627 45.9129 45.998 46.3991C46.226 45.7296 46.0162 45.4426 45.6697 45.889L45.6606 45.881ZM47.9768 44.518C48.3415 43.8166 48.7062 43.1072 49.071 42.4058C49.299 41.7362 49.0801 41.4572 48.7245 41.9116C48.5877 42.0869 48.4327 42.3739 48.305 42.7326C48.0497 43.4181 47.9676 44.1115 47.9859 44.518H47.9768ZM46.764 42.9159C47.0102 42.8601 47.4296 42.605 47.7944 42.079C47.995 41.8 48.1318 41.5051 48.2138 41.258C48.4236 40.6123 48.2047 40.3334 47.84 40.8196C48.0679 40.158 47.84 39.871 47.4935 40.3254C47.3567 40.5007 47.2108 40.7797 47.074 41.1384C46.8278 41.8159 46.7548 42.5014 46.764 42.9079V42.9159ZM46.5725 40.4928C46.764 40.2138 46.9099 39.9348 46.9828 39.6877C47.1834 39.0501 46.9646 38.7631 46.609 39.2493C46.8369 38.5957 46.609 38.3088 46.2624 38.7551C46.1348 38.9225 45.9889 39.2015 45.8612 39.5522C45.615 40.2218 45.5421 40.9073 45.5603 41.3058C45.8065 41.25 46.2168 41.0029 46.5725 40.4848V40.4928ZM45.3597 38.9066C45.5512 38.6356 45.688 38.3566 45.77 38.1095C45.9706 37.4798 45.7518 37.2008 45.3962 37.6711C45.615 37.0255 45.3962 36.7385 45.0497 37.1769C44.922 37.3443 44.7761 37.6153 44.6484 37.966C44.4113 38.6276 44.3384 39.3051 44.3566 39.7037C44.6028 39.6558 45.0041 39.4167 45.3597 38.9066ZM44.1378 37.3204C44.3202 37.0573 44.4661 36.7784 44.539 36.5392C44.7396 35.9175 44.5117 35.6385 44.1651 36.1008C44.3749 35.4632 44.1651 35.1762 43.8186 35.6067C43.691 35.774 43.5451 36.0451 43.4265 36.3878C43.1894 37.0334 43.1256 37.711 43.1439 38.1095C43.3901 38.0617 43.7822 37.8305 44.1378 37.3204ZM42.9159 35.7342C43.0983 35.4712 43.235 35.2001 43.308 34.961C43.4995 34.3473 43.2806 34.0683 42.9341 34.5226C42.5967 35.1842 42.2593 35.8458 41.9311 36.5074C42.1682 36.4595 42.5694 36.2284 42.9159 35.7422V35.7342ZM45.0953 31.0872C44.8673 31.7328 44.8126 32.3944 44.8308 32.777C45.077 32.7212 45.4782 32.4821 45.8339 31.9799C46.0162 31.7169 46.1621 31.4379 46.2351 31.1988C46.4266 30.585 46.1986 30.314 45.8521 30.7763C46.0618 30.1466 45.8339 29.8756 45.4965 30.3061C45.3688 30.4655 45.2229 30.7365 45.1044 31.0792L45.0953 31.0872ZM46.7457 31.8285C46.6181 31.9959 46.4722 32.2669 46.3445 32.6096C46.1074 33.2632 46.0527 33.9328 46.0709 34.3234C46.3172 34.2676 46.7184 34.0205 47.0831 33.5103C47.2746 33.2393 47.4205 32.9603 47.4935 32.7212C47.685 32.0995 47.457 31.8285 47.1014 32.3067C47.3111 31.6611 47.0922 31.3901 46.7457 31.8285ZM48.0132 33.3429C47.8764 33.5183 47.7305 33.7893 47.6029 34.14C47.3658 34.8016 47.302 35.4712 47.3202 35.8617C47.5664 35.8059 47.9768 35.5509 48.3415 35.0328C48.533 34.7618 48.6789 34.4748 48.7518 34.2357C48.9524 33.606 48.7245 33.335 48.3597 33.8132C48.5786 33.1676 48.3597 32.8966 48.0041 33.335L48.0132 33.3429ZM49.2716 34.8574C49.1348 35.0328 48.9889 35.3117 48.8613 35.6625C48.6151 36.332 48.5512 37.0095 48.5695 37.4081C48.8248 37.3443 49.2351 37.0813 49.5999 36.5632C49.7914 36.2842 49.9373 35.9972 50.0193 35.7581C50.2199 35.1204 50.0011 34.8494 49.6364 35.3357C49.8643 34.682 49.6364 34.411 49.2807 34.8654L49.2716 34.8574ZM50.5391 36.3719C50.4023 36.5472 50.2473 36.8342 50.1196 37.1929C49.8734 37.8704 49.8005 38.5559 49.8096 38.9544C50.0649 38.8906 50.4844 38.6276 50.8583 38.0936C51.0589 37.8146 51.2048 37.5197 51.2777 37.2726C51.4874 36.6269 51.2595 36.3559 50.8856 36.8501C51.1136 36.1885 50.8856 35.9175 50.53 36.3719H50.5391ZM52.9191 34.9132C53.1288 34.5067 53.3385 34.1002 53.5574 33.6857C53.4297 33.5502 53.3112 33.4067 53.1835 33.2712C52.9647 33.9168 52.9008 34.5465 52.9191 34.9212V34.9132ZM51.6333 33.4306C51.8795 33.3669 52.2716 33.1198 52.6273 32.6335C52.3811 32.3546 52.1349 32.0756 51.8887 31.7966C51.6698 32.4343 51.6151 33.056 51.6333 33.4306ZM50.3476 31.9481C50.5938 31.8843 50.9768 31.6452 51.3324 31.1669C51.0862 30.8879 50.84 30.609 50.5938 30.33C50.3841 30.9597 50.3294 31.5814 50.3476 31.9481ZM49.0619 30.4655C49.299 30.4097 49.6819 30.1706 50.0376 29.7003C49.7914 29.4213 49.5452 29.1423 49.299 28.8633C49.0892 29.4851 49.0436 30.0988 49.0619 30.4655ZM47.7761 28.9829C48.0132 28.9271 48.3962 28.696 48.7427 28.2337C48.4965 27.9547 48.2503 27.6757 48.0041 27.3967C47.8035 28.0105 47.7579 28.6242 47.7761 28.9829ZM46.4904 27.5003C46.7275 27.4445 47.1014 27.2214 47.4479 26.767C47.3202 26.6315 47.2017 26.488 47.074 26.3525C46.8825 26.7351 46.6819 27.1177 46.4904 27.5003Z' fill='url(%23paint61_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M42.688 57.1347C42.46 57.3101 42.305 57.597 42.2686 57.9637C42.2686 58.0036 42.2686 58.0354 42.2686 58.0673C42.7336 58.2108 43.2078 58.3543 43.6819 58.4898C44.1561 58.6333 44.6212 58.7767 45.0953 58.9122C45.1227 58.8883 45.1592 58.8644 45.1774 58.8405C45.4692 58.5535 45.6151 58.2666 45.606 58.0195C45.5878 57.3739 44.7124 57.1108 44.1288 57.613C44.1561 56.9434 43.2716 56.6804 42.688 57.1427V57.1347ZM47.7215 58.6572C47.5027 58.8325 47.3385 59.1195 47.3021 59.4782C47.3021 59.51 47.3021 59.5499 47.3021 59.5818C47.5847 59.6695 47.8765 59.7571 48.1592 59.8368C48.3872 59.4064 48.606 58.968 48.834 58.5296C48.5331 58.3622 48.0772 58.3782 47.7306 58.6492L47.7215 58.6572ZM47.986 55.6681C48.6425 55.5964 49.5635 55.3333 50.1106 54.7993C50.4024 54.5203 50.5483 54.2254 50.5392 53.9783C50.521 53.3327 49.6456 53.0616 49.0711 53.5638C49.0984 52.8943 48.2139 52.6312 47.6303 53.0856C47.4115 53.2609 47.2474 53.5479 47.2109 53.9066C47.1379 54.592 47.5665 55.2696 47.986 55.6681ZM43.0436 54.1616C43.7002 54.0899 44.6212 53.8189 45.1774 53.2848C45.4692 53.0059 45.6151 52.7109 45.606 52.4638C45.5878 51.8182 44.7124 51.5472 44.1379 52.0494C43.7731 52.7588 43.4084 53.4602 43.0436 54.1616ZM47.6395 47.5299C47.4115 47.7053 47.2565 47.9922 47.22 48.3589C47.147 49.0444 47.5756 49.7298 47.986 50.1284C48.6425 50.0567 49.5635 49.7936 50.1106 49.2596C50.4024 48.9806 50.5483 48.6857 50.5392 48.4386C50.521 47.7929 49.6456 47.5219 49.0711 48.0161C49.0984 47.3466 48.2139 47.0756 47.6303 47.5379L47.6395 47.5299ZM52.6638 49.0922C52.4359 49.2675 52.2809 49.5545 52.2444 49.9132C52.1988 50.3675 52.372 50.8218 52.6183 51.1965C53.0012 50.4632 53.3842 49.7139 53.7672 48.9806C53.4663 48.8052 53.0104 48.8212 52.6638 49.0922ZM52.9283 46.0952C53.5848 46.0234 54.5058 45.7683 55.0529 45.2343C55.3447 44.9553 55.4906 44.6604 55.4815 44.4133C55.4633 43.7677 54.5879 43.4887 54.0134 43.9829C54.0408 43.3133 53.1654 43.0344 52.5727 43.4967C52.3447 43.672 52.1897 43.959 52.1532 44.3177C52.0802 45.0031 52.5088 45.6886 52.9192 46.0872L52.9283 46.0952ZM48.0042 44.5488C48.6516 44.485 49.5726 44.222 50.1289 43.688C50.4207 43.409 50.5665 43.1141 50.5574 42.867C50.5483 42.2134 49.6729 41.9424 49.0893 42.4365C48.7246 43.138 48.3598 43.8474 48.0042 44.5488ZM52.6 37.9251C52.3812 38.1004 52.217 38.3874 52.1806 38.754C52.1076 39.4395 52.5362 40.133 52.9465 40.5315C53.594 40.4678 54.5149 40.2047 55.0712 39.6786C55.363 39.3997 55.5089 39.1047 55.4998 38.8576C55.4815 38.204 54.6152 37.9251 54.0408 38.4272C54.0681 37.7577 53.1927 37.4787 52.6091 37.933L52.6 37.9251ZM57.6062 39.5272C57.3873 39.7026 57.2323 39.9895 57.1867 40.3482C57.132 40.8105 57.3144 41.2648 57.5606 41.6395C57.9436 40.8982 58.3265 40.1569 58.7095 39.4156C58.4086 39.2402 57.9527 39.2562 57.6062 39.5272ZM57.8706 36.5222C58.4907 36.4584 59.3478 36.2273 59.9132 35.749C59.4481 35.5976 58.974 35.4461 58.5089 35.2947C58.0439 35.1432 57.5697 34.9918 57.1046 34.8404C57.0773 35.494 57.4876 36.1396 57.8706 36.5222ZM52.9556 34.936C53.5757 34.8802 54.4329 34.6411 54.9891 34.1628C54.5241 34.0114 54.0499 33.8599 53.5848 33.7085C53.3751 34.123 53.1654 34.5295 52.9556 34.936Z' fill='url(%23paint62_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M52.0436 28.2018C51.5329 28.0822 51.2593 28.138 51.1864 28.2337C51.5511 28.4648 52.1986 28.8155 52.846 29.0786C53.1925 29.2141 53.4661 29.3018 53.6393 29.3336C54.0861 29.4133 53.8399 29.1503 53.2016 28.8873C53.6849 28.9829 53.4296 28.7199 52.8186 28.4568C52.5816 28.3612 52.308 28.2655 52.0344 28.2018H52.0436ZM54.2047 29.9474C53.9676 29.8438 53.6849 29.7561 53.4114 29.6923C52.8916 29.5728 52.6089 29.6286 52.5268 29.7162C52.9007 29.9474 53.5481 30.3061 54.2047 30.5691C54.5512 30.7126 54.8339 30.8003 55.0162 30.8322C55.4722 30.9198 55.226 30.6488 54.5785 30.3858C55.071 30.4814 54.8156 30.2184 54.1956 29.9554L54.2047 29.9474ZM55.5816 31.4379C55.3445 31.3343 55.0527 31.2387 54.77 31.1749C54.2412 31.0553 53.9494 31.1032 53.8673 31.1908C54.2412 31.43 54.8977 31.7807 55.5725 32.0517C55.9281 32.1952 56.2108 32.2828 56.3932 32.3147C56.8582 32.4024 56.612 32.1314 55.9555 31.8684C56.457 31.972 56.2017 31.701 55.5816 31.4379ZM56.9585 32.9285C56.7123 32.8249 56.4205 32.7292 56.1378 32.6654C55.5998 32.5379 55.308 32.5937 55.2169 32.6734C55.5907 32.9125 56.2564 33.2633 56.9403 33.5343C57.305 33.6777 57.5877 33.7734 57.7701 33.8053C58.2443 33.8929 57.9981 33.6299 57.3324 33.3589C57.843 33.4625 57.5877 33.1995 56.9585 32.9285ZM58.3354 34.419C58.0892 34.3154 57.7974 34.2198 57.5056 34.148C56.9585 34.0205 56.6576 34.0683 56.5664 34.148C56.9494 34.3871 57.6242 34.7458 58.3081 35.0168C58.6728 35.1603 58.9646 35.256 59.1561 35.2878C59.6394 35.3835 59.3932 35.1125 58.7184 34.8415C59.2291 34.9531 58.9829 34.6821 58.3446 34.4111L58.3354 34.419ZM54.4874 34.0045C55.0071 34.1161 54.77 33.8531 54.1317 33.5821C53.8855 33.4785 53.5846 33.3828 53.2928 33.3111C53.2655 33.3111 53.2381 33.2951 53.2107 33.2951C53.3384 33.4386 53.4569 33.5741 53.5846 33.7096C53.8855 33.8053 54.1864 33.9089 54.4965 34.0045H54.4874ZM52.7548 32.7053C53.1104 32.8488 53.4114 32.9444 53.5937 32.9763C54.077 33.072 53.8399 32.8089 53.1834 32.5299C53.694 32.6415 53.4569 32.3705 52.8278 32.1075C52.5907 32.0039 52.2898 31.9082 52.0071 31.8444C51.9797 31.8444 51.9524 31.8285 51.925 31.8285C52.1712 32.1075 52.4174 32.3865 52.6636 32.6654C52.7001 32.6814 52.7275 32.6894 52.7639 32.7053H52.7548ZM51.46 31.2387C51.8156 31.3821 52.1074 31.4698 52.2806 31.5097C52.7548 31.5974 52.5177 31.3343 51.8612 31.0633C52.3718 31.1669 52.1347 30.9039 51.5056 30.6409C51.2685 30.5372 50.9767 30.4416 50.694 30.3778C50.6666 30.3778 50.6393 30.3619 50.6119 30.3619C50.8581 30.6409 51.1043 30.9198 51.3505 31.1988C51.387 31.2148 51.4144 31.2227 51.4508 31.2387H51.46ZM50.1651 29.772C50.5116 29.9155 50.8034 30.0032 50.9767 30.0351C51.4417 30.1228 51.2046 29.8597 50.5663 29.5887C51.0587 29.6923 50.8308 29.4293 50.2107 29.1663C49.9736 29.0626 49.6909 28.975 49.4083 28.9112C49.3809 28.9112 49.3535 28.9032 49.3262 28.8952C49.5724 29.1742 49.8186 29.4532 50.0648 29.7322C50.1013 29.7481 50.1286 29.7641 50.1651 29.772ZM48.8703 28.3054C49.2168 28.4409 49.4994 28.5366 49.6727 28.5684C50.1286 28.6561 49.8915 28.3931 49.2624 28.13C49.7456 28.2257 49.5177 27.9706 48.9067 27.7076C48.6788 27.6119 48.387 27.5163 48.1134 27.4525C48.086 27.4525 48.0587 27.4446 48.0313 27.4366C48.2775 27.7156 48.5237 27.9945 48.77 28.2735C48.8064 28.2895 48.8338 28.2974 48.8703 28.3134V28.3054ZM47.5754 26.8388C47.9128 26.9743 48.1955 27.062 48.3687 27.0938C48.8155 27.1735 48.5785 26.9105 47.9584 26.6475C47.6757 26.5518 47.393 26.4641 47.1104 26.3765C47.238 26.5199 47.3566 26.6554 47.4842 26.7989C47.5207 26.8149 47.548 26.8228 47.5845 26.8388H47.5754Z' fill='white'/%3e%3cpath style='mix-blend-mode:screen' opacity='0.2' fill-rule='evenodd' clip-rule='evenodd' d='M47.1108 26.3843L53.5942 33.7095L41.2019 57.7415L40.29 56.2669C41.4937 56.6734 51.5516 38.1731 51.4969 34.3152C51.4513 30.6646 48.6154 27.7871 47.3297 27.6038C46.5728 27.4922 46.2901 28.0183 46.2901 28.0183L47.1108 26.3922V26.3843Z' fill='url(%23paint63_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:multiply' opacity='0.3' fill-rule='evenodd' clip-rule='evenodd' d='M42.0679 57.9973C48.4692 59.8386 61.5271 37.4964 57.0499 34.8262L60.5058 35.9421L48.15 59.8386L42.0679 57.9973Z' fill='url(%23paint64_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' d='M47.4916 29.7098C52.0993 25.1312 52.0993 17.7077 47.4916 13.1291C42.8838 8.55041 35.4132 8.55041 30.8055 13.1291C26.1977 17.7077 26.1977 25.1312 30.8055 29.7098C35.4132 34.2885 42.8838 34.2885 47.4916 29.7098Z' fill='url(%23paint65_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' d='M99.0385 19.4814C104.41 19.4814 108.764 15.1547 108.764 9.81738C108.764 4.48007 104.41 0.15332 99.0385 0.15332C93.6672 0.15332 89.313 4.48007 89.313 9.81738C89.313 15.1547 93.6672 19.4814 99.0385 19.4814Z' fill='url(%23paint66_radial_4318_875)'/%3e%3cpath d='M90.0004 21.7916C88.9465 20.3688 88.7976 18.1036 89.4047 16.4758C89.6453 15.8384 93.059 16.0205 93.4026 16.4644C93.7577 16.9084 93.5859 17.6369 93.8952 18.4337C94.3534 19.6061 96.8392 18.7069 95.6249 17.2613C94.9605 16.4644 94.0441 15.9295 93.1964 15.3831C91.123 14.0513 90.4013 12.1276 91.0658 10.2722C91.6385 8.67856 93.0704 7.23293 94.72 6.53858C97.1599 5.5255 101.845 6.43613 102.739 9.14526C103.208 10.5795 103.14 12.4804 102.12 13.3C100.196 14.8708 96.885 13.4366 97.6754 11.3877C97.7441 11.2169 98.1336 11.1031 98.0305 10.9551C97.4348 10.0673 94.972 11.2966 96.1175 12.8105C96.7819 13.687 97.9045 14.4041 98.9813 15.2009C100.803 16.5327 101.879 19.4012 99.1646 21.7461C96.4153 24.1137 91.8791 24.3414 89.9775 21.7916H90.0004ZM75.7387 15.9636C75.8532 14.3245 76.9758 4.11402 77.835 3.23754C78.1672 2.89606 81.787 3.23754 81.8672 4.05711C82.062 5.9922 81.031 11.6723 80.5384 14.7456C80.3093 16.2026 80.6644 16.7263 81.1455 16.897C81.6152 17.0677 82.1994 16.8742 82.6233 15.5424C82.9211 14.609 84.101 4.37583 84.6394 4.11402C85.235 3.82945 88.832 4.262 88.6716 5.84422C88.2821 9.69164 87.7437 13.1634 87.0908 16.9653C86.1744 22.3039 79.7595 22.4291 76.9529 19.7313C76.1052 18.9232 75.6356 17.7279 75.7616 15.9522L75.7387 15.9636ZM61.6946 20.4143C61.4311 20.2436 60.5147 4.94497 61.7862 3.76116C62.8401 2.78223 65.5321 2.52042 66.437 3.82945C67.3535 5.16125 68.0866 8.81515 68.625 10.5567C68.6708 8.02973 68.7854 7.39229 68.6937 4.97912C68.6135 2.72531 72.1074 2.16755 72.9436 3.59041C73.2987 4.1937 73.3904 4.89944 73.4362 5.61656C73.5851 8.14356 73.2071 19.0825 71.9585 20.3119C71.3742 20.881 68.4761 20.6989 68.1324 20.0956C67.1931 18.4565 66.9525 16.1685 66.2652 14.6773C66.185 15.8612 66.4027 19.6972 66.2652 20.0728C66.0017 20.7558 62.3704 20.8469 61.706 20.4143H61.6946ZM54.031 15.827C54.2945 14.0285 54.2143 11.5243 53.7332 9.88514C52.9428 7.17602 51.4422 8.07527 51.2474 10.5681C51.1214 12.1959 51.4193 14.37 51.992 16.0091C52.8626 18.502 53.6645 18.3426 54.031 15.827ZM48.0858 17.9898C46.253 14.4155 46.104 8.31431 48.1316 5.49135C49.5062 3.59041 54.1914 3.15786 55.8524 4.86529C58.3268 7.40368 59.1744 13.0268 58.3268 16.3392C56.7918 22.3039 50.8121 23.2828 48.0858 17.9784V17.9898ZM39.3455 10.6592C38.9445 10.3405 38.2572 10.5681 37.547 10.8413C37.8219 11.9796 38.0854 13.1293 38.3603 14.2676C39.9182 13.596 40.6514 11.695 39.3455 10.6592ZM41.6021 18.4565C41.1439 17.3978 39.9411 17.5003 39.0018 17.7393L39.6433 20.3574C40.4795 20.3915 42.1978 19.8452 41.6021 18.4565ZM37.3752 24.182C34.855 24.33 32.5983 10.0331 32.6327 9.73717C32.7244 8.96313 33.1826 8.31431 33.7897 7.88176C35.5423 6.65241 38.578 6.0605 40.6628 6.54996C43.0684 7.1191 45.0158 10.0331 44.6263 12.4349C44.4659 13.4821 43.8703 14.4497 42.8164 15.3375C43.8817 15.4172 44.8096 15.8953 45.3022 16.5214C46.4821 18.0125 46.4362 20.2322 45.1647 21.655C43.435 23.6015 39.8037 24.0341 37.3752 24.182Z' fill='url(%23paint67_radial_4318_875)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M98.0647 11.5925C97.9731 11.8543 97.9502 12.1275 98.0533 12.3893C98.2824 13.004 98.9926 13.3796 99.5997 13.5048C100.39 13.6755 101.249 13.5048 101.879 12.9926C102.59 12.412 102.681 11.2055 102.601 10.3745C102.567 10.0103 102.486 9.63462 102.372 9.28175C102.326 9.14516 102.269 9.00856 102.2 8.88335C101.055 6.73199 96.9994 6.04901 94.9031 6.9255C93.4024 7.55155 92.0278 8.88335 91.478 10.4087C91.3061 10.8867 91.2259 11.399 91.2832 11.9112C91.4092 13.2658 92.3486 14.3244 93.4483 15.0415C94.3532 15.622 95.2696 16.1684 95.9684 16.9993C96.3464 17.4433 96.5412 18.0238 96.2548 18.5702C95.7393 19.5605 93.9752 19.7198 93.5284 18.5702C93.3795 18.1945 93.3223 17.8303 93.2764 17.4319C93.2535 17.2384 93.2306 16.931 93.1275 16.7603L93.1046 16.7262C92.9901 16.6579 92.6578 16.5896 92.5433 16.5668C92.1767 16.4985 91.7987 16.4757 91.4207 16.4643C91.0541 16.4643 90.6761 16.4643 90.3095 16.5099C90.2064 16.5213 89.8857 16.5782 89.7826 16.6465C89.2327 18.1376 89.3702 20.2321 90.3324 21.5297C90.5386 21.8029 90.7792 22.0533 91.0656 22.2696C92.1309 23.0778 93.5628 23.2941 94.8687 23.1575C96.335 22.9981 97.8012 22.3948 98.9239 21.4273C99.8975 20.5849 100.573 19.4694 100.39 18.1376C100.253 17.1018 99.5997 16.1342 98.7635 15.5196C97.7783 14.8024 96.5412 14.0284 95.808 13.0381C95.4529 12.56 95.3155 11.9909 95.5446 11.4331C95.682 11.103 95.9226 10.8298 96.2204 10.6249C96.839 10.1924 97.9043 9.98749 98.3969 10.716C98.4656 10.8071 98.4885 10.9209 98.4771 11.0347C98.4542 11.2851 98.2938 11.4103 98.1105 11.5356C98.0991 11.5356 98.0876 11.5583 98.0647 11.5697V11.5925ZM84.8798 4.47818C84.8225 4.62615 84.7537 4.88796 84.7308 4.99041C84.6277 5.41157 84.5476 5.8555 84.4674 6.27667C84.2497 7.48326 84.0664 8.70122 83.8946 9.90781C83.7113 11.1258 83.551 12.3551 83.3677 13.5731C83.2989 14.017 83.2302 14.461 83.1615 14.9049C83.1157 15.1439 83.0813 15.4399 83.0011 15.6789C82.8522 16.157 82.6116 16.7034 82.2336 17.0335C81.9358 17.2953 81.5807 17.4205 81.1912 17.3408C81.1224 17.3294 81.0652 17.3067 80.9964 17.2839C79.9311 16.9083 79.9769 15.5879 80.1259 14.6772C80.3779 13.1405 80.6413 11.6039 80.8819 10.0672C81.0652 8.90612 81.237 7.73368 81.3516 6.56124C81.3974 6.08316 81.4432 5.60508 81.4661 5.127C81.4776 4.7969 81.489 4.44403 81.4661 4.12531C81.3974 4.03424 81.0766 3.90903 80.985 3.87488C80.6299 3.74967 80.2404 3.66999 79.8624 3.61308C79.4844 3.55616 79.0949 3.52201 78.7054 3.52201C78.5794 3.52201 78.2586 3.52201 78.1212 3.56755C78.0295 3.70414 77.9264 4.04563 77.8921 4.15946C77.7546 4.62615 77.6401 5.11562 77.5484 5.60508C77.2735 6.95964 77.0788 8.32559 76.884 9.69153C76.7007 10.9892 76.5404 12.2868 76.4029 13.5845C76.3113 14.3813 76.2196 15.1895 76.1623 15.9976C76.0707 17.2611 76.2769 18.536 77.2277 19.458C78.2243 20.4142 79.6676 20.9492 81.0423 21.0516C82.0961 21.1313 83.1844 20.972 84.1237 20.5053C85.5785 19.7881 86.4033 18.4905 86.6668 16.9197C87.2968 13.2316 87.8696 9.55494 88.2476 5.82136C88.2476 5.74168 88.2476 5.662 88.2247 5.58232C88.0529 5.09285 87.1708 4.78551 86.7126 4.6603C86.3117 4.55786 85.8993 4.48956 85.4869 4.46679C85.3723 4.46679 85.063 4.45541 84.8912 4.47818H84.8798ZM62.0381 20.1296C62.2213 20.1865 62.4963 20.2207 62.6223 20.2321C63.0576 20.2776 63.5043 20.2776 63.9396 20.2662C64.3749 20.2548 64.8331 20.2093 65.257 20.1182C65.383 20.0955 65.761 20.0044 65.8756 19.9134C65.887 19.8337 65.887 19.7199 65.887 19.6516C65.887 19.4353 65.887 19.219 65.887 19.0027C65.887 18.4108 65.8641 17.8189 65.8526 17.227C65.8526 16.7375 65.8297 16.2481 65.8297 15.77C65.8297 15.4057 65.8297 15.0187 65.8412 14.6545L65.9443 13.0153L66.6202 14.5065C66.8493 15.0073 67.0096 15.5423 67.1585 16.0773C67.3189 16.6465 67.4678 17.2156 67.6282 17.7848C67.8344 18.5019 68.0864 19.2418 68.453 19.8906C68.5332 19.9817 68.8539 20.0727 68.957 20.0955C69.3007 20.1865 69.6787 20.2207 70.0338 20.2435C70.3889 20.2548 70.7555 20.2435 71.0991 20.1979C71.2251 20.1752 71.5344 20.1182 71.6261 20.0272C71.9697 19.6857 72.2561 18.0238 72.3248 17.5457C72.5769 15.9863 72.7029 14.3699 72.806 12.7877C72.8976 11.3648 72.9549 9.94196 72.9892 8.53048C73.0007 7.96134 73.0122 7.39219 73.0007 6.82305C73.0007 6.43603 73.0007 6.03763 72.9663 5.65061C72.932 5.02455 72.8518 4.35296 72.531 3.80659C72.1645 3.18053 71.1221 3.15776 70.5035 3.31712C69.6901 3.52201 69.0143 4.07978 69.0487 4.97902C69.083 5.87827 69.0945 6.77752 69.0716 7.68815C69.0487 8.65569 69.0028 9.61185 68.9914 10.5794L68.9456 13.1519L68.1895 10.6932C68.0406 10.2038 67.9031 9.70292 67.7771 9.21345C67.6282 8.62154 67.4678 8.04102 67.3075 7.44911C67.1242 6.7889 66.9294 6.11731 66.7003 5.47987C66.54 5.02455 66.3223 4.47818 66.0474 4.07978C65.3028 2.98702 62.8858 3.27159 62.0266 4.07978C61.9121 4.1936 61.809 4.71722 61.7746 4.87658C61.66 5.49125 61.6142 6.12869 61.5799 6.75475C61.4768 8.5191 61.4882 10.3176 61.534 12.0819C61.5799 13.8918 61.6486 15.7017 61.7746 17.5116C61.8204 18.149 61.8662 18.7751 61.9235 19.4125C61.9464 19.6174 61.9693 19.8109 61.9922 20.0158C61.9922 20.05 61.9922 20.1069 62.0152 20.1524L62.0381 20.1296ZM48.4522 17.8075C48.9562 18.7978 49.6664 19.7085 50.6058 20.3231C51.3618 20.8126 52.2324 21.0744 53.1374 21.0403C54.2142 20.9833 55.1993 20.5053 55.9783 19.7654C56.9749 18.832 57.5934 17.5457 57.9256 16.2481C58.3724 14.5065 58.2922 12.3779 57.9715 10.6135C57.6393 8.76952 56.8947 6.52709 55.5544 5.14977C54.0767 3.63584 49.6893 4.03424 48.4636 5.73029C47.1577 7.54017 46.9516 10.5566 47.1234 12.6966C47.2608 14.404 47.6618 16.2708 48.4522 17.7961V17.8075ZM54.4318 15.8838C54.3402 16.5326 54.0996 18.1149 53.229 18.1945C52.347 18.2856 51.82 16.7603 51.6024 16.1342C51.0296 14.4837 50.7089 12.2754 50.8349 10.5339C50.8807 9.91919 51.0182 9.23622 51.3045 8.68984C51.5336 8.25729 51.9002 7.84751 52.4157 7.81336C53.3894 7.75644 53.8934 9.01994 54.1111 9.75983C54.6265 11.5242 54.6838 14.0626 54.4203 15.8838H54.4318ZM33.0449 9.74845C33.0449 9.81675 33.0564 9.89643 33.0678 9.96472C33.0907 10.1355 33.1137 10.3176 33.148 10.4883C33.2397 11.0575 33.3313 11.6266 33.4344 12.1958C33.7322 13.8349 34.0644 15.4627 34.4654 17.079C34.683 17.9441 34.9121 18.8092 35.1756 19.6629C35.4047 20.4028 35.6567 21.1541 35.966 21.8712C36.1722 22.3607 36.4471 22.9298 36.7793 23.351C36.8939 23.499 37.1459 23.7722 37.3521 23.7608C39.6775 23.6242 43.2286 23.2144 44.8552 21.3817C45.9893 20.1069 46.0237 18.1149 44.9698 16.7717C44.4658 16.1342 43.5608 15.7928 42.7704 15.7358L41.7738 15.6675L42.5413 15.0187C43.3661 14.3244 44.0419 13.4479 44.2138 12.3665C44.5689 10.1696 42.736 7.46049 40.5595 6.93688C39.4828 6.68645 38.2227 6.75475 37.1459 6.97103C36.0806 7.17592 34.9121 7.5857 34.0301 8.21176C33.5146 8.57601 33.1251 9.12239 33.0449 9.74845ZM38.8985 17.3294C40.0441 17.0335 41.4301 16.9993 41.98 18.2856C42.1747 18.7409 42.2091 19.2304 41.9571 19.6857C41.5447 20.4142 40.4335 20.7898 39.6317 20.7557H39.3224L39.2536 20.4484C39.036 19.5719 38.8298 18.7068 38.6122 17.8303L38.5205 17.4319L38.91 17.3294H38.8985ZM37.9707 14.3471C37.6957 13.2088 37.4323 12.0592 37.1573 10.9209L37.0772 10.568L37.4094 10.4428C38.0508 10.1924 38.9902 9.82813 39.6088 10.3176C40.0555 10.6705 40.3419 11.1372 40.4221 11.6949C40.5939 12.9584 39.6546 14.1309 38.532 14.6203L38.0852 14.8138L37.9707 14.3357V14.3471Z' fill='url(%23paint68_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M98.2938 11.7525C98.248 11.9346 98.2365 12.1167 98.2938 12.2875C98.4771 12.8111 99.13 13.1184 99.634 13.2323C100.344 13.3802 101.123 13.2323 101.685 12.7769C102.303 12.2647 102.383 11.1378 102.303 10.3979C102.269 10.0451 102.2 9.70357 102.085 9.36208C102.04 9.23687 101.994 9.12304 101.937 9.00921C100.871 6.99444 96.9535 6.357 94.9832 7.17657C93.5628 7.76848 92.234 9.05474 91.707 10.5004C91.5467 10.9443 91.4779 11.411 91.5238 11.8777C91.6383 13.1412 92.5318 14.1315 93.5742 14.8031L93.7232 14.9055C95.7966 15.4975 97.7783 16.169 99.6226 16.8862C99.3477 16.4422 98.9926 16.0552 98.5802 15.7479C97.5492 14.9966 96.3349 14.2453 95.5675 13.2095C95.1551 12.6631 95.0061 11.9801 95.2696 11.3313C95.43 10.9557 95.7049 10.637 96.0371 10.3979C96.7817 9.87431 98.0189 9.69218 98.6031 10.5573C98.7062 10.7053 98.752 10.876 98.7291 11.0467C98.7062 11.3655 98.5229 11.5476 98.2823 11.7183L98.2938 11.7525ZM78.2815 3.80724C78.2243 3.94383 78.167 4.13734 78.1326 4.23979C77.9952 4.70648 77.8921 5.18456 77.8004 5.65126C77.5255 6.99444 77.3308 8.36039 77.136 9.72633C77.0329 10.4548 76.9413 11.172 76.8496 11.9005C77.9952 12.0029 79.1178 12.1167 80.2404 12.242C80.3664 11.5021 80.4809 10.7736 80.5955 10.0337C80.7788 8.87262 80.9391 7.71156 81.0652 6.53913C81.111 6.07243 81.1568 5.59435 81.1797 5.11627C81.1912 4.8317 81.2026 4.54712 81.1797 4.26255C81.0881 4.20564 80.9277 4.14872 80.8704 4.12596C80.5268 4.00075 80.1602 3.93245 79.8051 3.87553C79.4385 3.81862 79.0605 3.78447 78.6825 3.78447C78.5794 3.78447 78.4075 3.78447 78.2815 3.79585V3.80724ZM86.976 13.3006C87.3655 10.8077 87.7092 8.30347 87.9612 5.79924C87.9612 5.75371 87.9612 5.71956 87.9497 5.67403C87.8123 5.29839 86.976 5.01382 86.6324 4.92276C86.2544 4.82031 85.8534 4.75202 85.464 4.72925C85.3609 4.72925 85.2119 4.71787 85.0859 4.72925C85.0516 4.84308 85.0287 4.95691 85.0057 5.05935C84.9026 5.48052 84.8225 5.91307 84.7423 6.33424C84.5246 7.54082 84.3413 8.74741 84.1695 9.95399C84.0321 10.876 83.906 11.8094 83.7686 12.7428C84.8568 12.9135 85.9336 13.107 86.976 13.3119V13.3006ZM72.6341 11.6273C72.6914 10.5914 72.7258 9.55559 72.7487 8.50837C72.7601 7.93922 72.7716 7.38146 72.7601 6.81232C72.7601 6.4253 72.7601 6.03828 72.7258 5.65126C72.6914 5.08212 72.6227 4.4333 72.3248 3.93245C72.027 3.4316 71.0877 3.44298 70.6065 3.5682C69.9307 3.73894 69.3236 4.19425 69.3579 4.94552C69.3923 5.85615 69.4037 6.7554 69.3808 7.66603C69.3579 8.63358 69.3121 9.58974 69.3007 10.5573V11.5134C70.4118 11.5248 71.5344 11.559 72.6341 11.6159V11.6273ZM68.1895 11.5248L67.9489 10.7622C67.8 10.2727 67.6626 9.77186 67.5365 9.27102C67.3876 8.67911 67.2273 8.09858 67.0669 7.50667C66.8836 6.84647 66.7003 6.19764 66.4712 5.54882C66.3108 5.10488 66.1161 4.60404 65.8526 4.21702C65.4632 3.64788 64.5353 3.57958 63.9167 3.63649C63.3898 3.69341 62.6681 3.87553 62.2557 4.25117C62.187 4.365 62.0953 4.77478 62.0724 4.91138C61.9579 5.51467 61.912 6.14073 61.8777 6.7554C61.7746 8.39454 61.786 10.0451 61.8204 11.6956C63.7907 11.5817 65.7839 11.5248 67.8229 11.5248C67.9489 11.5248 68.0635 11.5248 68.1895 11.5248ZM57.8798 11.9915C57.834 11.5362 57.7767 11.0923 57.6965 10.6711C57.3758 8.87262 56.6541 6.6871 55.3482 5.35531C53.9965 3.9666 49.8039 4.34223 48.6813 5.90169C47.4212 7.65465 47.2265 10.6028 47.3868 12.6859C47.4097 12.9705 47.4441 13.255 47.4785 13.5396C48.5094 13.3233 49.5519 13.1298 50.6172 12.9477C50.5256 12.1395 50.4912 11.3199 50.5599 10.5231C50.6057 9.86293 50.7547 9.15719 51.0639 8.57666C51.3389 8.06443 51.7856 7.59774 52.4042 7.5522C52.6104 7.54082 52.8166 7.57497 53.0113 7.65465C53.7674 7.97337 54.1798 8.96368 54.386 9.69218C54.6265 10.5231 54.7525 11.4338 54.8213 12.3216C55.8293 12.1964 56.8488 12.0826 57.8798 11.9801V11.9915ZM33.3198 9.77187C33.3198 9.82878 33.3313 9.88569 33.3427 9.94261C33.3656 10.1134 33.3886 10.2955 33.4229 10.4662C33.5146 11.0354 33.6062 11.6045 33.7093 12.1623C34.0071 13.79 34.3393 15.4178 34.7288 17.0341C34.7632 17.1594 34.7861 17.2732 34.8205 17.3984C37.1573 16.4195 39.7004 15.543 42.4267 14.7803C43.1713 14.1315 43.7899 13.3347 43.9503 12.3444C44.2825 10.2841 42.5413 7.71156 40.5022 7.23348C39.4598 6.98306 38.2456 7.06274 37.2031 7.26763C36.1722 7.47252 35.0496 7.85954 34.1904 8.46283C33.7437 8.78155 33.4115 9.23687 33.3313 9.78325L33.3198 9.77187ZM37.6957 14.4388C37.4208 13.3006 37.1573 12.1509 36.8824 11.0126L36.7449 10.4321L37.3062 10.2158C37.5812 10.1134 37.8561 9.99952 38.1425 9.93122C38.6923 9.79463 39.2994 9.76048 39.7691 10.1361C40.2617 10.5345 40.5939 11.0695 40.6855 11.6956C40.8803 13.0843 39.8722 14.3705 38.635 14.9055L37.879 15.2356L37.6957 14.4388Z' fill='url(%23paint69_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M48.3264 11.4222C48.7159 10.2498 49.3803 8.04151 50.2051 6.45929C50.4227 6.04951 50.7664 5.54866 50.984 5.13888C51.0184 5.07058 51.0184 4.94537 50.9496 4.91122C50.6174 4.69495 49.2543 5.50313 48.945 5.856C47.9255 6.99429 47.5589 9.63511 47.7193 11.1604C47.8224 12.1166 47.9598 12.5605 48.3379 11.4336L48.3264 11.4222Z' fill='url(%23paint70_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M91.9934 10.534C91.7528 11.1714 91.7528 11.8885 91.9934 12.0137C92.1538 12.1048 92.4287 11.843 92.864 11.2625C94.0095 9.74853 94.9374 8.98588 96.6442 8.06387C97.0566 7.83621 97.5148 7.72238 97.9272 7.49473C97.9959 7.46058 98.0647 7.35813 98.0303 7.28983C97.9845 7.18739 97.8585 7.11909 97.7554 7.09632C95.2009 6.67516 92.864 8.21185 91.9934 10.5453V10.534Z' fill='url(%23paint71_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M62.4392 4.36438C62.3361 4.48959 62.2673 4.64895 62.2444 4.81969C61.9695 6.42468 61.9351 8.21179 61.9695 9.85092C61.9695 10.4314 62.2559 10.6933 62.4162 10.0217C62.7828 8.39391 62.8974 6.73201 63.3785 5.09288C63.5389 4.55788 63.8023 4.38714 63.9742 4.17087C64.1116 4.01151 64.0429 3.80661 63.7909 3.82938C63.4129 3.86353 62.7026 4.06842 62.4506 4.37576L62.4392 4.36438Z' fill='url(%23paint72_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M69.8391 4.17053C69.736 4.29574 69.6673 4.4551 69.6443 4.62584C69.5298 5.26328 69.5871 5.93487 69.5871 6.60646C69.5871 7.61954 69.5642 8.644 69.5871 9.64569C69.5871 10.2262 69.8735 10.488 70.0338 9.81644C70.4004 8.18868 70.2973 6.53817 70.7784 4.89903C70.9388 4.36404 71.2023 4.19329 71.3741 3.97702C71.5115 3.81766 71.4428 3.61277 71.1908 3.63553C70.8128 3.66968 70.1026 3.87457 69.8505 4.18191L69.8391 4.17053Z' fill='url(%23paint73_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M78.545 4.05725C78.4305 4.14832 78.3503 4.28491 78.293 4.44427C77.8234 5.95819 77.5828 7.72254 77.3995 9.38444C77.3423 9.96497 77.5714 10.3292 77.8005 9.70316C78.3503 8.20062 78.6711 6.58425 79.3355 5.11586C79.5531 4.63778 79.828 4.5581 80.0228 4.41012C80.1717 4.29629 80.1373 4.06864 79.8968 4.00034C79.5302 3.90928 78.82 3.86375 78.545 4.06864V4.05725Z' fill='url(%23paint74_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M85.4185 5.03667C85.2925 5.11635 85.2238 5.26432 85.1665 5.42368C84.6968 6.93761 84.5594 8.77025 84.3761 10.4208C84.3188 11.0013 84.5479 11.3655 84.777 10.7395C85.3269 9.23695 85.556 7.56367 86.2089 6.08389C86.3922 5.67411 86.6671 5.66272 86.8962 5.56028C87.0681 5.49198 87.1024 5.26432 86.8848 5.12773C86.564 4.9456 85.7736 4.80901 85.4071 5.02528L85.4185 5.03667Z' fill='url(%23paint75_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M33.595 9.39549C33.5377 9.54346 33.4919 9.71421 33.5148 9.88495C33.6294 11.5127 34.0303 13.2429 34.4541 14.8365C34.6031 15.3943 34.9353 15.5764 34.9238 14.8934C34.8894 13.2315 34.6031 11.581 34.6718 9.87357C34.6947 9.31581 34.8322 8.86049 34.9467 8.61007C35.0384 8.42794 34.9238 8.23443 34.6832 8.3255C34.3281 8.45071 33.8126 8.83773 33.5835 9.39549H33.595Z' fill='url(%23paint76_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M38.8068 10.2039C38.8068 12.7081 36.7563 14.7456 34.2362 14.7456C31.716 14.7456 29.6655 12.7081 29.6655 10.2039C29.6655 7.69965 31.716 5.66211 34.2362 5.66211C36.7563 5.66211 38.8068 7.69965 38.8068 10.2039Z' fill='url(%23paint77_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M53.6644 5.95862C53.6644 7.96201 52.0378 9.57838 50.0217 9.57838C48.0055 9.57838 46.3789 7.96201 46.3789 5.95862C46.3789 3.95524 48.0055 2.33887 50.0217 2.33887C52.0378 2.33887 53.6644 3.95524 53.6644 5.95862Z' fill='url(%23paint78_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' d='M63.0004 7.63223C64.62 7.63223 65.9329 6.32758 65.9329 4.71822C65.9329 3.10885 64.62 1.8042 63.0004 1.8042C61.3808 1.8042 60.0679 3.10885 60.0679 4.71822C60.0679 6.32758 61.3808 7.63223 63.0004 7.63223Z' fill='url(%23paint79_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M88.6488 5.66255C88.6488 7.27892 87.3314 8.57657 85.7162 8.57657C84.101 8.57657 82.7837 7.26754 82.7837 5.66255C82.7837 4.05757 84.101 2.74854 85.7162 2.74854C87.3314 2.74854 88.6488 4.05757 88.6488 5.66255Z' fill='url(%23paint80_radial_4318_875)'/%3e%3cpath style='mix-blend-mode:screen' fill-rule='evenodd' clip-rule='evenodd' d='M99.4279 8.0184C99.4279 10.2836 97.5721 12.1276 95.2926 12.1276C93.013 12.1276 91.1572 10.2836 91.1572 8.0184C91.1572 5.75321 93.013 3.90918 95.2926 3.90918C97.5721 3.90918 99.4279 5.75321 99.4279 8.0184Z' fill='url(%23paint81_radial_4318_875)'/%3e%3cdefs%3e%3cradialGradient id='paint0_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(68 56.4483) rotate(90) scale(10.7586 56.2759)'%3e%3cstop stop-color='%2313317C' stop-opacity='0.68849'/%3e%3cstop offset='0.26875' stop-color='%2313317C' stop-opacity='0.230931'/%3e%3cstop offset='0.544792' stop-color='%2313317C' stop-opacity='0.120518'/%3e%3cstop offset='1' stop-color='%2313317C' stop-opacity='0'/%3e%3c/radialGradient%3e%3cradialGradient id='paint1_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(65.268 40.3631) scale(18.0185 15.7503)'%3e%3cstop stop-color='%23E6007E'/%3e%3cstop offset='0.07' stop-color='%23CD0070'/%3e%3cstop offset='0.26' stop-color='%238F004E'/%3e%3cstop offset='0.44' stop-color='%235C0032'/%3e%3cstop offset='0.61' stop-color='%2334001C'/%3e%3cstop offset='0.77' stop-color='%2317000C'/%3e%3cstop offset='0.9' stop-color='%23060003'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint2_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(46.5635 39.4734) scale(28.8241 25.1958)'%3e%3cstop stop-color='%23FF78D2'/%3e%3cstop offset='1' stop-color='%23FC51A7'/%3e%3c/radialGradient%3e%3cradialGradient id='paint3_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(55.1076 31.0245) scale(48.2743 42.1975)'%3e%3cstop stop-color='%23F74FA9'/%3e%3cstop offset='1' stop-color='%23940066'/%3e%3c/radialGradient%3e%3cradialGradient id='paint4_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(47.8674 37.5358) scale(48.5752 42.4606)'%3e%3cstop stop-color='white'/%3e%3cstop offset='1' stop-color='%23FFBAF6'/%3e%3c/radialGradient%3e%3cradialGradient id='paint5_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(68.1653 43.0606) scale(23.2891 20.3575)'%3e%3cstop stop-color='white'/%3e%3cstop offset='1' stop-color='%23FFBAF6'/%3e%3c/radialGradient%3e%3cradialGradient id='paint6_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(59.9405 46.2243) scale(17.2434 15.0728)'%3e%3cstop offset='0.54' stop-color='white'/%3e%3cstop offset='0.58' stop-color='%23F9F4FA'/%3e%3cstop offset='0.66' stop-color='%23E9D9EE'/%3e%3cstop offset='0.76' stop-color='%23D0ADDA'/%3e%3cstop offset='0.87' stop-color='%23AD6FBF'/%3e%3cstop offset='1' stop-color='%2382239D'/%3e%3c/radialGradient%3e%3cradialGradient id='paint7_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(64.7461 37.13) scale(35.116 30.6956)'%3e%3cstop offset='0.54' stop-color='white'/%3e%3cstop offset='0.58' stop-color='%23F9F4FA'/%3e%3cstop offset='0.66' stop-color='%23E9D9EE'/%3e%3cstop offset='0.76' stop-color='%23D0ADDA'/%3e%3cstop offset='0.87' stop-color='%23AD6FBF'/%3e%3cstop offset='1' stop-color='%2382239D'/%3e%3c/radialGradient%3e%3cradialGradient id='paint8_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(42.8066 56.6666) scale(27.2284 23.8009)'%3e%3cstop offset='0.54' stop-color='white'/%3e%3cstop offset='0.58' stop-color='%23F9F4F7'/%3e%3cstop offset='0.66' stop-color='%23EAD9E3'/%3e%3cstop offset='0.75' stop-color='%23D1ADC3'/%3e%3cstop offset='0.87' stop-color='%23AE6F96'/%3e%3cstop offset='1' stop-color='%2382205C'/%3e%3c/radialGradient%3e%3cradialGradient id='paint9_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(77.7493 55.0884) scale(23.2982 20.3654)'%3e%3cstop offset='0.54' stop-color='white'/%3e%3cstop offset='0.58' stop-color='%23F9F4F7'/%3e%3cstop offset='0.66' stop-color='%23EAD9E3'/%3e%3cstop offset='0.75' stop-color='%23D1ADC3'/%3e%3cstop offset='0.87' stop-color='%23AE6F96'/%3e%3cstop offset='1' stop-color='%2382205C'/%3e%3c/radialGradient%3e%3cradialGradient id='paint10_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(57.0682 47.7699) scale(36.4838 31.8912)'%3e%3cstop stop-color='%23940066'/%3e%3cstop offset='1' stop-color='%23F74FA9'/%3e%3c/radialGradient%3e%3cradialGradient id='paint11_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(76.2906 45.2197) scale(25.8241 22.5734)'%3e%3cstop stop-color='%23FC51A7'/%3e%3cstop offset='1' stop-color='%23FF78D2'/%3e%3c/radialGradient%3e%3cradialGradient id='paint12_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(67.3539 50.8873) scale(49.6785 43.425)'%3e%3cstop stop-color='%23FFE906'/%3e%3cstop offset='0.09' stop-color='%23D6C405'/%3e%3cstop offset='0.22' stop-color='%239E9003'/%3e%3cstop offset='0.35' stop-color='%236E6402'/%3e%3cstop offset='0.49' stop-color='%23464001'/%3e%3cstop offset='0.62' stop-color='%23272400'/%3e%3cstop offset='0.74' stop-color='%23111000'/%3e%3cstop offset='0.86' stop-color='%23040400'/%3e%3cstop offset='0.97'/%3e%3c/radialGradient%3e%3cradialGradient id='paint13_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(66.6883 41.7129) scale(39.648 34.6571)'%3e%3cstop stop-color='%23FFE906'/%3e%3cstop offset='0.03' stop-color='%23F1DC05'/%3e%3cstop offset='0.18' stop-color='%23B2A304'/%3e%3cstop offset='0.34' stop-color='%237C7102'/%3e%3cstop offset='0.48' stop-color='%234F4801'/%3e%3cstop offset='0.62' stop-color='%232C2901'/%3e%3cstop offset='0.75' stop-color='%23141200'/%3e%3cstop offset='0.88' stop-color='%23050400'/%3e%3cstop offset='0.97'/%3e%3c/radialGradient%3e%3cradialGradient id='paint14_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(67.085 40.3555) scale(19.2678 16.8423)'%3e%3cstop stop-color='%23FFED00'/%3e%3cstop offset='0.13' stop-color='%23CDBE00'/%3e%3cstop offset='0.31' stop-color='%238F8500'/%3e%3cstop offset='0.48' stop-color='%235C5500'/%3e%3cstop offset='0.64' stop-color='%23343000'/%3e%3cstop offset='0.78' stop-color='%23171500'/%3e%3cstop offset='0.91' stop-color='%23060500'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3clinearGradient id='paint15_linear_4318_875' x1='49.299' y1='53.9162' x2='49.299' y2='10.3637' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE906'/%3e%3cstop offset='0.04' stop-color='%23ECD805'/%3e%3cstop offset='0.19' stop-color='%23AE9F04'/%3e%3cstop offset='0.34' stop-color='%23796F02'/%3e%3cstop offset='0.48' stop-color='%234D4701'/%3e%3cstop offset='0.62' stop-color='%232B2801'/%3e%3cstop offset='0.75' stop-color='%23131200'/%3e%3cstop offset='0.87' stop-color='%23050400'/%3e%3cstop offset='0.97'/%3e%3c/linearGradient%3e%3clinearGradient id='paint16_linear_4318_875' x1='76.3994' y1='54.6894' x2='76.3994' y2='10.4195' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE906'/%3e%3cstop offset='0.03' stop-color='%23F1DC05'/%3e%3cstop offset='0.18' stop-color='%23B2A304'/%3e%3cstop offset='0.34' stop-color='%237C7102'/%3e%3cstop offset='0.48' stop-color='%234F4801'/%3e%3cstop offset='0.62' stop-color='%232C2901'/%3e%3cstop offset='0.75' stop-color='%23141200'/%3e%3cstop offset='0.88' stop-color='%23050400'/%3e%3cstop offset='0.97'/%3e%3c/linearGradient%3e%3clinearGradient id='paint17_linear_4318_875' x1='61.0344' y1='56.9611' x2='61.0344' y2='10.5869' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE906'/%3e%3cstop offset='0.07' stop-color='%23CFBD04'/%3e%3cstop offset='0.16' stop-color='%239F9103'/%3e%3cstop offset='0.25' stop-color='%23746A02'/%3e%3cstop offset='0.35' stop-color='%23504901'/%3e%3cstop offset='0.45' stop-color='%23332E01'/%3e%3cstop offset='0.56' stop-color='%231C1A00'/%3e%3cstop offset='0.67' stop-color='%230C0B00'/%3e%3cstop offset='0.8' stop-color='%23020200'/%3e%3cstop offset='0.97'/%3e%3c/linearGradient%3e%3clinearGradient id='paint18_linear_4318_875' x1='86.6948' y1='52.346' x2='86.6948' y2='10.2521' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE906'/%3e%3cstop offset='0.09' stop-color='%23D6C405'/%3e%3cstop offset='0.22' stop-color='%239E9003'/%3e%3cstop offset='0.35' stop-color='%236E6402'/%3e%3cstop offset='0.49' stop-color='%23464001'/%3e%3cstop offset='0.62' stop-color='%23272400'/%3e%3cstop offset='0.74' stop-color='%23111000'/%3e%3cstop offset='0.86' stop-color='%23040400'/%3e%3cstop offset='0.97'/%3e%3c/linearGradient%3e%3clinearGradient id='paint19_linear_4318_875' x1='90.4699' y1='47.1496' x2='90.4699' y2='19.5945' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE906'/%3e%3cstop offset='0.09' stop-color='%23D6C405'/%3e%3cstop offset='0.22' stop-color='%239E9003'/%3e%3cstop offset='0.35' stop-color='%236E6402'/%3e%3cstop offset='0.49' stop-color='%23464001'/%3e%3cstop offset='0.62' stop-color='%23272400'/%3e%3cstop offset='0.74' stop-color='%23111000'/%3e%3cstop offset='0.86' stop-color='%23040400'/%3e%3cstop offset='0.97'/%3e%3c/linearGradient%3e%3clinearGradient id='paint20_linear_4318_875' x1='43.7821' y1='45.38' x2='43.7821' y2='17.0995' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFE906'/%3e%3cstop offset='0.09' stop-color='%23D6C405'/%3e%3cstop offset='0.22' stop-color='%239E9003'/%3e%3cstop offset='0.35' stop-color='%236E6402'/%3e%3cstop offset='0.49' stop-color='%23464001'/%3e%3cstop offset='0.62' stop-color='%23272400'/%3e%3cstop offset='0.74' stop-color='%23111000'/%3e%3cstop offset='0.86' stop-color='%23040400'/%3e%3cstop offset='0.97'/%3e%3c/linearGradient%3e%3cradialGradient id='paint21_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(54.2466 28.2653) rotate(-8.19011) scale(3.77245 20.1749)'%3e%3cstop stop-color='%23FFCC00'/%3e%3cstop offset='0.08' stop-color='%23D9AD00'/%3e%3cstop offset='0.22' stop-color='%23A08000'/%3e%3cstop offset='0.36' stop-color='%236F5900'/%3e%3cstop offset='0.5' stop-color='%23473900'/%3e%3cstop offset='0.63' stop-color='%23282000'/%3e%3cstop offset='0.76' stop-color='%23110E00'/%3e%3cstop offset='0.89' stop-color='%23040300'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint22_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(80.1034 34.3325) rotate(8.19011) scale(3.24067 19.0412)'%3e%3cstop stop-color='%23FFCC00'/%3e%3cstop offset='0.08' stop-color='%23D9AD00'/%3e%3cstop offset='0.22' stop-color='%23A08000'/%3e%3cstop offset='0.36' stop-color='%236F5900'/%3e%3cstop offset='0.5' stop-color='%23473900'/%3e%3cstop offset='0.63' stop-color='%23282000'/%3e%3cstop offset='0.76' stop-color='%23110E00'/%3e%3cstop offset='0.89' stop-color='%23040300'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint23_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(49.8976 33.1073) rotate(-14.4453) scale(2.24905 17.6326)'%3e%3cstop stop-color='%23FFCC00'/%3e%3cstop offset='0.08' stop-color='%23D9AD00'/%3e%3cstop offset='0.22' stop-color='%23A08000'/%3e%3cstop offset='0.36' stop-color='%236F5900'/%3e%3cstop offset='0.5' stop-color='%23473900'/%3e%3cstop offset='0.63' stop-color='%23282000'/%3e%3cstop offset='0.76' stop-color='%23110E00'/%3e%3cstop offset='0.89' stop-color='%23040300'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint24_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(74.6701 36.5011) rotate(5.17037) scale(2.26771 18.6799)'%3e%3cstop stop-color='%23FFCC00'/%3e%3cstop offset='0.08' stop-color='%23D9AD00'/%3e%3cstop offset='0.22' stop-color='%23A08000'/%3e%3cstop offset='0.36' stop-color='%236F5900'/%3e%3cstop offset='0.5' stop-color='%23473900'/%3e%3cstop offset='0.63' stop-color='%23282000'/%3e%3cstop offset='0.76' stop-color='%23110E00'/%3e%3cstop offset='0.89' stop-color='%23040300'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint25_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(61.9057 39.5629) rotate(53.1494) scale(1.28315 1.34338)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint26_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(68.4979 38.5995) rotate(53.1494) scale(0.974862 1.02062)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint27_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(59.6489 26.4282) rotate(53.1494) scale(0.799887 0.83743)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint28_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(72.1022 30.3316) rotate(53.1494) scale(0.974862 1.02062)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint29_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(66.7947 26.0418) rotate(53.1494) scale(0.941534 0.985725)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint30_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(65.4996 34.9037) rotate(53.1494) scale(2.27468 2.38144)'%3e%3cstop offset='0.03' stop-color='%23FF4A84'/%3e%3cstop offset='0.16' stop-color='%23FB4782'/%3e%3cstop offset='0.28' stop-color='%23F13F7C'/%3e%3cstop offset='0.38' stop-color='%23DF3373'/%3e%3cstop offset='0.48' stop-color='%23C62165'/%3e%3cstop offset='0.58' stop-color='%23A60A54'/%3e%3cstop offset='0.62' stop-color='%2399004D'/%3e%3cstop offset='0.64' stop-color='%238A0045'/%3e%3cstop offset='0.71' stop-color='%2359002D'/%3e%3cstop offset='0.78' stop-color='%23320019'/%3e%3cstop offset='0.85' stop-color='%2316000B'/%3e%3cstop offset='0.91' stop-color='%23050003'/%3e%3cstop offset='0.95'/%3e%3c/radialGradient%3e%3cradialGradient id='paint31_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(72.5525 34.1606) rotate(53.1494) scale(1.6831 1.76209)'%3e%3cstop offset='0.03' stop-color='%23FF4A84'/%3e%3cstop offset='0.16' stop-color='%23FB4782'/%3e%3cstop offset='0.28' stop-color='%23F13F7C'/%3e%3cstop offset='0.38' stop-color='%23DF3373'/%3e%3cstop offset='0.48' stop-color='%23C62165'/%3e%3cstop offset='0.58' stop-color='%23A60A54'/%3e%3cstop offset='0.62' stop-color='%2399004D'/%3e%3cstop offset='0.64' stop-color='%238A0045'/%3e%3cstop offset='0.71' stop-color='%2359002D'/%3e%3cstop offset='0.78' stop-color='%23320019'/%3e%3cstop offset='0.85' stop-color='%2316000B'/%3e%3cstop offset='0.91' stop-color='%23050003'/%3e%3cstop offset='0.95'/%3e%3c/radialGradient%3e%3cradialGradient id='paint32_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(76.9877 26.8561) rotate(53.1494) scale(1.2165 1.27359)'%3e%3cstop offset='0.03' stop-color='%23FF4A84'/%3e%3cstop offset='0.16' stop-color='%23FB4782'/%3e%3cstop offset='0.28' stop-color='%23F13F7C'/%3e%3cstop offset='0.38' stop-color='%23DF3373'/%3e%3cstop offset='0.48' stop-color='%23C62165'/%3e%3cstop offset='0.58' stop-color='%23A60A54'/%3e%3cstop offset='0.62' stop-color='%2399004D'/%3e%3cstop offset='0.64' stop-color='%238A0045'/%3e%3cstop offset='0.71' stop-color='%2359002D'/%3e%3cstop offset='0.78' stop-color='%23320019'/%3e%3cstop offset='0.85' stop-color='%2316000B'/%3e%3cstop offset='0.91' stop-color='%23050003'/%3e%3cstop offset='0.95'/%3e%3c/radialGradient%3e%3cradialGradient id='paint33_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(51.8031 34.1989) rotate(53.1494) scale(2.00805 2.1023)'%3e%3cstop offset='0.03' stop-color='%23FF4A84'/%3e%3cstop offset='0.16' stop-color='%23FB4782'/%3e%3cstop offset='0.28' stop-color='%23F13F7C'/%3e%3cstop offset='0.38' stop-color='%23DF3373'/%3e%3cstop offset='0.48' stop-color='%23C62165'/%3e%3cstop offset='0.58' stop-color='%23A60A54'/%3e%3cstop offset='0.62' stop-color='%2399004D'/%3e%3cstop offset='0.64' stop-color='%238A0045'/%3e%3cstop offset='0.71' stop-color='%2359002D'/%3e%3cstop offset='0.78' stop-color='%23320019'/%3e%3cstop offset='0.85' stop-color='%2316000B'/%3e%3cstop offset='0.91' stop-color='%23050003'/%3e%3cstop offset='0.95'/%3e%3c/radialGradient%3e%3cradialGradient id='paint34_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(76.8915 33.0645) rotate(-126.851) scale(1.24149 1.29976)'%3e%3cstop offset='0.03' stop-color='%23FF4A84'/%3e%3cstop offset='0.16' stop-color='%23FB4782'/%3e%3cstop offset='0.28' stop-color='%23F13F7C'/%3e%3cstop offset='0.38' stop-color='%23DF3373'/%3e%3cstop offset='0.48' stop-color='%23C62165'/%3e%3cstop offset='0.58' stop-color='%23A60A54'/%3e%3cstop offset='0.62' stop-color='%2399004D'/%3e%3cstop offset='0.64' stop-color='%238A0045'/%3e%3cstop offset='0.71' stop-color='%2359002D'/%3e%3cstop offset='0.78' stop-color='%23320019'/%3e%3cstop offset='0.85' stop-color='%2316000B'/%3e%3cstop offset='0.91' stop-color='%23050003'/%3e%3cstop offset='0.95'/%3e%3c/radialGradient%3e%3cradialGradient id='paint35_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(65.2162 33.2747) rotate(53.1494) scale(0.874877 0.91594)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint36_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(68.5026 30.9249) rotate(53.1494) scale(1.28315 1.34338)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint37_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(81.9563 36.0469) rotate(53.1494) scale(0.874876 0.915939)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint38_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(62.6458 29.4958) rotate(53.1494) scale(1.55811 1.63124)'%3e%3cstop offset='0.03' stop-color='%23FF9100'/%3e%3cstop offset='0.22' stop-color='%23FF8D00'/%3e%3cstop offset='0.38' stop-color='%23FF8300'/%3e%3cstop offset='0.53' stop-color='%23FF7100'/%3e%3cstop offset='0.67' stop-color='%23FF5800'/%3e%3cstop offset='0.8' stop-color='%239C2900'/%3e%3cstop offset='0.81' stop-color='%23611E00'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint39_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(67.453 38.6431) rotate(53.1494) scale(0.391612 0.409992)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint40_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(74.263 37.1271) rotate(53.1494) scale(0.391612 0.409992)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint41_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(76.9857 34.1333) rotate(-126.851) scale(0.54159 0.56701)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint42_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(67.9802 29.9671) rotate(53.1494) scale(0.391612 0.409992)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint43_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(65.094 23.0388) rotate(-126.851) scale(0.391612 0.409992)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint44_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(56.6221 31.6117) rotate(53.1494) scale(0.391611 0.409992)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint45_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(67.9922 18.7531) rotate(53.1494) scale(0.741562 0.776367)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint46_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(54.8177 27.6022) rotate(53.1494) scale(1.26649 1.32593)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint47_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(55.1785 28.7959) rotate(53.1494) scale(0.84988 0.88977)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint48_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(71.7474 24.3599) rotate(53.1494) scale(0.666572 0.697858)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint49_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(77.697 30.2908) rotate(53.1494) scale(0.449936 0.471054)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint50_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(53.4825 33.3708) rotate(53.1494) scale(1.22483 1.28231)'%3e%3cstop offset='0.03' stop-color='%23FF4A84'/%3e%3cstop offset='0.16' stop-color='%23FB4782'/%3e%3cstop offset='0.28' stop-color='%23F13F7C'/%3e%3cstop offset='0.38' stop-color='%23DF3373'/%3e%3cstop offset='0.48' stop-color='%23C62165'/%3e%3cstop offset='0.58' stop-color='%23A60A54'/%3e%3cstop offset='0.62' stop-color='%2399004D'/%3e%3cstop offset='0.64' stop-color='%238A0045'/%3e%3cstop offset='0.71' stop-color='%2359002D'/%3e%3cstop offset='0.78' stop-color='%23320019'/%3e%3cstop offset='0.85' stop-color='%2316000B'/%3e%3cstop offset='0.91' stop-color='%23050003'/%3e%3cstop offset='0.95'/%3e%3c/radialGradient%3e%3cradialGradient id='paint51_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(63.8541 29.537) rotate(53.1494) scale(0.65824 0.689135)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint52_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(71.1032 34.9914) rotate(53.1494) scale(0.77489 0.81126)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint53_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(69.683 28.5431) rotate(53.1494) scale(0.591583 0.61935)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint54_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(82.6323 35.4216) rotate(53.1494) scale(0.449936 0.471054)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint55_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(57.7049 32.4011) rotate(53.1494) scale(2.00805 2.1023)'%3e%3cstop offset='0.03' stop-color='%23FF4A84'/%3e%3cstop offset='0.16' stop-color='%23FB4782'/%3e%3cstop offset='0.28' stop-color='%23F13F7C'/%3e%3cstop offset='0.38' stop-color='%23DF3373'/%3e%3cstop offset='0.48' stop-color='%23C62165'/%3e%3cstop offset='0.58' stop-color='%23A60A54'/%3e%3cstop offset='0.62' stop-color='%2399004D'/%3e%3cstop offset='0.64' stop-color='%238A0045'/%3e%3cstop offset='0.71' stop-color='%2359002D'/%3e%3cstop offset='0.78' stop-color='%23320019'/%3e%3cstop offset='0.85' stop-color='%2316000B'/%3e%3cstop offset='0.91' stop-color='%23050003'/%3e%3cstop offset='0.95'/%3e%3c/radialGradient%3e%3cradialGradient id='paint56_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(58.531 30.8422) rotate(53.1494) scale(0.73323 0.767644)'%3e%3cstop offset='0.03' stop-color='%23FF7300'/%3e%3cstop offset='0.3' stop-color='%23FB6F00'/%3e%3cstop offset='0.52' stop-color='%23F16500'/%3e%3cstop offset='0.73' stop-color='%23E15300'/%3e%3cstop offset='0.8' stop-color='%23832D00'/%3e%3cstop offset='0.81' stop-color='%23612000'/%3e%3cstop offset='0.82' stop-color='%23591D00'/%3e%3cstop offset='0.83' stop-color='%23551C00'/%3e%3cstop offset='0.84' stop-color='%233B1300'/%3e%3cstop offset='0.85' stop-color='%23250C00'/%3e%3cstop offset='0.87' stop-color='%23140600'/%3e%3cstop offset='0.89' stop-color='%23080200'/%3e%3cstop offset='0.92' stop-color='%23010000'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3clinearGradient id='paint57_linear_4318_875' x1='54.1686' y1='56.7614' x2='54.1686' y2='40.7002' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23EBB6CA'/%3e%3cstop offset='1' stop-color='%236E1259'/%3e%3c/linearGradient%3e%3cradialGradient id='paint58_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(37.9646 27.3881) scale(41.2438 36.052)'%3e%3cstop stop-color='%23FF69CD'/%3e%3cstop offset='1' stop-color='%23ED288B'/%3e%3c/radialGradient%3e%3cradialGradient id='paint59_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(60.9069 28.8712) scale(17.7541 15.5192)'%3e%3cstop stop-color='%23FF78D2'/%3e%3cstop offset='1' stop-color='%23FC51A7'/%3e%3c/radialGradient%3e%3cradialGradient id='paint60_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(31.6726 31.4448) scale(41.0705 35.9006)'%3e%3cstop stop-color='%23F74FA9'/%3e%3cstop offset='1' stop-color='%23940066'/%3e%3c/radialGradient%3e%3cradialGradient id='paint61_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(44.2016 29.1901) scale(29.198 25.5226)'%3e%3cstop stop-color='white'/%3e%3cstop offset='1' stop-color='%23FFBAF6'/%3e%3c/radialGradient%3e%3cradialGradient id='paint62_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(24.3048 34.8643) scale(38.2984 33.4774)'%3e%3cstop stop-color='white'/%3e%3cstop offset='1' stop-color='%23FFBAF6'/%3e%3c/radialGradient%3e%3cradialGradient id='paint63_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(28.6728 37.5115) scale(31.9245 27.9058)'%3e%3cstop/%3e%3cstop offset='1' stop-color='%23FFD9E2'/%3e%3c/radialGradient%3e%3cradialGradient id='paint64_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(46.5543 44.3513) scale(34.8425 30.4565)'%3e%3cstop stop-color='%238A1F1F'/%3e%3cstop offset='1' stop-color='%234A2121'/%3e%3c/radialGradient%3e%3cradialGradient id='paint65_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(39.1456 21.4195) scale(11.7989 11.7244)'%3e%3cstop stop-color='%23FFA200'/%3e%3cstop offset='0.07' stop-color='%23E18F00'/%3e%3cstop offset='0.21' stop-color='%23A66900'/%3e%3cstop offset='0.36' stop-color='%23734900'/%3e%3cstop offset='0.5' stop-color='%234A2F00'/%3e%3cstop offset='0.64' stop-color='%23291A00'/%3e%3cstop offset='0.77' stop-color='%23120B00'/%3e%3cstop offset='0.89' stop-color='%23040300'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint66_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(99.0385 9.81738) scale(9.72548 9.66406)'%3e%3cstop stop-color='%23FFA200'/%3e%3cstop offset='0.07' stop-color='%23E18F00'/%3e%3cstop offset='0.21' stop-color='%23A66900'/%3e%3cstop offset='0.36' stop-color='%23734900'/%3e%3cstop offset='0.5' stop-color='%234A2F00'/%3e%3cstop offset='0.64' stop-color='%23291A00'/%3e%3cstop offset='0.77' stop-color='%23120B00'/%3e%3cstop offset='0.89' stop-color='%23040300'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint67_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(68.5677 97.0438) scale(96.4414 95.8325)'%3e%3cstop offset='0.78' stop-color='%23FCEA10'/%3e%3cstop offset='1' stop-color='%23FF6633'/%3e%3c/radialGradient%3e%3cradialGradient id='paint68_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(63.6762 124.556) scale(122.113 121.341)'%3e%3cstop offset='0.85' stop-color='%23FF3C00'/%3e%3cstop offset='1' stop-color='%23B5008E'/%3e%3c/radialGradient%3e%3cradialGradient id='paint69_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(65.7724 168.381) scale(165.975 164.927)'%3e%3cstop offset='0.91'/%3e%3cstop offset='0.92' stop-color='%23060003'/%3e%3cstop offset='0.93' stop-color='%2318030F'/%3e%3cstop offset='0.94' stop-color='%23360721'/%3e%3cstop offset='0.96' stop-color='%23600D3A'/%3e%3cstop offset='0.97' stop-color='%2395155B'/%3e%3cstop offset='0.99' stop-color='%23D51E82'/%3e%3cstop offset='1' stop-color='%23FF249C'/%3e%3c/radialGradient%3e%3cradialGradient id='paint70_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(46.9976 3.62496) scale(11.1917 11.1211)'%3e%3cstop stop-color='%23FFD621'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint71_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(94.6167 3.6587) scale(12.0738 11.9976)'%3e%3cstop stop-color='%23FFD621'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint72_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(61.3509 2.24716) scale(11.0772 11.0072)'%3e%3cstop stop-color='%23FFD621'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint73_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(69.484 2.8615) scale(9.17561 9.11769)'%3e%3cstop stop-color='%23FFD621'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint74_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(77.537 3.02141) scale(9.27873 9.22013)'%3e%3cstop stop-color='%23FFD621'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint75_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(85.2009 3.23817) scale(9.25581 9.19736)'%3e%3cstop stop-color='%23FFD621'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint76_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(32.5068 7.97263) scale(9.72548 9.66406)'%3e%3cstop stop-color='%23FFD621'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint77_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(34.2362 10.2039) scale(4.57063 4.54177)'%3e%3cstop stop-color='%23E94E1B'/%3e%3cstop offset='0.02' stop-color='%23E14B1A'/%3e%3cstop offset='0.17' stop-color='%23A63713'/%3e%3cstop offset='0.32' stop-color='%2373260D'/%3e%3cstop offset='0.47' stop-color='%234A1808'/%3e%3cstop offset='0.62' stop-color='%23290D04'/%3e%3cstop offset='0.76' stop-color='%23120602'/%3e%3cstop offset='0.89' stop-color='%23040100'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint78_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(50.0217 5.95862) scale(3.64276 3.61976)'%3e%3cstop stop-color='%23E94E1B'/%3e%3cstop offset='0.02' stop-color='%23E14B1A'/%3e%3cstop offset='0.17' stop-color='%23A63713'/%3e%3cstop offset='0.32' stop-color='%2373260D'/%3e%3cstop offset='0.47' stop-color='%234A1808'/%3e%3cstop offset='0.62' stop-color='%23290D04'/%3e%3cstop offset='0.76' stop-color='%23120602'/%3e%3cstop offset='0.89' stop-color='%23040100'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint79_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(63.0004 4.71822) scale(2.93253 2.91402)'%3e%3cstop stop-color='%23E94E1B'/%3e%3cstop offset='0.02' stop-color='%23E14B1A'/%3e%3cstop offset='0.17' stop-color='%23A63713'/%3e%3cstop offset='0.32' stop-color='%2373260D'/%3e%3cstop offset='0.47' stop-color='%234A1808'/%3e%3cstop offset='0.62' stop-color='%23290D04'/%3e%3cstop offset='0.76' stop-color='%23120602'/%3e%3cstop offset='0.89' stop-color='%23040100'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint80_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(85.7162 5.66255) scale(2.93253 2.91402)'%3e%3cstop stop-color='%23E94E1B'/%3e%3cstop offset='0.02' stop-color='%23E14B1A'/%3e%3cstop offset='0.17' stop-color='%23A63713'/%3e%3cstop offset='0.32' stop-color='%2373260D'/%3e%3cstop offset='0.47' stop-color='%234A1808'/%3e%3cstop offset='0.62' stop-color='%23290D04'/%3e%3cstop offset='0.76' stop-color='%23120602'/%3e%3cstop offset='0.89' stop-color='%23040100'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3cradialGradient id='paint81_radial_4318_875' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(95.2926 8.0184) scale(4.13533 4.10922)'%3e%3cstop stop-color='%23E94E1B'/%3e%3cstop offset='0.02' stop-color='%23E14B1A'/%3e%3cstop offset='0.17' stop-color='%23A63713'/%3e%3cstop offset='0.32' stop-color='%2373260D'/%3e%3cstop offset='0.47' stop-color='%234A1808'/%3e%3cstop offset='0.62' stop-color='%23290D04'/%3e%3cstop offset='0.76' stop-color='%23120602'/%3e%3cstop offset='0.89' stop-color='%23040100'/%3e%3cstop offset='1'/%3e%3c/radialGradient%3e%3c/defs%3e%3c/svg%3e";

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    const _postMessage = (message) => window.postMessage(message, window.location.href);
    const composeMessageHandler = (listeners) => {
        const handler = e => {
            Object.keys(listeners).map(key => {
                if (e.data && e.data.type == key) {
                    const _a = e.data, restData = __rest(_a, ["type"]);
                    listeners[key](restData);
                }
            });
        };
        return handler;
    };
    const onMountMessageLifeCycle = (messageRegisters) => {
        const messageHandler = composeMessageHandler(messageRegisters);
        onMount(() => {
            window.addEventListener('message', messageHandler);
            return () => {
                window.removeEventListener('message', messageHandler);
            };
        });
    };

    /* src/private.message.svelte generated by Svelte v3.48.0 */

    const { Object: Object_1$2 } = globals;
    const file$5 = "src/private.message.svelte";

    // (53:0) {#if isShown}
    function create_if_block$5(ctx) {
    	let div;
    	let t0;
    	let t1;
    	let t2;
    	let t3;
    	let div_style_value;
    	let if_block0 = (/*mode*/ ctx[0] === 'normal' || /*mode*/ ctx[0] === 'init-failed') && create_if_block_5$1(ctx);
    	let if_block1 = /*mode*/ ctx[0] === 'spin-failed' && create_if_block_4$1(ctx);
    	let if_block2 = /*mode*/ ctx[0] === 'show-next' && create_if_block_3$1(ctx);
    	let if_block3 = /*mode*/ ctx[0] === 'gift' && create_if_block_2$2(ctx);
    	let if_block4 = /*mode*/ ctx[0] !== 'init-failed' && create_if_block_1$4(ctx);

    	const block = {
    		c: function create() {
    			div = element("div");
    			if (if_block0) if_block0.c();
    			t0 = space();
    			if (if_block1) if_block1.c();
    			t1 = space();
    			if (if_block2) if_block2.c();
    			t2 = space();
    			if (if_block3) if_block3.c();
    			t3 = space();
    			if (if_block4) if_block4.c();
    			attr_dev(div, "class", "MessagePanel");

    			attr_dev(div, "style", div_style_value = [
    				// `margin-top: ${r + topOffset}px`,
    				`top: ${/*top*/ ctx[4]}px`,
    				`left: ${/*left*/ ctx[5]}px`,
    				`width: ${/*width*/ ctx[6]}px`,
    				/*isShown*/ ctx[2] ? 'opacity: 1' : ''
    			].join(';'));

    			add_location(div, file$5, 53, 0, 1510);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div, anchor);
    			if (if_block0) if_block0.m(div, null);
    			append_dev(div, t0);
    			if (if_block1) if_block1.m(div, null);
    			append_dev(div, t1);
    			if (if_block2) if_block2.m(div, null);
    			append_dev(div, t2);
    			if (if_block3) if_block3.m(div, null);
    			append_dev(div, t3);
    			if (if_block4) if_block4.m(div, null);
    			/*div_binding*/ ctx[12](div);
    		},
    		p: function update(ctx, dirty) {
    			if (/*mode*/ ctx[0] === 'normal' || /*mode*/ ctx[0] === 'init-failed') {
    				if (if_block0) {
    					if_block0.p(ctx, dirty);
    				} else {
    					if_block0 = create_if_block_5$1(ctx);
    					if_block0.c();
    					if_block0.m(div, t0);
    				}
    			} else if (if_block0) {
    				if_block0.d(1);
    				if_block0 = null;
    			}

    			if (/*mode*/ ctx[0] === 'spin-failed') {
    				if (if_block1) ; else {
    					if_block1 = create_if_block_4$1(ctx);
    					if_block1.c();
    					if_block1.m(div, t1);
    				}
    			} else if (if_block1) {
    				if_block1.d(1);
    				if_block1 = null;
    			}

    			if (/*mode*/ ctx[0] === 'show-next') {
    				if (if_block2) {
    					if_block2.p(ctx, dirty);
    				} else {
    					if_block2 = create_if_block_3$1(ctx);
    					if_block2.c();
    					if_block2.m(div, t2);
    				}
    			} else if (if_block2) {
    				if_block2.d(1);
    				if_block2 = null;
    			}

    			if (/*mode*/ ctx[0] === 'gift') {
    				if (if_block3) {
    					if_block3.p(ctx, dirty);
    				} else {
    					if_block3 = create_if_block_2$2(ctx);
    					if_block3.c();
    					if_block3.m(div, t3);
    				}
    			} else if (if_block3) {
    				if_block3.d(1);
    				if_block3 = null;
    			}

    			if (/*mode*/ ctx[0] !== 'init-failed') {
    				if (if_block4) {
    					if_block4.p(ctx, dirty);
    				} else {
    					if_block4 = create_if_block_1$4(ctx);
    					if_block4.c();
    					if_block4.m(div, null);
    				}
    			} else if (if_block4) {
    				if_block4.d(1);
    				if_block4 = null;
    			}

    			if (dirty & /*top, left, width, isShown*/ 116 && div_style_value !== (div_style_value = [
    				// `margin-top: ${r + topOffset}px`,
    				`top: ${/*top*/ ctx[4]}px`,
    				`left: ${/*left*/ ctx[5]}px`,
    				`width: ${/*width*/ ctx[6]}px`,
    				/*isShown*/ ctx[2] ? 'opacity: 1' : ''
    			].join(';'))) {
    				attr_dev(div, "style", div_style_value);
    			}
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div);
    			if (if_block0) if_block0.d();
    			if (if_block1) if_block1.d();
    			if (if_block2) if_block2.d();
    			if (if_block3) if_block3.d();
    			if (if_block4) if_block4.d();
    			/*div_binding*/ ctx[12](null);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block$5.name,
    		type: "if",
    		source: "(53:0) {#if isShown}",
    		ctx
    	});

    	return block;
    }

    // (66:2) {#if mode === 'normal' || mode === 'init-failed'}
    function create_if_block_5$1(ctx) {
    	let p;
    	let t;

    	const block = {
    		c: function create() {
    			p = element("p");
    			t = text(/*modeValue*/ ctx[3]);
    			add_location(p, file$5, 66, 2, 1785);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, p, anchor);
    			append_dev(p, t);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty & /*modeValue*/ 8) set_data_dev(t, /*modeValue*/ ctx[3]);
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(p);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_5$1.name,
    		type: "if",
    		source: "(66:2) {#if mode === 'normal' || mode === 'init-failed'}",
    		ctx
    	});

    	return block;
    }

    // (70:2) {#if mode === 'spin-failed'}
    function create_if_block_4$1(ctx) {
    	let p0;
    	let t1;
    	let p1;
    	let t3;
    	let p2;
    	let t4;
    	let strong;
    	let t6;
    	let t7;
    	let p3;

    	const block = {
    		c: function create() {
    			p0 = element("p");
    			p0.textContent = "We are sorry that you";
    			t1 = space();
    			p1 = element("p");
    			p1.textContent = "don't have any Wheels available,";
    			t3 = space();
    			p2 = element("p");
    			t4 = text("please ");
    			strong = element("strong");
    			strong.textContent = "check T&C";
    			t6 = text(" here");
    			t7 = space();
    			p3 = element("p");
    			p3.textContent = "to get a chance!";
    			add_location(p0, file$5, 70, 2, 1846);
    			add_location(p1, file$5, 71, 2, 1877);
    			add_location(strong, file$5, 72, 12, 1930);
    			add_location(p2, file$5, 72, 2, 1920);
    			add_location(p3, file$5, 73, 2, 1969);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, p0, anchor);
    			insert_dev(target, t1, anchor);
    			insert_dev(target, p1, anchor);
    			insert_dev(target, t3, anchor);
    			insert_dev(target, p2, anchor);
    			append_dev(p2, t4);
    			append_dev(p2, strong);
    			append_dev(p2, t6);
    			insert_dev(target, t7, anchor);
    			insert_dev(target, p3, anchor);
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(p0);
    			if (detaching) detach_dev(t1);
    			if (detaching) detach_dev(p1);
    			if (detaching) detach_dev(t3);
    			if (detaching) detach_dev(p2);
    			if (detaching) detach_dev(t7);
    			if (detaching) detach_dev(p3);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_4$1.name,
    		type: "if",
    		source: "(70:2) {#if mode === 'spin-failed'}",
    		ctx
    	});

    	return block;
    }

    // (77:2) {#if mode === 'show-next'}
    function create_if_block_3$1(ctx) {
    	let p0;
    	let t1;
    	let p1;
    	let strong;
    	let t2_value = /*getTimeString*/ ctx[8](/*modeValue*/ ctx[3]?.startTime) + "";
    	let t2;
    	let t3;
    	let p2;

    	const block = {
    		c: function create() {
    			p0 = element("p");
    			p0.textContent = "The Wheel will be available on";
    			t1 = space();
    			p1 = element("p");
    			strong = element("strong");
    			t2 = text(t2_value);
    			t3 = space();
    			p2 = element("p");
    			p2.textContent = "please wait till it is open";
    			add_location(p0, file$5, 77, 2, 2033);
    			add_location(strong, file$5, 79, 4, 2081);
    			add_location(p1, file$5, 78, 2, 2073);
    			add_location(p2, file$5, 83, 2, 2157);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, p0, anchor);
    			insert_dev(target, t1, anchor);
    			insert_dev(target, p1, anchor);
    			append_dev(p1, strong);
    			append_dev(strong, t2);
    			insert_dev(target, t3, anchor);
    			insert_dev(target, p2, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty & /*modeValue*/ 8 && t2_value !== (t2_value = /*getTimeString*/ ctx[8](/*modeValue*/ ctx[3]?.startTime) + "")) set_data_dev(t2, t2_value);
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(p0);
    			if (detaching) detach_dev(t1);
    			if (detaching) detach_dev(p1);
    			if (detaching) detach_dev(t3);
    			if (detaching) detach_dev(p2);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_3$1.name,
    		type: "if",
    		source: "(77:2) {#if mode === 'show-next'}",
    		ctx
    	});

    	return block;
    }

    // (87:2) {#if mode === 'gift'}
    function create_if_block_2$2(ctx) {
    	let p0;
    	let img;
    	let img_src_value;
    	let t0;
    	let p1;

    	const block = {
    		c: function create() {
    			p0 = element("p");
    			img = element("img");
    			t0 = space();
    			p1 = element("p");
    			p1.textContent = "Congratulations! You won a prize!";
    			if (!src_url_equal(img.src, img_src_value = img$e)) attr_dev(img, "src", img_src_value);
    			attr_dev(img, "alt", "");
    			add_location(img, file$5, 88, 4, 2235);
    			add_location(p0, file$5, 87, 2, 2227);
    			add_location(p1, file$5, 90, 2, 2271);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, p0, anchor);
    			append_dev(p0, img);
    			insert_dev(target, t0, anchor);
    			insert_dev(target, p1, anchor);
    		},
    		p: noop,
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(p0);
    			if (detaching) detach_dev(t0);
    			if (detaching) detach_dev(p1);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_2$2.name,
    		type: "if",
    		source: "(87:2) {#if mode === 'gift'}",
    		ctx
    	});

    	return block;
    }

    // (95:2) {#if mode !== 'init-failed'}
    function create_if_block_1$4(ctx) {
    	let div;
    	let button;
    	let mounted;
    	let dispose;

    	const block = {
    		c: function create() {
    			div = element("div");
    			button = element("button");
    			button.textContent = "OK";
    			attr_dev(button, "class", "MessagePanelButton");
    			add_location(button, file$5, 96, 4, 2394);
    			add_location(div, file$5, 95, 2, 2384);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div, anchor);
    			append_dev(div, button);

    			if (!mounted) {
    				dispose = listen_dev(button, "click", /*eventButton*/ ctx[7], false, false, false);
    				mounted = true;
    			}
    		},
    		p: noop,
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div);
    			mounted = false;
    			dispose();
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_1$4.name,
    		type: "if",
    		source: "(95:2) {#if mode !== 'init-failed'}",
    		ctx
    	});

    	return block;
    }

    function create_fragment$5(ctx) {
    	let if_block_anchor;
    	let if_block = /*isShown*/ ctx[2] && create_if_block$5(ctx);

    	const block = {
    		c: function create() {
    			if (if_block) if_block.c();
    			if_block_anchor = empty();
    			this.c = noop;
    		},
    		l: function claim(nodes) {
    			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
    		},
    		m: function mount(target, anchor) {
    			if (if_block) if_block.m(target, anchor);
    			insert_dev(target, if_block_anchor, anchor);
    		},
    		p: function update(ctx, [dirty]) {
    			if (/*isShown*/ ctx[2]) {
    				if (if_block) {
    					if_block.p(ctx, dirty);
    				} else {
    					if_block = create_if_block$5(ctx);
    					if_block.c();
    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
    				}
    			} else if (if_block) {
    				if_block.d(1);
    				if_block = null;
    			}
    		},
    		i: noop,
    		o: noop,
    		d: function destroy(detaching) {
    			if (if_block) if_block.d(detaching);
    			if (detaching) detach_dev(if_block_anchor);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_fragment$5.name,
    		type: "component",
    		source: "",
    		ctx
    	});

    	return block;
    }

    function instance$5($$self, $$props, $$invalidate) {
    	let width;
    	let left;
    	let top;
    	let { $$slots: slots = {}, $$scope } = $$props;
    	validate_slots('lottery-program-wof-private-message-panel', slots, []);
    	let { h = 0 } = $$props;
    	let { r = 0 } = $$props;
    	let { id = undefined } = $$props;
    	let topOffset = 0;
    	let renderValue = '';
    	let icon = '';
    	let isShown = false;
    	let mode = '';
    	let modeValue;
    	let root;

    	onMountMessageLifeCycle({
    		'wof-private-message-open': data => {
    			if (data.id !== id) return;
    			$$invalidate(0, mode = data.mode);
    			$$invalidate(3, modeValue = data.modeValue);
    			$$invalidate(2, isShown = true);
    		}
    	});

    	const _postMessageScoped = props => _postMessage(Object.assign(Object.assign({}, props), { id }));

    	const eventButton = () => {
    		$$invalidate(2, isShown = false);
    		_postMessageScoped({ type: 'wof-private-message-close' });
    	};

    	const getTimeString = _d => {
    		const d = new Date(_d);

    		return [
    			[
    				d.toLocaleString('en-us', { year: 'numeric' }),
    				d.toLocaleString('en-us', { month: '2-digit' }),
    				d.toLocaleString('en-us', { day: '2-digit' })
    			].join('-'),
    			d.toLocaleString('en-GB', {
    				hour: 'numeric',
    				minute: 'numeric',
    				second: 'numeric'
    			})
    		].join(' ');
    	};

    	const setTopOffset = () => {
    		setTimeout(
    			() => {
    				topOffset = root.offsetHeight / 2 * -1;
    			},
    			1
    		);
    	};

    	const writable_props = ['h', 'r', 'id'];

    	Object_1$2.keys($$props).forEach(key => {
    		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<lottery-program-wof-private-message-panel> was created with unknown prop '${key}'`);
    	});

    	function div_binding($$value) {
    		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
    			root = $$value;
    			$$invalidate(1, root);
    		});
    	}

    	$$self.$$set = $$props => {
    		if ('h' in $$props) $$invalidate(9, h = $$props.h);
    		if ('r' in $$props) $$invalidate(10, r = $$props.r);
    		if ('id' in $$props) $$invalidate(11, id = $$props.id);
    	};

    	$$self.$capture_state = () => ({
    		giftSvg: img$e,
    		onMountMessageLifeCycle,
    		_postMessage,
    		h,
    		r,
    		id,
    		topOffset,
    		renderValue,
    		icon,
    		isShown,
    		mode,
    		modeValue,
    		root,
    		_postMessageScoped,
    		eventButton,
    		getTimeString,
    		setTopOffset,
    		top,
    		left,
    		width
    	});

    	$$self.$inject_state = $$props => {
    		if ('h' in $$props) $$invalidate(9, h = $$props.h);
    		if ('r' in $$props) $$invalidate(10, r = $$props.r);
    		if ('id' in $$props) $$invalidate(11, id = $$props.id);
    		if ('topOffset' in $$props) topOffset = $$props.topOffset;
    		if ('renderValue' in $$props) renderValue = $$props.renderValue;
    		if ('icon' in $$props) icon = $$props.icon;
    		if ('isShown' in $$props) $$invalidate(2, isShown = $$props.isShown);
    		if ('mode' in $$props) $$invalidate(0, mode = $$props.mode);
    		if ('modeValue' in $$props) $$invalidate(3, modeValue = $$props.modeValue);
    		if ('root' in $$props) $$invalidate(1, root = $$props.root);
    		if ('top' in $$props) $$invalidate(4, top = $$props.top);
    		if ('left' in $$props) $$invalidate(5, left = $$props.left);
    		if ('width' in $$props) $$invalidate(6, width = $$props.width);
    	};

    	if ($$props && "$$inject" in $$props) {
    		$$self.$inject_state($$props.$$inject);
    	}

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty & /*mode*/ 1) {
    			mode && setTopOffset();
    		}

    		if ($$self.$$.dirty & /*r*/ 1024) {
    			$$invalidate(6, width = r * 2 + 5);
    		}

    		if ($$self.$$.dirty & /*r*/ 1024) {
    			$$invalidate(5, left = r / 2);
    		}

    		if ($$self.$$.dirty & /*h, root*/ 514) {
    			$$invalidate(4, top = h / 2 - (root === null || root === void 0
    			? void 0
    			: root.clientHeight) / 2);
    		}
    	};

    	return [
    		mode,
    		root,
    		isShown,
    		modeValue,
    		top,
    		left,
    		width,
    		eventButton,
    		getTimeString,
    		h,
    		r,
    		id,
    		div_binding
    	];
    }

    class Private_message extends SvelteElement {
    	constructor(options) {
    		super();
    		this.shadowRoot.innerHTML = `<style>:host{font-family:system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';position:absolute;width:100%}*,*::before,*::after{margin:0;padding:0;list-style:none;text-decoration:none;outline:none;box-sizing:border-box}.MessagePanel{position:absolute;background-color:#FFFFFF;padding:15px 30px;border-radius:8px;text-align:center;font-size:16px;opacity:.3;box-shadow:0 0 1px #a1a1a1;transition:margin-top opacity .3s ease-out}.MessagePanelButton{padding:4px 24px;margin-top:40px;font-size:16px;line-height:24px;color:#FFFFFF;background:#FF0000;border-radius:5px;font-weight:700;border:0;box-shadow:0 0 3px #ff0000;cursor:pointer}</style>`;

    		init(
    			this,
    			{
    				target: this.shadowRoot,
    				props: attribute_to_object(this.attributes),
    				customElement: true
    			},
    			instance$5,
    			create_fragment$5,
    			safe_not_equal,
    			{ h: 9, r: 10, id: 11 },
    			null
    		);

    		if (options) {
    			if (options.target) {
    				insert_dev(options.target, this, options.anchor);
    			}

    			if (options.props) {
    				this.$set(options.props);
    				flush();
    			}
    		}
    	}

    	static get observedAttributes() {
    		return ["h", "r", "id"];
    	}

    	get h() {
    		return this.$$.ctx[9];
    	}

    	set h(h) {
    		this.$$set({ h });
    		flush();
    	}

    	get r() {
    		return this.$$.ctx[10];
    	}

    	set r(r) {
    		this.$$set({ r });
    		flush();
    	}

    	get id() {
    		return this.$$.ctx[11];
    	}

    	set id(id) {
    		this.$$set({ id });
    		flush();
    	}
    }

    customElements.define("lottery-program-wof-private-message-panel", Private_message);

    var PointerMode;
    (function (PointerMode) {
        PointerMode["Arrow"] = "Arrow";
        PointerMode["Partition"] = "Partition";
    })(PointerMode || (PointerMode = {}));
    var ArrowMode;
    (function (ArrowMode) {
        ArrowMode["DownFromTop"] = "DownFromTop";
        ArrowMode["UpFromCenter"] = "UpFromCenter";
        ArrowMode["DownFromCenter"] = "DownFromCenter";
        ArrowMode["UpFromBottom"] = "UpFromBottom";
    })(ArrowMode || (ArrowMode = {}));
    var Api;
    (function (Api) {
        Api["lotteries"] = "lotteries";
        Api["outcome"] = "outcome";
        Api["draw"] = "draw";
    })(Api || (Api = {}));
    var Lang;
    (function (Lang) {
        Lang["en"] = "en";
        Lang["fr"] = "fr";
        Lang["de"] = "de";
        Lang["tr"] = "tr";
    })(Lang || (Lang = {}));
    var Tab;
    (function (Tab) {
        Tab["Program"] = "Program";
        Tab["History"] = "History";
    })(Tab || (Tab = {}));

    /* src/private.tabs.svelte generated by Svelte v3.48.0 */

    const { Object: Object_1$1 } = globals;
    const file$4 = "src/private.tabs.svelte";

    function get_each_context$3(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[2] = list[i];
    	return child_ctx;
    }

    function get_each_context_1$2(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[2] = list[i];
    	child_ctx[6] = i;
    	return child_ctx;
    }

    // (10:4) {#each Object.keys(Tab) as _tab, i}
    function create_each_block_1$2(ctx) {
    	let li;
    	let span;
    	let t0_value = /*_tab*/ ctx[2] + "";
    	let t0;
    	let t1;
    	let li_class_value;
    	let mounted;
    	let dispose;

    	function click_handler() {
    		return /*click_handler*/ ctx[1](/*_tab*/ ctx[2]);
    	}

    	const block = {
    		c: function create() {
    			li = element("li");
    			span = element("span");
    			t0 = text(t0_value);
    			t1 = space();
    			add_location(span, file$4, 11, 6, 321);
    			attr_dev(li, "class", li_class_value = /*_tab*/ ctx[2] === /*tab*/ ctx[0] ? 'active' : '');
    			add_location(li, file$4, 10, 4, 273);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, li, anchor);
    			append_dev(li, span);
    			append_dev(span, t0);
    			append_dev(li, t1);

    			if (!mounted) {
    				dispose = listen_dev(span, "click", click_handler, false, false, false);
    				mounted = true;
    			}
    		},
    		p: function update(new_ctx, dirty) {
    			ctx = new_ctx;

    			if (dirty & /*tab*/ 1 && li_class_value !== (li_class_value = /*_tab*/ ctx[2] === /*tab*/ ctx[0] ? 'active' : '')) {
    				attr_dev(li, "class", li_class_value);
    			}
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(li);
    			mounted = false;
    			dispose();
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block_1$2.name,
    		type: "each",
    		source: "(10:4) {#each Object.keys(Tab) as _tab, i}",
    		ctx
    	});

    	return block;
    }

    // (34:2) {#if tab === _tab}
    function create_if_block$4(ctx) {
    	let slot;

    	const block = {
    		c: function create() {
    			slot = element("slot");
    			attr_dev(slot, "name", `tab-${/*_tab*/ ctx[2]}`);
    			add_location(slot, file$4, 34, 4, 753);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, slot, anchor);
    		},
    		p: noop,
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(slot);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block$4.name,
    		type: "if",
    		source: "(34:2) {#if tab === _tab}",
    		ctx
    	});

    	return block;
    }

    // (33:0) {#each Object.keys(Tab) as _tab}
    function create_each_block$3(ctx) {
    	let if_block_anchor;
    	let if_block = /*tab*/ ctx[0] === /*_tab*/ ctx[2] && create_if_block$4(ctx);

    	const block = {
    		c: function create() {
    			if (if_block) if_block.c();
    			if_block_anchor = empty();
    		},
    		m: function mount(target, anchor) {
    			if (if_block) if_block.m(target, anchor);
    			insert_dev(target, if_block_anchor, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (/*tab*/ ctx[0] === /*_tab*/ ctx[2]) {
    				if (if_block) {
    					if_block.p(ctx, dirty);
    				} else {
    					if_block = create_if_block$4(ctx);
    					if_block.c();
    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
    				}
    			} else if (if_block) {
    				if_block.d(1);
    				if_block = null;
    			}
    		},
    		d: function destroy(detaching) {
    			if (if_block) if_block.d(detaching);
    			if (detaching) detach_dev(if_block_anchor);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block$3.name,
    		type: "each",
    		source: "(33:0) {#each Object.keys(Tab) as _tab}",
    		ctx
    	});

    	return block;
    }

    function create_fragment$4(ctx) {
    	let section;
    	let ul;
    	let t;
    	let each1_anchor;
    	let each_value_1 = Object.keys(Tab);
    	validate_each_argument(each_value_1);
    	let each_blocks_1 = [];

    	for (let i = 0; i < each_value_1.length; i += 1) {
    		each_blocks_1[i] = create_each_block_1$2(get_each_context_1$2(ctx, each_value_1, i));
    	}

    	let each_value = Object.keys(Tab);
    	validate_each_argument(each_value);
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block$3(get_each_context$3(ctx, each_value, i));
    	}

    	const block = {
    		c: function create() {
    			section = element("section");
    			ul = element("ul");

    			for (let i = 0; i < each_blocks_1.length; i += 1) {
    				each_blocks_1[i].c();
    			}

    			t = space();

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			each1_anchor = empty();
    			this.c = noop;
    			add_location(ul, file$4, 8, 2, 224);
    			attr_dev(section, "id", "TabBar");
    			attr_dev(section, "part", "TabBar");
    			add_location(section, file$4, 7, 0, 186);
    		},
    		l: function claim(nodes) {
    			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, section, anchor);
    			append_dev(section, ul);

    			for (let i = 0; i < each_blocks_1.length; i += 1) {
    				each_blocks_1[i].m(ul, null);
    			}

    			insert_dev(target, t, anchor);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].m(target, anchor);
    			}

    			insert_dev(target, each1_anchor, anchor);
    		},
    		p: function update(ctx, [dirty]) {
    			if (dirty & /*Object, Tab, tab, _postMessage*/ 1) {
    				each_value_1 = Object.keys(Tab);
    				validate_each_argument(each_value_1);
    				let i;

    				for (i = 0; i < each_value_1.length; i += 1) {
    					const child_ctx = get_each_context_1$2(ctx, each_value_1, i);

    					if (each_blocks_1[i]) {
    						each_blocks_1[i].p(child_ctx, dirty);
    					} else {
    						each_blocks_1[i] = create_each_block_1$2(child_ctx);
    						each_blocks_1[i].c();
    						each_blocks_1[i].m(ul, null);
    					}
    				}

    				for (; i < each_blocks_1.length; i += 1) {
    					each_blocks_1[i].d(1);
    				}

    				each_blocks_1.length = each_value_1.length;
    			}

    			if (dirty & /*Object, Tab, tab*/ 1) {
    				each_value = Object.keys(Tab);
    				validate_each_argument(each_value);
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context$3(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block$3(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(each1_anchor.parentNode, each1_anchor);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value.length;
    			}
    		},
    		i: noop,
    		o: noop,
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(section);
    			destroy_each(each_blocks_1, detaching);
    			if (detaching) detach_dev(t);
    			destroy_each(each_blocks, detaching);
    			if (detaching) detach_dev(each1_anchor);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_fragment$4.name,
    		type: "component",
    		source: "",
    		ctx
    	});

    	return block;
    }

    function instance$4($$self, $$props, $$invalidate) {
    	let { $$slots: slots = {}, $$scope } = $$props;
    	validate_slots('lottery-program-wof-private-tabs', slots, []);
    	let tab = Tab.Program;
    	const writable_props = [];

    	Object_1$1.keys($$props).forEach(key => {
    		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<lottery-program-wof-private-tabs> was created with unknown prop '${key}'`);
    	});

    	const click_handler = _tab => {
    		switch (_tab) {
    			case Tab.Program:
    				break;
    			case Tab.History:
    				_postMessage({ type: 'wof-private-message-outcomes' });
    				break;
    		}

    		//@ts-ignore
    		$$invalidate(0, tab = _tab);
    	};

    	$$self.$capture_state = () => ({ _postMessage, Tab, tab });

    	$$self.$inject_state = $$props => {
    		if ('tab' in $$props) $$invalidate(0, tab = $$props.tab);
    	};

    	if ($$props && "$$inject" in $$props) {
    		$$self.$inject_state($$props.$$inject);
    	}

    	return [tab, click_handler];
    }

    class Private_tabs extends SvelteElement {
    	constructor(options) {
    		super();
    		this.shadowRoot.innerHTML = `<style>:host{font-family:system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';width:100%}*,*::before,*::after{margin:0;padding:0;list-style:none;text-decoration:none;outline:none;box-sizing:border-box}#TabBar{width:100%;display:flex;align-items:center;flex-direction:column;padding:20px 0}#TabBar ul{max-width:600px;width:100%}#TabBar ul li{color:#FFFFFF;display:inline-block;margin-right:10px}#TabBar ul{border-bottom:3px #ccc solid}#TabBar ul li{padding:6px;cursor:pointer}#TabBar ul li.active{border-bottom:3px #d46666 solid;margin-bottom:-6px}</style>`;

    		init(
    			this,
    			{
    				target: this.shadowRoot,
    				props: attribute_to_object(this.attributes),
    				customElement: true
    			},
    			instance$4,
    			create_fragment$4,
    			safe_not_equal,
    			{},
    			null
    		);

    		if (options) {
    			if (options.target) {
    				insert_dev(options.target, this, options.anchor);
    			}
    		}
    	}
    }

    customElements.define("lottery-program-wof-private-tabs", Private_tabs);

    const convertArcToDeg = (arc) => arc * 180 / Math.PI % 360;
    const getArcDelta = (n) => 2 * Math.PI / n;
    const findDeg = (index, n) => {
        const degDelta = convertArcToDeg(getArcDelta(n));
        return (index) * degDelta;
    };
    const getArcLength = (radius, degrees) => {
        const circumference = 2 * Math.PI * radius;
        const arcLength = (degrees / 360) * circumference;
        return arcLength;
    };

    const classWithPart = (partAndClass, extraClass = '') => ({
        part: partAndClass,
        class: [partAndClass, extraClass].join(' '),
    });
    const imageLoaderSvg = (src) => {
        return new Promise((resolve, reject) => {
            let img = document.createElementNS("http://www.w3.org/2000/svg", "image");
            img.onload = () => resolve(img);
            img.onerror = () => resolve(img); //reject
            img.href.baseVal = src;
        });
    };
    const cvtCaseFromCamelToKebab = (text) => text
        .split(/(?=[A-Z])/)
        .map(s => s.toLocaleLowerCase())
        .join('-');
    const setProps = (element, props) => {
        Object.keys(props).map(_key => {
            element.setAttribute(cvtCaseFromCamelToKebab(_key), props[_key]);
        });
    };
    const mapObjectValueToTuple = (object) => Object.keys(object).map(key => object[key]);
    const fetcher = async (config) => {
        const { path, params, options } = config;
        const url = new URL(path);
        Object.keys(params).map(_key => {
            url.searchParams.append(_key, params[_key]);
        });
        let res;
        try {
            res = await fetch(url.toString(), options);
            res = await res.json();
        }
        catch (e) {
            console.log(e);
        }
        return res;
    };

    const fetcherApi = async (api, endpoint, config) => {
        const { session } = config;
        const options = {
            headers: Object.assign({ 'Content-Type': 'application/json', 'accept': 'text/plain' }, (session ? { 'x-SessionId': session } : {})),
        };
        const getArgs = {
            [Api.lotteries]: () => {
                return {
                    path: '/wof/lotteries',
                    params: {},
                    options,
                };
            },
            [Api.outcome]: () => {
                const { id } = config;
                return {
                    path: `/wof/outcome/${id}`,
                    params: {},
                    options,
                };
            },
            [Api.draw]: () => {
                const { id, guid } = config;
                return {
                    path: `/wof/draw/${id}`,
                    params: {},
                    options: Object.assign(Object.assign({}, options), { method: 'PUT', body: JSON.stringify({
                            guid
                        }) })
                };
            }
        };
        const args = getArgs[api]();
        args.path = endpoint + args.path;
        return await fetcher(args);
    };
    const getOptionsFromPartitions = (partitions, lang) => {
        let options = partitions.map((_partition, index) => {
            const partitionLang = {};
            Object.keys(_partition).map((_key) => {
                if (['name', 'image1', 'image2', 'image3'].includes(_key)) {
                    partitionLang[_key] = _partition[_key][lang === 'en' ? '*' : lang] || '';
                }
            });
            const option = {
                image: partitionLang['image1'],
                name: partitionLang['name']
            };
            return option;
        });
        let probabilityAll = 0;
        partitions.map(partition => probabilityAll += Number(partition.probability));
        if (probabilityAll < 1) {
            options.push({
                image: '',
                name: 'Thank you'
            });
        }
        return options;
    };
    const setMessage = (id, entry) => {
        const _postMessageScoped = (props) => _postMessage(Object.assign(Object.assign({}, props), { id }));
        switch (typeof entry) {
            case 'string':
                _postMessageScoped({ type: 'wof-private-message-open', mode: 'normal', modeValue: entry });
                break;
            case 'object':
                _postMessageScoped(Object.assign({ type: 'wof-private-message-open' }, entry));
                break;
        }
    };
    const getOptions = async (partitions, lang) => {
        const preloadImage = async (src) => {
            if (!src)
                return {};
            return {
                image: await imageLoaderSvg(src)
            };
        };
        const options = await Promise.all(getOptionsFromPartitions(partitions, lang).map(async (o) => (Object.assign(Object.assign({}, o), (await preloadImage(o.image))))));
        return options;
    };
    const getCurrentInfo = (lotteryProgramForPlayer, key) => {
        const { current } = lotteryProgramForPlayer;
        return {
            active: current.activeTickets,
            implicit: `${current.maxImplicitTickets - current.usedImplicitTickets}/${current.maxImplicitTickets}`,
            remainingTimes: current.remainingTimes,
        }[key];
    };
    const api = {
        lotteries: async (endpoint, session) => {
            const data = await fetcherApi(Api.lotteries, endpoint, { session });
            const lotteryProgramForPlayers = data.items || [];
            return lotteryProgramForPlayers;
        },
        draw: async (endpoint, session, id, guid, options, pointermode) => {
            var _a, _b;
            let data = await fetcherApi(Api.draw, endpoint, { id, session, guid });
            // data = getExceptionData(data)
            let index = (_b = (_a = data.item) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.wheelOfFortunePartitionIndex;
            let message;
            if (!index) {
                index = options.length - 1;
                message = `OOPs! You are close to a prize!`;
            }
            else {
                message = {
                    mode: 'gift',
                    modeValue: options[index].name,
                };
            }
            return {
                data,
                message, index
            };
        },
        outcome: async (endpoint, session, id) => {
            return await fetcherApi(Api.outcome, endpoint, { session, id });
        },
    };
    const getSpinContainerSelector = (pointerMode) => {
        switch (pointerMode) {
            case PointerMode.Arrow: return 'g.Partitions';
            case PointerMode.Partition: return 'g.Pointer';
        }
    };
    const findDegWithPointerMode = (index, length, pointerMode) => {
        switch (pointerMode) {
            case PointerMode.Arrow:
                return findDeg(length - index, length); // + randomInSection(length)
            case PointerMode.Partition:
                return findDeg(index, length);
        }
    };
    const getSpinCondition = (lotteryProgramForPlayer) => {
        const { current } = lotteryProgramForPlayer;
        if (!current)
            return false;
        const condition = current.activeTickets === 0 &&
            current.usedImplicitTickets === current.maxImplicitTickets;
        return condition;
    };

    /* src/private.outcomes.svelte generated by Svelte v3.48.0 */

    const { Object: Object_1 } = globals;
    const file$3 = "src/private.outcomes.svelte";

    function get_each_context$2(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[10] = list[i];
    	return child_ctx;
    }

    function get_each_context_1$1(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[13] = list[i];
    	child_ctx[15] = i;
    	return child_ctx;
    }

    // (68:16) {:else}
    function create_else_block$2(ctx) {
    	let div;
    	let tr0;
    	let t0_value = /*getName*/ ctx[2](/*lotteryProgramsForPlayer*/ ctx[0].filter(func)[0].program) + "";
    	let t0;
    	let t1;
    	let thead;
    	let tr1;
    	let th0;
    	let t3;
    	let th1;
    	let t5;
    	let th2;
    	let t7;
    	let tbody;
    	let t8;

    	function func(...args) {
    		return /*func*/ ctx[6](/*outcomesItem*/ ctx[10], ...args);
    	}

    	let each_value_1 = /*outcomesItem*/ ctx[10].outcomes;
    	validate_each_argument(each_value_1);
    	let each_blocks = [];

    	for (let i = 0; i < each_value_1.length; i += 1) {
    		each_blocks[i] = create_each_block_1$1(get_each_context_1$1(ctx, each_value_1, i));
    	}

    	const block = {
    		c: function create() {
    			div = element("div");
    			tr0 = element("tr");
    			t0 = text(t0_value);
    			t1 = space();
    			thead = element("thead");
    			tr1 = element("tr");
    			th0 = element("th");
    			th0.textContent = "Rewards";
    			t3 = space();
    			th1 = element("th");
    			th1.textContent = "Status";
    			t5 = space();
    			th2 = element("th");
    			th2.textContent = "Time";
    			t7 = space();
    			tbody = element("tbody");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			t8 = space();
    			add_location(tr0, file$3, 69, 18, 2477);
    			add_location(div, file$3, 68, 16, 2453);
    			add_location(th0, file$3, 73, 20, 2669);
    			add_location(th1, file$3, 74, 20, 2706);
    			add_location(th2, file$3, 75, 20, 2742);
    			add_location(tr1, file$3, 72, 18, 2644);
    			add_location(thead, file$3, 71, 16, 2618);
    			add_location(tbody, file$3, 78, 16, 2821);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div, anchor);
    			append_dev(div, tr0);
    			append_dev(tr0, t0);
    			insert_dev(target, t1, anchor);
    			insert_dev(target, thead, anchor);
    			append_dev(thead, tr1);
    			append_dev(tr1, th0);
    			append_dev(tr1, t3);
    			append_dev(tr1, th1);
    			append_dev(tr1, t5);
    			append_dev(tr1, th2);
    			insert_dev(target, t7, anchor);
    			insert_dev(target, tbody, anchor);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].m(tbody, null);
    			}

    			append_dev(tbody, t8);
    		},
    		p: function update(new_ctx, dirty) {
    			ctx = new_ctx;
    			if (dirty & /*lotteryProgramsForPlayer, outcomesAll*/ 3 && t0_value !== (t0_value = /*getName*/ ctx[2](/*lotteryProgramsForPlayer*/ ctx[0].filter(func)[0].program) + "")) set_data_dev(t0, t0_value);

    			if (dirty & /*Date, outcomesAll, undefined, Intl, getPrize*/ 10) {
    				each_value_1 = /*outcomesItem*/ ctx[10].outcomes;
    				validate_each_argument(each_value_1);
    				let i;

    				for (i = 0; i < each_value_1.length; i += 1) {
    					const child_ctx = get_each_context_1$1(ctx, each_value_1, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block_1$1(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(tbody, t8);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value_1.length;
    			}
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div);
    			if (detaching) detach_dev(t1);
    			if (detaching) detach_dev(thead);
    			if (detaching) detach_dev(t7);
    			if (detaching) detach_dev(tbody);
    			destroy_each(each_blocks, detaching);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_else_block$2.name,
    		type: "else",
    		source: "(68:16) {:else}",
    		ctx
    	});

    	return block;
    }

    // (66:16) {#if !outcomesItem.outcomes || outcomesItem.outcomes.length === 0}
    function create_if_block_1$3(ctx) {
    	let div;
    	let t;
    	let div_levels = [classWithPart("OutcomeNoContent")];
    	let div_data = {};

    	for (let i = 0; i < div_levels.length; i += 1) {
    		div_data = assign(div_data, div_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			div = element("div");
    			t = text("No histories");
    			set_attributes(div, div_data);
    			add_location(div, file$3, 66, 18, 2350);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div, anchor);
    			append_dev(div, t);
    		},
    		p: function update(ctx, dirty) {
    			set_attributes(div, div_data = get_spread_update(div_levels, [classWithPart("OutcomeNoContent")]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_1$3.name,
    		type: "if",
    		source: "(66:16) {#if !outcomesItem.outcomes || outcomesItem.outcomes.length === 0}",
    		ctx
    	});

    	return block;
    }

    // (63:14) {#if outcomesItem.isLoading}
    function create_if_block$3(ctx) {
    	let div;

    	const block = {
    		c: function create() {
    			div = element("div");
    			div.textContent = "Loading...";
    			add_location(div, file$3, 63, 16, 2205);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div, anchor);
    		},
    		p: noop,
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block$3.name,
    		type: "if",
    		source: "(63:14) {#if outcomesItem.isLoading}",
    		ctx
    	});

    	return block;
    }

    // (80:18) {#each outcomesItem.outcomes as outcome,index}
    function create_each_block_1$1(ctx) {
    	let tr;
    	let td0;
    	let t0_value = /*getPrize*/ ctx[3](/*outcome*/ ctx[13], /*outcomesItem*/ ctx[10].id) + "";
    	let t0;
    	let t1;
    	let td1;
    	let t2_value = /*outcome*/ ctx[13].draw.state + "";
    	let t2;
    	let t3;
    	let td2;

    	let t4_value = new Date(/*outcome*/ ctx[13].draw.time).toLocaleString(undefined, {
    		timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    	}) + "";

    	let t4;

    	const block = {
    		c: function create() {
    			tr = element("tr");
    			td0 = element("td");
    			t0 = text(t0_value);
    			t1 = space();
    			td1 = element("td");
    			t2 = text(t2_value);
    			t3 = space();
    			td2 = element("td");
    			t4 = text(t4_value);
    			add_location(td0, file$3, 81, 20, 2937);
    			add_location(td1, file$3, 82, 20, 3003);
    			add_location(td2, file$3, 83, 20, 3053);
    			add_location(tr, file$3, 80, 18, 2912);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, tr, anchor);
    			append_dev(tr, td0);
    			append_dev(td0, t0);
    			append_dev(tr, t1);
    			append_dev(tr, td1);
    			append_dev(td1, t2);
    			append_dev(tr, t3);
    			append_dev(tr, td2);
    			append_dev(td2, t4);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty & /*outcomesAll*/ 2 && t0_value !== (t0_value = /*getPrize*/ ctx[3](/*outcome*/ ctx[13], /*outcomesItem*/ ctx[10].id) + "")) set_data_dev(t0, t0_value);
    			if (dirty & /*outcomesAll*/ 2 && t2_value !== (t2_value = /*outcome*/ ctx[13].draw.state + "")) set_data_dev(t2, t2_value);

    			if (dirty & /*outcomesAll*/ 2 && t4_value !== (t4_value = new Date(/*outcome*/ ctx[13].draw.time).toLocaleString(undefined, {
    				timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    			}) + "")) set_data_dev(t4, t4_value);
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(tr);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block_1$1.name,
    		type: "each",
    		source: "(80:18) {#each outcomesItem.outcomes as outcome,index}",
    		ctx
    	});

    	return block;
    }

    // (62:12) {#each outcomesAll as outcomesItem}
    function create_each_block$2(ctx) {
    	let if_block_anchor;

    	function select_block_type(ctx, dirty) {
    		if (/*outcomesItem*/ ctx[10].isLoading) return create_if_block$3;
    		if (!/*outcomesItem*/ ctx[10].outcomes || /*outcomesItem*/ ctx[10].outcomes.length === 0) return create_if_block_1$3;
    		return create_else_block$2;
    	}

    	let current_block_type = select_block_type(ctx);
    	let if_block = current_block_type(ctx);

    	const block = {
    		c: function create() {
    			if_block.c();
    			if_block_anchor = empty();
    		},
    		m: function mount(target, anchor) {
    			if_block.m(target, anchor);
    			insert_dev(target, if_block_anchor, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
    				if_block.p(ctx, dirty);
    			} else {
    				if_block.d(1);
    				if_block = current_block_type(ctx);

    				if (if_block) {
    					if_block.c();
    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
    				}
    			}
    		},
    		d: function destroy(detaching) {
    			if_block.d(detaching);
    			if (detaching) detach_dev(if_block_anchor);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block$2.name,
    		type: "each",
    		source: "(62:12) {#each outcomesAll as outcomesItem}",
    		ctx
    	});

    	return block;
    }

    function create_fragment$3(ctx) {
    	let section;
    	let div1;
    	let div0;
    	let table;
    	let each_value = /*outcomesAll*/ ctx[1];
    	validate_each_argument(each_value);
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
    	}

    	let div0_levels = [classWithPart("TableContainer")];
    	let div0_data = {};

    	for (let i = 0; i < div0_levels.length; i += 1) {
    		div0_data = assign(div0_data, div0_levels[i]);
    	}

    	let div1_levels = [classWithPart("Outcomes")];
    	let div1_data = {};

    	for (let i = 0; i < div1_levels.length; i += 1) {
    		div1_data = assign(div1_data, div1_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			section = element("section");
    			div1 = element("div");
    			div0 = element("div");
    			table = element("table");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			this.c = noop;
    			add_location(table, file$3, 60, 10, 2090);
    			set_attributes(div0, div0_data);
    			add_location(div0, file$3, 59, 8, 2037);
    			set_attributes(div1, div1_data);
    			add_location(div1, file$3, 56, 4, 1827);
    			add_location(section, file$3, 55, 0, 1813);
    		},
    		l: function claim(nodes) {
    			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, section, anchor);
    			append_dev(section, div1);
    			append_dev(div1, div0);
    			append_dev(div0, table);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].m(table, null);
    			}
    		},
    		p: function update(ctx, [dirty]) {
    			if (dirty & /*outcomesAll, classWithPart, Date, undefined, Intl, getPrize, getName, lotteryProgramsForPlayer*/ 15) {
    				each_value = /*outcomesAll*/ ctx[1];
    				validate_each_argument(each_value);
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context$2(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block$2(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(table, null);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value.length;
    			}

    			set_attributes(div0, div0_data = get_spread_update(div0_levels, [classWithPart("TableContainer")]));
    			set_attributes(div1, div1_data = get_spread_update(div1_levels, [classWithPart("Outcomes")]));
    		},
    		i: noop,
    		o: noop,
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(section);
    			destroy_each(each_blocks, detaching);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_fragment$3.name,
    		type: "component",
    		source: "",
    		ctx
    	});

    	return block;
    }

    function instance$3($$self, $$props, $$invalidate) {
    	let { $$slots: slots = {}, $$scope } = $$props;
    	validate_slots('lottery-program-wof-private-outcomes', slots, []);
    	let { endpoint = '' } = $$props;
    	let { session = '' } = $$props;
    	let lotteryProgramsForPlayer;
    	let partitionsList = [];
    	let ids = [];
    	let outcomesAll = [];
    	const getName = objectI18n => objectI18n.name['*'];

    	const getPrize = (outcome, id) => {
    		var _a;
    		const partitions = partitionsList.filter(partitionsItem => partitionsItem.id === id)[0].partitions;

    		const index = (_a = outcome.draw.result) === null || _a === void 0
    		? void 0
    		: _a.wheelOfFortunePartitionIndex;

    		return !index ? 'Loss' : getName(partitions[index]);
    	};

    	const eventShowOutcome = async () => {
    		$$invalidate(1, outcomesAll = []);

    		ids.map(id => {
    			outcomesAll.push({ id, outcomes: [], isLoading: true });
    		});

    		ids.map(async id => {
    			const result = await api.outcome(endpoint, session, id);
    			const outcomes = result.items;

    			$$invalidate(1, outcomesAll = outcomesAll.map(o => {
    				if (o.id === id) {
    					return Object.assign(Object.assign({}, o), { outcomes, isLoading: false });
    				} else {
    					return o;
    				}
    			}));
    		});
    	};

    	onMountMessageLifeCycle({
    		'wof-private-message-lotteryProgramsForPlayer': data => {
    			$$invalidate(0, lotteryProgramsForPlayer = data.lotteryProgramsForPlayer);
    			ids = lotteryProgramsForPlayer.map(l => l.program.id);

    			partitionsList = lotteryProgramsForPlayer.map(l => ({
    				id: l.program.id,
    				partitions: l.program.wheelOfFortune.partitions
    			}));
    		},
    		'wof-private-message-outcomes': () => {
    			eventShowOutcome();
    		}
    	});

    	const writable_props = ['endpoint', 'session'];

    	Object_1.keys($$props).forEach(key => {
    		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<lottery-program-wof-private-outcomes> was created with unknown prop '${key}'`);
    	});

    	const func = (outcomesItem, l) => l.program.id === outcomesItem.id;

    	$$self.$$set = $$props => {
    		if ('endpoint' in $$props) $$invalidate(4, endpoint = $$props.endpoint);
    		if ('session' in $$props) $$invalidate(5, session = $$props.session);
    	};

    	$$self.$capture_state = () => ({
    		api,
    		onMountMessageLifeCycle,
    		classWithPart,
    		endpoint,
    		session,
    		lotteryProgramsForPlayer,
    		partitionsList,
    		ids,
    		outcomesAll,
    		getName,
    		getPrize,
    		eventShowOutcome
    	});

    	$$self.$inject_state = $$props => {
    		if ('endpoint' in $$props) $$invalidate(4, endpoint = $$props.endpoint);
    		if ('session' in $$props) $$invalidate(5, session = $$props.session);
    		if ('lotteryProgramsForPlayer' in $$props) $$invalidate(0, lotteryProgramsForPlayer = $$props.lotteryProgramsForPlayer);
    		if ('partitionsList' in $$props) partitionsList = $$props.partitionsList;
    		if ('ids' in $$props) ids = $$props.ids;
    		if ('outcomesAll' in $$props) $$invalidate(1, outcomesAll = $$props.outcomesAll);
    	};

    	if ($$props && "$$inject" in $$props) {
    		$$self.$inject_state($$props.$$inject);
    	}

    	return [
    		lotteryProgramsForPlayer,
    		outcomesAll,
    		getName,
    		getPrize,
    		endpoint,
    		session,
    		func
    	];
    }

    class Private_outcomes extends SvelteElement {
    	constructor(options) {
    		super();
    		this.shadowRoot.innerHTML = `<style>:host{font-family:system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';width:100%}*,*::before,*::after{margin:0;padding:0;list-style:none;text-decoration:none;outline:none;box-sizing:border-box}.Outcomes{width:80%;margin:30px auto}.OutcomeTitle{color:#FFF;font-weight:700;padding:20px 0}.OutcomeNoContent{color:#FFF;font-weight:700;padding:20px 20px}table{color:#FFFFFF;width:100%;text-align:center}table tr{margin-top:10px;line-height:normal}table tbody{display:block;max-height:300px;overflow-y:scroll;margin:30px 0}table thead,table tbody tr{display:table;width:100%;table-layout:fixed}</style>`;

    		init(
    			this,
    			{
    				target: this.shadowRoot,
    				props: attribute_to_object(this.attributes),
    				customElement: true
    			},
    			instance$3,
    			create_fragment$3,
    			safe_not_equal,
    			{ endpoint: 4, session: 5 },
    			null
    		);

    		if (options) {
    			if (options.target) {
    				insert_dev(options.target, this, options.anchor);
    			}

    			if (options.props) {
    				this.$set(options.props);
    				flush();
    			}
    		}
    	}

    	static get observedAttributes() {
    		return ["endpoint", "session"];
    	}

    	get endpoint() {
    		return this.$$.ctx[4];
    	}

    	set endpoint(endpoint) {
    		this.$$set({ endpoint });
    		flush();
    	}

    	get session() {
    		return this.$$.ctx[5];
    	}

    	set session(session) {
    		this.$$set({ session });
    		flush();
    	}
    }

    customElements.define("lottery-program-wof-private-outcomes", Private_outcomes);

    var img$d = "data:image/svg+xml,%3csvg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.13725 6.59296C-1.06246 11.7081 1.3605 17.6636 6.54907 19.8949C11.7376 22.1261 17.727 19.7883 19.9267 14.6732C22.1264 9.55803 19.7035 3.60256 14.5149 1.37127C9.32636 -0.860015 3.33697 1.47782 1.13725 6.59296Z' fill='url(%23paint0_radial_4318_413)'/%3e%3cdefs%3e%3cradialGradient id='paint0_radial_4318_413' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(10.4878 10.6315) rotate(-156.73) scale(10.1906 10.0463)'%3e%3cstop offset='0.3' stop-color='white'/%3e%3cstop offset='0.3099' stop-color='%23FFFCDB'/%3e%3cstop offset='0.3232' stop-color='%23FFF9B2'/%3e%3cstop offset='0.3381' stop-color='%23FFF68C'/%3e%3cstop offset='0.3543' stop-color='%23FFF36C'/%3e%3cstop offset='0.3722' stop-color='%23FFF150'/%3e%3cstop offset='0.3925' stop-color='%23FFEF3A'/%3e%3cstop offset='0.4161' stop-color='%23FFEE29'/%3e%3cstop offset='0.4453' stop-color='%23FFED1E'/%3e%3cstop offset='0.4863' stop-color='%23FFEC17'/%3e%3cstop offset='0.6' stop-color='%23FFEC15'/%3e%3cstop offset='1' stop-color='%23FFEC15' stop-opacity='0'/%3e%3c/radialGradient%3e%3c/defs%3e%3c/svg%3e";

    var img$c = "data:image/svg+xml,%3csvg width='90' height='108' viewBox='0 0 90 108' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg style='mix-blend-mode:color-dodge'%3e%3crect x='0.571289' y='0.309082' width='88.5275' height='107.038' fill='url(%23pattern0)'/%3e%3c/g%3e%3cdefs%3e%3cpattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'%3e%3cuse xlink:href='%23image0_4318_342' transform='translate(-0.0320035) scale(0.00345457 0.00285714)'/%3e%3c/pattern%3e%3cimage id='image0_4318_342' width='308' height='350' xlink:href='data:image/png%3bbase64%2ciVBORw0KGgoAAAANSUhEUgAAATQAAAFeCAYAAAAL7uOjAAAACXBIWXMAACxKAAAsSgF3enRNAAAgAElEQVR4nOy9T6xtT3YetFZdM4gUKRGMGOFImdOZMXMPGUEzACwrAmfCCIUeMHAQilqRRQyE0ECEIisSbYSwgxRoEzsIIaAtJYoSBHRHSCgIS21ZEbYI0JYtx4r77ULn7FprfetP1d7n3HPfu%2b/eV7/fu%2becvWtX1d676qtv/alV3HunL%2blLem5i5p988EP8P3vvf/3Li/mSbklfAO0NJ2b%2bUSL60XGH%2bP0PE9FX4M4vx/%2bJN/AkfiX8/v7lX%2b/9G5%2boPV/SR05fAO0zT8wsg/UrA6gu//7J13xXzESXbseXL9cEfTB0x4/UO3%2bLiL47vn9//Luk71zb0Pt3Pk4zvqTnpi%2bA9hkkZv4WMKzPgknx4clljoM0%2buzHBz8Bvh9cPr8wv9eXvgDaK0nM/O3Brn7sES3aMYNJ3u8hfEwzPAd46tKkx1UELabH9M6aAa7KFhZ5Y/q1we4uYPf1hzT9S7opfQG0j5iY%2bZtDNLz8%2b0MvUbPCDz8WiO5NqRXsIO1kqUUfnXTbx/XmvhfmnmPXw3ek7w193tce1sQvKaUvgPbgNKx9X3lJ4OLyRwaHGct4FtTddXF9kcO2Rbqvh56XR%2b8uv5Z8b02/8oXRPS59AbQ7EzN/NQDXQxXxGafOIwn7P2HIfTrmlknjrC3PR5/bezWyRmFn/tRxmZ7BMYj8N6bvDYPEBei%2bdU8B7zV9AbSTiZm//lLgRYQWvzuurQss4ezUtY9KdcPurnfdU58HgudGQUa286PHrr1jxIkx4gJy3/lidZ2nL4A2SaDveoiSHtNZkXF6zcEBb0QEufNh6HV7QVX7BXI7/F2mG7vqrQB4aU8HlhXbXJfXq4%2bTRoVn6%2bQE4L59XxFvL30BtJGGlfErt7pFVGqguwHrfGHH5dA5hnZb6c9MwBqfk04D4C03ny4pZM6ivDMgd74pz2JxV4B777q4dwtoA8C%2b%2bhylPQt6XL1E9ejt5VCiVeeumbaLfaZbX/GDkW0GYyhlnyEz96YzAIjsjCgzNH/1WYCrdXHnb2m0vN/1Kt8lwL0bQHsEgLny6HmuEZU7QyRot7qGKXCw/91PDQMuvj0wcaxleYdFyvewvKs7u3U/h2hzgAOjwrwJ5/zi2IHxs91HfvE9uIy8WUAb3vVfe1G3iQKEUp7DE8BfTiFa4Z4RfjhGdNI14q50Ao9WQmY1H5RNvav9c8g5c8kF2LDtaVJYusYBMzvNym53/n2G68jFAfjbb5G9vRlAG0r8r35M94lzeq/lwVAsF7PxosiQIQEZilJ3pocIwSU7O3NXp7VOt1ySm6DXjCfVq3OxmgKpIP99ImpxZo6NOf/9FtTvvBX29tkC2nCjuADYP/vQcudfcr6EaLcJa5Hp3XZRPFyLm68hMVMNZ4sm9vTlTLoDAMsTfYAIZ%2biaAhzN0Kw4tAY4ry%2brEe2FwI2Go%2b%2bFvX3zvss/bfpsAI2ZLxbIn/zYLGzeHst3s9jpMhQi54kLqywJOHgUOXvFN2DeffCY27Iu9b6%2beD/4eb2UY2eLmo4Ark9AaH5ZTdvOWFBPQfjzXEO%2b9TmB26sGNGb%2b2tCDffWRUSbuATCXM4DZ%2bQqrUxzG/R3QUYibXjC%2b9x0/n%2bWtVgcsbSqnBuz9fVfBizMi7qGNQg1L5R4nQBQdXCnun2FwwTbxPHC7FQTLdAW3wd6%2bf8f1HyW9OkADEHu4Qp918eDtAzXrum7xtFhwk1tFxJnI6cRWDxrPfsW8/HnqwvpZPdBicchC/NkdbPzx7tCLy%2buOAG7F8gp%2b538mHVx9U1NwCyJp/XTfNri9CkAbC7q/9mh9mK%2bDnq/ijuADIuPNUl0FZMd69foIO4jdv70CFdp6ORfP27hUnD8OAIkjiBlzu04EZXXxwGBn0bBwsrkrBmctmlobDpnbGV3biWau0qsSSz8poA3fsBcDMa2Hjkf4QjJyByJTuws3SmCsNHJndXlwtbuEB0OLNOBxKVQ3veE7pPtzaclgzvftfqxAg3x1jZnhndO5%2bdNHDKq2DMyA7fzwfhi4ffNTLqj/6ID2kv5hZX3%2bjz9eZl7mcOUlZf7x5UQRBgt2tbhw0tQIrAv285HS0WL76SSzYETP7qnZDpAYEi57PWKGHgMjqM0aUAAcR3CaU6uyTVPWlsXQc%2bkh4PaLQyT9qOD20QCNmX/wMUBszrQK2DimZflsBWYHQudafPU/zvOzOSOLtT/HD21W7/RocTreY8x6d%2bseBX4FsNV5sHTf%2bihyFraGutBJPmcpnZQxvdskslbln03PspLS8HO7ANujdwUr04sCGjN//6Vj4K8xqWBlN8o%2bufwsPt0jeDoGs7RKHsAaV8BG3np65hU/kNFFUXpaVWz0CbHvWeB3wM7w2NFE4IfNWuRMbY%2bvVwEoipsTS%2bkZcEsAXF9/7nneIrou04uvUHg4oL2EXmzJWs4pcQpGtcgzPXknmCVWUinv1xaBWYuXQPaR00zMTNPKBO9uZVVHV50qbwJsGfysxAgyUf82H1LHABdBLZewBjdt5wPWkrpaH897XkTf9jBAeymRMkl0JwFsWs4ZXVp5cgFmN2GaFy/x2G16r2MwU/DkI%2bXODRUfZJ2BV5kHd0m5sRveDH4OoCa6rDPCeQU%2bE1CbW0pD3lm5NdFLdWNxPf84x3mXrC/3nwfj2889SiR9FqAx83dfeg9Idoh2H/WICuhpKQcnOAIZ4Zitet6EsUS9XgLpcyIncwYxikD2kVNkabX%2bMPJUS8e98X7wS29oAWyIRrPqamZ2AB/jNC9cRuRYIdWW98YBBLv/kvIvWue%2bZghz8vGJ8m5Ov01Ef633/uP3FnAXoH0sBT85QLvzev/nBMHLBxF/7rZQTsTLDGZhe7cFyMZHUwGZHMPh8SI4twCp6WQyYR9n0zGbghzBw/gQ2FJZ1t6eBn7BzM6gEWVjgpdDvRL0qMgYz%2b0I/A/B7YzY%2bjLARmPv0/%2bm9/4Tt1x0GtCY%2bTsvEY56WSfdLIcV1xMl2DlAtRnOLcHsBLGK%2bSOXueVW2YFEBWLh2U2VkI9L8X215Q2s9Y%2bb%2b%2bVHzb04aFixBjasYSYtrkCtzl%2b2pGZlB8g6A7YMaEVhZ1lbP2sbz4j2AuD2D4novyWi//JI57YENGb%2bxlgQ/tF3634OmGW8qgDNPPzP1FJbJWfgdLKcqe6sRsfMyI6BzM/xuZaHpFHfFMCqd/CgVAJfvGGenJoBWyrS0y4kUTcBGxZbiqt2rGeClhoWLikNCkvN1xLc7nHXeHHWJuliUPj2sJh%2bF0%2bUgDacX//ll2vPcbpF1Fzm4goMTjpaHOrMIpjhyMmKrcTIymzHzmhRtFwBma2yvrF73SjqK5jBZLEqe53jtuVDdQnWnI7HZsrtyfNJR0%2bAWlY1Tco%2bALXUjhWwLUCtLvWozXpzdzz%2bjwZsNFxBvibA9iNydCwK/8ZLK/nPpFlXP82ogmxZAsnyuknuIzC7NvCodbVomZT7q2KivmoBZDrJ37r06%2bz5M%2byr3crPwjuKTIU9olTgh12AUVRldsCWno8LtdFdO65XDKamTbiWz9YOtnr1Y/SJyN72ouxmjATG59T1MWfMG9frx9CXFnI55xLHiQpy/O5Xt4GS3Hx3xb8QsF2kx3/h4vPae//Bpea/RET/IhH9wZep7/ZUiZtHM/7sYCVmHhdI5aCqwcz/ngNuLV7OrJSZoN3GyBIgFL3pIeJfFSn3kIFVPmsrFnOQTuSplhNtUm9BVvB7ZHHz3zScYddNOrKO9imKBBE5grq7j3NoFNnY7FjOf2M6rZN7VvoTl9v9XSL6Ay9f1/lUiZt6aEnR8gmGP%2bWsDwemzDC0Z%2b12Uber0pPF21QoWpSHAOjvZ//VfOZio5RjGLsZ6I4YWOVzd/fgmF/Vt%2bkpd30FkhsO3qJxp0GNMiJVuBTPrFw%2bcnt7OF4B2qS86SFDswRok5d10/v7OID2z/NQrr14xItbUunL5BDNnZkmf12SRI81aUW%2bcz5kBbDCdZml0Qkgm7GvCsg%2bQgBuXi9AX62AKOarOj1EVBkDKYFdbVHcwltE8ZTC7yWo%2baqwRj1Wg9qyJGjzMaj50uZU65ClTa47bq3P9RGWjf/jPzJEzk8OaJUYldOSnuXyEvu5AczidXUh6SQzKDpOiZcTS2VqSATlNSPz2ZhKa/bSr2LWnhVYL64IeVCsO6qcj4YMDMK8%2bGDU1faDxuKMIaM4Gh/JFdTAwom/FfDGO%2bcCBthUaEnXdj3czUdQ4o/29AytXJvSWZRm0ohde1awKek5DthOU2RsS71B6PG7fN7q9pPpsk3fb/xI7/2XmPn3iegfefEqQyqksIM8d4DQLesvy8Nci0xxgLK/JJZxRrw8AnVhaQmHCkbGzVd4FM7n1rRmYBwUzY1S7mpOwNTz9VMelIBvr58pjiUez8WzNptULFKGA8kZqF2gR/KFF8xAlwBzrhmdm/MwKnQAGi2lpxLKW%2b98DGrWOranyN1j4roqD10TYFu0clboo9K391u6zDTM/wsR/bGXrhFvb36wgLCTMkomCpHVUAlwdTk24m4Cs6q8pLw/5z/Wi3NHomUEMrn0uXS/vkd4UhNEnz3r2PLcvKMGF/Ioz05V%2biE7vtK9CXuTd3HNuhBB09DtWoo7diR%2bxmbi%2bSR2uls8LxPWwSTPxkI7I8Lmm3ghWPut3vsfJnDb%2bE9fGtDWIFYfqMAsDfRFjUtmVn9dcMIzYMYOPM4tHs9AVn1f%2bnm1gnUGKyyXpvmqpuOU34u/vlHlvRIAeZwvpfNuRyIR8MKXUKFSxgJ3ATug5WEdzUqO4HblPGxM7JJ1K9nalR2kexHmxqhnK1w9mFD8DLCo8QVY76YDNUOWhsK8Y100QZoJeJXgXD1kyX1Ewm6VdG9L39ZWiW6F1z3%2b7nQPkLkjBaAt05SZZUDjgxLRupmAK1y6CtszZ2VriyU9g5FVk8Bjkty7f3r1aoeKNcvX/LDO2MF6%2bhLKdgN0cxeeY2wACAHcouvHRtnlw35kfVrl5lGxN3lhibVFphYexjI8eNHII4aWS1ml2TNNjb%2bhzNPpn%2bu9m8hJO6D9fSL6xx5Xx55mIscRNM3Y2XFFdJqdrXRp7DO6VtwEZiX7usH1guw5pCoqZjYBtBtJWNUA/b4CsRmA2c/qxiGd6OU9D/VpOWtgowUY1IwtGldKEdQy5%2bMTN48ZFsXcq9UF4VS%2bl3B%2bvn/B2RDgxZmVuHp2NcZt6dd67z8qV%2bDY%2bc%2beV25OOpAcuvDh6DrFwuK/5dUnwYyfD2asV3MNZmxGBn9sv9KJZAxlyfELiDXe/2HLWP5ZyVqENrrd%2bc%2b/N6zH/RfeSTir9%2b7PhdKrdzspt03%2bxXfJet/jmHv%2b4z6Y3D893sSQIM/Zv9dIkP29cG2djkybedofb56HyuEl72rCkmdzzHyILNMUoCZj9hwqTNO38YRby/losZP9n9uuK67l9KW%2bGi87ZGb1Vzd469%2bkAyHkmDOTquNM3C9KyC0YWRmSyN3r8Ho9erOLZ5oAfXHN7NmmFkYaunSKrTgV1jdf%2b7kVMuExa7NcMQzQIWM7WCtaMbgoglIMu12EKJqxtFxvaH84NhU7Yzp16JbNVWay%2btnrNf0xXKD%2begHtEMxYX366lnBA%2bwEW5svpLBijYpxS8JfLtW7UkxHlGZxWujJ/3I41/X0UH79KM3HcA3jIE24kvb051qU0be0J4KsG81lgk26F0JBArWM5/vx%2bKD9tBLYlyGG5eKgEsUqULAB1CWAzQJvMgks92D27Rc2B7UQZ3%2bu9fwUP/EjI8IsPdbK9EczOMzOOB8rTt4PZhIWldq7BzIkXVUunSv%2bivjtYmYIZnHMOv/ek6pkeARjhdSFVsdpcWZPGNruEKQ5EcXDdj6CltemPThu2qYOPG2/jgW9a9nWbEka2JpMbbqdCCmzSFwQOVEcNt6nfwSHX3e01gweUCC/7b/hrhc4falmOX8xuJU7KOmL7rpwzCepYN71KKTZaZGiX3Vj%2b/dPFHaRbGZrPmuDHZaj5mc93DuBCLXf4ndVhp29V/D8WyPaxwqrjOd/B6qRtQX1S8W0KYHDi7BRXM5d4wFOqTFRuY232c9PjTpBbsbeCsVGwhk7ZWWRlBUurRU%2b4x%2bL5nBYx4fccVzL9KvhgeEa3pvNl9F44B0UdwCPFzshczuWn2VBJgDYr5Dwzi8gkHxWQTZhZecwuPgSzipXRrvhftXfKyKA50t5Hrezk6EQGX/MqKnaEIS0p0jA%2beLTuemc6ZMc/C3Crq%2bvVUk8vki5dJsLSMgGeACQ9tSsIeIUYeaxLcyXW2%2btVz2ABcuUjikemlzxgk%2bJzC9kvS52%2bFg9GkZNGwLRnR6i9gZhZ/pMZVmA2QRd3LIFHUeCx31kuDMWNqrBb3DHkMhVjToKZa28E4SmlrdpV3Gs414pc%2bFGyNAe45Yzl0rXJkU24/N2V1d1zGldItm7ioR4fX/Be%2bhBXr6d7U3F0Bx2Z7ISt2eSHEbyvy5nYBrcsB7vkadocWxNqtwNcOjrgxnsuVoBgWDfJ69l5Xh51JobaDGCey/xzOl3at6uDFUP7JhH9a89tVsW2bs2f8Yjzz%2b7z3MPODkXKAgVXXv/3sjIUM5chlKBEPMZBzDaGRmN452XPuYLZOQRJV%2bni0rgOFovjxHruTVumeomV6LceDxVsYBxQkXTJ1pCdZdHvWnqwOyAzM3YWRdDIJqORIN5TuP8ojlb3fJKl%2bcMvzdBOLZHSpU4xzUJwPxt0bwa0W8GsKPo2IwACx%2brYDLzmxzgUco9LxjwGW8XIAMwQ2PEZtBt7WACqCGLzt7pe27pyQq5SHKyir5zthXEW3DKwUTn4t3IAb76MlSXUjgRg8wPXART8wWYfu27U4OXbCuVWgOYvK35mtEpP%2b%2bUBbbqPZyVyPjAd99wb%2bvZBOc9lZrNj1QCcsTMrpIzMU%2bmzuGZjGRi85XLGyvK9WDlRhXr07KesM%2bSolz2JKNjKiq76OCM8hexiYlVVwAzYLqrHq3AII1aK2A8NMUyeCVaHVsdxvo38ahm9Dra98Xy5ib6ZJRRDFrEHkqtY17qL8HEVa4WZgazIZGs11QIaonJwCN%2bNz92uL1/J5FjIsP65TiPzTdfgezhO052fZgzt2UEfzzC0GQvLh1bsrHb2nDOKGct4jqgZRKsIaBNWVvuWIUiswu5UVlxSNibf9Z6mITfiU8C2FNnjvcYrL9XzPIJZCwVPx9xmFEq1CoKCkxm86subVpI4hj8eWUXBkAiNByCGrq2N0U%2btJ1%2b6HkRQZwFN7ahYGwdmk5laDkE%2bY2lcPAx3d%2bncjKEVRSzS6WgcbqlTTCVDu1gPHmPtXM3r86MV46jBrC7rEMxOsZNb9GaYyVwlZNZPdS3XYFZc7ZiRoVsFgiy2aVvIgvNYj3M9mBxtrbgX1/aD89DxNWcTUIxPSphqBraKtcm7QNaGz6/LcWVgwpgyQxLjwYWTXUB7u4JVC%2byMSraGTO1SyLWNeNPohgXGgtwOHiyxj/fCxXaiwNTw1AFl4uNQmifoF2ucNSre7wNSaQzQ2me6iOcA2oqdzSb9e9hZJb6VVxzqzsixmRrM/EXIxmKeRuaWcBuYSdsaHLM2zYHewEx%2b8Vgf6H3Xzr/SeUBI1kE5nUyO3v3k/FL5wsZCtpD9UayN3WEApZKtmX%2bZ1211l%2blo8XjferjOL3hfMzM9VdZH8X7SbR/sRVAytHw%2bP%2bF7InacZmh/pPf%2b/dnJlQ7te8/b0u4kmIUzt7CzqogzYHamrbfmkbOtOCYn1kAWlPpnGRl5IBNG6EGZQecya%2bD8LrkVoi/%2bvgPAajibUFS86oqlA9iMztll3bnLLlnblecF1iZN7X1Eve3IknYI2CerftWvbdc8oNsKgbgZtqbby%2b4l6FzLHCcw5ppNQ1mftrczMDG3FZ6/PrK2apJzR26bAw/Tsrhz9XxvBWa0ArTLGqnniZ2Zn3Ts2z139DOwckN107SybN6qN5PfjsFFdnMCzKxghiML/zcKQObOet0ZfD2djkGsLuw0iLnrbcgddWzNCcBGBODGbcR8rIEtspsmwCZAIgAHPm08nAGvXazP7kkciSX0N4/rt6C%2bRBGUPZgOoKRegJr0jQ4iMDai3N%2bTwm9O4mK49K5UXi7tO6VP6wfnNX3zKMNU5CS6X%2bycdfiKaazZWeJbnnUU5Z1Z3jRzmr0HzMx5HoFj5Gri%2bxUGgWs43OP4IyqpXPcCyNh4Sg1mk41SUpLQRPGez7zTFYD5L1wMPCo6tR8sK1EniKOYtq0cLJX/FlUxzqJIBysBoie/7vVpTXJuHnbPsHJgC3eyEj9R/F25ctwQDLLqF5Vf2uw9UHqK9UtdAtqdS51iOnLbeMiqgRdPPYLXPJXEYnLhKSNAuiiCzi1gZozBQFZurwIzY3ZrMBOdXNHwBODYztsBTCfmsEyqWrtK4D5BO6kqH23FguBjztrksjaipG2RtVnpY2%2bN66dYYh1b6%2bj%2b0ok3Cc09rh/Mp43VA56ttSGqutptiMvD2aBhNcUyFt/HaoYZEATalETRsLIBHuQ4NF898InSL56pdgloF/PoS4XmXs7mcGRC5g5Ku68N/sx6jSbNFpgju/KnQklRnERmVjDRCZBV7XCBJXnX3q8YGk%2buTecPQAyjHdbLvNwd5bKasYp%2bLWM/rywlLAPbscR2d9Jf%2blwCuLVmNSZwY/1UXZZaRz3w8gDsS3COtEWdBI/s41oFBYvAISKnLW1j5EQj%2b35S3fXY70sgeScQOe4l%2bKrpV2xXfFG53Fz%2b0fWAkGfQ4xzCTH3PXM1HYsitgMZUd/x8eAJohWgyy4hZU%2b6T4qYdi8Ea7xA1Wy5POm66X9cQjIqBujmeipdyTNpl6jsAzNGedovy7ASA6WfcKm9S0Ex/6DrWiV7mRMGZKDQTbzoKf6HeoW/D8Ynim24%2bLIAiYt8wlwZpzolrPf3uIG4WKwyK1QTx3vv4XomdtRhqjcurG4L%2byhVVy5TuiqU4eWbVwPOWOsX0QisFFrP85Lw/fAOYVWXeDGZhoJ4FM0zZk3YATQ%2bDnqf3WS1XSveRwkdjAVZSU3C1nEeYMV0/Kt%2bDGDl/Py2fS82tHKJNA8Ugh8m4Q6fcjW102pTLxpjiYNI1tQEkmMyQQKSbCMizUBFUuSAwk11zL3zR7bykfmJdWmNMzd5E4lS7zIqrCcZ5FYPHXqDYlriv58pAIP2nq7w67xm8DAzqr8ulPJSdLX3PMJ3YO/uc7OpTpWSc/7qNP5yv86iSAt8mYGZf4i5Mx22ywX8FFwWNfSC0UYydowBmrG3iCNTh2D42Wwlm5s4x/0fxXJN/toeBuJEw%2bYwX0dYi/PvC5P7w6sZDX8j4kNsAQ3zKo0yXb%2bTkUXiI0eYmIA5VwENrjmnLKQ/GuIeA12%2bCKqDhcamTQ3U4gTZnEJd/Ukrcw6AcIOy/x3XAs3XBdtSjXOzn6Uw1JmZj5fHp0LqpbThj%2bbpF7JSXPT1nmfLxkGnOAPLsfmjdrJY6udN5YblVJ7M7Xo5g4XUwdlq0I9HBFQaZGyQUnFa9l351zOocgzSAWG5LnRymTLVc%2bLyKudCBfjF0HPZgyV7sceJfajDovjoehQMxuoV8qyUoZ350Bsfg%2biFjZYuip2vERARFC%2bj1/%2bgMPF8iJSImgejpxM74XaupRU/XbjxePhwvMucsM9HzYeLmcqlTTC8kcvZqKBznmU0TBymDWy4nglk6OK27aMsUzKo6OLWiWMJp5aDIGcXL6RrKc2BGjOJZUUpcwuTmiCMAK26qFeyoG2shlfAA5Fn1/6PNqDciL85yEEfHmQ02DubN6jajf/cWUqBLF5FUQe3K1noCC6/EN1fariKo9xWT2GhNDAVXUU%2bsClBqWCJlNextW5IPBh81uWglelJEmrjMy59zorbLYt9S61Yz6Dkwo1vYGd3A0L5DRD92qkA6y9Dsy%2bHx4jxmZf/lFDvDZkbRzLUgDtrE3mbsrDmqL9%2bYivuYgFmr6sPSwIjQYhvitbLuj7orjAu2a1/PszC8wdk0ks%2bt%2b15HhlKyDUk1ayM8c4K14bnLuLB6bAG6GQasVWXonsCCIkvbr6nDfFdMTRiZZ2hQB9Zz8LtmaK7GOUsL5/SuZztnTVna43zPMJ1iaL33r95m7awZmh49Q%2bDuSZ2SaHcEZhVNm4JZvAIHfwSzkUGGbWZlXueySrH9ru0M7h4zMGsGTZU5xQ6tlfkliKU1neHXZFYypXvIi2u2G3CAsRTg2nWgK/YZayNhbtZ4OVOzNlLm1skmmAtd69fJaRuSKTufNWGVsvjdR4MNoA06//2MmLCPmVoJ/4OFzUIMxd8le5vNK6npt%2b4cdpT3eEK7R3//wvHQjtNpXKvYWTxZFbaSbBd1nGFmKk66Ar2fBYuYt2ClBkTo8Q/lQwOV9Un7wq1je65NbF4/N%2buUHNp9JEbS5Ly0p4c8mZ3qLSbpRiY9WxTUTVEOIiqCWyWSdnYUz/zamrG2eC8Yo4xEjBzlpk05tfFdDJ6KETR86tAB11k6nUesAWZO/qAsiTLxMl/EM/AK509BSpVOXXh36ZhOWze11nPLYa6D7rtnFqszTXounqcJQMCXycSeAS1alMIFFUOIuq6Z6BmNAB7MrF5nRXKRMjgwsyAqAzhJzarGKpZSxZuciZk7kEF9zmgyZ2g8Y3AnQcxdsMNDYqXCV4WNkQITiFSFHOjERPm2pSP21xVxIJJ2f07EO/x%2brQqccXOE2T7KC6IgGgrCkik7RmbWQHFO2hAicmzYtthWrCeWI%2b0KDyg/r/MGAhQ5c/YDw8B6M5TTvmeYTjO05y9WTyVKlz/P0ooUhro/MkfFdGQ1YItKylK8T5t3lk0krQAzFCUj8GNV6Ch7DsyAfRVvMAmadwKYNlfrweklUEp4IHivuz6fx4AH0YnmrI3JjAvaq1zQ2tqQoGfEEMGwGmEsFN9dtZjaBdQuKw22PpYxNeris0bes7%2bPhf7o2HQAACAASURBVO1XFoXUbTwHWzKFy5dkIpwxNXuuKO52eehVoFZ9zLeKiysDwTw9EBzoHnZGLyFyXh%2bg/anPw%2b/ngFksL0JkVfYU44ICPe5o5EinY2QIZm2eT/6wK3EpZqbVBMEnyQFoMGZEMDM22F0%2bTZUTL9STn2XY2yBmKMVxPG1vrUdVzpgEbJ3kZjoiuQo2DiaiUiTFUNoJ3Jjc3ps8gKcz0iRolRonWVVeuEwKQS3AF819WAWhDtCg4X1Je0Jd7CNxMHFibgpwZfjucwnBMbKzssRVNVHy9unUUqeYbgW0hyxWfy4rm6V1mZEOIKgU%2bfTnWsS11Nz5AtMcG8PBWfAYx8wwlE9spRNtGwXx24PZLtaFuy3DgFdPo9icJTwYhvOxk%2brVcI0OenycKKLpcfPk3wg9%2bfez6GOFTql9w3dn4q8p3EEpL/XxADayWGjimc/kAULa7ndHZ9Op%2bceTHgqHE308qWSAEFZHpODvn2GdSlHcibXQ4gJsK15XMr0paCG03wSfF9%2bz75zPbukmQDu7WH1B0EKmk%2bA2y1CCSwU2k0PhmsTOFnozQkAchxqWBi4Vqa14fSVyskFiGconsDEBM7x3GaxN4nqJ6KuWwxrEPEvzzyU/xAFixbN2FtE4R%2bi13b3/De5jj2lGTuzcTzclBT2CWw/BFZt825Xz%2br0wJBBEw/Ad3LO0nc2BT1gPoKZhvWFR%2btVqOT4J9uwkA0sCwLKUNFIHCUDoNHqsQC0/gsmVk7IjpJ5Od7Gza5vOGgX0gpN6NKY4EqrzxYCpWBOcm7Elp3%2baIFdSRxX6J7cqgENZga1FcVOXxsintLGgPDxyeBAjU5hHR9niBlh0Ts6SaUyx4X0XqOObZYhVuhHGeyqzrAAMfkG2PH7rXcxLBTJuVFIepzyoVr5tbAr7y/9bxzDcJmjhkNlwMxcXQ220bNyTgIz5lUEhsIjdFPfd1RUNBPZYChCOKwkqY4S7KAK8f5h4HBfMu5r9h7t%2bfq5%2br7f6nmE6s5Yzpl87k%2blwlpgTqWPGNqtPvk9mk2kzDFWufxXMQsayrRHMXLngz0QUwAxFQQGKtrOKyuvfGQIKMLOWezBrdn/gEK/r/XisvpQ1iwnA4V%2bzZZBwH%2bM/OdHsWbVxHywLN9tOf1sqA3%2bwruZ06yybtcO9k7H%2bsuE6Urc%2b0jPN69pUX6GbhOA1heVwyCyhCQ1yI7OWibGaCJo9N2yJmwwZ24WN8tdwnPRWww7H3GyM3A0lvpnPSL/ynItvNgqcFTtXDyc%2b/Ac8BF9%2bRe8m7CyKVSUzLNeKyu/FnCBZui%2bbq45ak6iyOHI6M7tY7sGBGQ7Kq2FBRKOq3bldbvAuTji/NXW%2bs6z%2bubIzdu4iITAP6DwNZkbdG1P8v4JIug/UNpjfpgpwyWC6/u7emmp5RA3STSxlkggXYp3clf/oq3bdoWqzdhhYsOnu4NhVLEQlW5UtJHWw5QOyAOGVgDu6U%2bMVJF3a6bTIfqNoWeW/W9wkukPkJHqM2JlmROh4Kffs3CmRM573eXAWZhA7cXLP%2biYss7lNN3SGbbF8JlEtu9lecdFcC6ZuGdA2PhIzm5UfZ//4cEtwjU88XBb96yJziHVMinGCyy4STvQuCGz58vtFUgx3reIeiQC4i54Ey4%2boe7DA69VfDLzpiuVKrqUifkLI7NSOtNwqLFw/qCf6oRWPdHq8kzdDHomc4as7n99Peme/13v/AzHbLelet43nWztLanY/V8PiYtFL5jMbaBMwi4iKoJ2kAwRLOQOig34FK2a5wBy%2be50ZO8ARnyq1fGpbWwZ0qsllZY1M99TicaVO9WPSgx6ccSzJliKyH%2beF8WAZytr6iGkmIIjPM%2birImsTCynenkRCuWDQhb1uqrznwcq2fXen1oe7hqcn%2bIuV3e0%2banJumBz2tgF57dIWZH/poVXcwWrV%2b1DXkBye27G7pTx6O7k5RS/Pp7/83ALu0aHRWae3Qz1agvXblF95hUBgM5OLD2Ezjbh8yrlCRI98cZ9QMDNUk9%2bGNefATHVK1X6YBZhZao6NsrDH8OZVAxV93eCpcluAmSsLr/MProVDrPq35u75EtOtge5NnpnoD0W/11DnNjLw0NtpDLfRmMZtMFhkwKn5Zcq81gpwfWI2SYOKEXpF2Rnb4pdeEr2bYQ9REzXlExlaGB1n7n%2bZZ6Xxv6GYPT1L3LzWcY/ISfR8sbNiNul3uGyqx5r4d%2bnRxDZk8NsAYjQCOAaE94xlmltEAjYAtFa1SX83FU1X3v/apds%2bDe5BCJGZ2Re5smJnkV3RCUZGFAIOxm/IHGNCFwy5fiyJVNeHgpWIqBbFoF0kpXQ8XEgUxVIVz%2bJQt1BFKuL1KPKhCLmHyI6ilrTXi5hwnWOOYMWNVs9FVI4qZPcyEocTNaMOLQiF4SG62GnuVj14pbcwxbbC0pnFzf%2bv9/6PpktvTPcyNHqYtVPS4XQxP8fld47GQTm6GLxhxp20r7Rg6cyJYIblBCho58BMUxOGAjRgAmZ2GUR65WFhVAsiW8RXK864gzCchuckR1MzYiJ7THYtshBsNkTU5SsT84xO75Obq7mRRdDFp%2bomRABYeAxgWQx3w2FSYjbrLEsfamoVbqO905Qd%2bsIhtrYFq6dO0qmr%2b57kH/aZVPbAopijgXquvlmug9L/w1OFH6TnANqNa63C7UwA7OwrmpWcI3PWSerBmGOuAQEls1NskSaN1xld3SLqMD0VMzWnWTvh2l4wM2V/bG1nYItHYiUDwDggExCL4asJQCxFCDExEcE46fTapG5mB27qagKhwRFq2Socri3IcD3YTvufPjd3g%2b5Ag0xSp38vcYUHotrIC4Qxxs7wdW%2bpGPwq9Ud3I4TvotCqyOWZe8ZmnUrfs288ouS7RU6i54mdeIzDwfoFzC2c1vmKBd5VGdAJCRYo71iDOhHOdZH5ZPnycuhsLNf5T6FFE0ZOKWq6heZrIwApa4Q1pSFeGiejSdyMJZyDdqfZD9sWru%2bcYbs71Q%2bPY/NAf5U1T4d9EJ9URd4hGGOsHMTRaxu17P1LtC7SyNOT6AeiYffiJop7u3HDWzw7tMU73e51oGjZC7E3PbPN191L6%2bZMxMyiqJeo5k61/vnmB%2b6ffQwPngDtV3vvf5QekJ7D0Ois2Al38pjsC4NAzDc/JmB2lA9mOqbMQBxC2nevO2N3KxUTq46tbqYiuE5P3BSr/DXN5u0pG9PdUUyknLEcB4RD8X7dqCX4udmx5hgqkyn3K/WAKff39jW4xnQKaDTI1yC4i%2bOu3QupEGjA7x%2buiYEN3hdMIAVL0/a2BrmtGVaf41nh%2bmBwqFJ6ZicyPScVDLHuxJJOjfmfflTzngtoD7J2FuyM8AEVvmnTMo5POx0XsiJkZwBisQR2ORDTvO4ML%2bMxqA9dNKSzU/AoBxBvaulbu2g0uE7EvV0PlYFsr2wCYjQHMWnPFZAC1TNwsUXyKj1enwUHfdiwWla6z2ZW1im4wXtBMLRj8K4YdFnNcrTwHlTPqc%2by%2bZDrsqqj2XvUT8nnduFadFLXQHmGRb6Jcl/LCF9jEathcgv0TUwzh1eF3L/fe3%2b2dVPSswCt9/712y5YHEb6fXeD5qdqZauciwd4etb1N/kzeYqrzjF10RBwUuoIoCRZQ34o1fToeL/NFOqE40ZBrInNoAaxlieaJi4TzGAkMCW7GhzSlnWchhoDoCA30etc1d59BMEN69S8ct8CbAygzKDzOwVqDhHDW0YrUGZq3GBNGFrFYSIs%2byhaiAPIoZRS5TcxvdJf18npo6kYU9iekwVm0d%2blvz2/%2bPb0XIZ2Sd87k2nxXO64epKmz/XEvNOYYhf1bKOZTxO%2byjTg8pfMaCZg5qLkZmaG37PeLNQxuT/mGsQY81UgBkzMfLk4AJlXtrNrh/cXM0xiQUiTdAMHa5zBzTEwuNk2mBCCG0u94uoWwLAENWmdA7WwN4Nbbla/a3y/9kzX/TlOHnJnUTd4fgyFVt0ynG6hd6n4UxX9zLnWnEuPALTTdPEZ5ocbc3l9TO5kZ2stZsBJGayzLV4JS6ya%2bK0dgFmTGd6DmTmUTowA6gZigSBl0O/upKwUje8BMfP/MGbRsvVSyjcV12BEIMea1dSA7VZwS89exUtHTIOuzY7bSnvTvaGYv4NUM1KJoIYMCURtFefJ2B9JG1Q5D22JRmdQ1SGL87o97F11v4xOHovcD0rBJw9%2bHBgDfrf3/kuPbMmzAa33ftO%2beZJuebyrvKfKgfGmPmTkRYMqmSNhka/fcBN83KX8bMiLc5bOMDMdkKIzUjYCvmZFYyoQuz6vhhE8PBMzUuRFP7OGslmDBaCB5dXghosIDNwq1kZEibUBBA9/MgOfFplVAWp8BtSEu1WWcve%2bcJLysBSvuHl8VO9xMiF7BxF/NB2ZOsuGeu5jK3/1rqsW6REMjc6G/Jhaag6Se1ZBBAtf6pQUA/Z99R6WbNtNqYGfYEYUOdj4RjquJyAEDujNdICFWZtgtQHu7akOq7KigUDVBRZAbHaDpUR2V8CWAOAExBqCGImf2hAvLw1oe2gfC1Hkilawwt3fPbhlMDVwawPc2lIkFQOInWteoXji5ed3P%2b9%2b/vUbAyQEtcDSKA7GxMpSDp/AfUNXKjg0ep7T7PpsAY7H7OxChn78oFE3p0cB2jmx806Z89lkedFpheLrOHM9iAd4mK5ERYHowOiUuzSABq5Hje4NYKbUB%2bfuAsxgMVQxwoAF%2bJFdgNjIqWIfsrQIYvaMHKtDcsYuy9BO2X%2bERYiIOgE3zOjATR9UW4uk7J%2bQgn3w9RPlv4n4ze4F3z9HpX4butZ9Lap6roT22DNqWufUSEBQJwKcdVh90Kn9rjvE3nE8qvhcNk03Du/fvC37ufQQQLvH7DqfNJ5p6ZxWNlI5rea3ll66dDiCzoLAE1PxZFONzveKc5kzI8D4O2UNCNDOOrc/ixrECBhNDWLmYSEsbYh9DQapwJYMaL0fQSdQ4A09lfxHUG0FbqUxgUGfp3fS9B6dLjXsmEUJ1Oy9OFATVpdAzfRf6CBt78IfkLIgyK3/jCASSKRnacew1Be/jlN0qp2Vf/dofZirBqZHMTQ6s8vxuVtf67XuSqGDuQHuqz5ufHVx6svBqRSmVR2zyCRksXlgZj7u2ihZmFyztpihgXWXdNMXeREnDmhjYx7ECIDMMTG0YzZ/jsGKOVq5M0czrKoYqUwKrBNH4IbyV2uGjYCOg4nZ8%2bJC1I0sEhbV%2bueCt60WG3yv8vzw3XumVo0w1b81LMejmRsFjr3FfmH9KrI0z0jte09/6VBZthyT0S/jWNzceu8/tSry3vRIQDuJuLci%2bjl4Q6ZztsoZL9tTS6fWGOiVIUzkxB9rXhxgNzCzWFacr2NoIXVSZW3P9XBrwTI4Y2MZxBCc2CDL/NzE8kkGGgZ37gBpCQOgKnBL5SBra570OdbWxJFZHGjZifcN2rg3pan1U26dgyFF7ln97MASKRZZF3I9sSs0SgUaNpnI3ZK50I8PRxLuEIVg6YBzlm6jFTeO6r97W/bz6WGA1nu/rBr4rTuutL/RufZAmTl7JU7MKEQBlw78z1R/BuU40CnYGS%2b6g9tN/C5m1jwzk3aoor%2bpbsYtyxE2oPTJt7JmYwZiBCBm3MuOm3gEui%2bEQgUSIF/hSwVuDFo3E/PMTshshWaRlLRSvCPUQzW4TwS10INAV0UUa7B66kky6bTg4qhnwzYVRYWfB6DE/qy7KzyXvtOBF/yzxc2fuPfCo/RIhkZHS6Hqx48dinyOImuex4qHul4Rcjj7pLMOsU5YNvFSGD0rV5FViyrrcOmegU1pngkwmQbdRMJjNmbSn4GYAmSzK4yB0QDTpoaR1jDM0PCZC%2bVFI4OAGzmwNNaGbIv1OduLSeDmlnvBhiu8K/Dt9cLyMHieTAH8QIGPdiRvkUaxk03lEMR/lmAFfiYu%2bgc6fFTQeV/isoyTpd0ubv7D3vt372zqYXo0oN3lk%2bZTDXiWeji8fvD6MDF2V4U/7kCGC43Rb0esHGfZlOqKrqGDpIGFC2Zk2CiYgbV5aPI3YAPGJ9Sh2FpK3Xr4GMREvApsTP6ZsGkNubKLZr5epqgfP4bzLxOKrgHcrEkAo75uef4cRVJhbxgeSAkcK8BWcODa6txlYBKSdwUOv2idlPpc2Xofe7qF0xgwZimjQX1Vsn4fh8py6pz%2bOmeqOwWCf%2b1MpnvTQwFtIO80AsdjrJcnHlo10XXK%2bz0eLEZ3CvQQKdX6GF7gyzLUgSVNXoU0BTNy36MRAOpRHRGImsA4UN/tBmcBYnQAYuSFTbsRAQ1wb0CdlmdLeGEA0VG6GkHZvrQJuKFI6pCq%2bffjJgNka2hQ0UcsYIh7MQBwu/cFy6GqrhnUJqFn1ImLIg66vU6g8O798871Ho2kNF4n4uaNS53%2bxJlM96ZHMzQ6ZmnHNz3Tod1LqV0qe928dcauyE93E6dc12HYdzQYMj53AWYcvmszkJmF3skuA4zskQEPVSAmS310NAQQswCRAsY0nFr3zObc6oEMG4ke/rYSwbM2AtYWDKnA2gK4iSGBwVLayImAHmiNrZnV0b%2bhvbqmom%2bc/BDJcFUFN5iozAoBYGmfLHra1uLrTN899MrfrLhLE%2b2MpaWJ01eeRko8cPtSp9/ovf8gFvvI9HBAO1wKNYH9ThnALEdtaL4pzYNi1IxODwCj0X4MyngFkubyocgZ2Zk418qALEgAsDR2wOJaqqcC91E9kDAmb41roNh3ICZAxgcgNsADYxCZCwosj5IWaTTb/OhjZA5tSgC3Jq2GtjhwAwup4U3Te3IiKIKDOj%2bPSwXU2HRe3gIq4MiQHxhQekWgXQxuGmnjZGi89AHDnJnYOZno7579F25TzxexXsT3DNNLMDQ645N2f7r9TUXBUphMnHEZel1D5T08pbjpCc7piTXFn0A9DcxsoI353YFZjsc1wFKNnU07fkP9kIqa1lKxlOqgjiDGNYgxwN9e8V65W3vJBloDIq76tN0ggEAgxwWi7BFH1qZPQStRKPXt1/sD/zYENbtte9agMpiCGr5DBTWrMhkJsNU4gUJHagpy0C2CwsszLPg16fox6DTKNIdiZ2JsVTnFhfNDenXhe/anptkflF4K0ObWzgORL6WJAiG/FCpmF%2bkd5pK9fknzxxFZlEO1TA5GuwY4oTFABkKoil3r2TFCXxd2%2biy%2bmvjSIK6XDHIbUMasuNSLMcCHhkJUg0ChD2PgSxz3AZU2BPGokYIbJgE2sVwq5gJrEzgRYPNLyFiDLhKsRjBSyTpxyFSk%2bjAFNW140Q/sWVlwR2gvG1CoyLsY%2bt6xNtS1miAnB8vy0EOg9BY4ogr12eky6czm/s6y%2bAelZ%2b0psErMfJGV/1CVJVkA5eWHg34Mc/FSyLoYghoCDUQQVSZBgaE5vy%2bxtkFndCFlwG9M8kcFM5jl9z4uZTUtQ6ymUm9kiSiyeSOAMTMpwXRBo4woasoyIL2%2bHiU2DhzFCePCZ2YA16SH6eM%2b49Keyw1tE7vZBhsCQxJtRLyqE/ldzYu4%2bHvcfykeyobt465HtU2bLk/q48vmtoLbXP7rOd17YLO9AjbYW0B0TH3fxV22zNs/OuxBIN%2b77jOwqX4KtrzTtuz3J%2bXSKMvps2DrPBzv/vtoc/yEZ1numh7q8aDm3tUf6b1/v3rlj0wvxdBoxtJWs8ARtE6vPSR9fqi6UCvoRCTzNTrTymcAs6OkeBXYlLGzCMzkGImkFpoXMWOWvLhTzMbSNhApxRVCZElPqExsFAbSYFJBVnAVMxm2pxOFPMb6n8Vgc6ytuWfILoik3d7wCBmiYgviKDu9m2njFt1kdayYLJUN7rV5l4pgmGBQEcQk4dJsJBT9DgxI06bizNIneaY3HBtVFjPPWP/%2bnY8BZvSSgNZ7/8nyOHk%2bWtoB4ooBPDzSiVfhMgcMSeVMWP/8CbGd9%2bAn6h5kZcYSiaxzE4o8DhGknNzSvRwQ%2bBAQmmxGQqqcd3qbZoPDeBiDSOn3GpCzrEuoAAjFsMAWY1%2bALD4mXIfJ1b9ZcMlGarX0QGLAFi2lTXVtnv3HCBwqgipo5GdG2vYBxsFIUInVsZ3C5FO/KjqwCwk1z%2bbSBoOiFyF6YgEFv52wM3/98XhbIP8LxD2bpZdkaHQ2PPc9qQa3LG5KKmV91yOjUstbN0vLJqiF0XJlPdO7TMBYk8nbgxlPjABNwIjU10yPE4qUTo0NKnFba0gg8h6xMcEhD6uiJ7PH18ZqAHySu4OtZVLLIkaKxcX6RLqqoN7DYBgSEMylfvbv0q8zRVCzCCCEoMYAavIuOYBaJPNxVyv3BVgaVZ/hmsjL42uM1s5ZyqrWlDjUWqab2IKkaJlwou2LLXWK6aUB7WqmPWcHqJwyjtZxTouZ53cX5sw8sW7mskx3dqoDdJ/PgNB6bXQL0eMHzAz9m7Q0aFuLY0V2bzpiY1bZzvzaOSAjXJmgazNHGWCNJAEiDHwZwK1RAW4SNBJ20WrkLaR%2bAT0yS6gbXwbDRAUPMfYb3XJPKoEd7ZGR6WXxnY%2bJhxnembv5WqCcOa/GoJZYDzYiW1wLuA2deeJFdSrBZb9%2bXwn3pRcFNPFJK83Kp8TOcC5lPEOEGToSfsJstaDVaT4bMzA%2bOcfzwDCg7IkQcEDkS729IO6lNbRoJ0bWGFTQ6W7ILJ3W4VnbkUBs0LbWGujKrBG4NwJGpyW1jgrz8a4WCB4O3FpmbdaMwdwoTzb7LYH7Bwejky6ot/eu7WfgsGAp1ei6ZCI8wzFNsPkvKs6la7u%2bEzdIgQnOjY9kpBvTJ/af8SARgErScEDAevw0y4vlO83Wphn/mbMlPCK9NEO7pJ%2bje1laOTtwyl%2bdjmCVs0Gnn4qbk2qHzUhmZtIZuvIjMsWwHEoPnU3PgiKt2/QD2UIUNVuWUSpR0yyRfvclfBKk/mPRy3%2b4eDQGMBhgAn5bwgCljc6FTPReZKARwY0R3KIRpHl9GzIMdP3gkq0J9CJz9aAm74LAmCEFRKY2Oy7MFzId9n2ufjUTl2eXux3e%2byWOSyFxTGo516DimlUxCtDajhddiF6lFwc0MQ6cZ2k%2bo5sl4ufJl7TMjsrqJG6ClckVMA3wkir2nmKRnXEJZpBbwUyPTkTNhoxilNuc3syU4F6/QwBiTC2jrYmWiNEFI8O1TgoIDURchmMKn9JGA/InMp0g44J2uG8W0IR3Fn3aXNwyEkuoZ2tiodzDE3F40%2bjaA%2byP4Xm7iQfBq2VGF/pGfIfSZrvXOFGtkz5H7TdwXbFS5rjUgjAg2wjMsvAA%2bx9PNfyB6WMwNFotWM8JiPkNk8q0tMmaSzOMO0HgXOsqhQSACoE%2bhYJexTow2wYhAcwaWBtLIwAwEBf5Fvp/1pspSRp17H%2bEjeX75BLgGlQjLE9Gu7RzZ19tiNtqQzVl%2byhbCjMmZ6yNYWDvxoumx4ngHANjlXbFVQgA4AhA1T1rcErwLZR2545gx9GK3oClOUtnYzD2yOJ/4FCJyqn32KS9UCl%2bcJXP0sLNfFVdrr16jN4Y8E%2bfKemR6WMB2lWXdovYKV97%2bEwzw6xMUPDiS45cq4P4WBThv7vBFCyb7oJqlgRH3KIs%2b43XwuuJjsAgGlmtzQATgZTN2kks4lkStFWccxt8CEgJ%2b9FlS1IPiMgIZMpswf9K2idLjWQlqYAbuoYIuJg71xARm2bCd1n5s%2bFN4KJ5qV1ZWqAvKiwDk4THV/SlyIywX%2bCEuf%2bVSVakFO2L3aZZu4lFin1IEo6PcrI6SLzIGQ7JfUV93EttgnKUPgqgPcs4cFh4dfDglWmHg2ENsoV68YO7hnYZteD5IpG04cyJoBr7SWJmhHqj5kpJg0qbKxZLU/Y3ZAVsLgQ7FpgFUko2pbsHfFa2WHQTWLe5676EkdkCctV5ocwoy4TASqDLz0FpZliJwRzjek0vcmIwSRKRM4mg8Cx0AjAW6/zSlAWKv1vzkTScbWi/zvVhfGk9Sx3JKOX9QkKMtkLR4XRoYGVwFu/VWJicWyuxi3xlevgWdWfSx2JoJMaBc8nMLJllFSb3lMZMiHNo92xpT9gdF/oOTNt%2btVqywBkKgajR%2bulGqRXFHPnCo9wG4k%2bjZgMbBtYgf25lATp6OhcGZWpe8W4sSxggu/Y2BTh0VTC2pxFmBYiEDWlx5obBEp7RrXAnADZYJcD2flBkR9cPN2E0zz5nIqg60Y4yXfBG1TsutPIendyzZTih%2bjc5V/h1%2bJ54okrNxFZMYI4xZQF2InxOGRqyQIuBI2MBjAGXhejfmd3CS6aPBmjLlQPJKc8%2bTcrs7lPSGoTghSEKybq88YonKpUiwRKX09fUKa5WdOVx%2bRX7r7vmTFO84NMzG0Mxdgy6JxcKGxT%2bLLsaRSBjwv9IB7Jf4C4uIlK3usA6YCMXogjFYBR3xTqqllG5YWCdcpHzWwOgRztnZGqn%2bA0CqhJ%2bABrILe%2bwpetiTWv6k6EmHGG2tZ2Efb8u/lx3LmKe1emvnyruBdLHZGg0NQ708muZ0muvPDdMuaVimHzieZnHTXVhGiwGcROBZEnjJ0ucVNmti85xNybc7IS8qFnpzdQgMMoR5gXLmpT5aMy1wR3EzwrcPtB1Qn2wyEQ81Ffx8NiXQagWSwWycdeyskFCjbOttxSQuorCzcRTAmBDg4ECm4Iew3HStqvvGFhFr6d1Zyt7f/Le1YjjjImO14NIT17sBGZubFtaGtQVlWQxUg8HcWK7Lm7f5YE0mffgtgElJFVOmdhfExoVv6RWp6/eGPBj68pfLn1UQOu9/%2bipfItfMeEMOGVNi%2bnHgGVZi9VRldFsMC%2bLKBiVLMVh%2bQE%2baDrOIBBgctxVRQ4MItVNwWcAcwW7AGSmlzKGIaKUipBCnAogMwdYaS%2bIW3CMpO0j4m1rnqUk1gb6NmTKCCAKtMMqigwUdYQW5FLEeHF3MSdaVBvmt875lKgDMAAAIABJREFUW3ofgwmjNDFzm5x1mxjDLbQEI7Ysk%2bt3onMj%2bKzXb2LZ0R43%2bySiv3/coJdLH5uhUbXV3XpG4Zx3xpwPJhTHtBadqG5FFje5WlIS1mxWbZCszel%2bjJk5ix0qvaHNusGIOqVaGzHigyzWlkFNQ6c0DjgXC7e2UskZ6wJ0M1rg0IpABqChD3zov0ApL98R3IydAbBBvDYxJKi9VNahgssHuntQC75lWLZ7P1FcKzpAimgE8MCoU9oUuNDgY%2b%2bvqp%2bUOdtvm5CcKB3cgKbtPUjpksMyVs5PLv387a15XPoUgFYHf%2bTy6zTNyRi7z1g2uZnJRys4TEVe6%2bcQvzQuBBd9D4geprA3Z6z9pwcz1bUIGwJGGWd3DoOojRkcFcZmARzMRELgAJCpGMnNQIoFaK2gFoEMREthe%2bJ/25qhpDELz%2bLkLgTY4gIIrUnZGavDsN02u3uShnHRZxhkU30VYgwIjsnC%2bPAdtmr1xniXuF5UF8XDon5lgS6ogLQLWrpkabASxPdA90nV0aOJXZLTXxOwuakx4E8elPii6aMD2tQ4MNWj3aAcLV/O5I2xDaaY7cQ71mSzqg8ciBmnniXC40GsQ8aHOiIn5Ojo88Bp/l1SAew9CR61KqahB76IfOAMKxgkoXOIAMisFAMyFS3HfpzAvq4w0RhWNJDporSNHthINj1hPw6j3xju%2bMRhoPolVmyWWrk3BRkB%2bAgudgfSAgV%2bVRX494YTTRRXORyr%2bpoLAwTWRAEX24Csj%2bWkWY/mjjpdG7p5wLgrOmnpeLsejv/T8uxHSJ%2bCodE0rFDv7sGvxMpS9q8LXR7vuJF5zKKmdlYxyTp07JRuhMGJyeYgBIwlXqeV%2b5lXDl%2bZQROgMTBjaGNrCBSjnGaOrcYmPRCqY4c6uyKQNQUyEvwDXZoAmYWvHtZQ3DRFRdhmYCzXO2DDXaNAz4ZAFdw9dD9Q8F/TySKYhNVQ4Khb4nDFSwPGJK9Jz3uu5KN6FGuPCJ4L6tqciOmZn75jucdSj3bGhMnzn1FhVpVbGwP%2bqaqmj5k%2bCaD13r9SHqc0kUzNzDMUMp/GI6fASMlMma6Mp6pP78Gfw5nadWsBGAC3BgulSUSpYNFE0ZAU%2b3KgQisBsAd0fdoWOSj1wG7mCmRqXTTFPjtGpkWAuMTWfqApqtcDURCP6TpLAaEGvnXsaY7Ts7GJooyGA%2bN0jq1h5Axc10nwBiTGmvjKqdEA/OdI2Jzet7wTC9luOi%2bwXibmb3V5tUiDs/gcI%2bj61HO08rvSUio5p5b5pMYASZ%2bKoVFlHHDJhfmZAdjK/jRSEQk15kXzd847s55i/tvYGVak4pcel/sO0V%2bVbQx3BwFecVOQQSuLr51YJY9CjglTE6URD4CD/S7l3hUdMpA1IgAyYXnit%2bbL8GKjIVBcInVtB7h6SP1oUCDy0UCcq8cANV11AJONxjITC2jLhpJury69r%2bsbBxHPqUlQNExlhIkIwWzzfcGv7fSdpeJh%2b7OPSpo5PFVOtXg26cfwrlCPlq/%2bpMYASZ8S0Or9O/Utntt8flyUvnYBBvAxs0/2P%2bVC2DTDat%2bCv4%2b16jIYnD5t8t21Uh1NbZDhvbdwHGf/xtFFw/Ro2OXVaBD0ZiqmkAE9twhiWeGvWAEMh9XNQoDM/bRNf3VPTtZNicVHTaPPophJYjRppuebsDViv7C%2biaIdgE1C/aq0yv7%2by3ekr4PTORTxXAAAxuepuUtyNa2XF7lmk2rPJ1dsq5qw6YTb2oG4%2bcmNAZI%2bGaD13r8xOXFLKW5WdJfrKoPoKd31OhNPZXYksySiYMLWudPnYRvBuokOmc4Kp6f340H1olQrSh8gJZMaKHz7UdQUcc5EsVAWez2ZqddAbFNH1VYCGcMeABhOXK2F7O9b9wyI7SBjgsLWUJfpxFC1iBpLNFAjs4S6%2bQDeg%2b6aZWF%2bbT0s6ilHfexBFte6Cmga64LIG0oXgT02nd7SxBnVJxm7oJ7jjmhlTI6Vn%2bd8zz65MUDSp2RoVG1I3OMXWP5kGfxTRgzk8FknFuOiZa4UthQ70LQ0ABwDwvrpggwtUhaB7ghkM/XWV3CyQSHhsCmIms1GrIJZAzBrCM7iYtBg/WS8d4xmi4wMmyrOsSgqqmsCkxIl0Ue1cL0wtibxN8T1gXThuzDFGthYxVBBupKt6aMRNpUj3SEAyUvAPAZYgaWBikBeoxmUYKKU/GNG7bCdnwNJt2pFBe/Y6yad0WHdPLmxtDIC4HgLfk%2bvxBgg6ZMCWu/9a/FYjgkF%2bQMfSzoLl7e63qdt6Aqu/0S5WujsqhaZj5TstQlWMJ2dc0I/rtQuMEYIWGmYap3SvaiZCjuRcADhpiPG0sjETUMzz8g0v7lVoI%2bV2w1KDSRsz0p980DxTUZePABZfnVtAarqfdh8A/G9KHMEEqWbuTTvl4csjSAMt1RuMc8ic4fnv%2bgHmlwIqBbuJxU1PZbcL86suZzN/hWOjb8FO/uNo2o%2bZvrUDI3i%2bk71jxl/3eeMpeGjPtGJnIGSveNp6gh9V7I6FhasZdqpbShYxx/oqGsb3VgEXVeIEJHuwBkOQi4Z2GjdzLgJ5n5zW5BjTrxUUcpEuBkjQ2KJQGbkqznQV8uiE7lh5QCcRFBT4wGL4SC7esDTB/9AiOqh1lzPnnKKYbR9smeO1lOpDcrs7mOwTFYjjvnthUlw2q5NmV2EK7bb9X3jTCrGUZ%2bjWkzfOlvNx0ivAdCcLs2/F0/304/ijRkTzk8/vnN0zVCICvozV40zCIGogCC8BNTAJl3nA5jjfI8qapItd2ImZQ8ygNX3is3nTK2A6rsUfNbI2I%2bAnYSqRuuk%2boMpsKFoFYCMzZcNRUeSst1uTeBgC%2b4k3vdN6gPDQQC2uNwKLZ8Dh%2b1%2b3XvIL23mDsEOT4J%2bFv0KFbBIffFSHyrBj%2bOO45Y3xiLPg8L69ITlYZ8vAzukb8tB9sPe%2b58qGvvJ0icHtN77tw5dODQzfsrW%2buusR8c0TfpBCUyLTBxm5ZQRWJK5TkAOYSxqXUS/KwJ2QT4SLQlDgiU5ojtrcF7%2bEzADzw2MTOGXPQbHVgcsTa2wDsiQcQ3AuVz/BPeOwEbYGXXFgp1oDKaD4OohinXUvRlba%2bqA7ETGBkxJ3TZkMmA1sFhZlWOr90vDedCkUQAQMUaJmgN7CfQ/v/FO3c8c9ARVh7RNy4CT501uOWdB1P7G6eI%2bUnoNDO2SviXvIlomDbuiEIppHHNUfE6406taTEbTUlRZbQMF%2by8X19pgQGWxecWbEcAPBnF5sA1QKC1AV3YpbUJDgLTX%2bafZwvVmldu2ckTKyKgEMnZAxghkqgfaKVPcQQp3sxIw0fDeKIq2oGNrhauHNgyiaIhlEqgwc0ugVqVK7JdrEFDRWDAeLzC/FovIyekCtBaCle3LdL3EPIuuqccJP6TqyEI3Fo6UUJh04J86vQpA671/3Ulzq88Y9LEEuDXwlfIEsj2Z4aSjCcYwKo3tGCn7qa7D2GBafMHOGJiZiEwQeYN9neoSob4epuhGgQqXyai3QIhSS9byURRsnqIABXHbYEWEbiuHQNbMR8xYVlPg2o0NLYX2tmeS9/HMhggANhSlNMaaMSwHpgErnOuKvXz/bLUt9uDMmNzC8/alqdgJTBGP4XtgK1mPgy1xj6TQizm7YGj%2bk63rXw1hViq7jDelX%2b%2b9/%2bCeC18yvRaGRsmFI5qHs1VAwa2akGrSJYhS%2b2gI29jLshXmM7XHrDIOh/QSuJVr6RsCK87MwUCQBpHviAqmgHJo7cMAkBr%2bR3wgmomXChTN6rXF42JhBKYHOzaJPo%2bGjq3po4ZNVaRYBPbWXADG5v%2bUhgNji6BTcmIoMF4UzZTB%2buVN5MROEYcN1bQcpzM0libAnHT5S%2bcwewiVi2/2c%2bT48sN5PAYPhUh9L6dtuAnStJyfPX3JR0yvCdDcyoGluTjoHzhedagoWC2AWzvwqHh1Yxfwg8CCCuIs6pc67R%2b7W0FTYGljYTeBqCkMUAaXGQNIRS207qn1ki97YMr0buDQUPQMjIwAyORZkLYRgIzzxitmHIC9Pke5CGxNiRqAGnnWJc9IQYlAd0UmEquuUNhUfG0dO9CWDrH%2bCOGn0ShQ9acz3aNBUXAN25cyv96i9lWzr8fLZkPBL3FaB3kItjAaGwj/9PLePlF6NYA2NlXQKBxRJHK/2b/CqQGgR7JlgFf2Nzf72eYZOnDLVM9yOquDu0YLN8HkWZMKIq0AuDDhN8AhfUpxYKOvrhNm4uoFsZSK46s948jITGcmgIxsCIAM/L0u5T9BaAwHcg332mS/S5OynyCCovW1EkHRxYPtGaX5InluNG03ZmT4olMZ27tLClQCK7MvBFLXfsn%2bz0hzhLm2IOhfssqmp1UxWzdEZissHJgk35y/cpD7k6XXxNAIWdrSONDBYkTFuy9eTspSvcAOwepaOpUqMHEIjkDAvSqxMh0sTViUHUa9NY4ZjqMN9TbJ6mkDTQc1SJTqq2V0yxiaDN2CkcnWdI0KRsZ2j8x%2bkbi4l7CDb7Pmqe8c6NdYJVlja9ESPGYGDaEtF4IbrgM1XVWBOjBltPaQLbS6vR%2bZBIwdjer1OWQ92rQnOKdaS2oJ3QJMXU8wzMh2s9MaZ2PDkcBjNNvbJMa3/hMnbvCTpFcFaNGF48g4UMgAwyRu09DeWeX9CwC0EqBIBiIVe35NOgbO3hS6hg1aY13C%2bGxTD8jtaYiJmiN8j4marGWqs24QNXURuDLAZkuXYIWAiH4Y6lrQxzMyWGRO5ow8BzK/jqE1cEhuspmJ1qYiLrijKbA5r34xKkRg0wfu/dZw/4BpCiwtvUekM0GNFdd4VinPQQgjYe8D7SZ%2bcxffwTh%2bdSN5FtYBn0LcUyCPJy0spv999Sg/dXptDI1SFI6VcSCCWSxJmN3mX/FUg6b9p34sErnVQMzcFNQnCaybu%2bXRCR5F8exnf12z6Hrooq11ijsEVYWgk6WxD3NRYDimLg9E47cBkACkWyXQbONfyc/NWz55ALFbfRXFbCLdOcquUZ7rxLUGg7vZvuyBDeMNZ4AitQx7KsPKAqUCc/CVXNN%2bFd83qh/sxq0R3fKlh3GG/IEEc03DOrrR3G9TK4DytQx/zZ850YJPll49oC2NA4Q9WnRdBG89vH0X2nhSu5vxwPVC1RYIjqYovgRGRm%2bQmShxTZiv7wpZUUfD7SgTkkXf4tNlItrMEMDmRa8szcDSWQdLTgIpiEWVNBU7kfEHLs43AAY7Biow3eXKgZgtAxhsDYwRAEK6c3qTtpsFU1cKgM8YBbEzvr3VANnGyx9C4GC9CanC7z5cJ3wWPgKbQgIIxa6tYUfX52Y6/dyQen639/4Li1Z%2b8vTqAG34tvxcXI0iXTnR90OEqiqJc6n5f%2byB%2borzi86gQ7cgVdHEry4Bo7DOQT9z%2bb9LvDTJs38GI1dqRAsnzj%2bRBgVAPWqlhNUFjOKeABzou8iAxFtXAx%2bMTC2AGhE5UCNCYIZWQ/1oDVXtmcSssxeiXxT8IrhDuCR4GNZehiMjOu107WfZaXLgzz6QUXCkX/qo8%2bpZb/KbwHCScRplsPs8k1z/0aT6V5NeI0MjXN85Mw5E/ZkqUsXnJi4tgaSRIKBzS6dGhTW%2bZbd5MboxAJqhKKEbgCS3A6kR9CAi1snJwIpOvaTiVo%2bkE73TZuIUglmDdhI6FcMsE5fUGz3C3%2bwBQ775lU8J1IytBQfmGH9sXp1xd7RQxqckKy/wvtm/E9SjaZlxAli6A%2bkd%2brIU7MFQwsJIQztVIKnf7M70uzvgLJwn0jWc0RhMvXfUSV%2bCOP7UqUI%2bYXqVgNZ7/37v9CvrTPZx1tLpD6/iq8ioEv1JhDek8Bi1FoaRm/GmE3W6IY4ni6lfxeBUhrXJl4KDwd2asioHES7qKqkxAKuLgRllVYMAu7mLCP%2bSKLdYnxg5kK21dMu42YmW2BowJXPvIAA1An2nAkH1ItwLssnTREmoObBIDYU%2bOKG4sEio76bP2DZtyeLf5po1lQRmL/wEF8%2b9CJY9ic4N1k4VJf7Nw0peQXqtDO2SviH9qGJpCmTLlznbKuVY13DMbyx5Ua9YUAwOo24xdiVuBvahAwejaRAMVo6rAkSpbzKoc1kgW2RNTMmSxuicKmCGTwQspHofILcx5KOh4zPWBIgWBdUAag30ZY5lIRgEYwGyQ1yg7lmfrSRQsDWUHsBkFlmJUiIMVVfv6nIymey6bjHXQSm/CUMagBGZUl/Nq9gT9H6s55c72K1SsK/ddC3Rv3pT7k%2bUXi2gXRxte7dYadE4QG4IhVyqC8tvrI/O5zcY9nSv790vvfA5xEn0WDjSwAfqVBm2Ltk5hcYLCqscOVBNHK%2buCweJWCJhU1sGMBPGFcGMAcxs%2bZVErBUwMybJyKE8thXGAk4RZdFYYI67nqnhCgMvqto7wgmIAQRPPbhlBuD/PS5tkzYW1w5R0cTDoUPDDM4YxXq8K0Bh399s0gcLZ9V6HU9oGc3GgL/Xe//u0VN5Dek1MzRCluZYQnql64TvW0BQBwaWhp2fMpjMVgtsYuGEirYBjCODfniDw%2bYsnPgBnM7YErCy/bSPyEqhsx6Jm2Kha/pcyKaIFtlWBjPc7UmbZVTJvkpMMwAUBpo2A7W9jiJMdrwP9kuamhxLbRXmGtkfPiXrC46puoc7eh3UKYBei5ysLj%2bCqmI0YXjI8rWRufuwq2Ec6UE9cSRwxAeIKbtyViqcekOjV5heNaBdHG173x1tndtGCDpQv9BzTCXl5/j7eDaO1sXrsaBD03S07I/tmlRzuk/fU4V1uR0/S3FT9hKonxGKmSQELnQVBDN2LQE9VjDL6gBWbPOgxvDDXdqiCAo6PWVqPqyGA2f9Oyru9kxssgAADjHExEggx1pYDYKRPkpaHftGOMX4dM10m9JmjGmtAq6rda6cidW5YJWOnf1%2b7/3PHVT1atJrZ2jkZgdPYtxbFd8eC5wnASCzE0ZMbqbbDTqFkp70tx4z82WGz%2bYHrHygMpviDkJATRzjEB2Qinc1SONyHETZyM4ieGmlABySt%2bFOI2T7DQjLEGU/N1OKyyWyFtR2PDcdVQVqbopIvmreNUJBDI40ysu59olBpsNNZwoOg1r7VHSViHPQAMPmQBh1XMfT5wai4rWn8YYn5wn7urala1O787PsugFLj4zO3fOhhPNfH97QK0qfBaA54wBq0%2bAFz5KBlfec70PcmxkXVAdxsXbhwIlEDtOkLy%2bZlkPTIAoV5UUCSc6qF44dJOVXrYFlcxS/VP6TgThU7uOOeT8uXHfpQG2wPwYQMz1bS24dkVWmqK7u8aDyn1xkDiYICtBIVxUwrgCQZWSqk/Mbo0hJ0pc2dcXvrg215t/PzqhD05k59pzZTOZLtFQ4Ct%2bR/vXnXPyx06sHtIujbe/0c/abQIl5ML8oKygO%2b1rcdyfKMsR4F78cyaW6sQ79eMzqm%2bnLUL/r27zr3rB2Gy%2bmJyNgUjy1bgoMrK2b%2btlg9cPWbwYzEylxCbiwSw5D3rgMRVBjY0zZAop1Q2lh3ZDunSnWZAgj7orF2SAGuVxNVHJCo7RcjEqs7I%2bTNXdSxKIObNqmk2mRETpnzDPzSsErDFsthL2uXOgdJJ1rrv/14kK1KPLVpc%2bBoREaBzSBUh9DurhUaDf1chcqBkYVg3UyhZKpoxqcfYh7UEe/UX/WA7JZTQt9S1k3%2b0E5U2ZnJiPrRuEpVGBmZ8EDX34NFtQymLEsqifcTzODGlofNeIvrpuklkS8BgvbvfgpD0E%2bnc9GeKZB8S5Zcd1qmYJBScjUeBluehCdAlinJVCAqP2cYy3EjGPOy%2bxqy3uwcMIaZrzclXMuvep1m1X6LABtONpCRFvO%2bjOqsatHtYjOfpufrVyH2XTHsCqVupIFDZx6w0EnU/HPtTizsr2upqBS1XeYlMR5EZdmzCxYBUmV4mFXqARmzlfjukGKrncUEAPlPunYt6Vf0VjgmF9e4a34JXehIqwo%2bGModJgR4mbEYhFt4br0uMO7XzKwoxQ6cmJpQOXiJG5zoq9NfOSwv5nOTfp9Yme/3Xv/9tlmv5b0uTA0Ql3aepYBJal%2bt8zTjhXBkUTEjFNicEkYvy4%2bZGg1k5lXf6hRACI0yE5KxMnNwN/L0MlMezeIm9IeEDcFCVTcZAkhZCDVcAMSKdUZFlCZLzzDt0VtGqCYZ8U0g2zcio6IdA8FL5JZfG9kNuQ2XGFddM7QDi2hxecTnh0SKZqnDnliyCddoN7R0xWV/OZDZv%2bGqqFXrjx%2bYsZ7RZbp%2bzEirZ9ut%2b6BbHZZkT4bVw1Mnw2gDUfb/41Av68WHCVYZunMStdjpq3dqhedTE%2bI02J3F6R6Fzo0bEjeryV3TrEqUlCA63DFjllYN6eeAJc2TxQvCcwalg06tFGJNlH2AQWvVgs7ZOOSEqjBLUem1ryDbMCiIcIZnDdHG1GHZkBuz6y5e8Ww5sI4kQleWY2wd%2b7eZUPL8SKn7Q42yh4TGcOSKbt3b%2bLOtoRuz7MEJBA/q7NBh1bWQfT7RPTnq9Jfe/qcGNol/Xv%2bJ2oYejquLM0BiG3vJMtR9g7aQy/AOT9zp9SbTsgUzoE2tjrJMNFqmG7ZRA4wiJ21burgphPWTJXEgs5sHMWotfEudB1kA2AF37HI1HzwSAG1lrz%2bqUVjgV/2egE1nSs2ePYjOkbuLtIn4Bjo0q6PWdqpjBD0cxS%2biki97jVFmk27YeIWETKufypBKnjPVsYAvxD9f3iNOzqdSZ8VoI2Itv9XOp6%2bRB%2bjk4pQEDv3zg8LiiXhTzTtxTTruageCxYqFbEYdNlx7Wba0QmcaW%2bwbjYCeZA0rqNjN7bJsbCy7FPmQ2CztkMU29d2PNmjYrxXATWPVhrt1i0nQ8dcEOebRgXxb2LbjD3h%2blSAaZsQEGRRrvOvXUHYvXX5uVM2faU82bci63r1ioG3ng2mMqaO3lCWTNjOVSn6aZopFVUsI736qBqz9LkxtEv6d0iovzIwWIvWuwczeKFb9zyOCUU4YAbSrXTmwquCDRHYP%2brQKIhMMgRRhyZe58jEkm2Bw%2bDDfLDIvGgZgEbxFIPYpiY3Ld8venwKqA44N/IbW9HIEmRAtz/bJjDpjAnK%2btizNWyWLGw3y7bcMbtWebGTUgggBS15J%2bH9yzkJESUPLysgzNK5M8/huiH7o7aGN7gvZRL9m3YKWygvu7jvyaSFjH2Je6XPPgNDaUv4HUr9u5/Lus0qfXaA1nu/KCv/QToefnVgaVGX3hUQN7Bsmy/ZTugnM6HToflddyodmh0ye2rSoYHG%2bOrfhPsiOJb2AOtmsDQ2MEZIcmxPwAx0RLjjEl2tlxCQEl1b3HrI5pgnzUCNMqipYWAAgbp5qCkTlw75%2b7HItPbQYiBJfKCRn7EyVXZlXOoWS/kWLInXY33LL9r1Q9nu3FjTpj1pPJHGOkFfczOKnVB0Cv8TbiCkhVB7ST8zOf1ZpM%2bRodExS6tns3lCXVz%2bFpNyoIXIWUoVRa5gE/N8Q0Z8lzjPG6rLgB0pL4GNhEljiznrJpn4psXEnaAAzFq4z3jLT7bqGxT9pnzXp4WrsgKoGb4yPTHKlqHNEdSwA0NP1nPIOHHNp7BzcMAVhuh80AY4i//gVSE/Tm3XmTC6khg7xnu3FDuCTXL7kx2RMcSlYut242XKujP9rt4YwcrpJu00Tn5rqHU%2b2/S5Alp46Nil2I14BQChUH30mNBJbAK1l45As1KXVYcra%2bSuv83oJj5O3Gwsqxf/0OXtN7JDl7DH1td%2bB3VTM8DIwGxAvaZghmJmoDqo9EfOo2IY3jMgURz7T64eMBwYttnqA9CPqbKe/Q5Mbr1qei4QqonQAXZ/0huW4xbY2uY2kl/uH11loBHB76%2bZPhMlTU2%2bn7R0XtoUDkgfj/07X2rHTSL4LF01MH2WgDaWY8BmpzbTeQMALpHKcueOcVt2OLx%2bZxMHHLg13%2bmDDsbpTVCHprH4vd5uB5GNiFxR%2bqFWNhxLdtKByTIFQJB75AH7fbMMT0mHVoMZ3i7qzfa8u4z6hBZT3fV9XAP6pOZ%2b81XMbbB2UpifMygk4dAca9VfEC2VCChphmLpFno5q%2bYOERjukUIZJ41EpRGriJ3GjcNEgMDO4f5vTFENsqcvgPYJ03XRbIf1lX4BOhoH0oubJrOLbvViOlhh0LdZfUGHJm2Teb/j8OlJqnB8c6U/K5INz9zdVRcETqI6OMA1I1Cspc5s30/T9mhogBZ%2b1VED9tlc2cpopC7XFvuthhDGsd0cSyNheEGNbyuj/FNBJnlZasSHUY5DsILCdeNMsiCjA2SN6mmb9vj%2bxfKn8d30trmlyaE2Wjj1lLox/dXP1VUD02cLaIOlfQ%2bO6F%2b3JyWwLNNPxF2pKRkPdJOMGN6qdNso%2bvOkg29HGcY5ZDyenZkynxhdK2Bf0BBFglR/1uXmjInAPT%2b5ReejHZ7AmM7MMQXIwgBMcD/ozR9BjQOoYTISJ0Ds9wOdP8YiNmwI2piS7MwVmLYPzT12etLntqvy95UCcA1Wizt%2bAZuVR7B10pUD%2b2ZP3hZffZULJay3W8N5kGwFDU73n6cjbUyfM0O7pK/ThKVVYmZ62d0zN9M/235iHVw3cNabw1FxxnlrGgeUuvZt69jNxC6Y30l2tmxSEocNKJDprAwAlc4My1f9mRW%2btx2kNXCrG%2bGzQTQcobtV/ARx84kosSsuWZpX1Bv4gV5NwwIZ6CcQE%2b3rTncgAsZYd%2bue6Vm53z9PxndcZBACp3eNIupsJQA4jhNYXUGUGNfjTE%2b/flmJc7L1rzp91oA2XsKvwxH/F4M94j9OFGK/Ynhdy3%2bRzzfYVDYtfQptmDE556MlIKYdHF%2bHU7Dsv7Z8CtNa3CQf9VXXpIojrJ6R6GRKKS4D3ouZsFO6OAIPnZlTmQHb0WCPuGYzfkpj3eYxlp5Ag46arxvLAAAgAElEQVR%2barKiIIqeHKycoZb6GcJz0K%2bwNtWVj%2bUV5Mw5yTrd2bBmbn3%2bMiFvDwaqrXfohZmdHUzj1aE/vW7E55M%2bd4ZG8jJmLI2CyKmm7A09fiaxp2IC3Y3XM%2bWItXVx4xyux0tZDJbMamjBB4ks4GB011iLm1I8fG9QEweCpnqrhk0aY9uYGkOTkZk9yXpFa6E6FQuoybWJqY0y1G8NUPKJyIOaN4Aaq4Mw2XbPAJQsUTTkQDPXjUxoTfStvJSX3vvkekMnRFepSaJejF2hJBhBKqXb2uUNCdZxG1Qu6OEf0e997q4amD57QBsv47fhiPubuFMydvqtxRDYEigxn35ks%2b41WfIeroPlQIXjK1YQ1zOW%2bWB04soDplaPgwhmKEqChl6ZHrcAZgD8blmWWXlFF4hWPNnBibEhuiTLwArFT3TpEPdaZFEtbuBsleX7rsyPgTnml5GZvHv0jeF5k6oWQIh1vVTANrcikPaqgRvokaNMOm/mv10e/UzTW2BoFPcd6P6LDRw2tQg50PFkXSUBXAwwnCm7c249mpmrZFDbQrvMClj4XTXFizKdETfNyIBi39gHgD1Fc2BGHswYF5p7AqUgZp%2bF7Ci7zwdH38TMxPUlPWbRi/nrtTWqe/PvqLkSwrmGP32F2h2Stz/ebK6lVu33wiBVyKuhBRK7TOGPTUvcO5VohVN5r5UvlH06P%2b/0VgDtz4/daVJ/EwV/Dwp%2bXaMZFK3UAWAabljr%2b92u0zqSU9EM6heRN44DwWfdGwQmfGEc/QbrptQDDTfCBv5wCkz23wrM7BQylj2emnNoZb%2bxiS5el7aw/eYISs7oAPq5ZmXthBnKFCwTXSfLkwsPWlmbvJPjFMVQfHmrPScQSEThaCGDhLMBDWa2vqklXQxHIV%2bXa9epQ792Jv%2b9/L/yuYXYPkpvAtCG/8x/DkfUINDjfGQ5SgqPA7CyQE0m42OyhmWJi9umE63T9W2bzbrbCJimLOjkAIztMhASvRN6qXtwRT%2bvJmJ2w7A5rGLm3q5mwF8tMeKL7qvpGqMWIts%2bASA0DQsk0UF8mxLZc/fkblTh4vDdOAMR6%2bSgxg99LuhqMlgmALy4duBi80ZeZbDvQtbHxirDcr5tttRpbMrjfd06QGOdpBv5ndnncuZIf%2bHgyXx26a0wtEv6BiXjABgCThYS1xT7k%2bOzGiO9ArUciTR0tzqJ1XEEB7z8RgCOeri1uDmcacU9w4VEEqPBQIyG6yoFlHB5EemAN2dbU%2ba762Ap0ZVbPSG5YR8%2bm3kHvHRPTU0faskEvWGDDeqQ%2bam5BMP9i85NF7LLfXl25UkrsDDwWEFxG%2b8hpgiTW4r0GeorgFcXreukF6WMwgF8/OwLyaQT/epbcdXA9GYAbVDnvwFHDMgCAxIfHP%2bCN7iycMTtNkAEMOPsf0QEMLEM6mZMRMSuzEIsFhotrJs2SHFt5kibWc5s8f6uE5I1pgyDrAazfUXAU2jgk2IJOzAT3RwDy0JgbLh13gXzWjPNF0apxVGPi%2bGj1RNgkGRxvkpyi7dzSnPgd3xQ38TNq/axv0nBPPpNVNOhWC%2b3h%2bt9wTvjdFO1%2bt6Pcv/0iaI%2bu/SWGNol/XECluapuu8dyaDlfNamBi%2bXUjTclNfC2thAD5t79Nm1UgIBfMUfnp0tXyYGbtSvoKsCUKIZmAWPg4s49gSD0liajyWm98G2/ydbIcX9spYn%2bjt08/COxuwWsz8Vk0xeD8sArrg4PSagxKCfVc0XuKY02bkJKFxXCIRiCCdKidEXlzjJShb/L3YRZ8oCNySLPjtlZ//gLblqYHpTgDZY2t%2bz3xU7C%2bwLYa/7C6sF7ZLK%2bX5FAo6m1uLahlWyHaOTL06tm8i6hmxjIXP2vE8DvcStI4uZ0UWkZV0bMDPcJADZJRMsKRtHmotnJm02EZIjqBHo08SiCSdFPGWPzbbSodWbE%2bd3kem320/0ROrkwubZXhPR1wywL03BW5AqNhM3Xbfqp5gZSfitt5jeGkOjuNPzef2Z9ChW0SlZr1InPhY5vSBbW/2ra8UtQXRato2ajeSldRPRCnyhWmwzyIGybdtSzBwMaSpmauNFN0a6gYkYEYQFOh%2b04FDXwFgQXToQsIRdykoEZIvC5qYvB2K/ieUR64JHoJOAXlerzaCa7gwGCoJNjAt2xoX9hvj%2bq85bsbUOfaxP/7uC3jfqUj//9OYArff%2bCyNQnaNo0doZO4R0RBQBNjFFDopn6%2bScMf7uxNrHOb0KmdlxdUxkZyhuzghDhcH7ZwiDBL5bDsxciPD97BOM0CRmgkyqv3GzEA2pzbrESXECmRqRUzK5uaWK0CEnileCIPuEy6M2nKdM34WsiZnMUslWjhOm5R518%2bVm7kIjV2RSVUqRNZZ2TckmQSELIKz%2bEf38UZGfc3qLDO2S/qJ9ZWI3C0KHrMS8qKkNaRcdurmggbKtEitN8jI3T3ZDCFoapvwWXpDUeQZGV6GCjJiYb1xDw4KU0EIHCWKqfbdNebVuFl2h13GhMy6PNugWeOMMGjOecD0mOKIlgwG8WbjVlHx0YP8kOfxQ8XskdWB1/oebznmb7iRmLhQiHtJwzbg6Z0uw7eGysfWgQ3NGgOHiocGoelKGePei9ytu0lsFtN77ZdeaH%2b4zdvCwxk4BEWzFf0c7lxEzt1rgWv4QT2OAwaVexl1fd7q9CWNYrsBRB/LauslkqMOg59IQPwHokHU8BR3avhGx3qnTmT0R9qRxHMFM6xltESBVfZ0tamdgipKe3OYnVhl%2bR/qa%2bSremU0suCN8NRRUqS7sLb6IdIF8bGNViTu8TBFMpwmC0XaC6BrBij8xBvzPn/MGKGfSW2Vol/TLKjYuzN5qeVp5/YNh4RpYFKPcHoCYMblqFWeVgO2ItypGwxD9GYJLKmWu3FFmhHozZE4tumUYY7KlWcjMgphZgJm5m4RlXqGpAtQ8rnGGAhSEEciYNOTQcHdToG%2byibAu6q%2bfeHfNCN8CS/Om5pGPDbmaWj9ZXXNghZarQ1Y6sFrMh6J/g7A/wv4AsD70wS5D%2bKsT6c050sb0lgHtJ2lsDK5m8cr/TI6puTuq8Qlgz%2bs1uqNuUfYpdD80dhYf5n6MBCvrFzEMtXCrBo4O516YtZzdIda7wFF8HVCJpdEAM18O%2bt49TcVMMjB7ModesttVZHxSXzIIzw2gBk1x0C2loYOvcq/pQwJgRusv2cRBUC6D/xoDGtvr3ZmrrI2Vd30VIze0SJJzjhX2JqsENAD7MERNdxyDuxARNcgcK2PA//1WXTUwvVlAG8uh/nY6XuQVZ0Y5F%2bNNWWJzg0jTbuyGFlp77/tt%2bCaBlr9wK7kwwO3q5Lo5M70taWkOiPwXGZe4OkBi8wsTg8XoJOCBmxcD28LewbY2cxczW2Z5yswE8QKIDeUdI9FB8jPah0ytNc/MnOMtQflCO1n2RJAdsCRgZHo76jfmVQVhvWmYSmIp2%2banuy0p9ucMiuMDKGognUK7qk9IAG3rqiIpHmdM//H81NtJb5mhXdKPL3UKwNBmAmG0jW7qwJi7aVLqog5lBOEj8SkqAjcIZu1LepgchikKbAY5oE0X/Rk7vZAldsxiTxpOe1zxpKSIQzBIiPxahOmmCTOjAFxPAi%2bg9hK3kScsLjA1bKWLc4ZGArj%2bOclLs9BQZzXHtHlrqbDtSNjhOYR5IjVZ91lQ9m6GrWv4oUJ94aMqR53a1ZH2zbpqYHrTgDYcbX81Ha9%2bd9yUougwqWzrRFELc1dicSp1KOLcBEQTxYBMp14gkzdFjKaKWyaPO9yGGOSMCmHZkDKtQsy0qBfe/YOBETLBQnU2sRq3hSNgant5LejQYHG7A8DNTxTjxTLI9rvaCuO3eborVkooYKdg450ID%2bdhZLkaS5qr7mrQcRugxPcRTMd9WJ5s82t0wTCraae4%2bDwnqSsYnr69vOgNpbfO0Oi6E3ThjxNXDeRlTGBy7z5CaBXPao%2beQGaG6pwE1qZK4qYLzxvbBiLVzN0YXU6KAIOFuPnkAEen%2bV1HJ2xthN2ROGisoX%2bA8Sg72NMTGAi8mLmzLwE7x04awbKgoH%2bLonM1%2bMslSZYT3Tcud/T0JABJIzgmXi260iqumZXLEfmBjTpGBcEsrB9t6l6xqavGRgTsaWf56MIxS946L6IlRuaIK2C8H5pe828sKnlT6c0DWu/9L3Wi3ynVpKgnU035uA7LEERz%2bq%2b4Nw%2bbJZI8GFz/VSY2zVrbKRmzGflRkVB3gAriJmQMIk4lnnlEfIIoGQpmwtJ0fO8ZWZmYri0KYNY0DLhUj3Wzipy2Z6kYCoSloTtHZmke1DLybclhuMmE4iie%2bPyJVTS/i0Z2bwMrFLjwhcH%2bUGPysmiVccJKHtIhuT4IDG6eC9pnZ/7WW4t5tkrvgaFd0n9yxNK6iFwbMLORouYk%2bqXtaS5yVpqXZSqKYrZVPFWVIlBxOgnhr8kr02X5kUm2uIO7gdmT6NQYwAzgUUQ6XLj%2bNNwupHwBIIbIubJ5sGuxMjhrsIJqcPT1wSGBYTZxFjax1YTrnurDPRewdBoAKFvLbQpuA6zVKhnmOi1/4roLxE/cMXD/G/XddZ7UuY0hPgwYsaCDE/1UcXNvNr0LQOu9/8lO9MMlS9NoG3id7ZdIGHhx5NucBbKbJk2VclhY0QH7Lp5sxSJj4YMbhPcR%2bSZa7CSxnINt2gR0XHDGEcnWXKp2vdxTAEjFQlhxEGvE0EByYd67E5mhWUp5tOGJGPRwVh8yNQM175/25MoOD5HUhG1PXfRqkm0L0f1VJbq/ravfIeyi7kujXazcdkHzqn/bNp0QRdS8HhMRczhti0U7zVE9qU%2bdjanjfSzEzaEp%2bc23GPNsld4LQ7ukX16xtDS9htSpQ3jZuNxkH1Hqwzt0aAiRsAZcNEpDpBo7j4chKbYBXaZkwqshoxM3J68SxVon8hmgYF6MJiFMRE8%2bNeKnYQ0NzEzZHIBZg0XkxiEHODSx3sJKBfTzioYJaGMENdXnKWNjuwFhayxRaJvThEV/NGHC7Mqv%2bXcHkVn5IGztF16Bie71K3IJ9wFNkTU2q/%2bgsHfFzug9AVrv/WtGyjNLE6ulsa4NLEoGYoolzKqwV3eGqN1mFM0szdXAA7rm0qtmi5ZHfwnQpWJgYZTWrtixh8XtI7LHDljm4d%2bSmCnPwQpHNxCMY3ZJF2W9uITIBUzeIKIGCmBqDRxvnacIALjqDtXwMX5v8KFKe7zz2j69v3a7d/8QPXXqg0azGgM2KKNKWTvr6pYcG8T16/K8TF/XYdUGuniQLd97szHPVuk9MbRL%2bt6MpVkH946RalkC/Yn0nMoj7QiLjs6nHDbax2oCrnJlcZMZDAjNGAhYKdHlQcJwq54toTP8GsDEFTMj8w%2bz5VSSn6/AJuE6TARmt5LARbQA6TWCWojN4ZajyaoLdfhodn97FU2NGvoAFKTFeZqEVmEtg437iCs6SfFyxtLnRgyTq1gsh1VUHWij1mKy0sWJmmaBf9OL0GfpvQHav1QfFpUxg2Wy1sqM%2bReigvolLqCYukqoMMbctzgz6%2bBnG2zo1%2blf1Aln2grxJCX/EPPOj%2bo5UeybmNmWYCbe/AhmFv9rv8AceEEQbSDyIrjqvTremW5JxdiRvxd4rEucoGzV64mPGgGoD9ChsBeALHnbcLNf0IsN7Zu6aGwAPlu3zVGkPPgA5j2mS3CYpaLf2NUp6u27Y2f03gCt9/53rorS0vLIbs3nhh0JN06RGPJFz7oOAKeEHkDJst5PdgqCOGJRdACWeNm6TLgV/ote6DHqh34ybJY2dEzK1dAtghQHNBijDO6L3kyCRaKYuWRm4zcuVXpqEgrI6sdIIAQ6LD0mTA3EKWzfBRltc2F4BldLCo8JaDMrJFCnbagPtvHmafimiVpi2/zThIft788elpJp5cBs7DNOk7qVHeSRFytdSI0UIVVi6uZZ28%2b/J1cNTO%2bNoV3Sn45mbhE5Z3oPFQ1AFLAzPjmu1MysL8zOo6O1BBcvX%2bnFZoCKs3zVSJa4YWjdhFGncb1ASY56F/Q9Izus7hlYk56TKLpyBhePswczB8BswPbExqowHtsTsigNOQSudQ1XEeSncb1/tUziHqOgEwyrGbwlQCJg2NNQO/bwP5NJTecv0Nf10DOQpfexn6ZsWm3xqTazmG%2bVxV2WznlRswNjhCt%2bNnWSd5LeHaD13n%2b2d/q9uEpA9Wjdq0CSgh7X85U0Db67IB0dcbBMtuyJdDG5TPtxfZ/ohZx1Exuu%2buONAgZfw92gYXdvcxfFzr5aFKybVwCRfQAUBDMTU7EVwQz3KXDsEtiX1WSOsMCG0PqJQK1%2bbs0suAwLxi8yP3O8z%2bodoEIARM6ooxv%2baLhMidBlY/zGVSa6WgDEzWghR4vmVujIcLmTV8%2bJ9dPl/1vvzVUD03tkaJf0HyBDQ1DTzvHBd0gicMAVc7qj%2bpvOmpJMW7YpZlxn6O7H1jSx9zD3kSG8MLofAnGz%2bXwNxDlCVwstG9w12PRmT4WYGZkZzZiZui80dRMRzvfUrC1P6kVroKbiMbBGuXlkVRgIU1xJzNJpk4JskCfGD0Njv1lwtCDjvasYLpsl6/sxlw0KLhtOpC/M12Jl7u4deNur9q24WAUMAvAY/mKq5B2ldwlol4i2GvvRrXrCKKPh%2b2ZOHuLBvWHAf%2bcCAJZR0J3ZJr8%2begIXL0KOmZB0WcTsAU7zgVOqeb2DM20zkHhqNnIZmBWBVZTBIZedmNncTuIunM/THMyU8WjdA9TgLtQSCkOZKyMBs4ItETl5NrKXiglHlszuDcrb6ypmxmvVo193WCJbv7kK4jn6l05KbbheCEZt5jIk37cPkc3ZJLxtmcn13n/zPbpqYHqvDO2S/nv95ixIlTwIj2l0zGnXhQF7joZZRgsf5NslbWoyeYt1kwE%2bMfZ%2b%2bOYkre4b5b0zLnDUtTzz7zLSp2ADzIz1HIDZqN/Et/GvwYL5ZnsGqEvHgFDn6qEBFG1CwPtUNxVkqJdrn%2bT8PIZc39D5ol8XCPBwipa8u//hyCUuFqCH5fDa67dL/j0D29rEAgHxzuS5IgBvUIa5lLiqfqZuwftJ7xnQ/hXRqor%2bAl0xvKn9g3VCMragvWnoVq4qlIK1xTRRoUGJAK0iOSFlmwLluI7hZ6E3Ul1UHyzEKZrAedZu14MCAzOTkEcRzNiDmUTdtTJhmIMZkxEZIvrUD2vcW2Qy5aPJv93Gx0QdfrDulA881cv916T7u27iyjEYPBh7dn0%2bhG4fDfgAETSOkgPYoGMbjrTfPCzkjad3C2gXs3Yn%2bt5OuFBJbqIKKs61u7mxX1gcOVwIHZuU2%2bE%2bPn34LNnZDQcJDIZt10rvn1SNc/aHOTQRxuIVd4fS/Lp%2bEEbxbGiVsFKR0SOCqiq3mAOj5IZNZzjeG%2biY5Pk679a0xVOoKujjwi9haeOHjxpb7T/h9KL5zjnc76Zio22oImLkB3WyzdXout8c8uq/yLnfX3rPDO2S/k0DM2NFlZ6FHDYcWSxl8LEuala9k9Odtfmgx9RtwGxTuAn5Zz%2b986XeTTzG8ebz7Y37uS9hsfVaewar53DsZVmzaUYC1UGip78IvBIIEiXRwTRN38jaCBONeZ9URryyvpmIuAreE3l5Em%2b7f9aiE6TITMNDlj6pG/6EiXekdxGR9ii9a0Drvf9SJ/p/O4idcWnJh24zqYY2JjMM9EAExMS%2bw1hP6OI9Ocw7zTfM51dR8gSWHd5zcaDDFyUfbuRCNwFxszyPvxmvobPwPS73oJDazZD1KFVMR51rx8mtm04fAgLI3gS4akOSEnHEGeHd4Lqh/os8tj7sBo5oQY9wuaFrCLh/FJ//3Xt1pI3pvTO0S/qz17%2b9J/jpACQKerLFGEQkFcenTSNmdVD0RobkvwbpNJgmOkmpsGm7oShcx91a3BkCg7CxjpEz6dAYQgnpJjANmcO5tFTvWUv3j2jxBDrjTRm2YD1q3tNyMDwbRVfH0sCQgM9lXLNBGOxtgz1aAXIslJQkeCGKS/gu7diHi052g/LVT63X8ficSoQqdvZv5ef8PtO7B7Te%2b58jot9TXVrPBgIzHFhcqw0Y3PXf9uFqZt8%2bfKAPuhu2AJHfIXsbsy6FWFbXcrVsL%2bqgLq8PR4E9nUScwFKi6GTMbEvn1GUs1rYgak6kpDY5hzol%2b%2b1BVOQ8geQo2Pmkun5fgtVnEdI93ARSaV/A33D83nDxpupBq%2bcQQnaLEUBdhYB/l%2bzb97XJ5//xnh1pY3r3gDbSX7avWSvi/oL%2bIure9K%2bsh%2bEuihJnrbw6UsKqAJJwMC34q8FqAVksbWsymzKwazrAtQhTbjD3eDyXWRkcnyqQw2MMYmbRPhzs0dFXcqAeTa%2bKi/EbQmRLkX2do6s8zxDtw9gll9d5%2b4S9uMiy0Rqua3lHhg8fxioDZF16bRY3tw%2bbAin6RAaC9mfTY3vH6Qug7enr06Av3fe3rofNDNmtt6lORpgZFFN%2bx6NRNIFe7LzEo5J/IwkbM9YgjrhmV6eqkT9GcRBndJYjgDseWJ6pP4PEba1Hc/dV6NGwNjkmeqhN1zuNNZHiQoFRaEeY9d494yJhxuMBb7hkCZcVOXGw%2b7JlV31sl2gHurjziHuPvWurg0zkhICOhfMs/vt/3rsjbUxfAG3vND/ovf9N9dTuU09sWCRM2tlpWMQ2XTdp%2bhQTFQyjrmuSYa3fJrIpduYhlaK4KdvMnfFZ2is//v0B82we1Zm9uLlK5/RnUDZWkr86fVlPV43j3YDYXOG8CZYj8zOjpmNksgvWtvWoqqvFbWxiYaCIpBJ/yF0JyBECb7jMW0FT%2bgvl0XecvgCapT8u30KIx/w9%2bABprCo4bmICUKo%2bK9mnDpdsygXIKZ432d0W68OQk0GMRGfP/UAgpCg3bfViUzz0dFJ/JrutlyVFNws9x7AsStZP2qUNWWincK%2bB56aHvOktxj0ut60m6YVkbu8X3Dk0Vp4si9MIKaZHdU6xKnpu%2bvw1ZppjZ0VfIvo9Inr3jrQxfQG0ka6Otr3/WuGBDe4bIiJsKlK6uGmEERnMUbKobXoki50q3OhRDpffxo6c9sylIljHXp/%2biah1XtyU40lPhT%2bjE36gSs6RNNGoaZVBRDfYxN2eDFJFqbnXx90eeGwaRj/BkvZHw7og/8MBUEY1wq7ikCAIcPdiXd/73H91kSwOH8A7S18Azad9U4mILsCwKMyWaBjYRDcyFTttxr2C44azfNcdhDA0jda5dXUVEJYlQQptdO3Jvo5orzBaLOrGWKokJj%2byDUP6Zeu2QlzFFaybd82Xo/55VakVnQ4ZVhrZWeCMte7LwtDZg60eRuda1kjbuM8o6f2OvSTENWfbRfJNtrEb7hxXNQH4JmIIH%2bfKA7qzeMMuYC3nrjbLDxnezebBt6QvgAap9/4LvfffwdhVWy/XzWX3jk02x9gKsZMc%2bMUxuxX%2b/92JMamlzlCxwVTuQhj1sdcoiscajdWMFyio9cIw4EiRpIqMzSyck452pEdj25zTMbtoGKAesbSbPjAsa5NtAdXrfjwEUcjHhFFHaOx0bzGCJGD3WKfK%2b/4NGhROX8NGHz5suqQJQ07hJLZH19iKCRD6Hn1xpF2lL4CW0797PeL0ZKbzMMOBdFB0ihwd90O/ihm//8MfWmTSacoiYBQ7bWNjMEoUMOO%2bodUyKqV5D/Losl/%2bpQGdo3X4M%2bdTto4e69GS42yhdVc7gCtHYqL5OG/KWMF94%2bimTC%2b2Uzb0Qdtwp6ewFyeNncOiuKnMDGYQDRopUwu4dqCoCZPVF0faSfoCaCH13v8MEf0Qj/b0pTYQmIP4vrCYMWZWOeNu5o6hm2zIRrRD5lGx04ANxbI2LH1ONw7OmzG/DpBCpPwQoDRZ6pJ23yJsyG9UbeHmJ1hO1KPhz00BeOitHA1L2adqtG0Li%2byHLoxh8X8pDrLpKDvFSYKdD1rDvdmNtFmVwWAhz6bjfQmTLRbsW8AAgv0W6Fe/ONLO0xdAK1Lv/ZdxV/S%2bRXFTQEF0J6R6kw6iJfoigUEyiEGSwELpxEGfEhCVvgTnkuxOFC2Fs6RFF71mYQfIKejRME9TLX6%2bsVtutbXuz7NXvjcJ3a1PHMXyInVzq5ErlKFtsBRK1AAwkX1Q3ZvpSTdYn/kBWH9UcfTU5/pPL2773acvgFanr9vRLAzu%2bnAAHbcOdMRFI1Kz/cXjeyV2gvmgPCeOlyVVDOkGPHNAFpYfWpr4YN2TslOtWARDDQ7h8JBF27ic6DBpsBPtemZoIH6KsYAGkOn6zGEQuGo10YlWwCQ8OmxjHEgfruy7js2h/UQnKFAruJUEoKvd3Uq%2bONIepC%2bAVqThwvG90tE2sbXBylSxTKpv%2bf/b%2b/ZfWbKrvLWrql/nnHvnzh2P7RkjgTwTAZElY0dIjhw0UfIHJPyUXyJBQpREESFRQiABggwhgRAjRooUWcRRjBBESRSwFYgiRRA5tmWMI8wQsA14zNhmHja%2bM/d1Ht1de69o773W2mvvqu5z7sx9nD53r6u%2b3V1dVV1dp/rr9fjWt7CsDG4IO9NgDQ47x2RqmC4Sj8VaRzmaMn7cDD26OJDvGzL3RaeXxigbkSN2hktnEGpuPjad%2bm/0UJWNH6ZoFYKha4VabkkDg%2baJMaHZKY8Oh/vJnqPsfPD38outtaOsEqRWKUOPZRVUQD0y7Uqdtw9uPIHVglVA22x/n1/Z9Muc8rq6cpmHnQPRwS3qG1nY6VIYK6FOERpi%2bZvPqqgUEJU5nFJ%2bW2twMSO9MRtgpyRh5bl4ya8ldW1d4WxGwA2030VRZjpH4wdRhJHKe2sgv5qNLFd5KJPWbZoxbDe57HXJzRO5bJR/hJSJauPvTaSB%2bOKQVzsOogUBNO3mNIZzWYGprKo755ZVYvt0q4C2wRDxY37ohChfyMWVRpFlnDGV5wBWIyWvzHtRvSdyY0kAACAASURBVB1XIN1yBOH/krrBEJCTa3XyOA/PsrVM3gHAICLemDG5k6MrpbxspC5g8tX5CCWUHIkgszAt4ZdyETfk0caQbuy0IiiSMy2Is4Sd8PjGSM%2bhxqKLEiqdYKgwwpLcMr3TJLnunirdY1p3OmPA3QEZKbvsLEDWqAuPf7USaU%2b3Cmjb7UfDq4OWptRMzL%2bqIbFrYwI4/jJjCD1sb7M3KOWE9K%2b9y375oxnlzaDk21g7g9cbrRuOW/kN49yeFnrM9prbHV8wg52clkfLPSrIxtyNJ/ga9b9%2bpWyGH5u1yeYcisw5i3o6/cPFfy%2bRkHIpxeCSBJShv5m1wxQFSKcJV8XzzyPP6HMnPYHwyvefcqYfehteBdXyCywMJcaTO654Ck8pApAHNsc8DvVFlKsYcby1MjEwIKuZnlbp3GDDyqo6BChezNyuplh8tpanwWE1JRVBrcVjEsq%2brgxgdeGgDFeLE2gkcgfHSrEZoRhF11/3cGbhqy6IlDULxZ%2bVOQ3WURdB%2brlJiX8FYJJnBbleRIGjuK6Czh7ic5VIezargHa6/VJaYxhAcGVK7jhMgHQlx4vTQt8PxQAH%2bTRWR%2bXuGZHnoC8CD9QA9g6iqOSwhjqGcpg/yj5O/tooV63Y7VkunrPKbhsdi45A6OBNB0XR4miQc3meq2fijw15gUze3XpsSoBWnysBKMdcNuAKpDoak3Yiv0zcSQLyo8Revg4xOQIAoX6Efamqe7VtVgHtdPvHZf0sz4Xww3TFZ8xvJxMdxVzW6cnaXJgqmZzwUXk0XV9w%2bX/pfRXbHF2SMhJlCeZI0eAPrsC69CHS/iHPj/HzDOS2KdRquQxTvp4ebM2jjVjWpIXaQ9PrqiHL/H%2bTJB2RQu0IQlw6GAHOEQ9NHtOxy/Gr%2bQTSNschJtNLVIoh9%2bGKXCY9Im/vWiXSnt0qoJ1ipJX2cR1uZsMvskSu7uMsXJyk25PFk9ov2lRNzSqVkHtT/Nowg3TnxrMF2uHoSXkPY0beofiyn/buY6%2brTBeonHx2EvDMF6wvxLBTS9Dh0gQY5ERX1tCeOihQYtW4NxWpJl07xz8%2brIUXl1n5IUlhpbx/ti/VoC75usQ/82mKmju7c6uAdjZTFI4hBKF%2bXLRCZYUDuuDPKtA4aE4XeY4RK4AkAU9DvYtphdCyE3I/SnFjIxBtaHcqX9/A9WCQyyPKtM1ouDgKqLyA1iVkEK/VuQwEjXxWqQunTR03oscwVM%2bAiBE%2beUjcpgTqLdUn4%2bDVOTfe1jGWpHBOhlKD6hEGVKp3STdtWYm0d2YV0M5giPi7iPiVTVppiRSLMseRW2KAvnZyYavWGK3c4VBVy5xmbGIWtoAA6EjnwZYRTUWL9GiBgENh4epybHtHDt%2bGOPQMfqNpcoAbuzjLHKRRD1B5iZy/Cp6TUYGqKgC4klCr3iXiDZ9/VhV2khZg%2bMmGDhtIg4MzL94p0NL5OF2KSUfhErhVAcc7tApoZ7cfCGsW%2bSaJKjB5aJL0ZZIt6hXTdkZtpxNzOACgtILj0JYEJAPvydEADhz7co7ZoKa5xZrCQ9H/A5iE2tlawFveYfTLgdkwL3a2UDYBRkoAGtQDUUY2LHOF7HsF3ocJnizLBvGAGt5j7yxN/nJE1VBnV7fJ8g%2bSSkdID3CSBQocNpVaq0TaO7QKaGe0TCvNOen7c5RctjKlJwIMl/D9BbrubeCoBdZ4eN1mYWd65ErMk3ssFxSmGwmkHYse6%2borQPIGBZw2hEul6ZanTQobPLJuLGLUF1ubNh9pVM/YY%2bMHY0zmkDKNLR5LI4%2bb9ECc3mybDSaFGeGnUUYOk4fmnIVmqC8ezKk/lnhxPIeCZrhiCWrK%2b3eI/70Sae/cKqDdmf3HjWtjitD4cpbQECF5UopzNuzrhExOCCQUTXk49ug4NAxmzv6XHNeYHe/xlH2PPd5mo56VOsAteTTBB/autnhpeeVYLUNm4YNMzUQlgpl9fla4UMGk5ONGTouamEeTpZygpKMfKiTVFT1EJ97ps68KEtwoL6FmWPn7znCmq5V/n3pCzm6I%2bH0DrbQiH5KWpYnbOXFDZUw29HWi7BGhZNxuU%2bY4iw1yb0JoBWkIF9MR46bU2BkqnLypU59b5oS6IojNkInvDanX5u%2budWybDCDSqol9kaSzmfxqnXJrGfRyJkzuMSsPj9ubWP7HWVXF5K11ZTTToUuiBpxH7XlAdTzG36pE2tdnFdDu0BDx11Pl0g28LP6VTdLWamCKo/Yo50LuxQ3yZ%2bnpUJQ7vSp0ANVbOlbiM%2bUXvAABvRJTIvhWAtPYhbLNYeOGdMlFFUA6xkXLdlrwQ7ZdqAIlSWBYXkh5K26F2mylQKPJ30AGPQP3YI6VZvi9qRuAq6ky99OhtL%2bJ7BQRaNUPyg9uOcxqW6wC2p3b39m4RRl2Zm1LlM8qN8FURdNyQuycITLNgGJMp1nqirtkIy0kVu14ojcGzlXDGXaTKKTCmg/fn3HFxmG0eSeUjXJ3jYRrnOfSoGoGIegYoSPtYDjVPOXNtIfWZpQUjWhDVREt0AhlSKv6NX1/rsPMXRY6Dvd8JiLtuC%2btjz95jOH%2bpUqkff1WAe0OzY%2b6Q8TnTx9KDMJtgiyyKbyykbBz3DfTzeswEpuRBekaSdIlsUnasWXfT7NFaQ07tj/Zr3q8rUNgQxUx26AEo7IwoHDSDd6leE%2bTtklg1sh0J3Y/uXsiFQV0UUb30jJ1xYkXLnMEAmHXCliFcNM/L4oqWdUbKAfKnjqHmw5EwKDInf3LkTNY7YxWAe312XfzVmNVSRh8XVQBwMXqmCvDzsKyPFq2t5E3c%2bUCsjHPqVjN8jIJkSWaTRW4N3SVbOzKHLiA/FSnz5qRz5CaLpLSq3Va/43bvVJoyE6q3p%2bVcXQozWiS7xyftazmsQ697YSJ6q8mKQilQAtqGY8jjGTf24j47850WquNWgW012G%2bFcqX1Af6aKrszoRMdMkDEAJtBiomC1W4GR1d%2biIOk9MjpFp2fjaFfwO0VRwOtXwMXpvwnmdT2AhhHozopI1caY1eiGklvZ3D8jNh3lROD1uW2ylAUjxoCtN7pdtfHnrZnTYALOfiOcYk5x3C9zLclKJQ8sbzw1JVTcxO%2bn8YnqVqd2IV0F6//ULYkn9xlWKC6KNxSOK5aLYfb%2b0kK6tpvG9QuRunhnE4YfZj8LLO2k6l31G%2bsCZHwxwXaNlYcn5jhVPl2gpUE1bGCBAOLsYBOGu9/RyXLTCthddN7d8mO7KcF6LfUx/vGBMmtq5Z4RwGvTuXAEy7z6KYwT9M0h0Vf6yi4GemfOur5%2b8rP3G1O7MKaK/TPIUDEftMKy3TR0PRuOJSfWCV930MdXpL1c5%2b0AY4kpFJXdEbaBeSUdtCKQvrqEx8xLDtGf2muEKGyXhab1P%2brLCy6qqB0A2y9OwdDj9R6YzFAoeeR8qE3wEZJaug6rOpi8VyphVncPiph5Ya3BWvTH70SONME2llAlRQSK5E2jdoFdDemP1a2rqI6cZaokRSCEc9NJVGTiTPERXbYC5NReeQx1JnwlbjSFPen9LuYeq3mvw95qK8Hjsbzqn1kpeII2XL/GkaLtJCQZoTlFQ5tOwvhDJxXnu%2bgxXp4HtHHRcu/2uIPLtj2Sf6KzrUDlv0FA2/pqanp7/837wLZ/uhtwpob8z%2bQbn1GNE2k9rONNSGseY4HOXlf4f5l0WscB5Sqm24V5ECQmKeZcXX/FttdHsPhY4DT%2bssRh0CeZhX5tGMPBwOoivfNP1wWNADaVIPrYyMKUi1WHi2sh0LnDOFhooH8WVMLW42L%2bjw31Ka2iF1J%2biURN9bXQTg22cqkfbuWAW0N2BE4fhcppU2HG4R3iDpznOxwEm1s/xygHaeUN0PCgpDoDIbn5Q4pUQmUb3fls03XyypQMDy/5yhylJoxQ6N%2bgzl6xwuprux6eJGFrdFEi6Edk4NAS4P2fAu88BZZIG8x0pA7rsAuEiTzp5RHl3ukaP8iLlEooXUTTBiP7rx1Fa7I6uA9sbtx3kPo1ppCGoCUCEXNIgilc68CBTqsFPJ1rA7oFJs2/JnpaX3djlyFvMudY4tS7dtKwiYPMEOI1S0lNhS4WEhdFsiYNqH8nHpNNiMSwZRBcSMh7xG7Ua3Ksn5FRYtDR7e4IkiCxGUKsWF18zToRylBQoi7df9RKfxd6h2p1YB7Q2aV%2bEAxFeHWmmKe6bBSlXACjYC3WfBavZyUkstdLg2wJhW4BjN17k0R9OQ55OGmJgRLn2yAc92a0/R9pf0pnbzqmpXYx5aoadmmtglAEOgVHWRjCVn2ENTk0/CgJsQYsb8pOWey4w6o9qudBVWOGsUajpF8Ul/hX99ykeudgdWAe0uGAL8%2b7CXTOtKgRvJCvmL%2bswu1AYRRq3a4EBNa/dhLI/RIw5cU3x5s4dF%2bxAqX43lhpjDBRml4Q7yZ2coCJR1W4GqUpyjfE%2bimbT8RDNmKf9lXfpQGigtE2NZRlsUYnk0XeRY9OE8Fh6qMQmK1GfgRyLXxGPvXOw6YMAriLRHiPj%2b009ktbNaBbS7Yz%2bFiHacwsEVzfiF8dQND2x93wedtPA4eAF2GIOy6TyatiLpXwSLkuBHCa04RFPaaGf8%2bK58dGZghpwwS6xbzQbThYHR8DDDKlUhdpGDx%2bPo0sfKP58DpkdEkDEFIpkGMlKu4d0z0EHqzUw5UdbDU/M2OY2QJQ4h98zyvMB/vZOzWO10q4B2F4z4Q79R7kkqnqjL/AA64NCKNdL/SRQB3V3gVJ4r61Pn%2bZ8sAX7WPBqmENZXOtMscGLQq9ans5J2M4WNkZanzXk0MjfA6PiQqp/ohgRcDkF5LkI8X9TGxHpAmkIxdioUZYPXk8omVUxTRdJJuI8CmloqCMk7i2mBQKh2iWit/vqujqe7%2b1YB7e7Z3873NOSNcRUsvXw6%2bmgahYCf7tEZMUOcJ16DJW845xQkqRUBlb24bf5aI4eRtzwJoVZRxoaFgg2fq/wIYyHqKaEtnx8%2bJU6OUSnajino6rdoaBKUyv%2bL%2bgn9Whgp8%2bR7YgFP9uiAQY07F%2bSzphCebp%2bsRNq7bxXQ7pJ5HpGncWwKO9NFzQNSYshiibbhW2GCNPdADjvRGkIPYQAj/mqZrFSX82HH/rTKk9jyWm4qDtOVzdEK54bNzXCl0kNrsp0OBW4H4/OM3pxhmfZD3qVBtQbtD1X459RAE%2bDJ9%2bDb1IhO40DCTeb%2bIUSZpqRvlgArnVcipLiySJSdgr%2b37bRVe31WAe3u2g%2bXeyvDzrzvc%2bS9DeRAqJvawwpO9utkdgD/%2bjuSpKG5jvmRZHfAOCNI6VuPRtqE6KC28tvGbOBtbcijSXFCc9bKfiu9CyOfA5uYJ2wgIV4AKcOdE8kjigNM0hnME/mJhKylgBA0%2bKHkwvS5FNFG5qJRx8A6VDVtqIwqigbff9FPEjvDWax2h1YB7S4aIv4i0CAVXZ4XD81xUlhLq6JwzgC2R6EscsNVTfXCRkueQZrz5r/wacPTywJ38yIZ5r84v6/HiuQqaDl%2bJlfN0Ai60APq8p5PzPZvMkmfvAMhV%2bmIw23Sj0n6m0Xcj8DInp0CvFCg0KPtRhUy2QY/fNXujlVAu8uGLAEjFI64/9JDYwmb8Ase2mli2NnzRKiB%2b4ZDtNMFhlK%2baCTnznvZnH7bkJPTJFjQO9XVyU0FgSYLGUf3H0LFoYeWOGXx8zXlMTayBuWwiBc8Uog1ur1TLWfV3%2bBoWSfVTC6yWO6RDZO9onwQog6BDSB7tpxLs9QFYhWR1op3diNwF6vdE6uAdvftfZI3cYrvRPkyu7bCMcv9ifwbmHIvLMutYyVdAhw7fpN2Z7Q3mH/JN3fiKGtyVBzI7Wy4gkbxa2Tk22BJk3tuACPYTi9yvpFHyzVN/haDPgOTAFCWNsmT6rX6BYkDbLIkdUahKFDnwNpKRVN3fij7wMadVnvDVgHtLhtVrv43ZIXMVOb3%2bNML%2b9ymwoCwx2EUDhJHNPVgZk3qpxiOgCaQZxS8I0NKG0ptg%2bbsnm4jFU75GEY/iRZSaKwCOWJjn6noCqXjS/tEOo9pMvrw3DiWJM9uxM1z0QM0jVETsHLj2aos%2b2ML%2bfXUj1sUHlC8sx4R/%2bldv%2biqiVVAuzf24%2bV8AeEgaSFI7cFRa03fO%2bhtn08M0Ak2YE9NJaaVlHQoCKCVUAldqgSWIaH3TjaUDlT9kI0uFR11bqpwbprkBOnwt1mj9qP3wblDR9ywRIUp94/UUO4ylY0YKyYum959H7TpYjdH%2bDvw38PG5%2bFchtCXATUp3hpjUh6NB944lTtNx/drUO2eWgW0e2B%2bao8x5rW0Z03EpN7OLPel9VXVVjyiLlMNLI9XDzUeNwk29QxMwzQQkrnOcm5mM1iJ3dmlowuUo4CVfaJoZqzuYWK%2bLp8gxZLYKneXd7nnOyKiMoeUHrCYTMx7NTByUunvx5y3%2bBvFPyTcq%2bmydAFgynKOyU1Vu7tWAe0eGSL%2bCGwIO%2bX6zjyvzeEjqv3wvhxLcqtcjhQ%2bmRJScseSSzH%2bJgMbZKFGbVNBgKkZebCYzw04S8hcFgsTYdYkFj%2bKklmsGo90uYeEvnho6eRYpnjIjwtrnPBBphwoyz8JlxBp6HBalag2AyLt5z1P8Qwft9obsApo985%2bCRGXun8vhZ2aZ8a/8C5WxVjVgWc/CmETU18i5MWBbaAw6tiNZNnLWkOycWbaqQobG/hspdslXDS1gaTGRvaPWTEjZdz1JmXtwUCqWAqnjM6K9FnSuk4VBsL8AG4yl/2a2Auqp1QRwFlNpB2e5qKTpNq9sApo98ioOCA6VwMPjZa6U3JKeSV0hLoxXDGzZrCOFp/Md5luqdE7RbwIeFqsSGYGD/Rryo8z2SFt3qvJH7IskIATpiHLlvstfSJeV4kZ7JRnHFj/qLwu0UHTYKQLDyB5UEcSTuu1FVqGo4E4jqTQFZH2FT8pbOtJq3ZXrALavbWfAMjboACSxr1MC%2bJm50z9Xo1J0xVKGbHmVDM70QzoS%2blIJtrLFlmFoEPgTH7fRqUPOZpNVIwtFU7txlBIinonmK/mRsi0Yzy69NlpHXnjVJtEyhHq9KNjEi4DYqhwmixxzyCuFTkCWNKUJsuijxDPbeyZjS39xiTKbhHVV82z%2b2QV0O6hIeLvIMJzAMnLcWGEmaVQ08m95FosVduIaCvhi9O5NJdhkISLXHRgPX2FUYJXGrfCePEmVDsFClyamyecLMwZWRqEBvmzZiyXprZFhVLFKhtbpVSFld9T7waI6JoHn37FHKSNWoRUDPDUmQD81B4VvCq00KOVdid9CCzPDaTIYZV3Zq1qcUqPV4j47L27yqppq4B27%2b3ZvEk9ugu95TF2LggJaupFKqPRsWWVtrKYUK4wbobdEF8NbOKEp1TlTFXNcU8sZ2WdJX/Gq3DVNIWhZtgJIE9yasjY/vz/zL5Al6qIyFJB%2bly4nHqCaVH0YD0IGmL6Fx/cEGhmVBmSJPJ/Ix9q8vSmjEg7zJ39wulnqtrdsgpo99gQ8UPGwDGMVDx1tVNaosZG1snqTkKnbK2z6JVJWMbqEsNVNtVZzTCEOtvbsWUcCxXy8csj24%2bl64KzZFzKvTVGSYU3OW0DkkdXamOyp5wG23D%2bjE6lE3IGgZUjlVuWV0vFGCQ9J96XcxmR1r/6/Xd25qq9EauAdh8MEX6O30VATc8cUKGnLQi2ccK2mi2gw0wdId7pxxjHzFFrsuTYGW1sdR4cvG0Pm5JnoFSIkKeYJ6Z%2bSsAznYVkuPlkM8clJPL7sH6vibOkUMKT0Tn8bCjHFjXl4pFbyk1iJg80SqT9dNU8u79WAe3%2bmISdimiZJaK3VTtRte3IEkmoDcSxt1RBt6HYgNwRjUOxM14pYzhWzgQwqJ6yt6XrBy4VCFDcICf1E0fzErKP0ajHGBn93E0A6txEJdoU7Erw25QhJ9VrVHXaP171fQQuqyS4VZagOIWVqnGfrQLafTAv/miM%2bRQUHprTHPKs2glb/RgnI%2b5YjjvRFXryVHxSm3N0TPwsM24J4zYTR4b95EphI/SAUuQHcbRSIxuZwttSU8%2b14CNz0VQPPTbpeSoiNLIzpDaHRvW/6mJDwiWa4KS2Fq6YYz4aSTGNFHpL7xmJAMfVac7dsZQQV5kp3PxK1Ty7/1YB7T4ZIn4gC0uYYMtflmzqkKUKGtIQFd10zdo4gmq5bW2UTKiRIG7Ew1NWXiDcWH5aAKqzWQaKHUneUI7qTJYkgHgWZqrOFrqLYoFmQcvW1iUeGQGTEJtp6HMKPak9TAGpNKO7pKih/6YFIP7AGT9WtbtoFdDuk/niAAAcAg1BCSPtIH0LUttSujfFV51H1kFoLG%2bh5WplmPJNvDVSi2gkVa7COrKwvGmo2tmQ4oaBltU2miiz0bzBqyMCWQF9kpDaQFnb0C0gyX3kpvC4gRNeGFeQnVQigTTUGg4ZMTWqp%2bR9mq08KIo4Gj6MAKt1H4FOiQn0RKS1Q0Xao6p59mCsAtr9tfczuDAPqhfOko3egbOZCkcGRUytCAROd4bGp2icHjJMEmtOTc2nN9z4bMtWIytK76SgGElwt%2bV6Y%2b%2bTLtMAKDYm%2bZPXmobHlGGjk15NaXmX/w2fipHWhkjHIMqfE8mSmNeTEFoHt5n929POUbV7YxXQ7q99yBiTiKtjNzU/0lo1x9PFHA5qwMhixC0AZdRXT2KtPOBEfVMhYVaNPQXSthYEaI3klTk1wSqZy9ZOB51SfUmkLX1iymdxYUB1CDCR1oNgTz8YQV6JqqTB65JKpxPVDFDn2SoJIp6kzl5ZPyTS%2bo1/auuJqnbPrALafTRfHHAOP1IWw5IWfmqJiqqpI8x%2bXt8BqaWCAKDWWOvD5G8Ha8rD2ZBzK/R4tuTbCkbXyOt32CEQduOyvFki6Ka4ssm2b%2bSeZZZ4iR%2bQ0pC7i8W7tiaF2RymMg4a0whBTcBVpsVES96eC8NOGPhE1UMVC2CYO/v1StV4cFYB7f7bs%2bylyQQooWZAonSQjTIwcHvuH0vE5OVmuBhVDmmzNSIFJCHilh7ORi3Mws9G5fVGG502L4giio7kyFkxNgGkw9wzA1UB1WKPSES1CE4J8LIBKzwt3Wm/NZGfy0lQikgLlarxYK0C2n02L/6IiF%2bRcK6sdrok78zhDYc6tu9jdY2%2bZKgpFy5V74QGAukecVsOLH2Zx1uf8mVnyaUNKpuQc8JK/iwONk6FAfGIJP%2bI9HkMqV7wyYw6ZlbakJRENo8DZO4Yk3Jtmoge8peYAmsJJakxnf82DlNnQHHwf%2bC98DOcnmr3yCqgPRj7UcPjzPk7ofoAeYAtsH%2bg5GyyXFgBWzFEdTk64PBhVvFkXtgpNYKzXih5QaCAPtOoxQWTVrZwsshpSolTU5UApJqZIC7x2NgLDOvy3AZMg0%2bcbKFamDA98Ljb97FLg%2bkZNgs3cz6hstrm9ICtAtoDME/hQMTbyUOj75LTxIHhLDb%2b0iENtuVBw86NUA6g2E7tjFNGxM6InpCq4pUeWNn5dNb82eDiYs9L0KBYM%2bDqMIdmFGo0XFpoghC3lBlM4RWGENSXKZt4oMZwh4LJ3jrQQHj/DVDjeR8KCKHSLFPUuRiQVDUKqsZtRPxVqPZArQLag7Ofkd5NFyttkcLRB7Xa0GfYW1j3fbyt6bF/3boB7GABEgKUTuWSigHFMghZhaXsdZROXiDJbxkBxaAn%2bbOxdTk6Lj20cj9jIai6UiWiziSDcl0z5qhxBdORRJCjfk2XyQU5oYMEjbOG264i8iNrpg06ETL7sY0np9p9swpoD84ihQOGsaBTuTWQcBQlB4TkOTBvjakGTDvomYrgAdH6Sp2D1Zq%2b2LSPQDcQ5VUK6VwEm7J4ED26QmCNrZzwRKA6emGxhzbyUrnMqP3GnJXSjEMnBYKyOZzbmZwMWzBZiBj2HQAqxqZoMr4KnT/Kp7EENwEgUzT6wjtDdD0AfPAcXmMPnVVAe0BGFI6f5y%2bF8Jos9QRaJM%2bBVCMUXUDL4UheWqpvqWIqPYeq7IkD1cd0C1BAqhRp5EiaZJSFw5joDVub4l%2bPqf1wNZLDc3ksMzX5%2bCCNmOPqo1VqHPJpKDynJL%2buUDBFgxvPUefNWHstL3zy232kUjXOh1VAe7D2bDMWmmH2jaZ7%2bha5pKUvq6sHkiKnCihmTdjbBxM7/V0N44wgtAYxhW2Uz1sew5Z1BlWJkXuV5iIgNoE7lkJaCjAbmnruW7ioSR4oTGQOX/w8BMo8iYnOR/qh4KE0uSovisIJT3ji2QWDJnSoxYDzYxXQHqB5iW7n8BPpCBINAMkLQkgkW0fFAMlFUdiZmtn5y8bDhyO4heqgI2/vdNJZ1gnErT5YyHAnc%2bPPxt6m5GqM3JvBRcn0lJzqm1JlCGhonQ2fLUWUecmXzy0GBeFewvSe%2bzRVF0AagDI4C5%2bpVI3zYxXQHry9H2moicuqZpi13PCoNCZ9gvK2smQ4gHQESCcBp/2ZB%2bZk3PBoYcAqPptQGs5kuhMAR/w2kPfdtsyVrhKTLVQ4DWEeJiTlWWAXMuUVI/UCg/flqDDQWwX8JAfU25Gu2KJTgz22sH8ruTP/0j8659fXQ2Xdw34CHrQh4oeNMS%2biMW%2bTQSrUwmSMCxI5vfdc%2bjQ5l72N%2bWxa9nbH0MpEgGB6RAAX/yVuGgk7eXKRl0r0CX%2bjBL5D%2bOaa8KqJMmeAg3dS5tKk8tzp2tQ2NQQ1v0w%2bYe6CZZY01fjOgM7re6VfK/wwE/aKVAFF9ugo9AwTmzABpa6whknsmOYNsCgA38hueKL0%2bb7CHi6rHtr5sB9Bys/k3lmSenb6RoAHrJ3mG6%2bVhpqWyeF5lUK6PSPTP64Yv9TWqYKDK/NwusypOjGbLSXNLTb0NiFrapfXMebRhLahxDSabOOGJSEJ%2bBLFw1L3AFM7epEHonATbZRFdy6T2%2bb5nYjwQ%2bfytxSeYQAAIABJREFUanqIrQLaOTAi2h6mI1FxDulxoa5WlrFQtlmZT1LgFnJF%2bRCWsaAQ2VvCkjoyLEAA5uGaeFlbUnXbQs4SbBlARFxRUzYUuIvXqfpcoydL3QHFtHQO8YOKifoE0iLFn5HHB0q1Uyq%2bKz8df/OnrPYgrALa%2bbH3R37ZMJeGqD2ExL9aW0uDhKMNKo3SRZCmGZWlRfmyjhBsM4bHdlKpgG96KvXWgY1ddJT%2bSus7UJ%2bNgspmBL8NKdmWO9WN6i4BkmibmVT11J8b1UfhbgxQRZmUV8RfrFSN82cV0M6PPcuTtzH7crEqBMpEo9QFABJ2OiLZ9iQj3bOkECTSKdM51uu8Wuc25qkQLA/Ws5vPE27gog3kj7bQNXR71fhFKU1PRaN88rgghJF%2bcLCVhnLuCOVQNZxTS16soWHBFG46IiYjh5s2DzNR3QPAj5/ni%2blhtQpo58T8r70n2qajoW%2b7iHMBhZ8opFI93zPPoSPxsrTLET0SqxqyORQFJqBSnk74VcxBs2knZyt4YnDpNvVybrynl1y%2bp4zwa7M%2bTI54m%2bDNxZF/QOtwZ0WUajKYFEwkZ9a75I6qUJUn3rH3yiCWZgfgJypV43xaBbTzZe/bROHIRBwx8t79l3IQdqK6d4V3h9HT0p0DUDhMGiQtt1G2BrpOTzsvrGF1i3K4nBmV496YQxuZL5qazuOOWrW/wD8DyIBbB708F4tluLkrHw3kAKXPAaLocUhxhYUzE5H2/ef/Uno4rQLaOTL/q4%2bI/0NCTkXhCKqpfQyNgiR372C9XouYIYedqKqjvRBtqfXHoZpFAPI1ToLW8XlD/ZseQ7ysdWwh0lvklnrNnTwRD3HENvZyjjVNyKsqv6e34YOFvMIZT0tUtTXBQzMhFEWHsg/ufbU63OQfDVt6ZhH8mqa55qk2u3mFXXyrgHb%2b7N%2bMUzhs1oLD8yC91E3w0rjSR/5FUeoTFyjmkoZAk3VbAVf4UJUttxBs3bBv/WyhaVp5QNco3g/VLIGsgODf2ya0Fcltzj9CmtAUmvl7pmiojthBuIkxh%2bZUixlnAJz7iTv5aNXur1VAO2dGirafS0eVZ9Wl%2bdylcKssDiC36jgsQJBzQhgKA7ZAoSRfzT3b5GmxA7ShxJntZas2%2bIb7Yh0EFRaL7HbM9VkEonB4IFMV2pBDs%2bB6zpFR6O7zZCYy0UKIKuGmS3k2AGpyJw%2bWcooWU07RRu7Z0quk7Mq19DBaBbTzaT8djkplvxGSegYQd0pAqkAGeWYgU7BlVQqHidPGlVOn8uPs1Vlu7T5771M6gjH0o0W6qsp7diUwAoNbmriOLGXEQNvE3FoMHVNZJDarYxyIYkycPSDk2LhWHCjsqCoawZ3H3UkTvyoYQDwPv1ypGufbKqCdQ/NEW%2bfcV5OsEJKWWRIh5LDT0rwBHXYiEUmRc28idBgnQPmhucmcIjaQJj9VU0WDCIGkjey4V9WoLNcZJDlEsVZpPI7O4zSgxyXTPlQyn4%2bpeBOWEkqimVpIk6qbEn6nvtWgTkuyTSwIaUXzLKz90zt%2baV14q4B2fu0DgyPT%2bZxEIcheSsKPukKKwpbnHfR2SMPQswvYG0oqrVg4XanBPdNEUwQPLL2ujK5hxium2ecFzoKpQmbcyoO7URLcfCyW2PwhRAytW6l6K5px3K5PFWBWDubQXHTPlHeGiJ/y6ijn/qp5yK0C2vm1ZxHxWFfiYpWzpypnD/3ae1vrlDwv9M6ySJFAh2WF8gonARLNGhBwBMXHgnysJ0CJVmmZbmPKQKuYkSJKso0OOdWbDEJTRSxh1VmX8miGJzbRuLyoe5YqlXy8eqgwh56pG4O6NTBRZ%2bhHY/gDU%2b3cWQW0c2o%2bV4OI/0UfnYOUM4sdOdEDW63WgcLh5w44HHpG4YtJuTfek/8Sr8rCgPbQpIgQQzsOdVkGPA/08qb3jb4XbSQ8XQ45nQ45VWs5pr0Nh7ckOe7A%2bKcJTYGu0ltFb7EB%2bP3zNc1o0IVfXzwZTLAXPhoQVcMc%2bjTALl9PD4tVQDvf9j7Jk2kKR6ajr5kZLC2t5g04FnyMJNuYFwJSlXAJGKRvNIVcRoZegpbMScAyMkxlQ3o/27BRGw%2b3V8%2b5ysi5Q5s04pDCznBuesnak%2bySSbBqRoaxUKO698iaphGyLR%2bDU%2b1OJPBYibQ7YhXQzrFFoi38r3SE4j5J8puLA9ncAMxBJ%2bqdpRgUU%2b1wYNLzCdELQ63Dnx9FfliSR2s2a6GlQmTxuhPum6Md2Sx8bsSFa8VjM4NKqiMgcyKG6YqOc5D%2bVr7wrU1hJRdSUG0TAK9SNXbGKqCdf/tX4Qh1ngzTFxMwVeN89W7V2wHNIq0P1BeZT8hF5VsFAUMwg8BRPxvKZOvZnFuMBgrHvJzNtx9x6iSElSEpJlA%2bvHe1JlVa0QkJbV0xt7imUNOfizD%2bz8Zl69AJECPvXrWSoQKyJNNN58S5j9S%2bzd2xCmjn3DzR1jn3Moc/PLgjfQmL4SeYk2xlIIjk3JickRBEg5UVD01hjEtN7bKoeJaY/m50jbhDPReguPQGYSEIADtWlcWkElLOHfCf0w9N8R5VY0xoKjDNEGXlfAkPDTNqjFU0DzoP1TvbIauAthv2Q5InYwKoTX2dodIpGveJX8V5JqAeTl1QCEWB3sJyFQfvgqKA8OxOZvOGVxU%2bnUqzPWWFpgw5R65CDdBYhLzlipQKDPNHZcK5ZTJt4hZb1UGRqp88EcoNW7sQXqx9m7tlFdB2wIhoe8yyPjqBz90CnizrhwmvwpT1dSSD6o%2bWOomkiACpiUD2Z7i0aTiJZGDSNtB2I0UBbS6VA/Q4vOwYVOc4mkR4Q1Gh5GPTFUcjMwF4Z1EWHKVDAEk6KFYx43BlH1KuQ3Wzl8HL7OGFxzz3NBsabIXOQWF7HR68Y1YBbXcsY6kjoOj7p5AzrxyiCjtRJcrRjblbJoSBcVgvjRQ3Rmj0eAYPraH/OdwbiDGiIuMOSG256apqy2ExNaevRbyRuGYy6TxWcLkokI38E8VaJF04Dt3HvbPw0RGf3eUL5mG0Cmi7Yx8CwIzsKRQLoms4TYMwWhTIZYOGhTmvKBbcrK0thKYqhN1mplG8MtyQQsPoaYWLDpusijlG2eDZAT17pQxkBsnTjBQN8QR5fii3ijmUbdmbc%2byFuZQvc9RCpb0zL7ZZ%2bzZ3zyqg7Yj5Sptz%2bJ8EkJgYqhrO/Zc1dhI4WK36RJoVgEm0D9Wzrrw6zG8mtjsxWGwzLOdpjpoqPxRDhfPdc79VTPCHHnNF09Drsvosc/RkqrwqUPQ811S1gW3yzvw%2b6G1qMWAHrQLabtnPGZlZmYYNo1MVz0LIH9FKmJWGggD1L8ZBKz73Jkoc%2bnQIXeIMlYDByPSRDfRoT6PXzt05PTMheHX%2b1qDok4WqrXGU4mNVR6O6DSJa9uTReYAP8zrDzIVc0NEW3pn3%2bJzDL9V5m7tpFdB2yPyXzFr3hzLYI3DPole2pJ5OlCb04TRwJL1G63gYL3sp6XXgrgJH2vyIxU6K%2b8K24p51A2dxm/lBy0gC/86l/k/Dx2QgtDL169jjumZJ8tD3akMe0D9mUVsjYW8cIBylhvLhwU28r7mzHbUKaLtnP6m7AEB5ULGfk6qda0/JWMe8EXKrU5prh9QShZhG1KlsW94XQL2gWntNr0FzSshRoktq9MpqUpg5CmiKG1foCon3RUNQgmTSmqYemNj5EJrTadK5pUb1WBxIg0%2bS25lPxAq6aCA6bjXc3FGrgLZ79mEEiBSObOCuk2EoZckO0SplVyXYaMYmofPmTngdrNLhQWQVdPlHtP1dtvEG5VpN2XWJ3yZOYMqORfBsBMRCgl%2bqmdFd8%2bv0eko8JiqH97TCuVEHozsD4pQrpnHEcwgRKD9SiwG7axXQdsziuDv3c%2bGodX%2biUCuUrpe074CMqOupyudDVKAp5ODKHFZ6YJ0CHR1%2bjijlRuNS51gVgeEl%2bmmN2gSKTbgjwnJvZWPEv2vUijKLykSqRwAyEWWELH8m4%2buKaVqGpkGZpnpnu24V0HbTnk0UDqW6ocatWe5nXPXS9%2bkw6Yf55oDlqodVyL/1cLLspWMAMuaFA03oEOdOTSoZNDttqSKUVU5QOTVHE4utS2KSjeKfQaP70bXvRVOaaPiJb3/iTgrDx8ql2sZIWMp5s0Aojg37X6qdAbttFdB20IjC8Snhk%2bmRd2qQSrT4iBn1/LrPO4UoizBMIkWmPzgpmWbQZHjIyGCW5pYezrQ18dCKXtER7NOcudC6FQCaQmvqMmBv01GxAYmHtrY22wdPm%2bd8IFeEw1AV6hBw8Xn1znbcKqDtrn3AAIeS0TNZr1aZgqvV09UZtEiix5Hihoy0LCLEHBgRNKXtlHz%2bZiNPy8XkXaJsjEiWCf2XOwJC80LMj0WlXif6ZzzgxANbVAuJ23uFX2v7yM/rab6AeLB9pmTb1GLAhbAKaDtqQUHVwGGW6AaAVb%2bOt7WnM/ShEuirnZxTQx12yjCVkZmb3FepkvYSSeJIUYBzYjiSEGNzbiTkbLJ2LZAugdh%2b5b0xr3PG7aVGreOQQscmVji9Z7kMVd54k%2bom%2b2cy0s/F1izOnQXOmq0yQRfAKqDtsFnrPshNTAxWrLMPJUmW1SYYyKiqp72w0jx4tK0JX/5GqboSDsT8lkl5rNOdNBVyZm1aIEeQabmZKKHmaKJ55M/p6QNOVT9Rabmh9JEGQVpMHQacN8tlgoLV3NkFsApou23PBoVWl1Q3QNQ0uA0ol8TmdYwh1j2Rc30Id6KkhBrlShme%2bjSobOau1YZaqTLtvTUbLz6mjcTezbSsDIsbSvS3lNdjwA7nhAGSmtWBPDT/WZ11Spk2AOGNOjPgYlgFtB22WBxwnwifQHUJOJearyNtwYZBKhx2OhkwrAV/hHlKemkgswhia1U6T5uoZhs1/Nma%2bFKcMKU4YgX2ZaTaNg1IMeo1/5nWxI3zj1UsGsGN8mfhdaUd52jOQpy3EMm0fW%2brd3ZBrALa7tsHY9Keaf%2bYglCma6jiAE%2bK4pQ88ni7nGImj5ALBFJNpVdKB4z1zUYASkw02oYDUoYWZYhaqon67oC1Q/EmQ%2boNWeEIY96M5LdXYbITd0KkKnDImzUmxcxgaqvTBbMKaLtvHzbG3GbJHJ8UF5ItFwL4I2pdMzQpf%2bY2DUfCzA9LQKlWkt7wJnlokMWsysa0NZrBG6ehyRBUdS1PnxLMjh5YyJ/5KejIlc2YP2uoVd3nz5CS/iGnWISaEAYuuy/VAcIXxyqg7bj5zgFr3X8DLkBi9FbWodrZw2plU7XTV/4cSjcBTxEH0MUBkJ7ORKaNaxnCqVQUUMUHzeuATXQ0l/TSTFo2DDmTB9kYHvLCAIu0nAALqfuB6Bh%2blTWFmEEI0sWQk0Ug%2bbG/p11V7%2bwCWQW0i2EfEjVaDueEjlG0QhkQDyUm0jF%2b%2bddxSpIuDABBUGLUq3M1UkXl5dtMh5ybUm2eshEKECqs1PK3MQSN%2bUFW1bUyWLgXfglXQMMcAT3LlLkn8XPV/NkFsgpoF8BIu%2bsrwhHjboD01U1IQxOgZDCxRiBFtJUZw1QUAPEAQe8ts%2b2i2pBmdpblytJ4VJ9F6eU0AkQmAZQHLO99BpVZJ54kT7cKfaosDWSK4kIUh/xo5Z5dLKuAdnHsl9n7QtXY7aQSSFOeKMdGHIyYS5PipMm8MEfVT6GEgJ7xycUGJeiY9XCOQF6TvxQlvlP3AvdxosK7MB3dpmqt9yR5alXgwJXeI8bPYahI4Wjaeqp2OvLawuuVqnHBrALaxbFnfcWOVSYcEzQ0rigXiiuAMuYutCJF7lc07gGlsXZMfbDRI%2bIeUI%2bETQgPTaxHqkbygTmSDPJTPimZNqrJoeaMagzMwdSFAcJBQQNlbLuQb9c9zQvAOOEpDRGON1PDzQtpFdAuiPnQqbfuOaNyZBJ%2bEtE278TELHzkYep62lLuZCEVBQx5QGkdR0PRw7bsXrnxsDKqcHNNcrgOk3g9EFnpv3QiPAkQvTivqGFCpRbB9bEhnfNnliqjvVL2taoYQA34VffsAloFtItlH/JfdD942FGzdgi5egq3lKRQoHh4RVuX5lPGyqAP62iyFFUcdZM4DroF8mT92brUEw8N1SJI/hMYXxEIo/DSjd/IEeNfBqRA6mX1/7dt5LA1Iq8dd87UlLbqnl1Y6x72E3DBzHPSfhaISQ9Ajds%2bHPRf/rZVxYD45fdeTfjyNw20Xs2ijV7MweU9eOLxx6FpDRzM5zCfz2A66ejWwHQygfV6BR01eXvwCH2fJgKGp1Us9mbQdq0KB214eHj7hFR0Ab72p9fg6PAkgaLWdlMqu8wb8/tomFvG94Aia%2bRD6TX1dvJMUqca6jF6mTer7tnFtApoF8h82DmddM%2b1bfNOUeBAlppuY3VQ/cmffPJJuLS/D3uLaQgFPfgc3b4FaC0sj0/gK19%2bCaazDmYEZJNJA4vZBOaTuKybNNA1LbQtj5yLHZr%2buQe01nNmW0OJecrDoaN8HFAezEl%2b7Mknnwh5MdNNwK57uHW0hMPjY3jhhT%2bhfFn0DVfLdRSnXK1h6ekmq8g5C%2b/DnLMw0amP4WcfPc%2bepqevLf7Kw36tXFSrgHbBbN3bD3dd%2b85EcI0eymNvugqPXb0K3aSF1fIEbl2/Di%2b9%2bBIsZlOYTidwsJjCYjGF/ekM9g%2bmsDefwLybwHTawmw2ga5rYT7tYD5pYNJ1sD%2bbQDsxMG3byMr3gDhpAjB2bZzA3rQR0Lxb1nvQ8hSLUGCI99g7WFoA66c2oYXD61%2bH476H42UfQOvwpIfDkzjN6vKVy9B0swCUh0cn8Opr1%2bHLf/KSTIEPVUykXk0aT8dSQU4XA2I3QfXOLqgZxLPkPKrtihljvm0y6T6zt7cPb3nz4%2bHre/36dbDrNcw9SM2nsDeZwN5iAovFDC4t5hG89iawP53Cwd4cLntg25/CtJ0ED21vNoHZtIPptIF528F0NoGFfz4xMGkbmERRsjDwKXhm3kNr26CC4UGNebrBS/Ke2trB0ifvPYkXMeTsvAfm75crB0frJRwdr%2bFw1cPR0RqOl2s4Wq3h8HgNt4%2bP4fDI3/t1VvDYm98EDXRweHwEL774Cty4fSvkCNekiRb329O4Pwtt297q%2b/5yvaAvplUP7QLZM888843vete7vvfLX/4yXrt2zRwe3oLFNILRfDaFhQ8ZO4D9hYG9eQN7EwPziYNHL82Ch%2bZzX5dmPmfWhNv%2brINLe/MAZLPpBBazLoacIQxtYTZpYNZ20E7a2EhOgNa11BvV0jwAUlp0wROLebBVHykhEXRi6Ombzo9OVnCybOBw3sHRsoejeQeHJw0cLRu4YRCmzQQmDULXIExbgBvXvg4nJyu4cXQCJ8sVXH30Ksz29uDk%2bASe/%2bIL2Th3n%2buz1v7Gw36dXGSrgHYB7Du%2b4zv%2bwssvv/yhF1988e3L5YnxIZ8HHw9QCx8yLiawF/JfTQCyy/szONjzXtYUDhYzWEwd7E8gLDvYm8LBfgd78ylc3pvA5YMOZj7EnM9gNu9gb%2bJBroPJbBbBaj5hJUiATjV5enetVU3qa4DGOZiGWZoOFjbI6wK4qZ9FFxj/y6WD26sWDo9XcHzSws2THpYnDdw%2baeF4tQxgfPOoCcA892DWWWiwiYoc2MLMdHD71nX4%2bp9%2bLXh1Pux84m1PhpDzpZdegeXyxOfharh5ga0C2g6b98hefPHFX3/%2b%2beefahoDDGQhDGwbmHZNzHvNWtibTmBvL%2bbK9mcNHExbuOSBa9HC5T0PXjPYX3RwaX8Kl/YmcOlgCpcXswBs%2b8Ez6%2bDSwQSgmwLsdQCLGcB0CjBnT6wFmDCgtXRvEjHIKZauT5x5x8mP0ltHbaBuvYZuhbB/MgF3NIVbxydweNwHADs8OYGbRwizBmHWQQCz2QRhNjMBqG8emZDbO5w10HYIk87BJIS9CF//2itwsopFhCeeeBIee%2byxv1QpGxfXag5tR%2b3bv/3bf/L3fu/3fpA9sknXJCCbJEBbzCchTNzzoDafhBBy3997oPIemPfW5hO4%2bugBXNmfw8HeDB45mAdv6E1XL8PBvIPOx3Z70%2biNLTygTQDmU4D9aQQv%2bV1s1E2rNPI11tN9QDduM4%2bLVzYC3fEK4NbKz9gDODyB24druHG0hFtHK7h5uAqVz1ev34abR2u4eXgCNw5XcO3GIRwdL%2bHW8RqOTtahkHDr6BiOjy3cXi1hedLD0aqPg2R6B91kik899dT/efTRR3/kYx/72Mcf9mvpIln10HbQ3v3ud3/wM5/5zPf4kNLnsiZdC5PWBFqFrzrOQiWyhZnPfXUGDgKYdXCw18L%2b3OfIDDx2eQp7iw4uLzp4ZH8ClxYNXN0z8Mg%2bwKP7AFcuzWC6jwBzALiyANibQ0C5gxlA50FqTpfPhE4gycvGOFN6AuJj7pPSwIZ0b%2bNuOguwZwEutQCXO4DbLcBhAwe3lnBw3MLRDQPXO4Rr3jNrFjBtMRQtDPTQNdPgnXkg9x7cpPOH6KDr1tAdIxx1BroTE3N169DTav7oDz//zLq3H3v66aeff%2bKJJ767AtvFsApoO2beM2MwmwYw8yAWv8xTD2xdXO6Bbu49tFkLi5kJ995Lu%2bRvPvScGdifNqEI8MisgcszC1dmDq4uGnjTAQJcMhFYDqYAl1uAgwZCHBcAbEpANaXnnbpBAWhtGr0ORgGZAjTx1k7iLvx7HXgGrgE48MC2gr1pD3tTB/MJwqLrYdLMgsM4byy8NgG41fmihIPOuFA0mICDSYdw26fyAvj5DgoLy87BirohVn0Df/LlF5764z/%2b4sfe8Y53fPSxxx77ro9%2b9KNfetivsV22Cmg7ZD5n5sNMD2YeyDoKMTnc9EAWvZQmVSE91WLiqRcd7E%2b7CGxTD3oQvLPHL3dwZb%2bFKwdTePzSBC55D%2bnSBOBKB3CpA3h0ArDPYeWM7lt6vKD7ibqUPGjtFd6aCi9hpUJOq0DNFeI%2bCOA9xH0DcNgCTFcArYWrXQ/7kw7mMIVF52AxmQWPbNbGSurEUP6scWCOY/%2bp74A46bzSSAPTMAzGwKp10PXssTn4wz/43DOLvYMvvOc97/knv/mbv1lFH3fUKqDtkN26deufn5ycGA9gbeNZ%2brHdiHNoni7h82ZyC%2bDWwWzaBoqDB735xMBi4r2yFi55aoYPRbsGrsxMqF4GALk6i6B2dQqwmBBgaU%2bMwcx7aJ7StU8gdomAq6PXgECNQ059fwwAS7rxYwbAToWzS4D9mwDzWRzz1PUw6ybwDWBh6tu1sIXGdqHg4Fyknvi2KnAdEWkdNDChc%2bSgbfpw3pZrB11jYdXY2KrVGFidHHb/99O/9bPvfve73/Hbv/3bf%2bthv9520Sqg7ZCtVqunm8ZIL6N/3PoeyvCFjAAX%2bWAR3HyfpQ9BJ96ja3xlMAJeALnOwN4UYa9xcHkW8/swt7FyOVkD7DUA017lyGYq3PS3q3TrCMz2FYhNz3BSH4khZqwIEKC9BgA3PHQTuPFMgxlA2wM86nup5gDGV0mn8Gb0jVwOJqTWa8KYqhX0fQvOtlE%2bqW9Dd4A/F%2b26D%2bfruO3DD4G/Nat4Hg2dO89V%2b3%2b/%2b9z3fMu3fMuf%2b/znP/%2buh/2a2zWrgLZD1rbta3y0LPPDMj5SUwxfzvh6eAxxIlPTNkGWpw3Txl1QgHXUqO5aDx9xVia0lLgPhUoOCV0kkoXLxZJXNqfX5gR0MwV%2bZ7U5ref3eUSfYk6A%2bArtzxG4megUhtRbG2WKVgau9gb6tYHVGqBft7Bed7CeO%2bpfdeC8h9msZQSeMT0Y00EDVs5hY2x%2bLg3A81/4o2/z%2bcpPf/rT/%2bxhv%2b52yap80A7Z5cuXf4bFD0WZtpxNwnLZyGPrSBiR1GB7Um71IZdv7Pbyr/3KD09ZA9w8TrfeizU68qLWBF5rAh2%2bb1Re7E7BTFtL4SqD2SUKaZf0viq3NvOVV%2b%2bJ9QBt1BI/mEPoHJi3Nnihe52JucNwox7UacwxzruoFhKrw0Yqwpr20rXRw/3s7//%2bD/q85UN1ke24VQ9th8xTCzzN4Esv/PFTceo5hl5IL2DYOQO9M9D5HkmvOtFE5Ym%2bMaF/ctlb6EJ41YI59hI8PbRHJiTMPQXMe2q%2bunngY1O/4ks3AVZzgEdnAPPbBCwLynet6aTtEwjtqdBz73WcUEdh5hHdTmg/HiwP6T1tBLijdcS24Lz14XOuVxja473uWetvHqRWMbyetDaE3H3rqS0I1lM4bAO2RZjYNmwf8pDWgPPr%2bdfRgG0aWPcr4/OWAFDzaTtiFdB2zN72trf95Rs3bnzu5o3XFo2Jcyl9XmhtXMij%2bYodixt6GoMPq9q1DctCJbTv4WSJMPVf3GMI26JdhnFv65WDqysHV1ZraI/XACdLgJtzgEeOAd66R0DmPajrBDTf4ElqBEaWAG%2bf/EUGu/aUE%2bxoXysFZh7AngeA2/ScQtLVEuD2McAKAa6vAhl3tYwV1J701RywZBKIugbnHEOuMYTuBkxvwhi8kIck/TbfWdBaAz2H69Y3M6yeftivuV2yCmg7Zp4n9cwzz3zrZz/72c/duvGaRxCVT4u5oJhH6ME08c/bcD8lhZ%2b9wzCF3PdOHi8t3Jq3cNS3cP14CreWXofME3FXcOV4AdMbPcD1FuC1JcClGwCPHlAF4ZjyXJfo9hKBmKZyzAgAl6ry6ejGubklAeWKwMuD2DUCN86trQBuLAFuLSOQLfvQB%2bqWcejLzcN1UNg4Wdug7BEGqoRZnTwRnsPvpLq7zTgfedpwqmrnzyqg7aAxqH3hC1/4na//6Ve9i0QS1JxXa4KQI2IPdtJSG2UTQlEXuowaWK4RTtYIK%2bwCg/5waWF/buHm7RXcuDSBKwsbWoguLTrYO%2big627D9KADmN4EeLQDeGQaw9FLrypPbE6ANqfbjG49eWGPEFxosu1KAdosdW2UAAAGJklEQVTX4nJ3CNCQR7g%2bBji0AK8eAbx0AtbLCd1awbGXGTrqQ3vTjWMPwmu4sezh9nG8%2bdfD5wtzRzGq2PpwnMbfWVK3jfMFIuQ5i6Jqy/nJxWLxyYf9etslq72cO27vfOc7f%2bX5L/zRX0G3NkKuDcTahpRm4%2bM5dw9MW3nuG7o5aR56PacN7E/b0LC%2bN/E8tRYOPKBNGziYtLBYdLC/14Lx280bmC06mPhO8UUT26I8u3VGHQW%2bPco3rYf7Jo1bD1rZQFOEqWrhkcZjXr%2bO7pNXf7y9BjjuAU56cCuE9fEaTk4sLI/iQOTbN9Zw7L2zlYXbJxZuL%2bPt6LiHw5WNgLf0g5P7MDz5xBNqw/R4F577gojPK67Ccxc8vVUfSbZLUsC9/Mijxy%2b/8rXXkxSs9oCsemg7bs8999x3surGV778wlOhUGAb6J1PaiPMen/fhqbsZZjLGYFtOXVwMonM%2bfnKwtGyDVJDN7sG9k5amHW%2b77OFxWQNi2kDe9P43LdLebDzSrbTeRv4bF4vbeKf%2b/tZE6S5A5h5cOtIdYOlhSSg4/gXI6j5%2b6UL4NZ7wcclRmltnyfzgNMjrE6i3PbR2sLhCgNgHS6jN3a8dnB4EkHqKNw7OA5AFsFstQHM/LK1l%2bjuoxfnw1V/Dttuim9/6s/8jYf9%2bto1qx7aBTKvi/bKKy9/6CtfeuGpCXULcMN6pCgkj80vCwq0XewBDd0EnYlKtF1sevctVAt/PzXRo5t60DPJuws0iCjd49cPbPyJCYAWKoe%2bv7KN09JN6GoYnmsbmCMx5OtXMSz0IaKX5V6vMVJMvJfVY7gFkPJg5UHLInlfFpYrhON1BDIPWAG4gseFweM66fvweBVCUS8qiQRoyTPr6X6%2b2O%2b/%2bVv/7F//%2bMc/8Z8f9mtq16wC2gU077Fdu3bt5195%2bcX3Hh/d7nQoyo8nnREuVgA0aZmKwCZ9oZPohXVtG9qmZm0LnW%2bf6iIg%2bu6EWRt5XxPqMfX3Hd3HgSmxwthSlt13MgANBfZemqVZm5ErB6Fg4cHF30fPku49CHnPyoNUHwEveFu0PHhbpHzrPbJVAMEIZGuaHL%2bi3k3/uvfKeBmr5n7T25/%2bnTe96c1/tTap76ZVQLvg9p73vOcfvnrt2vd%2b7asvvd32Mc82mWjtNAa1hpQ74vOuTT2hXpqI15t4QAs9oxHkpm0Erym1EoV2qyZSIvzyhqqsTQMCaKr9XAjBOkkfaqChUhk9NH9ve59awwBEnlfnCcIeqLw350EtgCCBWAC13hGIRSDzHtm6T%2bElL2Ov7PE3v%2bX6W59824998pO1MX2XrQLaQ2Qe3G7euPFdN66/%2bs2exxZY8QRYLfd9ekCbxGWh4b1JTe8dAxo1xU%2bIUe9voae0bYInxs8Dl8sQ34umrjcjvSmeM4ZEq6DxA6HKGCc3UQjqIlF4zY8d57zo3jkBqABcNJszAhvSZHUUkUf/us%2bTvfmtT3zxsTc9/sM1vLwYVgHtITWfbzs6Ovzuw9u3/uJrr177xuOjw66jULEjOW8PYPFxSwAWSagMhAG0eDkDGpNYW5p13sR5nYZIrZu4XXwZBjIHjd7z/Zjsufn70AHhp7zb%2bNyDVxgs7CJYeUAMgBe8MRuAsKfZn5aAz4PcE2/7hleuXLn6a4u9/X9RQ8uLZRXQqgXzebfj46O/uzw5%2bfO3bl5/543r1x/p%2b5WJ3liSKmppQnpLQMehZAAwPT09DB6mRnnyzgwB2yZDl4ivjntWXcy1eY5d4NHRVHUPXIFDZuPszZ4mpYcw1UUAC72rDuHxt7zl%2bmJx8ML%2bwcH//NSnfqs2m19gq4BWbaN5kFsul9%2b5PDl5Zr1efdPR0e1vOj48PDg6ut1xSNlm4SWI15aBmImVTl6HTT%2bWJnv21Bw34buwzFI7UyTBDsmxPpT0YOfBa3/v4IXJdPrCdDb/aM2JPVxWAa3a67L3vve9f81a%2b4Tt1%2b9YrVdPe/C6ceP6Ow31kV5/7bVHVqulyYHNpLaiEU9NPDR%2bTmx99tbe/Ja3XkdqZXrk8pXn/OrzxeKTxpivTqezX6nhY7UKaNXui7G3x%2b91Wi6tbduXP/GJmqivdgcGAP8fzzchVv1ccdkAAAAASUVORK5CYII='/%3e%3c/defs%3e%3c/svg%3e";

    var img$b = "data:image/svg+xml,%3csvg width='90' height='108' viewBox='0 0 90 108' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg style='mix-blend-mode:screen' opacity='0.41'%3e%3crect x='0.571289' y='0.309082' width='88.5275' height='107.038' fill='url(%23pattern0)'/%3e%3c/g%3e%3cdefs%3e%3cpattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'%3e%3cuse xlink:href='%23image0_4318_341' transform='translate(-0.0320035) scale(0.00345457 0.00285714)'/%3e%3c/pattern%3e%3cimage id='image0_4318_341' width='308' height='350' xlink:href='data:image/png%3bbase64%2ciVBORw0KGgoAAAANSUhEUgAAATQAAAFeCAYAAAAL7uOjAAAACXBIWXMAACxKAAAsSgF3enRNAAAgAElEQVR4nOy9T6xtT3YetFZdM4gUKRGMGOFImdOZMXMPGUEzACwrAmfCCIUeMHAQilqRRQyE0ECEIisSbYSwgxRoEzsIIaAtJYoSBHRHSCgIS21ZEbYI0JYtx4r77ULn7FprfetP1d7n3HPfu%2b/eV7/fu%2becvWtX1d676qtv/alV3HunL%2blLem5i5p988EP8P3vvf/3Li/mSbklfAO0NJ2b%2bUSL60XGH%2bP0PE9FX4M4vx/%2bJN/AkfiX8/v7lX%2b/9G5%2boPV/SR05fAO0zT8wsg/UrA6gu//7J13xXzESXbseXL9cEfTB0x4/UO3%2bLiL47vn9//Luk71zb0Pt3Pk4zvqTnpi%2bA9hkkZv4WMKzPgknx4clljoM0%2buzHBz8Bvh9cPr8wv9eXvgDaK0nM/O3Brn7sES3aMYNJ3u8hfEwzPAd46tKkx1UELabH9M6aAa7KFhZ5Y/q1we4uYPf1hzT9S7opfQG0j5iY%2bZtDNLz8%2b0MvUbPCDz8WiO5NqRXsIO1kqUUfnXTbx/XmvhfmnmPXw3ek7w193tce1sQvKaUvgPbgNKx9X3lJ4OLyRwaHGct4FtTddXF9kcO2Rbqvh56XR%2b8uv5Z8b02/8oXRPS59AbQ7EzN/NQDXQxXxGafOIwn7P2HIfTrmlknjrC3PR5/bezWyRmFn/tRxmZ7BMYj8N6bvDYPEBei%2bdU8B7zV9AbSTiZm//lLgRYQWvzuurQss4ezUtY9KdcPurnfdU58HgudGQUa286PHrr1jxIkx4gJy3/lidZ2nL4A2SaDveoiSHtNZkXF6zcEBb0QEufNh6HV7QVX7BXI7/F2mG7vqrQB4aU8HlhXbXJfXq4%2bTRoVn6%2bQE4L59XxFvL30BtJGGlfErt7pFVGqguwHrfGHH5dA5hnZb6c9MwBqfk04D4C03ny4pZM6ivDMgd74pz2JxV4B777q4dwtoA8C%2b%2bhylPQt6XL1E9ejt5VCiVeeumbaLfaZbX/GDkW0GYyhlnyEz96YzAIjsjCgzNH/1WYCrdXHnb2m0vN/1Kt8lwL0bQHsEgLny6HmuEZU7QyRot7qGKXCw/91PDQMuvj0wcaxleYdFyvewvKs7u3U/h2hzgAOjwrwJ5/zi2IHxs91HfvE9uIy8WUAb3vVfe1G3iQKEUp7DE8BfTiFa4Z4RfjhGdNI14q50Ao9WQmY1H5RNvav9c8g5c8kF2LDtaVJYusYBMzvNym53/n2G68jFAfjbb5G9vRlAG0r8r35M94lzeq/lwVAsF7PxosiQIQEZilJ3pocIwSU7O3NXp7VOt1ySm6DXjCfVq3OxmgKpIP99ImpxZo6NOf/9FtTvvBX29tkC2nCjuADYP/vQcudfcr6EaLcJa5Hp3XZRPFyLm68hMVMNZ4sm9vTlTLoDAMsTfYAIZ%2biaAhzN0Kw4tAY4ry%2brEe2FwI2Go%2b%2bFvX3zvss/bfpsAI2ZLxbIn/zYLGzeHst3s9jpMhQi54kLqywJOHgUOXvFN2DeffCY27Iu9b6%2beD/4eb2UY2eLmo4Ark9AaH5ZTdvOWFBPQfjzXEO%2b9TmB26sGNGb%2b2tCDffWRUSbuATCXM4DZ%2bQqrUxzG/R3QUYibXjC%2b9x0/n%2bWtVgcsbSqnBuz9fVfBizMi7qGNQg1L5R4nQBQdXCnun2FwwTbxPHC7FQTLdAW3wd6%2bf8f1HyW9OkADEHu4Qp918eDtAzXrum7xtFhwk1tFxJnI6cRWDxrPfsW8/HnqwvpZPdBicchC/NkdbPzx7tCLy%2buOAG7F8gp%2b538mHVx9U1NwCyJp/XTfNri9CkAbC7q/9mh9mK%2bDnq/ijuADIuPNUl0FZMd69foIO4jdv70CFdp6ORfP27hUnD8OAIkjiBlzu04EZXXxwGBn0bBwsrkrBmctmlobDpnbGV3biWau0qsSSz8poA3fsBcDMa2Hjkf4QjJyByJTuws3SmCsNHJndXlwtbuEB0OLNOBxKVQ3veE7pPtzaclgzvftfqxAg3x1jZnhndO5%2bdNHDKq2DMyA7fzwfhi4ffNTLqj/6ID2kv5hZX3%2bjz9eZl7mcOUlZf7x5UQRBgt2tbhw0tQIrAv285HS0WL76SSzYETP7qnZDpAYEi57PWKGHgMjqM0aUAAcR3CaU6uyTVPWlsXQc%2bkh4PaLQyT9qOD20QCNmX/wMUBszrQK2DimZflsBWYHQudafPU/zvOzOSOLtT/HD21W7/RocTreY8x6d%2bseBX4FsNV5sHTf%2bihyFraGutBJPmcpnZQxvdskslbln03PspLS8HO7ANujdwUr04sCGjN//6Vj4K8xqWBlN8o%2bufwsPt0jeDoGs7RKHsAaV8BG3np65hU/kNFFUXpaVWz0CbHvWeB3wM7w2NFE4IfNWuRMbY%2bvVwEoipsTS%2bkZcEsAXF9/7nneIrou04uvUHg4oL2EXmzJWs4pcQpGtcgzPXknmCVWUinv1xaBWYuXQPaR00zMTNPKBO9uZVVHV50qbwJsGfysxAgyUf82H1LHABdBLZewBjdt5wPWkrpaH897XkTf9jBAeymRMkl0JwFsWs4ZXVp5cgFmN2GaFy/x2G16r2MwU/DkI%2bXODRUfZJ2BV5kHd0m5sRveDH4OoCa6rDPCeQU%2bE1CbW0pD3lm5NdFLdWNxPf84x3mXrC/3nwfj2889SiR9FqAx83dfeg9Idoh2H/WICuhpKQcnOAIZ4Zitet6EsUS9XgLpcyIncwYxikD2kVNkabX%2bMPJUS8e98X7wS29oAWyIRrPqamZ2AB/jNC9cRuRYIdWW98YBBLv/kvIvWue%2bZghz8vGJ8m5Ov01Ef633/uP3FnAXoH0sBT85QLvzev/nBMHLBxF/7rZQTsTLDGZhe7cFyMZHUwGZHMPh8SI4twCp6WQyYR9n0zGbghzBw/gQ2FJZ1t6eBn7BzM6gEWVjgpdDvRL0qMgYz%2b0I/A/B7YzY%2bjLARmPv0/%2bm9/4Tt1x0GtCY%2bTsvEY56WSfdLIcV1xMl2DlAtRnOLcHsBLGK%2bSOXueVW2YFEBWLh2U2VkI9L8X215Q2s9Y%2bb%2b%2bVHzb04aFixBjasYSYtrkCtzl%2b2pGZlB8g6A7YMaEVhZ1lbP2sbz4j2AuD2D4novyWi//JI57YENGb%2bxlgQ/tF3634OmGW8qgDNPPzP1FJbJWfgdLKcqe6sRsfMyI6BzM/xuZaHpFHfFMCqd/CgVAJfvGGenJoBWyrS0y4kUTcBGxZbiqt2rGeClhoWLikNCkvN1xLc7nHXeHHWJuliUPj2sJh%2bF0%2bUgDacX//ll2vPcbpF1Fzm4goMTjpaHOrMIpjhyMmKrcTIymzHzmhRtFwBma2yvrF73SjqK5jBZLEqe53jtuVDdQnWnI7HZsrtyfNJR0%2bAWlY1Tco%2bALXUjhWwLUCtLvWozXpzdzz%2bjwZsNFxBvibA9iNydCwK/8ZLK/nPpFlXP82ogmxZAsnyuknuIzC7NvCodbVomZT7q2KivmoBZDrJ37r06%2bz5M%2byr3crPwjuKTIU9olTgh12AUVRldsCWno8LtdFdO65XDKamTbiWz9YOtnr1Y/SJyN72ouxmjATG59T1MWfMG9frx9CXFnI55xLHiQpy/O5Xt4GS3Hx3xb8QsF2kx3/h4vPae//Bpea/RET/IhH9wZep7/ZUiZtHM/7sYCVmHhdI5aCqwcz/ngNuLV7OrJSZoN3GyBIgFL3pIeJfFSn3kIFVPmsrFnOQTuSplhNtUm9BVvB7ZHHz3zScYddNOrKO9imKBBE5grq7j3NoFNnY7FjOf2M6rZN7VvoTl9v9XSL6Ay9f1/lUiZt6aEnR8gmGP%2bWsDwemzDC0Z%2b12Uber0pPF21QoWpSHAOjvZ//VfOZio5RjGLsZ6I4YWOVzd/fgmF/Vt%2bkpd30FkhsO3qJxp0GNMiJVuBTPrFw%2bcnt7OF4B2qS86SFDswRok5d10/v7OID2z/NQrr14xItbUunL5BDNnZkmf12SRI81aUW%2bcz5kBbDCdZml0Qkgm7GvCsg%2bQgBuXi9AX62AKOarOj1EVBkDKYFdbVHcwltE8ZTC7yWo%2baqwRj1Wg9qyJGjzMaj50uZU65ClTa47bq3P9RGWjf/jPzJEzk8OaJUYldOSnuXyEvu5AczidXUh6SQzKDpOiZcTS2VqSATlNSPz2ZhKa/bSr2LWnhVYL64IeVCsO6qcj4YMDMK8%2bGDU1faDxuKMIaM4Gh/JFdTAwom/FfDGO%2bcCBthUaEnXdj3czUdQ4o/29AytXJvSWZRm0ohde1awKek5DthOU2RsS71B6PG7fN7q9pPpsk3fb/xI7/2XmPn3iegfefEqQyqksIM8d4DQLesvy8Nci0xxgLK/JJZxRrw8AnVhaQmHCkbGzVd4FM7n1rRmYBwUzY1S7mpOwNTz9VMelIBvr58pjiUez8WzNptULFKGA8kZqF2gR/KFF8xAlwBzrhmdm/MwKnQAGi2lpxLKW%2b98DGrWOranyN1j4roqD10TYFu0clboo9K391u6zDTM/wsR/bGXrhFvb36wgLCTMkomCpHVUAlwdTk24m4Cs6q8pLw/5z/Wi3NHomUEMrn0uXS/vkd4UhNEnz3r2PLcvKMGF/Ioz05V%2biE7vtK9CXuTd3HNuhBB09DtWoo7diR%2bxmbi%2bSR2uls8LxPWwSTPxkI7I8Lmm3ghWPut3vsfJnDb%2bE9fGtDWIFYfqMAsDfRFjUtmVn9dcMIzYMYOPM4tHs9AVn1f%2bnm1gnUGKyyXpvmqpuOU34u/vlHlvRIAeZwvpfNuRyIR8MKXUKFSxgJ3ATug5WEdzUqO4HblPGxM7JJ1K9nalR2kexHmxqhnK1w9mFD8DLCo8QVY76YDNUOWhsK8Y100QZoJeJXgXD1kyX1Ewm6VdG9L39ZWiW6F1z3%2b7nQPkLkjBaAt05SZZUDjgxLRupmAK1y6CtszZ2VriyU9g5FVk8Bjkty7f3r1aoeKNcvX/LDO2MF6%2bhLKdgN0cxeeY2wACAHcouvHRtnlw35kfVrl5lGxN3lhibVFphYexjI8eNHII4aWS1ml2TNNjb%2bhzNPpn%2bu9m8hJO6D9fSL6xx5Xx55mIscRNM3Y2XFFdJqdrXRp7DO6VtwEZiX7usH1guw5pCoqZjYBtBtJWNUA/b4CsRmA2c/qxiGd6OU9D/VpOWtgowUY1IwtGldKEdQy5%2bMTN48ZFsXcq9UF4VS%2bl3B%2bvn/B2RDgxZmVuHp2NcZt6dd67z8qV%2bDY%2bc%2beV25OOpAcuvDh6DrFwuK/5dUnwYyfD2asV3MNZmxGBn9sv9KJZAxlyfELiDXe/2HLWP5ZyVqENrrd%2bc%2b/N6zH/RfeSTir9%2b7PhdKrdzspt03%2bxXfJet/jmHv%2b4z6Y3D893sSQIM/Zv9dIkP29cG2djkybedofb56HyuEl72rCkmdzzHyILNMUoCZj9hwqTNO38YRby/losZP9n9uuK67l9KW%2bGi87ZGb1Vzd469%2bkAyHkmDOTquNM3C9KyC0YWRmSyN3r8Ho9erOLZ5oAfXHN7NmmFkYaunSKrTgV1jdf%2b7kVMuExa7NcMQzQIWM7WCtaMbgoglIMu12EKJqxtFxvaH84NhU7Yzp16JbNVWay%2btnrNf0xXKD%2begHtEMxYX366lnBA%2bwEW5svpLBijYpxS8JfLtW7UkxHlGZxWujJ/3I41/X0UH79KM3HcA3jIE24kvb051qU0be0J4KsG81lgk26F0JBArWM5/vx%2bKD9tBLYlyGG5eKgEsUqULAB1CWAzQJvMgks92D27Rc2B7UQZ3%2bu9fwUP/EjI8IsPdbK9EczOMzOOB8rTt4PZhIWldq7BzIkXVUunSv%2bivjtYmYIZnHMOv/ek6pkeARjhdSFVsdpcWZPGNruEKQ5EcXDdj6CltemPThu2qYOPG2/jgW9a9nWbEka2JpMbbqdCCmzSFwQOVEcNt6nfwSHX3e01gweUCC/7b/hrhc4falmOX8xuJU7KOmL7rpwzCepYN71KKTZaZGiX3Vj%2b/dPFHaRbGZrPmuDHZaj5mc93DuBCLXf4ndVhp29V/D8WyPaxwqrjOd/B6qRtQX1S8W0KYHDi7BRXM5d4wFOqTFRuY232c9PjTpBbsbeCsVGwhk7ZWWRlBUurRU%2b4x%2bL5nBYx4fccVzL9KvhgeEa3pvNl9F44B0UdwCPFzshczuWn2VBJgDYr5Dwzi8gkHxWQTZhZecwuPgSzipXRrvhftXfKyKA50t5Hrezk6EQGX/MqKnaEIS0p0jA%2beLTuemc6ZMc/C3Crq%2bvVUk8vki5dJsLSMgGeACQ9tSsIeIUYeaxLcyXW2%2btVz2ABcuUjikemlzxgk%2bJzC9kvS52%2bFg9GkZNGwLRnR6i9gZhZ/pMZVmA2QRd3LIFHUeCx31kuDMWNqrBb3DHkMhVjToKZa28E4SmlrdpV3Gs414pc%2bFGyNAe45Yzl0rXJkU24/N2V1d1zGldItm7ioR4fX/Be%2bhBXr6d7U3F0Bx2Z7ISt2eSHEbyvy5nYBrcsB7vkadocWxNqtwNcOjrgxnsuVoBgWDfJ69l5Xh51JobaDGCey/xzOl3at6uDFUP7JhH9a89tVsW2bs2f8Yjzz%2b7z3MPODkXKAgVXXv/3sjIUM5chlKBEPMZBzDaGRmN452XPuYLZOQRJV%2bni0rgOFovjxHruTVumeomV6LceDxVsYBxQkXTJ1pCdZdHvWnqwOyAzM3YWRdDIJqORIN5TuP8ojlb3fJKl%2bcMvzdBOLZHSpU4xzUJwPxt0bwa0W8GsKPo2IwACx%2brYDLzmxzgUco9LxjwGW8XIAMwQ2PEZtBt7WACqCGLzt7pe27pyQq5SHKyir5zthXEW3DKwUTn4t3IAb76MlSXUjgRg8wPXART8wWYfu27U4OXbCuVWgOYvK35mtEpP%2b%2bUBbbqPZyVyPjAd99wb%2bvZBOc9lZrNj1QCcsTMrpIzMU%2bmzuGZjGRi85XLGyvK9WDlRhXr07KesM%2bSolz2JKNjKiq76OCM8hexiYlVVwAzYLqrHq3AII1aK2A8NMUyeCVaHVsdxvo38ahm9Dra98Xy5ib6ZJRRDFrEHkqtY17qL8HEVa4WZgazIZGs11QIaonJwCN%2bNz92uL1/J5FjIsP65TiPzTdfgezhO052fZgzt2UEfzzC0GQvLh1bsrHb2nDOKGct4jqgZRKsIaBNWVvuWIUiswu5UVlxSNibf9Z6mITfiU8C2FNnjvcYrL9XzPIJZCwVPx9xmFEq1CoKCkxm86subVpI4hj8eWUXBkAiNByCGrq2N0U%2btJ1%2b6HkRQZwFN7ahYGwdmk5laDkE%2bY2lcPAx3d%2bncjKEVRSzS6WgcbqlTTCVDu1gPHmPtXM3r86MV46jBrC7rEMxOsZNb9GaYyVwlZNZPdS3XYFZc7ZiRoVsFgiy2aVvIgvNYj3M9mBxtrbgX1/aD89DxNWcTUIxPSphqBraKtcm7QNaGz6/LcWVgwpgyQxLjwYWTXUB7u4JVC%2byMSraGTO1SyLWNeNPohgXGgtwOHiyxj/fCxXaiwNTw1AFl4uNQmifoF2ucNSre7wNSaQzQ2me6iOcA2oqdzSb9e9hZJb6VVxzqzsixmRrM/EXIxmKeRuaWcBuYSdsaHLM2zYHewEx%2b8Vgf6H3Xzr/SeUBI1kE5nUyO3v3k/FL5wsZCtpD9UayN3WEApZKtmX%2bZ1211l%2blo8XjferjOL3hfMzM9VdZH8X7SbR/sRVAytHw%2bP%2bF7InacZmh/pPf%2b/dnJlQ7te8/b0u4kmIUzt7CzqogzYHamrbfmkbOtOCYn1kAWlPpnGRl5IBNG6EGZQecya%2bD8LrkVoi/%2bvgPAajibUFS86oqlA9iMztll3bnLLlnblecF1iZN7X1Eve3IknYI2CerftWvbdc8oNsKgbgZtqbby%2b4l6FzLHCcw5ppNQ1mftrczMDG3FZ6/PrK2apJzR26bAw/Tsrhz9XxvBWa0ArTLGqnniZ2Zn3Ts2z139DOwckN107SybN6qN5PfjsFFdnMCzKxghiML/zcKQObOet0ZfD2djkGsLuw0iLnrbcgddWzNCcBGBODGbcR8rIEtspsmwCZAIgAHPm08nAGvXazP7kkciSX0N4/rt6C%2bRBGUPZgOoKRegJr0jQ4iMDai3N%2bTwm9O4mK49K5UXi7tO6VP6wfnNX3zKMNU5CS6X%2bycdfiKaazZWeJbnnUU5Z1Z3jRzmr0HzMx5HoFj5Gri%2bxUGgWs43OP4IyqpXPcCyNh4Sg1mk41SUpLQRPGez7zTFYD5L1wMPCo6tR8sK1EniKOYtq0cLJX/FlUxzqJIBysBoie/7vVpTXJuHnbPsHJgC3eyEj9R/F25ctwQDLLqF5Vf2uw9UHqK9UtdAtqdS51iOnLbeMiqgRdPPYLXPJXEYnLhKSNAuiiCzi1gZozBQFZurwIzY3ZrMBOdXNHwBODYztsBTCfmsEyqWrtK4D5BO6kqH23FguBjztrksjaipG2RtVnpY2%2bN66dYYh1b6%2bj%2b0ok3Cc09rh/Mp43VA56ttSGqutptiMvD2aBhNcUyFt/HaoYZEATalETRsLIBHuQ4NF898InSL56pdgloF/PoS4XmXs7mcGRC5g5Ku68N/sx6jSbNFpgju/KnQklRnERmVjDRCZBV7XCBJXnX3q8YGk%2buTecPQAyjHdbLvNwd5bKasYp%2bLWM/rywlLAPbscR2d9Jf%2blwCuLVmNSZwY/1UXZZaRz3w8gDsS3COtEWdBI/s41oFBYvAISKnLW1j5EQj%2b35S3fXY70sgeScQOe4l%2bKrpV2xXfFG53Fz%2b0fWAkGfQ4xzCTH3PXM1HYsitgMZUd/x8eAJohWgyy4hZU%2b6T4qYdi8Ea7xA1Wy5POm66X9cQjIqBujmeipdyTNpl6jsAzNGedovy7ASA6WfcKm9S0Ex/6DrWiV7mRMGZKDQTbzoKf6HeoW/D8Ynim24%2bLIAiYt8wlwZpzolrPf3uIG4WKwyK1QTx3vv4XomdtRhqjcurG4L%2byhVVy5TuiqU4eWbVwPOWOsX0QisFFrP85Lw/fAOYVWXeDGZhoJ4FM0zZk3YATQ%2bDnqf3WS1XSveRwkdjAVZSU3C1nEeYMV0/Kt%2bDGDl/Py2fS82tHKJNA8Ugh8m4Q6fcjW102pTLxpjiYNI1tQEkmMyQQKSbCMizUBFUuSAwk11zL3zR7bykfmJdWmNMzd5E4lS7zIqrCcZ5FYPHXqDYlriv58pAIP2nq7w67xm8DAzqr8ulPJSdLX3PMJ3YO/uc7OpTpWSc/7qNP5yv86iSAt8mYGZf4i5Mx22ywX8FFwWNfSC0UYydowBmrG3iCNTh2D42Wwlm5s4x/0fxXJN/toeBuJEw%2bYwX0dYi/PvC5P7w6sZDX8j4kNsAQ3zKo0yXb%2bTkUXiI0eYmIA5VwENrjmnLKQ/GuIeA12%2bCKqDhcamTQ3U4gTZnEJd/Ukrcw6AcIOy/x3XAs3XBdtSjXOzn6Uw1JmZj5fHp0LqpbThj%2bbpF7JSXPT1nmfLxkGnOAPLsfmjdrJY6udN5YblVJ7M7Xo5g4XUwdlq0I9HBFQaZGyQUnFa9l351zOocgzSAWG5LnRymTLVc%2bLyKudCBfjF0HPZgyV7sceJfajDovjoehQMxuoV8qyUoZ350Bsfg%2biFjZYuip2vERARFC%2bj1/%2bgMPF8iJSImgejpxM74XaupRU/XbjxePhwvMucsM9HzYeLmcqlTTC8kcvZqKBznmU0TBymDWy4nglk6OK27aMsUzKo6OLWiWMJp5aDIGcXL6RrKc2BGjOJZUUpcwuTmiCMAK26qFeyoG2shlfAA5Fn1/6PNqDciL85yEEfHmQ02DubN6jajf/cWUqBLF5FUQe3K1noCC6/EN1fariKo9xWT2GhNDAVXUU%2bsClBqWCJlNextW5IPBh81uWglelJEmrjMy59zorbLYt9S61Yz6Dkwo1vYGd3A0L5DRD92qkA6y9Dsy%2bHx4jxmZf/lFDvDZkbRzLUgDtrE3mbsrDmqL9%2bYivuYgFmr6sPSwIjQYhvitbLuj7orjAu2a1/PszC8wdk0ks%2bt%2b15HhlKyDUk1ayM8c4K14bnLuLB6bAG6GQasVWXonsCCIkvbr6nDfFdMTRiZZ2hQB9Zz8LtmaK7GOUsL5/SuZztnTVna43zPMJ1iaL33r95m7awZmh49Q%2bDuSZ2SaHcEZhVNm4JZvAIHfwSzkUGGbWZlXueySrH9ru0M7h4zMGsGTZU5xQ6tlfkliKU1neHXZFYypXvIi2u2G3CAsRTg2nWgK/YZayNhbtZ4OVOzNlLm1skmmAtd69fJaRuSKTufNWGVsvjdR4MNoA06//2MmLCPmVoJ/4OFzUIMxd8le5vNK6npt%2b4cdpT3eEK7R3//wvHQjtNpXKvYWTxZFbaSbBd1nGFmKk66Ar2fBYuYt2ClBkTo8Q/lQwOV9Un7wq1je65NbF4/N%2buUHNp9JEbS5Ly0p4c8mZ3qLSbpRiY9WxTUTVEOIiqCWyWSdnYUz/zamrG2eC8Yo4xEjBzlpk05tfFdDJ6KETR86tAB11k6nUesAWZO/qAsiTLxMl/EM/AK509BSpVOXXh36ZhOWze11nPLYa6D7rtnFqszTXounqcJQMCXycSeAS1alMIFFUOIuq6Z6BmNAB7MrF5nRXKRMjgwsyAqAzhJzarGKpZSxZuciZk7kEF9zmgyZ2g8Y3AnQcxdsMNDYqXCV4WNkQITiFSFHOjERPm2pSP21xVxIJJ2f07EO/x%2brQqccXOE2T7KC6IgGgrCkik7RmbWQHFO2hAicmzYtthWrCeWI%2b0KDyg/r/MGAhQ5c/YDw8B6M5TTvmeYTjO05y9WTyVKlz/P0ooUhro/MkfFdGQ1YItKylK8T5t3lk0krQAzFCUj8GNV6Ch7DsyAfRVvMAmadwKYNlfrweklUEp4IHivuz6fx4AH0YnmrI3JjAvaq1zQ2tqQoGfEEMGwGmEsFN9dtZjaBdQuKw22PpYxNeris0bes7%2bPhf7o2HQAACAASURBVO1XFoXUbTwHWzKFy5dkIpwxNXuuKO52eehVoFZ9zLeKiysDwTw9EBzoHnZGLyFyXh%2bg/anPw%2b/ngFksL0JkVfYU44ICPe5o5EinY2QIZm2eT/6wK3EpZqbVBMEnyQFoMGZEMDM22F0%2bTZUTL9STn2XY2yBmKMVxPG1vrUdVzpgEbJ3kZjoiuQo2DiaiUiTFUNoJ3Jjc3ps8gKcz0iRolRonWVVeuEwKQS3AF819WAWhDtCg4X1Je0Jd7CNxMHFibgpwZfjucwnBMbKzssRVNVHy9unUUqeYbgW0hyxWfy4rm6V1mZEOIKgU%2bfTnWsS11Nz5AtMcG8PBWfAYx8wwlE9spRNtGwXx24PZLtaFuy3DgFdPo9icJTwYhvOxk%2brVcI0OenycKKLpcfPk3wg9%2bfez6GOFTql9w3dn4q8p3EEpL/XxADayWGjimc/kAULa7ndHZ9Op%2bceTHgqHE308qWSAEFZHpODvn2GdSlHcibXQ4gJsK15XMr0paCG03wSfF9%2bz75zPbukmQDu7WH1B0EKmk%2bA2y1CCSwU2k0PhmsTOFnozQkAchxqWBi4Vqa14fSVyskFiGconsDEBM7x3GaxN4nqJ6KuWwxrEPEvzzyU/xAFixbN2FtE4R%2bi13b3/De5jj2lGTuzcTzclBT2CWw/BFZt825Xz%2br0wJBBEw/Ad3LO0nc2BT1gPoKZhvWFR%2btVqOT4J9uwkA0sCwLKUNFIHCUDoNHqsQC0/gsmVk7IjpJ5Od7Gza5vOGgX0gpN6NKY4EqrzxYCpWBOcm7Elp3%2baIFdSRxX6J7cqgENZga1FcVOXxsintLGgPDxyeBAjU5hHR9niBlh0Ts6SaUyx4X0XqOObZYhVuhHGeyqzrAAMfkG2PH7rXcxLBTJuVFIepzyoVr5tbAr7y/9bxzDcJmjhkNlwMxcXQ220bNyTgIz5lUEhsIjdFPfd1RUNBPZYChCOKwkqY4S7KAK8f5h4HBfMu5r9h7t%2bfq5%2br7f6nmE6s5Yzpl87k%2blwlpgTqWPGNqtPvk9mk2kzDFWufxXMQsayrRHMXLngz0QUwAxFQQGKtrOKyuvfGQIKMLOWezBrdn/gEK/r/XisvpQ1iwnA4V%2bzZZBwH%2bM/OdHsWbVxHywLN9tOf1sqA3%2bwruZ06yybtcO9k7H%2bsuE6Urc%2b0jPN69pUX6GbhOA1heVwyCyhCQ1yI7OWibGaCJo9N2yJmwwZ24WN8tdwnPRWww7H3GyM3A0lvpnPSL/ynItvNgqcFTtXDyc%2b/Ac8BF9%2bRe8m7CyKVSUzLNeKyu/FnCBZui%2bbq45ak6iyOHI6M7tY7sGBGQ7Kq2FBRKOq3bldbvAuTji/NXW%2bs6z%2bubIzdu4iITAP6DwNZkbdG1P8v4JIug/UNpjfpgpwyWC6/u7emmp5RA3STSxlkggXYp3clf/oq3bdoWqzdhhYsOnu4NhVLEQlW5UtJHWw5QOyAOGVgDu6U%2bMVJF3a6bTIfqNoWeW/W9wkukPkJHqM2JlmROh4Kffs3CmRM573eXAWZhA7cXLP%2biYss7lNN3SGbbF8JlEtu9lecdFcC6ZuGdA2PhIzm5UfZ//4cEtwjU88XBb96yJziHVMinGCyy4STvQuCGz58vtFUgx3reIeiQC4i54Ey4%2boe7DA69VfDLzpiuVKrqUifkLI7NSOtNwqLFw/qCf6oRWPdHq8kzdDHomc4as7n99Peme/13v/AzHbLelet43nWztLanY/V8PiYtFL5jMbaBMwi4iKoJ2kAwRLOQOig34FK2a5wBy%2be50ZO8ARnyq1fGpbWwZ0qsllZY1M99TicaVO9WPSgx6ccSzJliKyH%2beF8WAZytr6iGkmIIjPM%2birImsTCynenkRCuWDQhb1uqrznwcq2fXen1oe7hqcn%2bIuV3e0%2banJumBz2tgF57dIWZH/poVXcwWrV%2b1DXkBye27G7pTx6O7k5RS/Pp7/83ALu0aHRWae3Qz1agvXblF95hUBgM5OLD2Ezjbh8yrlCRI98cZ9QMDNUk9%2bGNefATHVK1X6YBZhZao6NsrDH8OZVAxV93eCpcluAmSsLr/MProVDrPq35u75EtOtge5NnpnoD0W/11DnNjLw0NtpDLfRmMZtMFhkwKn5Zcq81gpwfWI2SYOKEXpF2Rnb4pdeEr2bYQ9REzXlExlaGB1n7n%2bZZ6Xxv6GYPT1L3LzWcY/ISfR8sbNiNul3uGyqx5r4d%2bnRxDZk8NsAYjQCOAaE94xlmltEAjYAtFa1SX83FU1X3v/apds%2bDe5BCJGZ2Re5smJnkV3RCUZGFAIOxm/IHGNCFwy5fiyJVNeHgpWIqBbFoF0kpXQ8XEgUxVIVz%2bJQt1BFKuL1KPKhCLmHyI6ilrTXi5hwnWOOYMWNVs9FVI4qZPcyEocTNaMOLQiF4SG62GnuVj14pbcwxbbC0pnFzf%2bv9/6PpktvTPcyNHqYtVPS4XQxP8fld47GQTm6GLxhxp20r7Rg6cyJYIblBCho58BMUxOGAjRgAmZ2GUR65WFhVAsiW8RXK864gzCchuckR1MzYiJ7THYtshBsNkTU5SsT84xO75Obq7mRRdDFp%2bomRABYeAxgWQx3w2FSYjbrLEsfamoVbqO905Qd%2bsIhtrYFq6dO0qmr%2b57kH/aZVPbAopijgXquvlmug9L/w1OFH6TnANqNa63C7UwA7OwrmpWcI3PWSerBmGOuAQEls1NskSaN1xld3SLqMD0VMzWnWTvh2l4wM2V/bG1nYItHYiUDwDggExCL4asJQCxFCDExEcE46fTapG5mB27qagKhwRFq2Socri3IcD3YTvufPjd3g%2b5Ag0xSp38vcYUHotrIC4Qxxs7wdW%2bpGPwq9Ud3I4TvotCqyOWZe8ZmnUrfs288ouS7RU6i54mdeIzDwfoFzC2c1vmKBd5VGdAJCRYo71iDOhHOdZH5ZPnycuhsLNf5T6FFE0ZOKWq6heZrIwApa4Q1pSFeGiejSdyMJZyDdqfZD9sWru%2bcYbs71Q%2bPY/NAf5U1T4d9EJ9URd4hGGOsHMTRaxu17P1LtC7SyNOT6AeiYffiJop7u3HDWzw7tMU73e51oGjZC7E3PbPN191L6%2bZMxMyiqJeo5k61/vnmB%2b6ffQwPngDtV3vvf5QekJ7D0Ois2Al38pjsC4NAzDc/JmB2lA9mOqbMQBxC2nevO2N3KxUTq46tbqYiuE5P3BSr/DXN5u0pG9PdUUyknLEcB4RD8X7dqCX4udmx5hgqkyn3K/WAKff39jW4xnQKaDTI1yC4i%2bOu3QupEGjA7x%2buiYEN3hdMIAVL0/a2BrmtGVaf41nh%2bmBwqFJ6ZicyPScVDLHuxJJOjfmfflTzngtoD7J2FuyM8AEVvmnTMo5POx0XsiJkZwBisQR2ORDTvO4ML%2bMxqA9dNKSzU/AoBxBvaulbu2g0uE7EvV0PlYFsr2wCYjQHMWnPFZAC1TNwsUXyKj1enwUHfdiwWla6z2ZW1im4wXtBMLRj8K4YdFnNcrTwHlTPqc%2by%2bZDrsqqj2XvUT8nnduFadFLXQHmGRb6Jcl/LCF9jEathcgv0TUwzh1eF3L/fe3%2b2dVPSswCt9/712y5YHEb6fXeD5qdqZauciwd4etb1N/kzeYqrzjF10RBwUuoIoCRZQ34o1fToeL/NFOqE40ZBrInNoAaxlieaJi4TzGAkMCW7GhzSlnWchhoDoCA30etc1d59BMEN69S8ct8CbAygzKDzOwVqDhHDW0YrUGZq3GBNGFrFYSIs%2byhaiAPIoZRS5TcxvdJf18npo6kYU9iekwVm0d%2blvz2/%2bPb0XIZ2Sd87k2nxXO64epKmz/XEvNOYYhf1bKOZTxO%2byjTg8pfMaCZg5qLkZmaG37PeLNQxuT/mGsQY81UgBkzMfLk4AJlXtrNrh/cXM0xiQUiTdAMHa5zBzTEwuNk2mBCCG0u94uoWwLAENWmdA7WwN4Nbbla/a3y/9kzX/TlOHnJnUTd4fgyFVt0ynG6hd6n4UxX9zLnWnEuPALTTdPEZ5ocbc3l9TO5kZ2stZsBJGayzLV4JS6ya%2bK0dgFmTGd6DmTmUTowA6gZigSBl0O/upKwUje8BMfP/MGbRsvVSyjcV12BEIMea1dSA7VZwS89exUtHTIOuzY7bSnvTvaGYv4NUM1KJoIYMCURtFefJ2B9JG1Q5D22JRmdQ1SGL87o97F11v4xOHovcD0rBJw9%2bHBgDfrf3/kuPbMmzAa33ftO%2beZJuebyrvKfKgfGmPmTkRYMqmSNhka/fcBN83KX8bMiLc5bOMDMdkKIzUjYCvmZFYyoQuz6vhhE8PBMzUuRFP7OGslmDBaCB5dXghosIDNwq1kZEibUBBA9/MgOfFplVAWp8BtSEu1WWcve%2bcJLysBSvuHl8VO9xMiF7BxF/NB2ZOsuGeu5jK3/1rqsW6REMjc6G/Jhaag6Se1ZBBAtf6pQUA/Z99R6WbNtNqYGfYEYUOdj4RjquJyAEDujNdICFWZtgtQHu7akOq7KigUDVBRZAbHaDpUR2V8CWAOAExBqCGImf2hAvLw1oe2gfC1Hkilawwt3fPbhlMDVwawPc2lIkFQOInWteoXji5ed3P%2b9%2b/vUbAyQEtcDSKA7GxMpSDp/AfUNXKjg0ep7T7PpsAY7H7OxChn78oFE3p0cB2jmx806Z89lkedFpheLrOHM9iAd4mK5ERYHowOiUuzSABq5Hje4NYKbUB%2bfuAsxgMVQxwoAF%2bJFdgNjIqWIfsrQIYvaMHKtDcsYuy9BO2X%2bERYiIOgE3zOjATR9UW4uk7J%2bQgn3w9RPlv4n4ze4F3z9HpX4butZ9Lap6roT22DNqWufUSEBQJwKcdVh90Kn9rjvE3nE8qvhcNk03Du/fvC37ufQQQLvH7DqfNJ5p6ZxWNlI5rea3ll66dDiCzoLAE1PxZFONzveKc5kzI8D4O2UNCNDOOrc/ixrECBhNDWLmYSEsbYh9DQapwJYMaL0fQSdQ4A09lfxHUG0FbqUxgUGfp3fS9B6dLjXsmEUJ1Oy9OFATVpdAzfRf6CBt78IfkLIgyK3/jCASSKRnacew1Be/jlN0qp2Vf/dofZirBqZHMTQ6s8vxuVtf67XuSqGDuQHuqz5ufHVx6svBqRSmVR2zyCRksXlgZj7u2ihZmFyztpihgXWXdNMXeREnDmhjYx7ECIDMMTG0YzZ/jsGKOVq5M0czrKoYqUwKrBNH4IbyV2uGjYCOg4nZ8%2bJC1I0sEhbV%2bueCt60WG3yv8vzw3XumVo0w1b81LMejmRsFjr3FfmH9KrI0z0jte09/6VBZthyT0S/jWNzceu8/tSry3vRIQDuJuLci%2bjl4Q6ZztsoZL9tTS6fWGOiVIUzkxB9rXhxgNzCzWFacr2NoIXVSZW3P9XBrwTI4Y2MZxBCc2CDL/NzE8kkGGgZ37gBpCQOgKnBL5SBra570OdbWxJFZHGjZifcN2rg3pan1U26dgyFF7ln97MASKRZZF3I9sSs0SgUaNpnI3ZK50I8PRxLuEIVg6YBzlm6jFTeO6r97W/bz6WGA1nu/rBr4rTuutL/RufZAmTl7JU7MKEQBlw78z1R/BuU40CnYGS%2b6g9tN/C5m1jwzk3aoor%2bpbsYtyxE2oPTJt7JmYwZiBCBm3MuOm3gEui%2bEQgUSIF/hSwVuDFo3E/PMTshshWaRlLRSvCPUQzW4TwS10INAV0UUa7B66kky6bTg4qhnwzYVRYWfB6DE/qy7KzyXvtOBF/yzxc2fuPfCo/RIhkZHS6Hqx48dinyOImuex4qHul4Rcjj7pLMOsU5YNvFSGD0rV5FViyrrcOmegU1pngkwmQbdRMJjNmbSn4GYAmSzK4yB0QDTpoaR1jDM0PCZC%2bVFI4OAGzmwNNaGbIv1OduLSeDmlnvBhiu8K/Dt9cLyMHieTAH8QIGPdiRvkUaxk03lEMR/lmAFfiYu%2bgc6fFTQeV/isoyTpd0ubv7D3vt372zqYXo0oN3lk%2bZTDXiWeji8fvD6MDF2V4U/7kCGC43Rb0esHGfZlOqKrqGDpIGFC2Zk2CiYgbV5aPI3YAPGJ9Sh2FpK3Xr4GMREvApsTP6ZsGkNubKLZr5epqgfP4bzLxOKrgHcrEkAo75uef4cRVJhbxgeSAkcK8BWcODa6txlYBKSdwUOv2idlPpc2Xofe7qF0xgwZimjQX1Vsn4fh8py6pz%2bOmeqOwWCf%2b1MpnvTQwFtIO80AsdjrJcnHlo10XXK%2bz0eLEZ3CvQQKdX6GF7gyzLUgSVNXoU0BTNy36MRAOpRHRGImsA4UN/tBmcBYnQAYuSFTbsRAQ1wb0CdlmdLeGEA0VG6GkHZvrQJuKFI6pCq%2bffjJgNka2hQ0UcsYIh7MQBwu/cFy6GqrhnUJqFn1ImLIg66vU6g8O798871Ho2kNF4n4uaNS53%2bxJlM96ZHMzQ6ZmnHNz3Tod1LqV0qe928dcauyE93E6dc12HYdzQYMj53AWYcvmszkJmF3skuA4zskQEPVSAmS310NAQQswCRAsY0nFr3zObc6oEMG4ke/rYSwbM2AtYWDKnA2gK4iSGBwVLayImAHmiNrZnV0b%2bhvbqmom%2bc/BDJcFUFN5iozAoBYGmfLHra1uLrTN899MrfrLhLE%2b2MpaWJ01eeRko8cPtSp9/ovf8gFvvI9HBAO1wKNYH9ThnALEdtaL4pzYNi1IxODwCj0X4MyngFkubyocgZ2Zk418qALEgAsDR2wOJaqqcC91E9kDAmb41roNh3ICZAxgcgNsADYxCZCwosj5IWaTTb/OhjZA5tSgC3Jq2GtjhwAwup4U3Te3IiKIKDOj%2bPSwXU2HRe3gIq4MiQHxhQekWgXQxuGmnjZGi89AHDnJnYOZno7579F25TzxexXsT3DNNLMDQ645N2f7r9TUXBUphMnHEZel1D5T08pbjpCc7piTXFn0A9DcxsoI353YFZjsc1wFKNnU07fkP9kIqa1lKxlOqgjiDGNYgxwN9e8V65W3vJBloDIq76tN0ggEAgxwWi7BFH1qZPQStRKPXt1/sD/zYENbtte9agMpiCGr5DBTWrMhkJsNU4gUJHagpy0C2CwsszLPg16fox6DTKNIdiZ2JsVTnFhfNDenXhe/anptkflF4K0ObWzgORL6WJAiG/FCpmF%2bkd5pK9fknzxxFZlEO1TA5GuwY4oTFABkKoil3r2TFCXxd2%2biy%2bmvjSIK6XDHIbUMasuNSLMcCHhkJUg0ChD2PgSxz3AZU2BPGokYIbJgE2sVwq5gJrEzgRYPNLyFiDLhKsRjBSyTpxyFSk%2bjAFNW140Q/sWVlwR2gvG1CoyLsY%2bt6xNtS1miAnB8vy0EOg9BY4ogr12eky6czm/s6y%2bAelZ%2b0psErMfJGV/1CVJVkA5eWHg34Mc/FSyLoYghoCDUQQVSZBgaE5vy%2bxtkFndCFlwG9M8kcFM5jl9z4uZTUtQ6ymUm9kiSiyeSOAMTMpwXRBo4woasoyIL2%2bHiU2DhzFCePCZ2YA16SH6eM%2b49Keyw1tE7vZBhsCQxJtRLyqE/ldzYu4%2bHvcfykeyobt465HtU2bLk/q48vmtoLbXP7rOd17YLO9AjbYW0B0TH3fxV22zNs/OuxBIN%2b77jOwqX4KtrzTtuz3J%2bXSKMvps2DrPBzv/vtoc/yEZ1numh7q8aDm3tUf6b1/v3rlj0wvxdBoxtJWs8ARtE6vPSR9fqi6UCvoRCTzNTrTymcAs6OkeBXYlLGzCMzkGImkFpoXMWOWvLhTzMbSNhApxRVCZElPqExsFAbSYFJBVnAVMxm2pxOFPMb6n8Vgc6ytuWfILoik3d7wCBmiYgviKDu9m2njFt1kdayYLJUN7rV5l4pgmGBQEcQk4dJsJBT9DgxI06bizNIneaY3HBtVFjPPWP/%2bnY8BZvSSgNZ7/8nyOHk%2bWtoB4ooBPDzSiVfhMgcMSeVMWP/8CbGd9%2bAn6h5kZcYSiaxzE4o8DhGknNzSvRwQ%2bBAQmmxGQqqcd3qbZoPDeBiDSOn3GpCzrEuoAAjFsMAWY1%2bALD4mXIfJ1b9ZcMlGarX0QGLAFi2lTXVtnv3HCBwqgipo5GdG2vYBxsFIUInVsZ3C5FO/KjqwCwk1z%2bbSBoOiFyF6YgEFv52wM3/98XhbIP8LxD2bpZdkaHQ2PPc9qQa3LG5KKmV91yOjUstbN0vLJqiF0XJlPdO7TMBYk8nbgxlPjABNwIjU10yPE4qUTo0NKnFba0gg8h6xMcEhD6uiJ7PH18ZqAHySu4OtZVLLIkaKxcX6RLqqoN7DYBgSEMylfvbv0q8zRVCzCCCEoMYAavIuOYBaJPNxVyv3BVgaVZ/hmsjL42uM1s5ZyqrWlDjUWqab2IKkaJlwou2LLXWK6aUB7WqmPWcHqJwyjtZxTouZ53cX5sw8sW7mskx3dqoDdJ/PgNB6bXQL0eMHzAz9m7Q0aFuLY0V2bzpiY1bZzvzaOSAjXJmgazNHGWCNJAEiDHwZwK1RAW4SNBJ20WrkLaR%2bAT0yS6gbXwbDRAUPMfYb3XJPKoEd7ZGR6WXxnY%2bJhxnembv5WqCcOa/GoJZYDzYiW1wLuA2deeJFdSrBZb9%2bXwn3pRcFNPFJK83Kp8TOcC5lPEOEGToSfsJstaDVaT4bMzA%2bOcfzwDCg7IkQcEDkS729IO6lNbRoJ0bWGFTQ6W7ILJ3W4VnbkUBs0LbWGujKrBG4NwJGpyW1jgrz8a4WCB4O3FpmbdaMwdwoTzb7LYH7Bwejky6ot/eu7WfgsGAp1ei6ZCI8wzFNsPkvKs6la7u%2bEzdIgQnOjY9kpBvTJ/af8SARgErScEDAevw0y4vlO83Wphn/mbMlPCK9NEO7pJ%2bje1laOTtwyl%2bdjmCVs0Gnn4qbk2qHzUhmZtIZuvIjMsWwHEoPnU3PgiKt2/QD2UIUNVuWUSpR0yyRfvclfBKk/mPRy3%2b4eDQGMBhgAn5bwgCljc6FTPReZKARwY0R3KIRpHl9GzIMdP3gkq0J9CJz9aAm74LAmCEFRKY2Oy7MFzId9n2ufjUTl2eXux3e%2byWOSyFxTGo516DimlUxCtDajhddiF6lFwc0MQ6cZ2k%2bo5sl4ufJl7TMjsrqJG6ClckVMA3wkir2nmKRnXEJZpBbwUyPTkTNhoxilNuc3syU4F6/QwBiTC2jrYmWiNEFI8O1TgoIDURchmMKn9JGA/InMp0g44J2uG8W0IR3Fn3aXNwyEkuoZ2tiodzDE3F40%2bjaA%2byP4Xm7iQfBq2VGF/pGfIfSZrvXOFGtkz5H7TdwXbFS5rjUgjAg2wjMsvAA%2bx9PNfyB6WMwNFotWM8JiPkNk8q0tMmaSzOMO0HgXOsqhQSACoE%2bhYJexTow2wYhAcwaWBtLIwAwEBf5Fvp/1pspSRp17H%2bEjeX75BLgGlQjLE9Gu7RzZ19tiNtqQzVl%2byhbCjMmZ6yNYWDvxoumx4ngHANjlXbFVQgA4AhA1T1rcErwLZR2545gx9GK3oClOUtnYzD2yOJ/4FCJyqn32KS9UCl%2bcJXP0sLNfFVdrr16jN4Y8E%2bfKemR6WMB2lWXdovYKV97%2bEwzw6xMUPDiS45cq4P4WBThv7vBFCyb7oJqlgRH3KIs%2b43XwuuJjsAgGlmtzQATgZTN2kks4lkStFWccxt8CEgJ%2b9FlS1IPiMgIZMpswf9K2idLjWQlqYAbuoYIuJg71xARm2bCd1n5s%2bFN4KJ5qV1ZWqAvKiwDk4THV/SlyIywX%2bCEuf%2bVSVakFO2L3aZZu4lFin1IEo6PcrI6SLzIGQ7JfUV93EttgnKUPgqgPcs4cFh4dfDglWmHg2ENsoV68YO7hnYZteD5IpG04cyJoBr7SWJmhHqj5kpJg0qbKxZLU/Y3ZAVsLgQ7FpgFUko2pbsHfFa2WHQTWLe5676EkdkCctV5ocwoy4TASqDLz0FpZliJwRzjek0vcmIwSRKRM4mg8Cx0AjAW6/zSlAWKv1vzkTScbWi/zvVhfGk9Sx3JKOX9QkKMtkLR4XRoYGVwFu/VWJicWyuxi3xlevgWdWfSx2JoJMaBc8nMLJllFSb3lMZMiHNo92xpT9gdF/oOTNt%2btVqywBkKgajR%2bulGqRXFHPnCo9wG4k%2bjZgMbBtYgf25lATp6OhcGZWpe8W4sSxggu/Y2BTh0VTC2pxFmBYiEDWlx5obBEp7RrXAnADZYJcD2flBkR9cPN2E0zz5nIqg60Y4yXfBG1TsutPIendyzZTih%2bjc5V/h1%2bJ54okrNxFZMYI4xZQF2InxOGRqyQIuBI2MBjAGXhejfmd3CS6aPBmjLlQPJKc8%2bTcrs7lPSGoTghSEKybq88YonKpUiwRKX09fUKa5WdOVx%2bRX7r7vmTFO84NMzG0Mxdgy6JxcKGxT%2bLLsaRSBjwv9IB7Jf4C4uIlK3usA6YCMXogjFYBR3xTqqllG5YWCdcpHzWwOgRztnZGqn%2bA0CqhJ%2bABrILe%2bwpetiTWv6k6EmHGG2tZ2Efb8u/lx3LmKe1emvnyruBdLHZGg0NQ708muZ0muvPDdMuaVimHzieZnHTXVhGiwGcROBZEnjJ0ucVNmti85xNybc7IS8qFnpzdQgMMoR5gXLmpT5aMy1wR3EzwrcPtB1Qn2wyEQ81Ffx8NiXQagWSwWycdeyskFCjbOttxSQuorCzcRTAmBDg4ECm4Iew3HStqvvGFhFr6d1Zyt7f/Le1YjjjImO14NIT17sBGZubFtaGtQVlWQxUg8HcWK7Lm7f5YE0mffgtgElJFVOmdhfExoVv6RWp6/eGPBj68pfLn1UQOu9/%2bipfItfMeEMOGVNi%2bnHgGVZi9VRldFsMC%2bLKBiVLMVh%2bQE%2baDrOIBBgctxVRQ4MItVNwWcAcwW7AGSmlzKGIaKUipBCnAogMwdYaS%2bIW3CMpO0j4m1rnqUk1gb6NmTKCCAKtMMqigwUdYQW5FLEeHF3MSdaVBvmt875lKgDMAAAIABJREFUW3ofgwmjNDFzm5x1mxjDLbQEI7Ysk%2bt3onMj%2bKzXb2LZ0R43%2bySiv3/coJdLH5uhUbXV3XpG4Zx3xpwPJhTHtBadqG5FFje5WlIS1mxWbZCszel%2bjJk5ix0qvaHNusGIOqVaGzHigyzWlkFNQ6c0DjgXC7e2UskZ6wJ0M1rg0IpABqChD3zov0ApL98R3IydAbBBvDYxJKi9VNahgssHuntQC75lWLZ7P1FcKzpAimgE8MCoU9oUuNDgY%2b%2bvqp%2bUOdtvm5CcKB3cgKbtPUjpksMyVs5PLv387a15XPoUgFYHf%2bTy6zTNyRi7z1g2uZnJRys4TEVe6%2bcQvzQuBBd9D4geprA3Z6z9pwcz1bUIGwJGGWd3DoOojRkcFcZmARzMRELgAJCpGMnNQIoFaK2gFoEMREthe%2bJ/25qhpDELz%2bLkLgTY4gIIrUnZGavDsN02u3uShnHRZxhkU30VYgwIjsnC%2bPAdtmr1xniXuF5UF8XDon5lgS6ogLQLWrpkabASxPdA90nV0aOJXZLTXxOwuakx4E8elPii6aMD2tQ4MNWj3aAcLV/O5I2xDaaY7cQ71mSzqg8ciBmnniXC40GsQ8aHOiIn5Ojo88Bp/l1SAew9CR61KqahB76IfOAMKxgkoXOIAMisFAMyFS3HfpzAvq4w0RhWNJDporSNHthINj1hPw6j3xju%2bMRhoPolVmyWWrk3BRkB%2bAgudgfSAgV%2bVRX494YTTRRXORyr%2bpoLAwTWRAEX24Csj%2bWkWY/mjjpdG7p5wLgrOmnpeLsejv/T8uxHSJ%2bCodE0rFDv7sGvxMpS9q8LXR7vuJF5zKKmdlYxyTp07JRuhMGJyeYgBIwlXqeV%2b5lXDl%2bZQROgMTBjaGNrCBSjnGaOrcYmPRCqY4c6uyKQNQUyEvwDXZoAmYWvHtZQ3DRFRdhmYCzXO2DDXaNAz4ZAFdw9dD9Q8F/TySKYhNVQ4Khb4nDFSwPGJK9Jz3uu5KN6FGuPCJ4L6tqciOmZn75jucdSj3bGhMnzn1FhVpVbGwP%2bqaqmj5k%2bCaD13r9SHqc0kUzNzDMUMp/GI6fASMlMma6Mp6pP78Gfw5nadWsBGAC3BgulSUSpYNFE0ZAU%2b3KgQisBsAd0fdoWOSj1wG7mCmRqXTTFPjtGpkWAuMTWfqApqtcDURCP6TpLAaEGvnXsaY7Ts7GJooyGA%2bN0jq1h5Axc10nwBiTGmvjKqdEA/OdI2Jzet7wTC9luOi%2bwXibmb3V5tUiDs/gcI%2bj61HO08rvSUio5p5b5pMYASZ%2bKoVFlHHDJhfmZAdjK/jRSEQk15kXzd847s55i/tvYGVak4pcel/sO0V%2bVbQx3BwFecVOQQSuLr51YJY9CjglTE6URD4CD/S7l3hUdMpA1IgAyYXnit%2bbL8GKjIVBcInVtB7h6SP1oUCDy0UCcq8cANV11AJONxjITC2jLhpJury69r%2bsbBxHPqUlQNExlhIkIwWzzfcGv7fSdpeJh%2b7OPSpo5PFVOtXg26cfwrlCPlq/%2bpMYASZ8S0Or9O/Utntt8flyUvnYBBvAxs0/2P%2bVC2DTDat%2bCv4%2b16jIYnD5t8t21Uh1NbZDhvbdwHGf/xtFFw/Ro2OXVaBD0ZiqmkAE9twhiWeGvWAEMh9XNQoDM/bRNf3VPTtZNicVHTaPPophJYjRppuebsDViv7C%2biaIdgE1C/aq0yv7%2by3ekr4PTORTxXAAAxuepuUtyNa2XF7lmk2rPJ1dsq5qw6YTb2oG4%2bcmNAZI%2bGaD13r8xOXFLKW5WdJfrKoPoKd31OhNPZXYksySiYMLWudPnYRvBuokOmc4Kp6f340H1olQrSh8gJZMaKHz7UdQUcc5EsVAWez2ZqddAbFNH1VYCGcMeABhOXK2F7O9b9wyI7SBjgsLWUJfpxFC1iBpLNFAjs4S6%2bQDeg%2b6aZWF%2bbT0s6ilHfexBFte6Cmga64LIG0oXgT02nd7SxBnVJxm7oJ7jjmhlTI6Vn%2bd8zz65MUDSp2RoVG1I3OMXWP5kGfxTRgzk8FknFuOiZa4UthQ70LQ0ABwDwvrpggwtUhaB7ghkM/XWV3CyQSHhsCmIms1GrIJZAzBrCM7iYtBg/WS8d4xmi4wMmyrOsSgqqmsCkxIl0Ue1cL0wtibxN8T1gXThuzDFGthYxVBBupKt6aMRNpUj3SEAyUvAPAZYgaWBikBeoxmUYKKU/GNG7bCdnwNJt2pFBe/Y6yad0WHdPLmxtDIC4HgLfk%2bvxBgg6ZMCWu/9a/FYjgkF%2bQMfSzoLl7e63qdt6Aqu/0S5WujsqhaZj5TstQlWMJ2dc0I/rtQuMEYIWGmYap3SvaiZCjuRcADhpiPG0sjETUMzz8g0v7lVoI%2bV2w1KDSRsz0p980DxTUZePABZfnVtAarqfdh8A/G9KHMEEqWbuTTvl4csjSAMt1RuMc8ic4fnv%2bgHmlwIqBbuJxU1PZbcL86suZzN/hWOjb8FO/uNo2o%2bZvrUDI3i%2bk71jxl/3eeMpeGjPtGJnIGSveNp6gh9V7I6FhasZdqpbShYxx/oqGsb3VgEXVeIEJHuwBkOQi4Z2GjdzLgJ5n5zW5BjTrxUUcpEuBkjQ2KJQGbkqznQV8uiE7lh5QCcRFBT4wGL4SC7esDTB/9AiOqh1lzPnnKKYbR9smeO1lOpDcrs7mOwTFYjjvnthUlw2q5NmV2EK7bb9X3jTCrGUZ%2bjWkzfOlvNx0ivAdCcLs2/F0/304/ijRkTzk8/vnN0zVCICvozV40zCIGogCC8BNTAJl3nA5jjfI8qapItd2ImZQ8ygNX3is3nTK2A6rsUfNbI2I%2bAnYSqRuuk%2boMpsKFoFYCMzZcNRUeSst1uTeBgC%2b4k3vdN6gPDQQC2uNwKLZ8Dh%2b1%2b3XvIL23mDsEOT4J%2bFv0KFbBIffFSHyrBj%2bOO45Y3xiLPg8L69ITlYZ8vAzukb8tB9sPe%2b58qGvvJ0icHtN77tw5dODQzfsrW%2buusR8c0TfpBCUyLTBxm5ZQRWJK5TkAOYSxqXUS/KwJ2QT4SLQlDgiU5ojtrcF7%2bEzADzw2MTOGXPQbHVgcsTa2wDsiQcQ3AuVz/BPeOwEbYGXXFgp1oDKaD4OohinXUvRlba%2bqA7ETGBkxJ3TZkMmA1sFhZlWOr90vDedCkUQAQMUaJmgN7CfQ/v/FO3c8c9ARVh7RNy4CT501uOWdB1P7G6eI%2bUnoNDO2SviXvIlomDbuiEIppHHNUfE6406taTEbTUlRZbQMF%2by8X19pgQGWxecWbEcAPBnF5sA1QKC1AV3YpbUJDgLTX%2bafZwvVmldu2ckTKyKgEMnZAxghkqgfaKVPcQQp3sxIw0fDeKIq2oGNrhauHNgyiaIhlEqgwc0ugVqVK7JdrEFDRWDAeLzC/FovIyekCtBaCle3LdL3EPIuuqccJP6TqyEI3Fo6UUJh04J86vQpA671/3Ulzq88Y9LEEuDXwlfIEsj2Z4aSjCcYwKo3tGCn7qa7D2GBafMHOGJiZiEwQeYN9neoSob4epuhGgQqXyai3QIhSS9byURRsnqIABXHbYEWEbiuHQNbMR8xYVlPg2o0NLYX2tmeS9/HMhggANhSlNMaaMSwHpgErnOuKvXz/bLUt9uDMmNzC8/alqdgJTBGP4XtgK1mPgy1xj6TQizm7YGj%2bk63rXw1hViq7jDelX%2b%2b9/%2bCeC18yvRaGRsmFI5qHs1VAwa2akGrSJYhS%2b2gI29jLshXmM7XHrDIOh/QSuJVr6RsCK87MwUCQBpHviAqmgHJo7cMAkBr%2bR3wgmomXChTN6rXF42JhBKYHOzaJPo%2bGjq3po4ZNVaRYBPbWXADG5v%2bUhgNji6BTcmIoMF4UzZTB%2buVN5MROEYcN1bQcpzM0libAnHT5S%2bcwewiVi2/2c%2bT48sN5PAYPhUh9L6dtuAnStJyfPX3JR0yvCdDcyoGluTjoHzhedagoWC2AWzvwqHh1Yxfwg8CCCuIs6pc67R%2b7W0FTYGljYTeBqCkMUAaXGQNIRS207qn1ki97YMr0buDQUPQMjIwAyORZkLYRgIzzxitmHIC9Pke5CGxNiRqAGnnWJc9IQYlAd0UmEquuUNhUfG0dO9CWDrH%2bCOGn0ShQ9acz3aNBUXAN25cyv96i9lWzr8fLZkPBL3FaB3kItjAaGwj/9PLePlF6NYA2NlXQKBxRJHK/2b/CqQGgR7JlgFf2Nzf72eYZOnDLVM9yOquDu0YLN8HkWZMKIq0AuDDhN8AhfUpxYKOvrhNm4uoFsZSK46s948jITGcmgIxsCIAM/L0u5T9BaAwHcg332mS/S5OynyCCovW1EkHRxYPtGaX5InluNG03ZmT4olMZ27tLClQCK7MvBFLXfsn%2bz0hzhLm2IOhfssqmp1UxWzdEZissHJgk35y/cpD7k6XXxNAIWdrSONDBYkTFuy9eTspSvcAOwepaOpUqMHEIjkDAvSqxMh0sTViUHUa9NY4ZjqMN9TbJ6mkDTQc1SJTqq2V0yxiaDN2CkcnWdI0KRsZ2j8x%2bkbi4l7CDb7Pmqe8c6NdYJVlja9ESPGYGDaEtF4IbrgM1XVWBOjBltPaQLbS6vR%2bZBIwdjer1OWQ92rQnOKdaS2oJ3QJMXU8wzMh2s9MaZ2PDkcBjNNvbJMa3/hMnbvCTpFcFaNGF48g4UMgAwyRu09DeWeX9CwC0EqBIBiIVe35NOgbO3hS6hg1aY13C%2bGxTD8jtaYiJmiN8j4marGWqs24QNXURuDLAZkuXYIWAiH4Y6lrQxzMyWGRO5ow8BzK/jqE1cEhuspmJ1qYiLrijKbA5r34xKkRg0wfu/dZw/4BpCiwtvUekM0GNFdd4VinPQQgjYe8D7SZ%2bcxffwTh%2bdSN5FtYBn0LcUyCPJy0spv999Sg/dXptDI1SFI6VcSCCWSxJmN3mX/FUg6b9p34sErnVQMzcFNQnCaybu%2bXRCR5F8exnf12z6Hrooq11ijsEVYWgk6WxD3NRYDimLg9E47cBkACkWyXQbONfyc/NWz55ALFbfRXFbCLdOcquUZ7rxLUGg7vZvuyBDeMNZ4AitQx7KsPKAqUCc/CVXNN%2bFd83qh/sxq0R3fKlh3GG/IEEc03DOrrR3G9TK4DytQx/zZ850YJPll49oC2NA4Q9WnRdBG89vH0X2nhSu5vxwPVC1RYIjqYovgRGRm%2bQmShxTZiv7wpZUUfD7SgTkkXf4tNlItrMEMDmRa8szcDSWQdLTgIpiEWVNBU7kfEHLs43AAY7Biow3eXKgZgtAxhsDYwRAEK6c3qTtpsFU1cKgM8YBbEzvr3VANnGyx9C4GC9CanC7z5cJ3wWPgKbQgIIxa6tYUfX52Y6/dyQen639/4Li1Z%2b8vTqAG34tvxcXI0iXTnR90OEqiqJc6n5f%2byB%2borzi86gQ7cgVdHEry4Bo7DOQT9z%2bb9LvDTJs38GI1dqRAsnzj%2bRBgVAPWqlhNUFjOKeABzou8iAxFtXAx%2bMTC2AGhE5UCNCYIZWQ/1oDVXtmcSssxeiXxT8IrhDuCR4GNZehiMjOu107WfZaXLgzz6QUXCkX/qo8%2bpZb/KbwHCScRplsPs8k1z/0aT6V5NeI0MjXN85Mw5E/ZkqUsXnJi4tgaSRIKBzS6dGhTW%2bZbd5MboxAJqhKKEbgCS3A6kR9CAi1snJwIpOvaTiVo%2bkE73TZuIUglmDdhI6FcMsE5fUGz3C3%2bwBQ775lU8J1IytBQfmGH9sXp1xd7RQxqckKy/wvtm/E9SjaZlxAli6A%2bkd%2brIU7MFQwsJIQztVIKnf7M70uzvgLJwn0jWc0RhMvXfUSV%2bCOP7UqUI%2bYXqVgNZ7/37v9CvrTPZx1tLpD6/iq8ioEv1JhDek8Bi1FoaRm/GmE3W6IY4ni6lfxeBUhrXJl4KDwd2asioHES7qKqkxAKuLgRllVYMAu7mLCP%2bSKLdYnxg5kK21dMu42YmW2BowJXPvIAA1An2nAkH1ItwLssnTREmoObBIDYU%2bOKG4sEio76bP2DZtyeLf5po1lQRmL/wEF8%2b9CJY9ic4N1k4VJf7Nw0peQXqtDO2SviH9qGJpCmTLlznbKuVY13DMbyx5Ua9YUAwOo24xdiVuBvahAwejaRAMVo6rAkSpbzKoc1kgW2RNTMmSxuicKmCGTwQspHofILcx5KOh4zPWBIgWBdUAag30ZY5lIRgEYwGyQ1yg7lmfrSRQsDWUHsBkFlmJUiIMVVfv6nIymey6bjHXQSm/CUMagBGZUl/Nq9gT9H6s55c72K1SsK/ddC3Rv3pT7k%2bUXi2gXRxte7dYadE4QG4IhVyqC8tvrI/O5zcY9nSv790vvfA5xEn0WDjSwAfqVBm2Ltk5hcYLCqscOVBNHK%2buCweJWCJhU1sGMBPGFcGMAcxs%2bZVErBUwMybJyKE8thXGAk4RZdFYYI67nqnhCgMvqto7wgmIAQRPPbhlBuD/PS5tkzYW1w5R0cTDoUPDDM4YxXq8K0Bh399s0gcLZ9V6HU9oGc3GgL/Xe//u0VN5Dek1MzRCluZYQnql64TvW0BQBwaWhp2fMpjMVgtsYuGEirYBjCODfniDw%2bYsnPgBnM7YErCy/bSPyEqhsx6Jm2Kha/pcyKaIFtlWBjPc7UmbZVTJvkpMMwAUBpo2A7W9jiJMdrwP9kuamhxLbRXmGtkfPiXrC46puoc7eh3UKYBei5ysLj%2bCqmI0YXjI8rWRufuwq2Ec6UE9cSRwxAeIKbtyViqcekOjV5heNaBdHG173x1tndtGCDpQv9BzTCXl5/j7eDaO1sXrsaBD03S07I/tmlRzuk/fU4V1uR0/S3FT9hKonxGKmSQELnQVBDN2LQE9VjDL6gBWbPOgxvDDXdqiCAo6PWVqPqyGA2f9Oyru9kxssgAADjHExEggx1pYDYKRPkpaHftGOMX4dM10m9JmjGmtAq6rda6cidW5YJWOnf1%2b7/3PHVT1atJrZ2jkZgdPYtxbFd8eC5wnASCzE0ZMbqbbDTqFkp70tx4z82WGz%2bYHrHygMpviDkJATRzjEB2Qinc1SONyHETZyM4ieGmlABySt%2bFOI2T7DQjLEGU/N1OKyyWyFtR2PDcdVQVqbopIvmreNUJBDI40ysu59olBpsNNZwoOg1r7VHSViHPQAMPmQBh1XMfT5wai4rWn8YYn5wn7urala1O787PsugFLj4zO3fOhhPNfH97QK0qfBaA54wBq0%2bAFz5KBlfec70PcmxkXVAdxsXbhwIlEDtOkLy%2bZlkPTIAoV5UUCSc6qF44dJOVXrYFlcxS/VP6TgThU7uOOeT8uXHfpQG2wPwYQMz1bS24dkVWmqK7u8aDyn1xkDiYICtBIVxUwrgCQZWSqk/Mbo0hJ0pc2dcXvrg215t/PzqhD05k59pzZTOZLtFQ4Ct%2bR/vXnXPyx06sHtIujbe/0c/abQIl5ML8oKygO%2b1rcdyfKMsR4F78cyaW6sQ79eMzqm%2bnLUL/r27zr3rB2Gy%2bmJyNgUjy1bgoMrK2b%2btlg9cPWbwYzEylxCbiwSw5D3rgMRVBjY0zZAop1Q2lh3ZDunSnWZAgj7orF2SAGuVxNVHJCo7RcjEqs7I%2bTNXdSxKIObNqmk2mRETpnzDPzSsErDFsthL2uXOgdJJ1rrv/14kK1KPLVpc%2bBoREaBzSBUh9DurhUaDf1chcqBkYVg3UyhZKpoxqcfYh7UEe/UX/WA7JZTQt9S1k3%2b0E5U2ZnJiPrRuEpVGBmZ8EDX34NFtQymLEsqifcTzODGlofNeIvrpuklkS8BgvbvfgpD0E%2bnc9GeKZB8S5Zcd1qmYJBScjUeBluehCdAlinJVCAqP2cYy3EjGPOy%2bxqy3uwcMIaZrzclXMuvep1m1X6LABtONpCRFvO%2bjOqsatHtYjOfpufrVyH2XTHsCqVupIFDZx6w0EnU/HPtTizsr2upqBS1XeYlMR5EZdmzCxYBUmV4mFXqARmzlfjukGKrncUEAPlPunYt6Vf0VjgmF9e4a34JXehIqwo%2bGModJgR4mbEYhFt4br0uMO7XzKwoxQ6cmJpQOXiJG5zoq9NfOSwv5nOTfp9Yme/3Xv/9tlmv5b0uTA0Ql3aepYBJal%2bt8zTjhXBkUTEjFNicEkYvy4%2bZGg1k5lXf6hRACI0yE5KxMnNwN/L0MlMezeIm9IeEDcFCVTcZAkhZCDVcAMSKdUZFlCZLzzDt0VtGqCYZ8U0g2zcio6IdA8FL5JZfG9kNuQ2XGFddM7QDi2hxecTnh0SKZqnDnliyCddoN7R0xWV/OZDZv%2bGqqFXrjx%2bYsZ7RZbp%2bzEirZ9ut%2b6BbHZZkT4bVw1Mnw2gDUfb/41Av68WHCVYZunMStdjpq3dqhedTE%2bI02J3F6R6Fzo0bEjeryV3TrEqUlCA63DFjllYN6eeAJc2TxQvCcwalg06tFGJNlH2AQWvVgs7ZOOSEqjBLUem1ryDbMCiIcIZnDdHG1GHZkBuz6y5e8Ww5sI4kQleWY2wd%2b7eZUPL8SKn7Q42yh4TGcOSKbt3b%2bLOtoRuz7MEJBA/q7NBh1bWQfT7RPTnq9Jfe/qcGNol/Xv%2bJ2oYejquLM0BiG3vJMtR9g7aQy/AOT9zp9SbTsgUzoE2tjrJMNFqmG7ZRA4wiJ21burgphPWTJXEgs5sHMWotfEudB1kA2AF37HI1HzwSAG1lrz%2bqUVjgV/2egE1nSs2ePYjOkbuLtIn4Bjo0q6PWdqpjBD0cxS%2biki97jVFmk27YeIWETKufypBKnjPVsYAvxD9f3iNOzqdSZ8VoI2Itv9XOp6%2bRB%2bjk4pQEDv3zg8LiiXhTzTtxTTruageCxYqFbEYdNlx7Wba0QmcaW%2bwbjYCeZA0rqNjN7bJsbCy7FPmQ2CztkMU29d2PNmjYrxXATWPVhrt1i0nQ8dcEOebRgXxb2LbjD3h%2blSAaZsQEGRRrvOvXUHYvXX5uVM2faU82bci63r1ioG3ng2mMqaO3lCWTNjOVSn6aZopFVUsI736qBqz9LkxtEv6d0iovzIwWIvWuwczeKFb9zyOCUU4YAbSrXTmwquCDRHYP%2brQKIhMMgRRhyZe58jEkm2Bw%2bDDfLDIvGgZgEbxFIPYpiY3Ld8venwKqA44N/IbW9HIEmRAtz/bJjDpjAnK%2btizNWyWLGw3y7bcMbtWebGTUgggBS15J%2bH9yzkJESUPLysgzNK5M8/huiH7o7aGN7gvZRL9m3YKWygvu7jvyaSFjH2Je6XPPgNDaUv4HUr9u5/Lus0qfXaA1nu/KCv/QToefnVgaVGX3hUQN7Bsmy/ZTugnM6HToflddyodmh0ye2rSoYHG%2bOrfhPsiOJb2AOtmsDQ2MEZIcmxPwAx0RLjjEl2tlxCQEl1b3HrI5pgnzUCNMqipYWAAgbp5qCkTlw75%2b7HItPbQYiBJfKCRn7EyVXZlXOoWS/kWLInXY33LL9r1Q9nu3FjTpj1pPJHGOkFfczOKnVB0Cv8TbiCkhVB7ST8zOf1ZpM%2bRodExS6tns3lCXVz%2bFpNyoIXIWUoVRa5gE/N8Q0Z8lzjPG6rLgB0pL4GNhEljiznrJpn4psXEnaAAzFq4z3jLT7bqGxT9pnzXp4WrsgKoGb4yPTHKlqHNEdSwA0NP1nPIOHHNp7BzcMAVhuh80AY4i//gVSE/Tm3XmTC6khg7xnu3FDuCTXL7kx2RMcSlYut242XKujP9rt4YwcrpJu00Tn5rqHU%2b2/S5Alp46Nil2I14BQChUH30mNBJbAK1l45As1KXVYcra%2bSuv83oJj5O3Gwsqxf/0OXtN7JDl7DH1td%2bB3VTM8DIwGxAvaZghmJmoDqo9EfOo2IY3jMgURz7T64eMBwYttnqA9CPqbKe/Q5Mbr1qei4QqonQAXZ/0huW4xbY2uY2kl/uH11loBHB76%2bZPhMlTU2%2bn7R0XtoUDkgfj/07X2rHTSL4LF01MH2WgDaWY8BmpzbTeQMALpHKcueOcVt2OLx%2bZxMHHLg13%2bmDDsbpTVCHprH4vd5uB5GNiFxR%2bqFWNhxLdtKByTIFQJB75AH7fbMMT0mHVoMZ3i7qzfa8u4z6hBZT3fV9XAP6pOZ%2b81XMbbB2UpifMygk4dAca9VfEC2VCChphmLpFno5q%2bYOERjukUIZJ41EpRGriJ3GjcNEgMDO4f5vTFENsqcvgPYJ03XRbIf1lX4BOhoH0oubJrOLbvViOlhh0LdZfUGHJm2Teb/j8OlJqnB8c6U/K5INz9zdVRcETqI6OMA1I1Cspc5s30/T9mhogBZ%2b1VED9tlc2cpopC7XFvuthhDGsd0cSyNheEGNbyuj/FNBJnlZasSHUY5DsILCdeNMsiCjA2SN6mmb9vj%2bxfKn8d30trmlyaE2Wjj1lLox/dXP1VUD02cLaIOlfQ%2bO6F%2b3JyWwLNNPxF2pKRkPdJOMGN6qdNso%2bvOkg29HGcY5ZDyenZkynxhdK2Bf0BBFglR/1uXmjInAPT%2b5ReejHZ7AmM7MMQXIwgBMcD/ozR9BjQOoYTISJ0Ds9wOdP8YiNmwI2piS7MwVmLYPzT12etLntqvy95UCcA1Wizt%2bAZuVR7B10pUD%2b2ZP3hZffZULJay3W8N5kGwFDU73n6cjbUyfM0O7pK/ThKVVYmZ62d0zN9M/235iHVw3cNabw1FxxnlrGgeUuvZt69jNxC6Y30l2tmxSEocNKJDprAwAlc4My1f9mRW%2btx2kNXCrG%2bGzQTQcobtV/ARx84kosSsuWZpX1Bv4gV5NwwIZ6CcQE%2b3rTncgAsZYd%2bue6Vm53z9PxndcZBACp3eNIupsJQA4jhNYXUGUGNfjTE%2b/flmJc7L1rzp91oA2XsKvwxH/F4M94j9OFGK/Ynhdy3%2bRzzfYVDYtfQptmDE556MlIKYdHF%2bHU7Dsv7Z8CtNa3CQf9VXXpIojrJ6R6GRKKS4D3ouZsFO6OAIPnZlTmQHb0WCPuGYzfkpj3eYxlp5Ag46arxvLAAAgAElEQVR%2barKiIIqeHKycoZb6GcJz0K%2bwNtWVj%2bUV5Mw5yTrd2bBmbn3%2bMiFvDwaqrXfohZmdHUzj1aE/vW7E55M%2bd4ZG8jJmLI2CyKmm7A09fiaxp2IC3Y3XM%2bWItXVx4xyux0tZDJbMamjBB4ks4GB011iLm1I8fG9QEweCpnqrhk0aY9uYGkOTkZk9yXpFa6E6FQuoybWJqY0y1G8NUPKJyIOaN4Aaq4Mw2XbPAJQsUTTkQDPXjUxoTfStvJSX3vvkekMnRFepSaJejF2hJBhBKqXb2uUNCdZxG1Qu6OEf0e997q4amD57QBsv47fhiPubuFMydvqtxRDYEigxn35ks%2b41WfIeroPlQIXjK1YQ1zOW%2bWB04soDplaPgwhmKEqChl6ZHrcAZgD8blmWWXlFF4hWPNnBibEhuiTLwArFT3TpEPdaZFEtbuBsleX7rsyPgTnml5GZvHv0jeF5k6oWQIh1vVTANrcikPaqgRvokaNMOm/mv10e/UzTW2BoFPcd6P6LDRw2tQg50PFkXSUBXAwwnCm7c249mpmrZFDbQrvMClj4XTXFizKdETfNyIBi39gHgD1Fc2BGHswYF5p7AqUgZp%2bF7Ci7zwdH38TMxPUlPWbRi/nrtTWqe/PvqLkSwrmGP32F2h2Stz/ebK6lVu33wiBVyKuhBRK7TOGPTUvcO5VohVN5r5UvlH06P%2b/0VgDtz4/daVJ/EwV/Dwp%2bXaMZFK3UAWAabljr%2b92u0zqSU9EM6heRN44DwWfdGwQmfGEc/QbrptQDDTfCBv5wCkz23wrM7BQylj2emnNoZb%2bxiS5el7aw/eYISs7oAPq5ZmXthBnKFCwTXSfLkwsPWlmbvJPjFMVQfHmrPScQSEThaCGDhLMBDWa2vqklXQxHIV%2bXa9epQ792Jv%2b9/L/yuYXYPkpvAtCG/8x/DkfUINDjfGQ5SgqPA7CyQE0m42OyhmWJi9umE63T9W2bzbrbCJimLOjkAIztMhASvRN6qXtwRT%2bvJmJ2w7A5rGLm3q5mwF8tMeKL7qvpGqMWIts%2bASA0DQsk0UF8mxLZc/fkblTh4vDdOAMR6%2bSgxg99LuhqMlgmALy4duBi80ZeZbDvQtbHxirDcr5tttRpbMrjfd06QGOdpBv5ndnncuZIf%2bHgyXx26a0wtEv6BiXjABgCThYS1xT7k%2bOzGiO9ArUciTR0tzqJ1XEEB7z8RgCOeri1uDmcacU9w4VEEqPBQIyG6yoFlHB5EemAN2dbU%2ba762Ap0ZVbPSG5YR8%2bm3kHvHRPTU0faskEvWGDDeqQ%2bam5BMP9i85NF7LLfXl25UkrsDDwWEFxG%2b8hpgiTW4r0GeorgFcXreukF6WMwgF8/OwLyaQT/epbcdXA9GYAbVDnvwFHDMgCAxIfHP%2bCN7iycMTtNkAEMOPsf0QEMLEM6mZMRMSuzEIsFhotrJs2SHFt5kibWc5s8f6uE5I1pgyDrAazfUXAU2jgk2IJOzAT3RwDy0JgbLh13gXzWjPNF0apxVGPi%2bGj1RNgkGRxvkpyi7dzSnPgd3xQ38TNq/axv0nBPPpNVNOhWC%2b3h%2bt9wTvjdFO1%2bt6Pcv/0iaI%2bu/SWGNol/XECluapuu8dyaDlfNamBi%2bXUjTclNfC2thAD5t79Nm1UgIBfMUfnp0tXyYGbtSvoKsCUKIZmAWPg4s49gSD0liajyWm98G2/ydbIcX9spYn%2bjt08/COxuwWsz8Vk0xeD8sArrg4PSagxKCfVc0XuKY02bkJKFxXCIRiCCdKidEXlzjJShb/L3YRZ8oCNySLPjtlZ//gLblqYHpTgDZY2t%2bz3xU7C%2bwLYa/7C6sF7ZLK%2bX5FAo6m1uLahlWyHaOTL06tm8i6hmxjIXP2vE8DvcStI4uZ0UWkZV0bMDPcJADZJRMsKRtHmotnJm02EZIjqBHo08SiCSdFPGWPzbbSodWbE%2bd3kem320/0ROrkwubZXhPR1wywL03BW5AqNhM3Xbfqp5gZSfitt5jeGkOjuNPzef2Z9ChW0SlZr1InPhY5vSBbW/2ra8UtQXRato2ajeSldRPRCnyhWmwzyIGybdtSzBwMaSpmauNFN0a6gYkYEYQFOh%2b04FDXwFgQXToQsIRdykoEZIvC5qYvB2K/ieUR64JHoJOAXlerzaCa7gwGCoJNjAt2xoX9hvj%2bq85bsbUOfaxP/7uC3jfqUj//9OYArff%2bCyNQnaNo0doZO4R0RBQBNjFFDopn6%2bScMf7uxNrHOb0KmdlxdUxkZyhuzghDhcH7ZwiDBL5bDsxciPD97BOM0CRmgkyqv3GzEA2pzbrESXECmRqRUzK5uaWK0CEnileCIPuEy6M2nKdM34WsiZnMUslWjhOm5R518%2bVm7kIjV2RSVUqRNZZ2TckmQSELIKz%2bEf38UZGfc3qLDO2S/qJ9ZWI3C0KHrMS8qKkNaRcdurmggbKtEitN8jI3T3ZDCFoapvwWXpDUeQZGV6GCjJiYb1xDw4KU0EIHCWKqfbdNebVuFl2h13GhMy6PNugWeOMMGjOecD0mOKIlgwG8WbjVlHx0YP8kOfxQ8XskdWB1/oebznmb7iRmLhQiHtJwzbg6Z0uw7eGysfWgQ3NGgOHiocGoelKGePei9ytu0lsFtN77ZdeaH%2b4zdvCwxk4BEWzFf0c7lxEzt1rgWv4QT2OAwaVexl1fd7q9CWNYrsBRB/LauslkqMOg59IQPwHokHU8BR3avhGx3qnTmT0R9qRxHMFM6xltESBVfZ0tamdgipKe3OYnVhl%2bR/qa%2bSremU0suCN8NRRUqS7sLb6IdIF8bGNViTu8TBFMpwmC0XaC6BrBij8xBvzPn/MGKGfSW2Vol/TLKjYuzN5qeVp5/YNh4RpYFKPcHoCYMblqFWeVgO2ItypGwxD9GYJLKmWu3FFmhHozZE4tumUYY7KlWcjMgphZgJm5m4RlXqGpAtQ8rnGGAhSEEciYNOTQcHdToG%2byibAu6q%2bfeHfNCN8CS/Om5pGPDbmaWj9ZXXNghZarQ1Y6sFrMh6J/g7A/wv4AsD70wS5D%2bKsT6c050sb0lgHtJ2lsDK5m8cr/TI6puTuq8Qlgz%2bs1uqNuUfYpdD80dhYf5n6MBCvrFzEMtXCrBo4O516YtZzdIda7wFF8HVCJpdEAM18O%2bt49TcVMMjB7ModesttVZHxSXzIIzw2gBk1x0C2loYOvcq/pQwJgRusv2cRBUC6D/xoDGtvr3ZmrrI2Vd30VIze0SJJzjhX2JqsENAD7MERNdxyDuxARNcgcK2PA//1WXTUwvVlAG8uh/nY6XuQVZ0Y5F%2bNNWWJzg0jTbuyGFlp77/tt%2bCaBlr9wK7kwwO3q5Lo5M70taWkOiPwXGZe4OkBi8wsTg8XoJOCBmxcD28LewbY2cxczW2Z5yswE8QKIDeUdI9FB8jPah0ytNc/MnOMtQflCO1n2RJAdsCRgZHo76jfmVQVhvWmYSmIp2%2banuy0p9ucMiuMDKGognUK7qk9IAG3rqiIpHmdM//H81NtJb5mhXdKPL3UKwNBmAmG0jW7qwJi7aVLqog5lBOEj8SkqAjcIZu1LepgchikKbAY5oE0X/Rk7vZAldsxiTxpOe1zxpKSIQzBIiPxahOmmCTOjAFxPAi%2bg9hK3kScsLjA1bKWLc4ZGArj%2bOclLs9BQZzXHtHlrqbDtSNjhOYR5IjVZ91lQ9m6GrWv4oUJ94aMqR53a1ZH2zbpqYHrTgDYcbX81Ha9%2bd9yUougwqWzrRFELc1dicSp1KOLcBEQTxYBMp14gkzdFjKaKWyaPO9yGGOSMCmHZkDKtQsy0qBfe/YOBETLBQnU2sRq3hSNgant5LejQYHG7A8DNTxTjxTLI9rvaCuO3eborVkooYKdg450ID%2bdhZLkaS5qr7mrQcRugxPcRTMd9WJ5s82t0wTCraae4%2bDwnqSsYnr69vOgNpbfO0Oi6E3ThjxNXDeRlTGBy7z5CaBXPao%2beQGaG6pwE1qZK4qYLzxvbBiLVzN0YXU6KAIOFuPnkAEen%2bV1HJ2xthN2ROGisoX%2bA8Sg72NMTGAi8mLmzLwE7x04awbKgoH%2bLonM1%2bMslSZYT3Tcud/T0JABJIzgmXi260iqumZXLEfmBjTpGBcEsrB9t6l6xqavGRgTsaWf56MIxS946L6IlRuaIK2C8H5pe828sKnlT6c0DWu/9L3Wi3ynVpKgnU035uA7LEERz%2bq%2b4Nw%2bbJZI8GFz/VSY2zVrbKRmzGflRkVB3gAriJmQMIk4lnnlEfIIoGQpmwtJ0fO8ZWZmYri0KYNY0DLhUj3Wzipy2Z6kYCoSloTtHZmke1DLybclhuMmE4iie%2bPyJVTS/i0Z2bwMrFLjwhcH%2bUGPysmiVccJKHtIhuT4IDG6eC9pnZ/7WW4t5tkrvgaFd0n9yxNK6iFwbMLORouYk%2bqXtaS5yVpqXZSqKYrZVPFWVIlBxOgnhr8kr02X5kUm2uIO7gdmT6NQYwAzgUUQ6XLj%2bNNwupHwBIIbIubJ5sGuxMjhrsIJqcPT1wSGBYTZxFjax1YTrnurDPRewdBoAKFvLbQpuA6zVKhnmOi1/4roLxE/cMXD/G/XddZ7UuY0hPgwYsaCDE/1UcXNvNr0LQOu9/8lO9MMlS9NoG3id7ZdIGHhx5NucBbKbJk2VclhY0QH7Lp5sxSJj4YMbhPcR%2bSZa7CSxnINt2gR0XHDGEcnWXKp2vdxTAEjFQlhxEGvE0EByYd67E5mhWUp5tOGJGPRwVh8yNQM175/25MoOD5HUhG1PXfRqkm0L0f1VJbq/ravfIeyi7kujXazcdkHzqn/bNp0QRdS8HhMRczhti0U7zVE9qU%2bdjanjfSzEzaEp%2bc23GPNsld4LQ7ukX16xtDS9htSpQ3jZuNxkH1Hqwzt0aAiRsAZcNEpDpBo7j4chKbYBXaZkwqshoxM3J68SxVon8hmgYF6MJiFMRE8%2bNeKnYQ0NzEzZHIBZg0XkxiEHODSx3sJKBfTzioYJaGMENdXnKWNjuwFhayxRaJvThEV/NGHC7Mqv%2bXcHkVn5IGztF16Bie71K3IJ9wFNkTU2q/%2bgsHfFzug9AVrv/WtGyjNLE6ulsa4NLEoGYoolzKqwV3eGqN1mFM0szdXAA7rm0qtmi5ZHfwnQpWJgYZTWrtixh8XtI7LHDljm4d%2bSmCnPwQpHNxCMY3ZJF2W9uITIBUzeIKIGCmBqDRxvnacIALjqDtXwMX5v8KFKe7zz2j69v3a7d/8QPXXqg0azGgM2KKNKWTvr6pYcG8T16/K8TF/XYdUGuniQLd97szHPVuk9MbRL%2bt6MpVkH946RalkC/Yn0nMoj7QiLjs6nHDbax2oCrnJlcZMZDAjNGAhYKdHlQcJwq54toTP8GsDEFTMj8w%2bz5VSSn6/AJuE6TARmt5LARbQA6TWCWojN4ZajyaoLdfhodn97FU2NGvoAFKTFeZqEVmEtg437iCs6SfFyxtLnRgyTq1gsh1VUHWij1mKy0sWJmmaBf9OL0GfpvQHav1QfFpUxg2Wy1sqM%2bReigvolLqCYukqoMMbctzgz6%2bBnG2zo1%2blf1Aln2grxJCX/EPPOj%2bo5UeybmNmWYCbe/AhmFv9rv8AceEEQbSDyIrjqvTremW5JxdiRvxd4rEucoGzV64mPGgGoD9ChsBeALHnbcLNf0IsN7Zu6aGwAPlu3zVGkPPgA5j2mS3CYpaLf2NUp6u27Y2f03gCt9/53rorS0vLIbs3nhh0JN06RGPJFz7oOAKeEHkDJst5PdgqCOGJRdACWeNm6TLgV/ote6DHqh34ybJY2dEzK1dAtghQHNBijDO6L3kyCRaKYuWRm4zcuVXpqEgrI6sdIIAQ6LD0mTA3EKWzfBRltc2F4BldLCo8JaDMrJFCnbagPtvHmafimiVpi2/zThIft788elpJp5cBs7DNOk7qVHeSRFytdSI0UIVVi6uZZ28%2b/J1cNTO%2bNoV3Sn45mbhE5Z3oPFQ1AFLAzPjmu1MysL8zOo6O1BBcvX%2bnFZoCKs3zVSJa4YWjdhFGncb1ASY56F/Q9Izus7hlYk56TKLpyBhePswczB8BswPbExqowHtsTsigNOQSudQ1XEeSncb1/tUziHqOgEwyrGbwlQCJg2NNQO/bwP5NJTecv0Nf10DOQpfexn6ZsWm3xqTazmG%2bVxV2WznlRswNjhCt%2bNnWSd5LeHaD13n%2b2d/q9uEpA9Wjdq0CSgh7X85U0Db67IB0dcbBMtuyJdDG5TPtxfZ/ohZx1Exuu%2buONAgZfw92gYXdvcxfFzr5aFKybVwCRfQAUBDMTU7EVwQz3KXDsEtiX1WSOsMCG0PqJQK1%2bbs0suAwLxi8yP3O8z%2bodoEIARM6ooxv%2baLhMidBlY/zGVSa6WgDEzWghR4vmVujIcLmTV8%2bJ9dPl/1vvzVUD03tkaJf0HyBDQ1DTzvHBd0gicMAVc7qj%2bpvOmpJMW7YpZlxn6O7H1jSx9zD3kSG8MLofAnGz%2bXwNxDlCVwstG9w12PRmT4WYGZkZzZiZui80dRMRzvfUrC1P6kVroKbiMbBGuXlkVRgIU1xJzNJpk4JskCfGD0Njv1lwtCDjvasYLpsl6/sxlw0KLhtOpC/M12Jl7u4deNur9q24WAUMAvAY/mKq5B2ldwlol4i2GvvRrXrCKKPh%2b2ZOHuLBvWHAf%2bcCAJZR0J3ZJr8%2begIXL0KOmZB0WcTsAU7zgVOqeb2DM20zkHhqNnIZmBWBVZTBIZedmNncTuIunM/THMyU8WjdA9TgLtQSCkOZKyMBs4ItETl5NrKXiglHlszuDcrb6ypmxmvVo193WCJbv7kK4jn6l05KbbheCEZt5jIk37cPkc3ZJLxtmcn13n/zPbpqYHqvDO2S/nv95ixIlTwIj2l0zGnXhQF7joZZRgsf5NslbWoyeYt1kwE%2bMfZ%2b%2bOYkre4b5b0zLnDUtTzz7zLSp2ADzIz1HIDZqN/Et/GvwYL5ZnsGqEvHgFDn6qEBFG1CwPtUNxVkqJdrn%2bT8PIZc39D5ol8XCPBwipa8u//hyCUuFqCH5fDa67dL/j0D29rEAgHxzuS5IgBvUIa5lLiqfqZuwftJ7xnQ/hXRqor%2bAl0xvKn9g3VCMragvWnoVq4qlIK1xTRRoUGJAK0iOSFlmwLluI7hZ6E3Ul1UHyzEKZrAedZu14MCAzOTkEcRzNiDmUTdtTJhmIMZkxEZIvrUD2vcW2Qy5aPJv93Gx0QdfrDulA881cv916T7u27iyjEYPBh7dn0%2bhG4fDfgAETSOkgPYoGMbjrTfPCzkjad3C2gXs3Yn%2bt5OuFBJbqIKKs61u7mxX1gcOVwIHZuU2%2bE%2bPn34LNnZDQcJDIZt10rvn1SNc/aHOTQRxuIVd4fS/Lp%2bEEbxbGiVsFKR0SOCqiq3mAOj5IZNZzjeG%2biY5Pk679a0xVOoKujjwi9haeOHjxpb7T/h9KL5zjnc76Zio22oImLkB3WyzdXout8c8uq/yLnfX3rPDO2S/k0DM2NFlZ6FHDYcWSxl8LEuala9k9Odtfmgx9RtwGxTuAn5Zz%2b986XeTTzG8ebz7Y37uS9hsfVaewar53DsZVmzaUYC1UGip78IvBIIEiXRwTRN38jaCBONeZ9URryyvpmIuAreE3l5Em%2b7f9aiE6TITMNDlj6pG/6EiXekdxGR9ii9a0Drvf9SJ/p/O4idcWnJh24zqYY2JjMM9EAExMS%2bw1hP6OI9Ocw7zTfM51dR8gSWHd5zcaDDFyUfbuRCNwFxszyPvxmvobPwPS73oJDazZD1KFVMR51rx8mtm04fAgLI3gS4akOSEnHEGeHd4Lqh/os8tj7sBo5oQY9wuaFrCLh/FJ//3Xt1pI3pvTO0S/qz17%2b9J/jpACQKerLFGEQkFcenTSNmdVD0RobkvwbpNJgmOkmpsGm7oShcx91a3BkCg7CxjpEz6dAYQgnpJjANmcO5tFTvWUv3j2jxBDrjTRm2YD1q3tNyMDwbRVfH0sCQgM9lXLNBGOxtgz1aAXIslJQkeCGKS/gu7diHi052g/LVT63X8ficSoQqdvZv5ef8PtO7B7Te%2b58jot9TXVrPBgIzHFhcqw0Y3PXf9uFqZt8%2bfKAPuhu2AJHfIXsbsy6FWFbXcrVsL%2bqgLq8PR4E9nUScwFKi6GTMbEvn1GUs1rYgak6kpDY5hzol%2b%2b1BVOQ8geQo2Pmkun5fgtVnEdI93ARSaV/A33D83nDxpupBq%2bcQQnaLEUBdhYB/l%2bzb97XJ5//xnh1pY3r3gDbSX7avWSvi/oL%2bIure9K%2bsh%2bEuihJnrbw6UsKqAJJwMC34q8FqAVksbWsymzKwazrAtQhTbjD3eDyXWRkcnyqQw2MMYmbRPhzs0dFXcqAeTa%2bKi/EbQmRLkX2do6s8zxDtw9gll9d5%2b4S9uMiy0Rqua3lHhg8fxioDZF16bRY3tw%2bbAin6RAaC9mfTY3vH6Qug7enr06Av3fe3rofNDNmtt6lORpgZFFN%2bx6NRNIFe7LzEo5J/IwkbM9YgjrhmV6eqkT9GcRBndJYjgDseWJ6pP4PEba1Hc/dV6NGwNjkmeqhN1zuNNZHiQoFRaEeY9d494yJhxuMBb7hkCZcVOXGw%2b7JlV31sl2gHurjziHuPvWurg0zkhICOhfMs/vt/3rsjbUxfAG3vND/ovf9N9dTuU09sWCRM2tlpWMQ2XTdp%2bhQTFQyjrmuSYa3fJrIpduYhlaK4KdvMnfFZ2is//v0B82we1Zm9uLlK5/RnUDZWkr86fVlPV43j3YDYXOG8CZYj8zOjpmNksgvWtvWoqqvFbWxiYaCIpBJ/yF0JyBECb7jMW0FT%2bgvl0XecvgCapT8u30KIx/w9%2bABprCo4bmICUKo%2bK9mnDpdsygXIKZ432d0W68OQk0GMRGfP/UAgpCg3bfViUzz0dFJ/JrutlyVFNws9x7AsStZP2qUNWWincK%2bB56aHvOktxj0ut60m6YVkbu8X3Dk0Vp4si9MIKaZHdU6xKnpu%2bvw1ZppjZ0VfIvo9Inr3jrQxfQG0ka6Otr3/WuGBDe4bIiJsKlK6uGmEERnMUbKobXoki50q3OhRDpffxo6c9sylIljHXp/%2biah1XtyU40lPhT%2bjE36gSs6RNNGoaZVBRDfYxN2eDFJFqbnXx90eeGwaRj/BkvZHw7og/8MBUEY1wq7ikCAIcPdiXd/73H91kSwOH8A7S18Azad9U4mILsCwKMyWaBjYRDcyFTttxr2C44azfNcdhDA0jda5dXUVEJYlQQptdO3Jvo5orzBaLOrGWKokJj%2byDUP6Zeu2QlzFFaybd82Xo/55VakVnQ4ZVhrZWeCMte7LwtDZg60eRuda1kjbuM8o6f2OvSTENWfbRfJNtrEb7hxXNQH4JmIIH%2bfKA7qzeMMuYC3nrjbLDxnezebBt6QvgAap9/4LvfffwdhVWy/XzWX3jk02x9gKsZMc%2bMUxuxX%2b/92JMamlzlCxwVTuQhj1sdcoiscajdWMFyio9cIw4EiRpIqMzSyck452pEdj25zTMbtoGKAesbSbPjAsa5NtAdXrfjwEUcjHhFFHaOx0bzGCJGD3WKfK%2b/4NGhROX8NGHz5suqQJQ07hJLZH19iKCRD6Hn1xpF2lL4CW0797PeL0ZKbzMMOBdFB0ihwd90O/ihm//8MfWmTSacoiYBQ7bWNjMEoUMOO%2bodUyKqV5D/Losl/%2bpQGdo3X4M%2bdTto4e69GS42yhdVc7gCtHYqL5OG/KWMF94%2bimTC%2b2Uzb0Qdtwp6ewFyeNncOiuKnMDGYQDRopUwu4dqCoCZPVF0faSfoCaCH13v8MEf0Qj/b0pTYQmIP4vrCYMWZWOeNu5o6hm2zIRrRD5lGx04ANxbI2LH1ONw7OmzG/DpBCpPwQoDRZ6pJ23yJsyG9UbeHmJ1hO1KPhz00BeOitHA1L2adqtG0Li%2byHLoxh8X8pDrLpKDvFSYKdD1rDvdmNtFmVwWAhz6bjfQmTLRbsW8AAgv0W6Fe/ONLO0xdAK1Lv/ZdxV/S%2bRXFTQEF0J6R6kw6iJfoigUEyiEGSwELpxEGfEhCVvgTnkuxOFC2Fs6RFF71mYQfIKejRME9TLX6%2bsVtutbXuz7NXvjcJ3a1PHMXyInVzq5ErlKFtsBRK1AAwkX1Q3ZvpSTdYn/kBWH9UcfTU5/pPL2773acvgFanr9vRLAzu%2bnAAHbcOdMRFI1Kz/cXjeyV2gvmgPCeOlyVVDOkGPHNAFpYfWpr4YN2TslOtWARDDQ7h8JBF27ic6DBpsBPtemZoIH6KsYAGkOn6zGEQuGo10YlWwCQ8OmxjHEgfruy7js2h/UQnKFAruJUEoKvd3Uq%2bONIepC%2bAVqThwvG90tE2sbXBylSxTKpv%2bf/b%2b/ZfWbKrvLWrql/nnHvnzh2P7RkjgTwTAZElY0dIjhw0UfIHJPyUXyJBQpREESFRQiABggwhgRAjRooUWcRRjBBESRSwFYgiRRA5tmWMI8wQsA14zNhmHja%2bM/d1Ht1de69o773W2mvvqu5z7sx9nD53r6u%2b3V1dVV1dp/rr9fjWt7CsDG4IO9NgDQ47x2RqmC4Sj8VaRzmaMn7cDD26OJDvGzL3RaeXxigbkSN2hktnEGpuPjad%2bm/0UJWNH6ZoFYKha4VabkkDg%2baJMaHZKY8Oh/vJnqPsfPD38outtaOsEqRWKUOPZRVUQD0y7Uqdtw9uPIHVglVA22x/n1/Z9Muc8rq6cpmHnQPRwS3qG1nY6VIYK6FOERpi%2bZvPqqgUEJU5nFJ%2bW2twMSO9MRtgpyRh5bl4ya8ldW1d4WxGwA2030VRZjpH4wdRhJHKe2sgv5qNLFd5KJPWbZoxbDe57HXJzRO5bJR/hJSJauPvTaSB%2bOKQVzsOogUBNO3mNIZzWYGprKo755ZVYvt0q4C2wRDxY37ohChfyMWVRpFlnDGV5wBWIyWvzHtRvSdyY0kAACAASURBVB1XIN1yBOH/krrBEJCTa3XyOA/PsrVM3gHAICLemDG5k6MrpbxspC5g8tX5CCWUHIkgszAt4ZdyETfk0caQbuy0IiiSMy2Is4Sd8PjGSM%2bhxqKLEiqdYKgwwpLcMr3TJLnunirdY1p3OmPA3QEZKbvsLEDWqAuPf7USaU%2b3Cmjb7UfDq4OWptRMzL%2bqIbFrYwI4/jJjCD1sb7M3KOWE9K%2b9y375oxnlzaDk21g7g9cbrRuOW/kN49yeFnrM9prbHV8wg52clkfLPSrIxtyNJ/ga9b9%2bpWyGH5u1yeYcisw5i3o6/cPFfy%2bRkHIpxeCSBJShv5m1wxQFSKcJV8XzzyPP6HMnPYHwyvefcqYfehteBdXyCywMJcaTO654Ck8pApAHNsc8DvVFlKsYcby1MjEwIKuZnlbp3GDDyqo6BChezNyuplh8tpanwWE1JRVBrcVjEsq%2brgxgdeGgDFeLE2gkcgfHSrEZoRhF11/3cGbhqy6IlDULxZ%2bVOQ3WURdB%2brlJiX8FYJJnBbleRIGjuK6Czh7ic5VIezargHa6/VJaYxhAcGVK7jhMgHQlx4vTQt8PxQAH%2bTRWR%2bXuGZHnoC8CD9QA9g6iqOSwhjqGcpg/yj5O/tooV63Y7VkunrPKbhsdi45A6OBNB0XR4miQc3meq2fijw15gUze3XpsSoBWnysBKMdcNuAKpDoak3Yiv0zcSQLyo8Revg4xOQIAoX6Efamqe7VtVgHtdPvHZf0sz4Xww3TFZ8xvJxMdxVzW6cnaXJgqmZzwUXk0XV9w%2bX/pfRXbHF2SMhJlCeZI0eAPrsC69CHS/iHPj/HzDOS2KdRquQxTvp4ebM2jjVjWpIXaQ9PrqiHL/H%2bTJB2RQu0IQlw6GAHOEQ9NHtOxy/Gr%2bQTSNschJtNLVIoh9%2bGKXCY9Im/vWiXSnt0qoJ1ipJX2cR1uZsMvskSu7uMsXJyk25PFk9ov2lRNzSqVkHtT/Nowg3TnxrMF2uHoSXkPY0beofiyn/buY6%2brTBeonHx2EvDMF6wvxLBTS9Dh0gQY5ERX1tCeOihQYtW4NxWpJl07xz8%2brIUXl1n5IUlhpbx/ti/VoC75usQ/82mKmju7c6uAdjZTFI4hBKF%2bXLRCZYUDuuDPKtA4aE4XeY4RK4AkAU9DvYtphdCyE3I/SnFjIxBtaHcqX9/A9WCQyyPKtM1ouDgKqLyA1iVkEK/VuQwEjXxWqQunTR03oscwVM%2bAiBE%2beUjcpgTqLdUn4%2bDVOTfe1jGWpHBOhlKD6hEGVKp3STdtWYm0d2YV0M5giPi7iPiVTVppiRSLMseRW2KAvnZyYavWGK3c4VBVy5xmbGIWtoAA6EjnwZYRTUWL9GiBgENh4epybHtHDt%2bGOPQMfqNpcoAbuzjLHKRRD1B5iZy/Cp6TUYGqKgC4klCr3iXiDZ9/VhV2khZg%2bMmGDhtIg4MzL94p0NL5OF2KSUfhErhVAcc7tApoZ7cfCGsW%2bSaJKjB5aJL0ZZIt6hXTdkZtpxNzOACgtILj0JYEJAPvydEADhz7co7ZoKa5xZrCQ9H/A5iE2tlawFveYfTLgdkwL3a2UDYBRkoAGtQDUUY2LHOF7HsF3ocJnizLBvGAGt5j7yxN/nJE1VBnV7fJ8g%2bSSkdID3CSBQocNpVaq0TaO7QKaGe0TCvNOen7c5RctjKlJwIMl/D9BbrubeCoBdZ4eN1mYWd65ErMk3ssFxSmGwmkHYse6%2borQPIGBZw2hEul6ZanTQobPLJuLGLUF1ubNh9pVM/YY%2bMHY0zmkDKNLR5LI4%2bb9ECc3mybDSaFGeGnUUYOk4fmnIVmqC8ezKk/lnhxPIeCZrhiCWrK%2b3eI/70Sae/cKqDdmf3HjWtjitD4cpbQECF5UopzNuzrhExOCCQUTXk49ug4NAxmzv6XHNeYHe/xlH2PPd5mo56VOsAteTTBB/autnhpeeVYLUNm4YNMzUQlgpl9fla4UMGk5ONGTouamEeTpZygpKMfKiTVFT1EJ97ps68KEtwoL6FmWPn7znCmq5V/n3pCzm6I%2bH0DrbQiH5KWpYnbOXFDZUw29HWi7BGhZNxuU%2bY4iw1yb0JoBWkIF9MR46bU2BkqnLypU59b5oS6IojNkInvDanX5u%2budWybDCDSqol9kaSzmfxqnXJrGfRyJkzuMSsPj9ubWP7HWVXF5K11ZTTToUuiBpxH7XlAdTzG36pE2tdnFdDu0BDx11Pl0g28LP6VTdLWamCKo/Yo50LuxQ3yZ%2bnpUJQ7vSp0ANVbOlbiM%2bUXvAABvRJTIvhWAtPYhbLNYeOGdMlFFUA6xkXLdlrwQ7ZdqAIlSWBYXkh5K26F2mylQKPJ30AGPQP3YI6VZvi9qRuAq6ky99OhtL%2bJ7BQRaNUPyg9uOcxqW6wC2p3b39m4RRl2Zm1LlM8qN8FURdNyQuycITLNgGJMp1nqirtkIy0kVu14ojcGzlXDGXaTKKTCmg/fn3HFxmG0eSeUjXJ3jYRrnOfSoGoGIegYoSPtYDjVPOXNtIfWZpQUjWhDVREt0AhlSKv6NX1/rsPMXRY6Dvd8JiLtuC%2btjz95jOH%2bpUqkff1WAe0OzY%2b6Q8TnTx9KDMJtgiyyKbyykbBz3DfTzeswEpuRBekaSdIlsUnasWXfT7NFaQ07tj/Zr3q8rUNgQxUx26AEo7IwoHDSDd6leE%2bTtklg1sh0J3Y/uXsiFQV0UUb30jJ1xYkXLnMEAmHXCliFcNM/L4oqWdUbKAfKnjqHmw5EwKDInf3LkTNY7YxWAe312XfzVmNVSRh8XVQBwMXqmCvDzsKyPFq2t5E3c%2bUCsjHPqVjN8jIJkSWaTRW4N3SVbOzKHLiA/FSnz5qRz5CaLpLSq3Va/43bvVJoyE6q3p%2bVcXQozWiS7xyftazmsQ697YSJ6q8mKQilQAtqGY8jjGTf24j47850WquNWgW012G%2bFcqX1Af6aKrszoRMdMkDEAJtBiomC1W4GR1d%2biIOk9MjpFp2fjaFfwO0VRwOtXwMXpvwnmdT2AhhHozopI1caY1eiGklvZ3D8jNh3lROD1uW2ylAUjxoCtN7pdtfHnrZnTYALOfiOcYk5x3C9zLclKJQ8sbzw1JVTcxO%2bn8YnqVqd2IV0F6//ULYkn9xlWKC6KNxSOK5aLYfb%2b0kK6tpvG9QuRunhnE4YfZj8LLO2k6l31G%2bsCZHwxwXaNlYcn5jhVPl2gpUE1bGCBAOLsYBOGu9/RyXLTCthddN7d8mO7KcF6LfUx/vGBMmtq5Z4RwGvTuXAEy7z6KYwT9M0h0Vf6yi4GemfOur5%2b8rP3G1O7MKaK/TPIUDEftMKy3TR0PRuOJSfWCV930MdXpL1c5%2b0AY4kpFJXdEbaBeSUdtCKQvrqEx8xLDtGf2muEKGyXhab1P%2brLCy6qqB0A2y9OwdDj9R6YzFAoeeR8qE3wEZJaug6rOpi8VyphVncPiph5Ya3BWvTH70SONME2llAlRQSK5E2jdoFdDemP1a2rqI6cZaokRSCEc9NJVGTiTPERXbYC5NReeQx1JnwlbjSFPen9LuYeq3mvw95qK8Hjsbzqn1kpeII2XL/GkaLtJCQZoTlFQ5tOwvhDJxXnu%2bgxXp4HtHHRcu/2uIPLtj2Sf6KzrUDlv0FA2/pqanp7/837wLZ/uhtwpob8z%2bQbn1GNE2k9rONNSGseY4HOXlf4f5l0WscB5Sqm24V5ECQmKeZcXX/FttdHsPhY4DT%2bssRh0CeZhX5tGMPBwOoivfNP1wWNADaVIPrYyMKUi1WHi2sh0LnDOFhooH8WVMLW42L%2bjw31Ka2iF1J%2biURN9bXQTg22cqkfbuWAW0N2BE4fhcppU2HG4R3iDpznOxwEm1s/xygHaeUN0PCgpDoDIbn5Q4pUQmUb3fls03XyypQMDy/5yhylJoxQ6N%2bgzl6xwuprux6eJGFrdFEi6Edk4NAS4P2fAu88BZZIG8x0pA7rsAuEiTzp5RHl3ukaP8iLlEooXUTTBiP7rx1Fa7I6uA9sbtx3kPo1ppCGoCUCEXNIgilc68CBTqsFPJ1rA7oFJs2/JnpaX3djlyFvMudY4tS7dtKwiYPMEOI1S0lNhS4WEhdFsiYNqH8nHpNNiMSwZRBcSMh7xG7Ua3Ksn5FRYtDR7e4IkiCxGUKsWF18zToRylBQoi7df9RKfxd6h2p1YB7Q2aV%2bEAxFeHWmmKe6bBSlXACjYC3WfBavZyUkstdLg2wJhW4BjN17k0R9OQ55OGmJgRLn2yAc92a0/R9pf0pnbzqmpXYx5aoadmmtglAEOgVHWRjCVn2ENTk0/CgJsQYsb8pOWey4w6o9qudBVWOGsUajpF8Ul/hX99ykeudgdWAe0uGAL8%2b7CXTOtKgRvJCvmL%2bswu1AYRRq3a4EBNa/dhLI/RIw5cU3x5s4dF%2bxAqX43lhpjDBRml4Q7yZ2coCJR1W4GqUpyjfE%2bimbT8RDNmKf9lXfpQGigtE2NZRlsUYnk0XeRY9OE8Fh6qMQmK1GfgRyLXxGPvXOw6YMAriLRHiPj%2b009ktbNaBbS7Yz%2bFiHacwsEVzfiF8dQND2x93wedtPA4eAF2GIOy6TyatiLpXwSLkuBHCa04RFPaaGf8%2bK58dGZghpwwS6xbzQbThYHR8DDDKlUhdpGDx%2bPo0sfKP58DpkdEkDEFIpkGMlKu4d0z0EHqzUw5UdbDU/M2OY2QJQ4h98zyvMB/vZOzWO10q4B2F4z4Q79R7kkqnqjL/AA64NCKNdL/SRQB3V3gVJ4r61Pn%2bZ8sAX7WPBqmENZXOtMscGLQq9ans5J2M4WNkZanzXk0MjfA6PiQqp/ohgRcDkF5LkI8X9TGxHpAmkIxdioUZYPXk8omVUxTRdJJuI8CmloqCMk7i2mBQKh2iWit/vqujqe7%2b1YB7e7Z3873NOSNcRUsvXw6%2bmgahYCf7tEZMUOcJ16DJW845xQkqRUBlb24bf5aI4eRtzwJoVZRxoaFgg2fq/wIYyHqKaEtnx8%2bJU6OUSnajino6rdoaBKUyv%2bL%2bgn9Whgp8%2bR7YgFP9uiAQY07F%2bSzphCebp%2bsRNq7bxXQ7pJ5HpGncWwKO9NFzQNSYshiibbhW2GCNPdADjvRGkIPYQAj/mqZrFSX82HH/rTKk9jyWm4qDtOVzdEK54bNzXCl0kNrsp0OBW4H4/OM3pxhmfZD3qVBtQbtD1X459RAE%2bDJ9%2bDb1IhO40DCTeb%2bIUSZpqRvlgArnVcipLiySJSdgr%2b37bRVe31WAe3u2g%2bXeyvDzrzvc%2bS9DeRAqJvawwpO9utkdgD/%2bjuSpKG5jvmRZHfAOCNI6VuPRtqE6KC28tvGbOBtbcijSXFCc9bKfiu9CyOfA5uYJ2wgIV4AKcOdE8kjigNM0hnME/mJhKylgBA0%2bKHkwvS5FNFG5qJRx8A6VDVtqIwqigbff9FPEjvDWax2h1YB7S4aIv4i0CAVXZ4XD81xUlhLq6JwzgC2R6EscsNVTfXCRkueQZrz5r/wacPTywJ38yIZ5r84v6/HiuQqaDl%2bJlfN0Ai60APq8p5PzPZvMkmfvAMhV%2bmIw23Sj0n6m0Xcj8DInp0CvFCg0KPtRhUy2QY/fNXujlVAu8uGLAEjFI64/9JDYwmb8Ase2mli2NnzRKiB%2b4ZDtNMFhlK%2baCTnznvZnH7bkJPTJFjQO9XVyU0FgSYLGUf3H0LFoYeWOGXx8zXlMTayBuWwiBc8Uog1ur1TLWfV3%2bBoWSfVTC6yWO6RDZO9onwQog6BDSB7tpxLs9QFYhWR1op3diNwF6vdE6uAdvftfZI3cYrvRPkyu7bCMcv9ifwbmHIvLMutYyVdAhw7fpN2Z7Q3mH/JN3fiKGtyVBzI7Wy4gkbxa2Tk22BJk3tuACPYTi9yvpFHyzVN/haDPgOTAFCWNsmT6rX6BYkDbLIkdUahKFDnwNpKRVN3fij7wMadVnvDVgHtLhtVrv43ZIXMVOb3%2bNML%2b9ymwoCwx2EUDhJHNPVgZk3qpxiOgCaQZxS8I0NKG0ptg%2bbsnm4jFU75GEY/iRZSaKwCOWJjn6noCqXjS/tEOo9pMvrw3DiWJM9uxM1z0QM0jVETsHLj2aos%2b2ML%2bfXUj1sUHlC8sx4R/%2bldv%2biqiVVAuzf24%2bV8AeEgaSFI7cFRa03fO%2bhtn08M0Ak2YE9NJaaVlHQoCKCVUAldqgSWIaH3TjaUDlT9kI0uFR11bqpwbprkBOnwt1mj9qP3wblDR9ywRIUp94/UUO4ylY0YKyYum959H7TpYjdH%2bDvw38PG5%2bFchtCXATUp3hpjUh6NB944lTtNx/drUO2eWgW0e2B%2bao8x5rW0Z03EpN7OLPel9VXVVjyiLlMNLI9XDzUeNwk29QxMwzQQkrnOcm5mM1iJ3dmlowuUo4CVfaJoZqzuYWK%2bLp8gxZLYKneXd7nnOyKiMoeUHrCYTMx7NTByUunvx5y3%2bBvFPyTcq%2bmydAFgynKOyU1Vu7tWAe0eGSL%2bCGwIO%2bX6zjyvzeEjqv3wvhxLcqtcjhQ%2bmRJScseSSzH%2bJgMbZKFGbVNBgKkZebCYzw04S8hcFgsTYdYkFj%2bKklmsGo90uYeEvnho6eRYpnjIjwtrnPBBphwoyz8JlxBp6HBalag2AyLt5z1P8Qwft9obsApo985%2bCRGXun8vhZ2aZ8a/8C5WxVjVgWc/CmETU18i5MWBbaAw6tiNZNnLWkOycWbaqQobG/hspdslXDS1gaTGRvaPWTEjZdz1JmXtwUCqWAqnjM6K9FnSuk4VBsL8AG4yl/2a2Auqp1QRwFlNpB2e5qKTpNq9sApo98ioOCA6VwMPjZa6U3JKeSV0hLoxXDGzZrCOFp/Md5luqdE7RbwIeFqsSGYGD/Rryo8z2SFt3qvJH7IskIATpiHLlvstfSJeV4kZ7JRnHFj/qLwu0UHTYKQLDyB5UEcSTuu1FVqGo4E4jqTQFZH2FT8pbOtJq3ZXrALavbWfAMjboACSxr1MC%2bJm50z9Xo1J0xVKGbHmVDM70QzoS%2blIJtrLFlmFoEPgTH7fRqUPOZpNVIwtFU7txlBIinonmK/mRsi0Yzy69NlpHXnjVJtEyhHq9KNjEi4DYqhwmixxzyCuFTkCWNKUJsuijxDPbeyZjS39xiTKbhHVV82z%2b2QV0O6hIeLvIMJzAMnLcWGEmaVQ08m95FosVduIaCvhi9O5NJdhkISLXHRgPX2FUYJXGrfCePEmVDsFClyamyecLMwZWRqEBvmzZiyXprZFhVLFKhtbpVSFld9T7waI6JoHn37FHKSNWoRUDPDUmQD81B4VvCq00KOVdid9CCzPDaTIYZV3Zq1qcUqPV4j47L27yqppq4B27%2b3ZvEk9ugu95TF2LggJaupFKqPRsWWVtrKYUK4wbobdEF8NbOKEp1TlTFXNcU8sZ2WdJX/Gq3DVNIWhZtgJIE9yasjY/vz/zL5Al6qIyFJB%2bly4nHqCaVH0YD0IGmL6Fx/cEGhmVBmSJPJ/Ix9q8vSmjEg7zJ39wulnqtrdsgpo99gQ8UPGwDGMVDx1tVNaosZG1snqTkKnbK2z6JVJWMbqEsNVNtVZzTCEOtvbsWUcCxXy8csj24%2bl64KzZFzKvTVGSYU3OW0DkkdXamOyp5wG23D%2bjE6lE3IGgZUjlVuWV0vFGCQ9J96XcxmR1r/6/Xd25qq9EauAdh8MEX6O30VATc8cUKGnLQi2ccK2mi2gw0wdId7pxxjHzFFrsuTYGW1sdR4cvG0Pm5JnoFSIkKeYJ6Z%2bSsAznYVkuPlkM8clJPL7sH6vibOkUMKT0Tn8bCjHFjXl4pFbyk1iJg80SqT9dNU8u79WAe3%2bmISdimiZJaK3VTtRte3IEkmoDcSxt1RBt6HYgNwRjUOxM14pYzhWzgQwqJ6yt6XrBy4VCFDcICf1E0fzErKP0ajHGBn93E0A6txEJdoU7Erw25QhJ9VrVHXaP171fQQuqyS4VZagOIWVqnGfrQLafTAv/miM%2bRQUHprTHPKs2glb/RgnI%2b5YjjvRFXryVHxSm3N0TPwsM24J4zYTR4b95EphI/SAUuQHcbRSIxuZwttSU8%2b14CNz0VQPPTbpeSoiNLIzpDaHRvW/6mJDwiWa4KS2Fq6YYz4aSTGNFHpL7xmJAMfVac7dsZQQV5kp3PxK1Ty7/1YB7T4ZIn4gC0uYYMtflmzqkKUKGtIQFd10zdo4gmq5bW2UTKiRIG7Ew1NWXiDcWH5aAKqzWQaKHUneUI7qTJYkgHgWZqrOFrqLYoFmQcvW1iUeGQGTEJtp6HMKPak9TAGpNKO7pKih/6YFIP7AGT9WtbtoFdDuk/niAAAcAg1BCSPtIH0LUttSujfFV51H1kFoLG%2bh5WplmPJNvDVSi2gkVa7COrKwvGmo2tmQ4oaBltU2miiz0bzBqyMCWQF9kpDaQFnb0C0gyX3kpvC4gRNeGFeQnVQigTTUGg4ZMTWqp%2bR9mq08KIo4Gj6MAKt1H4FOiQn0RKS1Q0Xao6p59mCsAtr9tfczuDAPqhfOko3egbOZCkcGRUytCAROd4bGp2icHjJMEmtOTc2nN9z4bMtWIytK76SgGElwt%2bV6Y%2b%2bTLtMAKDYm%2bZPXmobHlGGjk15NaXmX/w2fipHWhkjHIMqfE8mSmNeTEFoHt5n929POUbV7YxXQ7q99yBiTiKtjNzU/0lo1x9PFHA5qwMhixC0AZdRXT2KtPOBEfVMhYVaNPQXSthYEaI3klTk1wSqZy9ZOB51SfUmkLX1iymdxYUB1CDCR1oNgTz8YQV6JqqTB65JKpxPVDFDn2SoJIp6kzl5ZPyTS%2bo1/auuJqnbPrALafTRfHHAOP1IWw5IWfmqJiqqpI8x%2bXt8BqaWCAKDWWOvD5G8Ha8rD2ZBzK/R4tuTbCkbXyOt32CEQduOyvFki6Ka4ssm2b%2bSeZZZ4iR%2bQ0pC7i8W7tiaF2RymMg4a0whBTcBVpsVES96eC8NOGPhE1UMVC2CYO/v1StV4cFYB7f7bs%2bylyQQooWZAonSQjTIwcHvuH0vE5OVmuBhVDmmzNSIFJCHilh7ORi3Mws9G5fVGG502L4giio7kyFkxNgGkw9wzA1UB1WKPSES1CE4J8LIBKzwt3Wm/NZGfy0lQikgLlarxYK0C2n02L/6IiF%2bRcK6sdrok78zhDYc6tu9jdY2%2bZKgpFy5V74QGAukecVsOLH2Zx1uf8mVnyaUNKpuQc8JK/iwONk6FAfGIJP%2bI9HkMqV7wyYw6ZlbakJRENo8DZO4Yk3Jtmoge8peYAmsJJakxnf82DlNnQHHwf%2bC98DOcnmr3yCqgPRj7UcPjzPk7ofoAeYAtsH%2bg5GyyXFgBWzFEdTk64PBhVvFkXtgpNYKzXih5QaCAPtOoxQWTVrZwsshpSolTU5UApJqZIC7x2NgLDOvy3AZMg0%2bcbKFamDA98Ljb97FLg%2bkZNgs3cz6hstrm9ICtAtoDME/hQMTbyUOj75LTxIHhLDb%2b0iENtuVBw86NUA6g2E7tjFNGxM6InpCq4pUeWNn5dNb82eDiYs9L0KBYM%2bDqMIdmFGo0XFpoghC3lBlM4RWGENSXKZt4oMZwh4LJ3jrQQHj/DVDjeR8KCKHSLFPUuRiQVDUKqsZtRPxVqPZArQLag7Ofkd5NFyttkcLRB7Xa0GfYW1j3fbyt6bF/3boB7GABEgKUTuWSigHFMghZhaXsdZROXiDJbxkBxaAn%2bbOxdTk6Lj20cj9jIai6UiWiziSDcl0z5qhxBdORRJCjfk2XyQU5oYMEjbOG264i8iNrpg06ETL7sY0np9p9swpoD84ihQOGsaBTuTWQcBQlB4TkOTBvjakGTDvomYrgAdH6Sp2D1Zq%2b2LSPQDcQ5VUK6VwEm7J4ED26QmCNrZzwRKA6emGxhzbyUrnMqP3GnJXSjEMnBYKyOZzbmZwMWzBZiBj2HQAqxqZoMr4KnT/Kp7EENwEgUzT6wjtDdD0AfPAcXmMPnVVAe0BGFI6f5y%2bF8Jos9QRaJM%2bBVCMUXUDL4UheWqpvqWIqPYeq7IkD1cd0C1BAqhRp5EiaZJSFw5joDVub4l%2bPqf1wNZLDc3ksMzX5%2bCCNmOPqo1VqHPJpKDynJL%2buUDBFgxvPUefNWHstL3zy232kUjXOh1VAe7D2bDMWmmH2jaZ7%2bha5pKUvq6sHkiKnCihmTdjbBxM7/V0N44wgtAYxhW2Uz1sew5Z1BlWJkXuV5iIgNoE7lkJaCjAbmnruW7ioSR4oTGQOX/w8BMo8iYnOR/qh4KE0uSovisIJT3ji2QWDJnSoxYDzYxXQHqB5iW7n8BPpCBINAMkLQkgkW0fFAMlFUdiZmtn5y8bDhyO4heqgI2/vdNJZ1gnErT5YyHAnc%2bPPxt6m5GqM3JvBRcn0lJzqm1JlCGhonQ2fLUWUecmXzy0GBeFewvSe%2bzRVF0AagDI4C5%2bpVI3zYxXQHry9H2moicuqZpi13PCoNCZ9gvK2smQ4gHQESCcBp/2ZB%2bZk3PBoYcAqPptQGs5kuhMAR/w2kPfdtsyVrhKTLVQ4DWEeJiTlWWAXMuUVI/UCg/flqDDQWwX8JAfU25Gu2KJTgz22sH8ruTP/0j8659fXQ2Xdw34CHrQh4oeNMS%2biMW%2bTQSrUwmSMCxI5vfdc%2bjQ5l72N%2bWxa9nbH0MpEgGB6RAAX/yVuGgk7eXKRl0r0CX%2bjBL5D%2bOaa8KqJMmeAg3dS5tKk8tzp2tQ2NQQ1v0w%2bYe6CZZY01fjOgM7re6VfK/wwE/aKVAFF9ugo9AwTmzABpa6whknsmOYNsCgA38hueKL0%2bb7CHi6rHtr5sB9Bys/k3lmSenb6RoAHrJ3mG6%2bVhpqWyeF5lUK6PSPTP64Yv9TWqYKDK/NwusypOjGbLSXNLTb0NiFrapfXMebRhLahxDSabOOGJSEJ%2bBLFw1L3AFM7epEHonATbZRFdy6T2%2bb5nYjwQ%2bfytxSeYQAAIABJREFUanqIrQLaOTAi2h6mI1FxDulxoa5WlrFQtlmZT1LgFnJF%2bRCWsaAQ2VvCkjoyLEAA5uGaeFlbUnXbQs4SbBlARFxRUzYUuIvXqfpcoydL3QHFtHQO8YOKifoE0iLFn5HHB0q1Uyq%2bKz8df/OnrPYgrALa%2bbH3R37ZMJeGqD2ExL9aW0uDhKMNKo3SRZCmGZWlRfmyjhBsM4bHdlKpgG96KvXWgY1ddJT%2bSus7UJ%2bNgspmBL8NKdmWO9WN6i4BkmibmVT11J8b1UfhbgxQRZmUV8RfrFSN82cV0M6PPcuTtzH7crEqBMpEo9QFABJ2OiLZ9iQj3bOkECTSKdM51uu8Wuc25qkQLA/Ws5vPE27gog3kj7bQNXR71fhFKU1PRaN88rgghJF%2bcLCVhnLuCOVQNZxTS16soWHBFG46IiYjh5s2DzNR3QPAj5/ni%2blhtQpo58T8r70n2qajoW%2b7iHMBhZ8opFI93zPPoSPxsrTLET0SqxqyORQFJqBSnk74VcxBs2knZyt4YnDpNvVybrynl1y%2bp4zwa7M%2bTI54m%2bDNxZF/QOtwZ0WUajKYFEwkZ9a75I6qUJUn3rH3yiCWZgfgJypV43xaBbTzZe/bROHIRBwx8t79l3IQdqK6d4V3h9HT0p0DUDhMGiQtt1G2BrpOTzsvrGF1i3K4nBmV496YQxuZL5qazuOOWrW/wD8DyIBbB708F4tluLkrHw3kAKXPAaLocUhxhYUzE5H2/ef/Uno4rQLaOTL/q4%2bI/0NCTkXhCKqpfQyNgiR372C9XouYIYedqKqjvRBtqfXHoZpFAPI1ToLW8XlD/ZseQ7ysdWwh0lvklnrNnTwRD3HENvZyjjVNyKsqv6e34YOFvMIZT0tUtTXBQzMhFEWHsg/ufbU63OQfDVt6ZhH8mqa55qk2u3mFXXyrgHb%2b7N%2bMUzhs1oLD8yC91E3w0rjSR/5FUeoTFyjmkoZAk3VbAVf4UJUttxBs3bBv/WyhaVp5QNco3g/VLIGsgODf2ya0Fcltzj9CmtAUmvl7pmiojthBuIkxh%2bZUixlnAJz7iTv5aNXur1VAO2dGirafS0eVZ9Wl%2bdylcKssDiC36jgsQJBzQhgKA7ZAoSRfzT3b5GmxA7ShxJntZas2%2bIb7Yh0EFRaL7HbM9VkEonB4IFMV2pBDs%2bB6zpFR6O7zZCYy0UKIKuGmS3k2AGpyJw%2bWcooWU07RRu7Z0quk7Mq19DBaBbTzaT8djkplvxGSegYQd0pAqkAGeWYgU7BlVQqHidPGlVOn8uPs1Vlu7T5771M6gjH0o0W6qsp7diUwAoNbmriOLGXEQNvE3FoMHVNZJDarYxyIYkycPSDk2LhWHCjsqCoawZ3H3UkTvyoYQDwPv1ypGufbKqCdQ/NEW%2bfcV5OsEJKWWRIh5LDT0rwBHXYiEUmRc28idBgnQPmhucmcIjaQJj9VU0WDCIGkjey4V9WoLNcZJDlEsVZpPI7O4zSgxyXTPlQyn4%2bpeBOWEkqimVpIk6qbEn6nvtWgTkuyTSwIaUXzLKz90zt%2baV14q4B2fu0DgyPT%2bZxEIcheSsKPukKKwpbnHfR2SMPQswvYG0oqrVg4XanBPdNEUwQPLL2ujK5hxium2ecFzoKpQmbcyoO7URLcfCyW2PwhRAytW6l6K5px3K5PFWBWDubQXHTPlHeGiJ/y6ijn/qp5yK0C2vm1ZxHxWFfiYpWzpypnD/3ae1vrlDwv9M6ySJFAh2WF8gonARLNGhBwBMXHgnysJ0CJVmmZbmPKQKuYkSJKso0OOdWbDEJTRSxh1VmX8miGJzbRuLyoe5YqlXy8eqgwh56pG4O6NTBRZ%2bhHY/gDU%2b3cWQW0c2o%2bV4OI/0UfnYOUM4sdOdEDW63WgcLh5w44HHpG4YtJuTfek/8Sr8rCgPbQpIgQQzsOdVkGPA/08qb3jb4XbSQ8XQ45nQ45VWs5pr0Nh7ckOe7A%2bKcJTYGu0ltFb7EB%2bP3zNc1o0IVfXzwZTLAXPhoQVcMc%2bjTALl9PD4tVQDvf9j7Jk2kKR6ajr5kZLC2t5g04FnyMJNuYFwJSlXAJGKRvNIVcRoZegpbMScAyMkxlQ3o/27BRGw%2b3V8%2b5ysi5Q5s04pDCznBuesnak%2bySSbBqRoaxUKO698iaphGyLR%2bDU%2b1OJPBYibQ7YhXQzrFFoi38r3SE4j5J8puLA9ncAMxBJ%2bqdpRgUU%2b1wYNLzCdELQ63Dnx9FfliSR2s2a6GlQmTxuhPum6Md2Sx8bsSFa8VjM4NKqiMgcyKG6YqOc5D%2bVr7wrU1hJRdSUG0TAK9SNXbGKqCdf/tX4Qh1ngzTFxMwVeN89W7V2wHNIq0P1BeZT8hF5VsFAUMwg8BRPxvKZOvZnFuMBgrHvJzNtx9x6iSElSEpJlA%2bvHe1JlVa0QkJbV0xt7imUNOfizD%2bz8Zl69AJECPvXrWSoQKyJNNN58S5j9S%2bzd2xCmjn3DzR1jn3Moc/PLgjfQmL4SeYk2xlIIjk3JickRBEg5UVD01hjEtN7bKoeJaY/m50jbhDPReguPQGYSEIADtWlcWkElLOHfCf0w9N8R5VY0xoKjDNEGXlfAkPDTNqjFU0DzoP1TvbIauAthv2Q5InYwKoTX2dodIpGveJX8V5JqAeTl1QCEWB3sJyFQfvgqKA8OxOZvOGVxU%2bnUqzPWWFpgw5R65CDdBYhLzlipQKDPNHZcK5ZTJt4hZb1UGRqp88EcoNW7sQXqx9m7tlFdB2wIhoe8yyPjqBz90CnizrhwmvwpT1dSSD6o%2bWOomkiACpiUD2Z7i0aTiJZGDSNtB2I0UBbS6VA/Q4vOwYVOc4mkR4Q1Gh5GPTFUcjMwF4Z1EWHKVDAEk6KFYx43BlH1KuQ3Wzl8HL7OGFxzz3NBsabIXOQWF7HR68Y1YBbXcsY6kjoOj7p5AzrxyiCjtRJcrRjblbJoSBcVgvjRQ3Rmj0eAYPraH/OdwbiDGiIuMOSG256apqy2ExNaevRbyRuGYy6TxWcLkokI38E8VaJF04Dt3HvbPw0RGf3eUL5mG0Cmi7Yx8CwIzsKRQLoms4TYMwWhTIZYOGhTmvKBbcrK0thKYqhN1mplG8MtyQQsPoaYWLDpusijlG2eDZAT17pQxkBsnTjBQN8QR5fii3ijmUbdmbc%2byFuZQvc9RCpb0zL7ZZ%2bzZ3zyqg7Yj5Sptz%2bJ8EkJgYqhrO/Zc1dhI4WK36RJoVgEm0D9Wzrrw6zG8mtjsxWGwzLOdpjpoqPxRDhfPdc79VTPCHHnNF09Drsvosc/RkqrwqUPQ811S1gW3yzvw%2b6G1qMWAHrQLabtnPGZlZmYYNo1MVz0LIH9FKmJWGggD1L8ZBKz73Jkoc%2bnQIXeIMlYDByPSRDfRoT6PXzt05PTMheHX%2b1qDok4WqrXGU4mNVR6O6DSJa9uTReYAP8zrDzIVc0NEW3pn3%2bJzDL9V5m7tpFdB2yPyXzFr3hzLYI3DPole2pJ5OlCb04TRwJL1G63gYL3sp6XXgrgJH2vyIxU6K%2b8K24p51A2dxm/lBy0gC/86l/k/Dx2QgtDL169jjumZJ8tD3akMe0D9mUVsjYW8cIBylhvLhwU28r7mzHbUKaLtnP6m7AEB5ULGfk6qda0/JWMe8EXKrU5prh9QShZhG1KlsW94XQL2gWntNr0FzSshRoktq9MpqUpg5CmiKG1foCon3RUNQgmTSmqYemNj5EJrTadK5pUb1WBxIg0%2bS25lPxAq6aCA6bjXc3FGrgLZ79mEEiBSObOCuk2EoZckO0SplVyXYaMYmofPmTngdrNLhQWQVdPlHtP1dtvEG5VpN2XWJ3yZOYMqORfBsBMRCgl%2bqmdFd8%2bv0eko8JiqH97TCuVEHozsD4pQrpnHEcwgRKD9SiwG7axXQdsziuDv3c%2bGodX%2biUCuUrpe074CMqOupyudDVKAp5ODKHFZ6YJ0CHR1%2bjijlRuNS51gVgeEl%2bmmN2gSKTbgjwnJvZWPEv2vUijKLykSqRwAyEWWELH8m4%2buKaVqGpkGZpnpnu24V0HbTnk0UDqW6ocatWe5nXPXS9%2bkw6Yf55oDlqodVyL/1cLLspWMAMuaFA03oEOdOTSoZNDttqSKUVU5QOTVHE4utS2KSjeKfQaP70bXvRVOaaPiJb3/iTgrDx8ql2sZIWMp5s0Aojg37X6qdAbttFdB20IjC8Snhk%2bmRd2qQSrT4iBn1/LrPO4UoizBMIkWmPzgpmWbQZHjIyGCW5pYezrQ18dCKXtER7NOcudC6FQCaQmvqMmBv01GxAYmHtrY22wdPm%2bd8IFeEw1AV6hBw8Xn1znbcKqDtrn3AAIeS0TNZr1aZgqvV09UZtEiix5Hihoy0LCLEHBgRNKXtlHz%2bZiNPy8XkXaJsjEiWCf2XOwJC80LMj0WlXif6ZzzgxANbVAuJ23uFX2v7yM/rab6AeLB9pmTb1GLAhbAKaDtqQUHVwGGW6AaAVb%2bOt7WnM/ShEuirnZxTQx12yjCVkZmb3FepkvYSSeJIUYBzYjiSEGNzbiTkbLJ2LZAugdh%2b5b0xr3PG7aVGreOQQscmVji9Z7kMVd54k%2bom%2b2cy0s/F1izOnQXOmq0yQRfAKqDtsFnrPshNTAxWrLMPJUmW1SYYyKiqp72w0jx4tK0JX/5GqboSDsT8lkl5rNOdNBVyZm1aIEeQabmZKKHmaKJ55M/p6QNOVT9Rabmh9JEGQVpMHQacN8tlgoLV3NkFsApou23PBoVWl1Q3QNQ0uA0ol8TmdYwh1j2Rc30Id6KkhBrlShme%2bjSobOau1YZaqTLtvTUbLz6mjcTezbSsDIsbSvS3lNdjwA7nhAGSmtWBPDT/WZ11Spk2AOGNOjPgYlgFtB22WBxwnwifQHUJOJearyNtwYZBKhx2OhkwrAV/hHlKemkgswhia1U6T5uoZhs1/Nma%2bFKcMKU4YgX2ZaTaNg1IMeo1/5nWxI3zj1UsGsGN8mfhdaUd52jOQpy3EMm0fW%2brd3ZBrALa7tsHY9Keaf%2bYglCma6jiAE%2bK4pQ88ni7nGImj5ALBFJNpVdKB4z1zUYASkw02oYDUoYWZYhaqon67oC1Q/EmQ%2boNWeEIY96M5LdXYbITd0KkKnDImzUmxcxgaqvTBbMKaLtvHzbG3GbJHJ8UF5ItFwL4I2pdMzQpf%2bY2DUfCzA9LQKlWkt7wJnlokMWsysa0NZrBG6ehyRBUdS1PnxLMjh5YyJ/5KejIlc2YP2uoVd3nz5CS/iGnWISaEAYuuy/VAcIXxyqg7bj5zgFr3X8DLkBi9FbWodrZw2plU7XTV/4cSjcBTxEH0MUBkJ7ORKaNaxnCqVQUUMUHzeuATXQ0l/TSTFo2DDmTB9kYHvLCAIu0nAALqfuB6Bh%2blTWFmEEI0sWQk0Ug%2bbG/p11V7%2bwCWQW0i2EfEjVaDueEjlG0QhkQDyUm0jF%2b%2bddxSpIuDABBUGLUq3M1UkXl5dtMh5ybUm2eshEKECqs1PK3MQSN%2bUFW1bUyWLgXfglXQMMcAT3LlLkn8XPV/NkFsgpoF8BIu%2bsrwhHjboD01U1IQxOgZDCxRiBFtJUZw1QUAPEAQe8ts%2b2i2pBmdpblytJ4VJ9F6eU0AkQmAZQHLO99BpVZJ54kT7cKfaosDWSK4kIUh/xo5Z5dLKuAdnHsl9n7QtXY7aQSSFOeKMdGHIyYS5PipMm8MEfVT6GEgJ7xycUGJeiY9XCOQF6TvxQlvlP3AvdxosK7MB3dpmqt9yR5alXgwJXeI8bPYahI4Wjaeqp2OvLawuuVqnHBrALaxbFnfcWOVSYcEzQ0rigXiiuAMuYutCJF7lc07gGlsXZMfbDRI%2bIeUI%2bETQgPTaxHqkbygTmSDPJTPimZNqrJoeaMagzMwdSFAcJBQQNlbLuQb9c9zQvAOOEpDRGON1PDzQtpFdAuiPnQqbfuOaNyZBJ%2bEtE278TELHzkYep62lLuZCEVBQx5QGkdR0PRw7bsXrnxsDKqcHNNcrgOk3g9EFnpv3QiPAkQvTivqGFCpRbB9bEhnfNnliqjvVL2taoYQA34VffsAloFtItlH/JfdD942FGzdgi5egq3lKRQoHh4RVuX5lPGyqAP62iyFFUcdZM4DroF8mT92brUEw8N1SJI/hMYXxEIo/DSjd/IEeNfBqRA6mX1/7dt5LA1Iq8dd87UlLbqnl1Y6x72E3DBzHPSfhaISQ9Ajds%2bHPRf/rZVxYD45fdeTfjyNw20Xs2ijV7MweU9eOLxx6FpDRzM5zCfz2A66ejWwHQygfV6BR01eXvwCH2fJgKGp1Us9mbQdq0KB214eHj7hFR0Ab72p9fg6PAkgaLWdlMqu8wb8/tomFvG94Aia%2bRD6TX1dvJMUqca6jF6mTer7tnFtApoF8h82DmddM%2b1bfNOUeBAlppuY3VQ/cmffPJJuLS/D3uLaQgFPfgc3b4FaC0sj0/gK19%2bCaazDmYEZJNJA4vZBOaTuKybNNA1LbQtj5yLHZr%2buQe01nNmW0OJecrDoaN8HFAezEl%2b7Mknnwh5MdNNwK57uHW0hMPjY3jhhT%2bhfFn0DVfLdRSnXK1h6ekmq8g5C%2b/DnLMw0amP4WcfPc%2bepqevLf7Kw36tXFSrgHbBbN3bD3dd%2b85EcI0eymNvugqPXb0K3aSF1fIEbl2/Di%2b9%2bBIsZlOYTidwsJjCYjGF/ekM9g%2bmsDefwLybwHTawmw2ga5rYT7tYD5pYNJ1sD%2bbQDsxMG3byMr3gDhpAjB2bZzA3rQR0Lxb1nvQ8hSLUGCI99g7WFoA66c2oYXD61%2bH476H42UfQOvwpIfDkzjN6vKVy9B0swCUh0cn8Opr1%2bHLf/KSTIEPVUykXk0aT8dSQU4XA2I3QfXOLqgZxLPkPKrtihljvm0y6T6zt7cPb3nz4%2bHre/36dbDrNcw9SM2nsDeZwN5iAovFDC4t5hG89iawP53Cwd4cLntg25/CtJ0ED21vNoHZtIPptIF528F0NoGFfz4xMGkbmERRsjDwKXhm3kNr26CC4UGNebrBS/Ke2trB0ifvPYkXMeTsvAfm75crB0frJRwdr%2bFw1cPR0RqOl2s4Wq3h8HgNt4%2bP4fDI3/t1VvDYm98EDXRweHwEL774Cty4fSvkCNekiRb329O4Pwtt297q%2b/5yvaAvplUP7QLZM888843vete7vvfLX/4yXrt2zRwe3oLFNILRfDaFhQ8ZO4D9hYG9eQN7EwPziYNHL82Ch%2bZzX5dmPmfWhNv%2brINLe/MAZLPpBBazLoacIQxtYTZpYNZ20E7a2EhOgNa11BvV0jwAUlp0wROLebBVHykhEXRi6Ombzo9OVnCybOBw3sHRsoejeQeHJw0cLRu4YRCmzQQmDULXIExbgBvXvg4nJyu4cXQCJ8sVXH30Ksz29uDk%2bASe/%2bIL2Th3n%2buz1v7Gw36dXGSrgHYB7Du%2b4zv%2bwssvv/yhF1988e3L5YnxIZ8HHw9QCx8yLiawF/JfTQCyy/szONjzXtYUDhYzWEwd7E8gLDvYm8LBfgd78ylc3pvA5YMOZj7EnM9gNu9gb%2bJBroPJbBbBaj5hJUiATjV5enetVU3qa4DGOZiGWZoOFjbI6wK4qZ9FFxj/y6WD26sWDo9XcHzSws2THpYnDdw%2baeF4tQxgfPOoCcA892DWWWiwiYoc2MLMdHD71nX4%2bp9%2bLXh1Pux84m1PhpDzpZdegeXyxOfharh5ga0C2g6b98hefPHFX3/%2b%2beefahoDDGQhDGwbmHZNzHvNWtibTmBvL%2bbK9mcNHExbuOSBa9HC5T0PXjPYX3RwaX8Kl/YmcOlgCpcXswBs%2b8Ez6%2bDSwQSgmwLsdQCLGcB0CjBnT6wFmDCgtXRvEjHIKZauT5x5x8mP0ltHbaBuvYZuhbB/MgF3NIVbxydweNwHADs8OYGbRwizBmHWQQCz2QRhNjMBqG8emZDbO5w10HYIk87BJIS9CF//2itwsopFhCeeeBIee%2byxv1QpGxfXag5tR%2b3bv/3bf/L3fu/3fpA9sknXJCCbJEBbzCchTNzzoDafhBBy3997oPIemPfW5hO4%2bugBXNmfw8HeDB45mAdv6E1XL8PBvIPOx3Z70%2biNLTygTQDmU4D9aQQv%2bV1s1E2rNPI11tN9QDduM4%2bLVzYC3fEK4NbKz9gDODyB24druHG0hFtHK7h5uAqVz1ev34abR2u4eXgCNw5XcO3GIRwdL%2bHW8RqOTtahkHDr6BiOjy3cXi1hedLD0aqPg2R6B91kik899dT/efTRR3/kYx/72Mcf9mvpIln10HbQ3v3ud3/wM5/5zPf4kNLnsiZdC5PWBFqFrzrOQiWyhZnPfXUGDgKYdXCw18L%2b3OfIDDx2eQp7iw4uLzp4ZH8ClxYNXN0z8Mg%2bwKP7AFcuzWC6jwBzALiyANibQ0C5gxlA50FqTpfPhE4gycvGOFN6AuJj7pPSwIZ0b%2bNuOguwZwEutQCXO4DbLcBhAwe3lnBw3MLRDQPXO4Rr3jNrFjBtMRQtDPTQNdPgnXkg9x7cpPOH6KDr1tAdIxx1BroTE3N169DTav7oDz//zLq3H3v66aeff%2bKJJ767AtvFsApoO2beM2MwmwYw8yAWv8xTD2xdXO6Bbu49tFkLi5kJ995Lu%2bRvPvScGdifNqEI8MisgcszC1dmDq4uGnjTAQJcMhFYDqYAl1uAgwZCHBcAbEpANaXnnbpBAWhtGr0ORgGZAjTx1k7iLvx7HXgGrgE48MC2gr1pD3tTB/MJwqLrYdLMgsM4byy8NgG41fmihIPOuFA0mICDSYdw26fyAvj5DgoLy87BirohVn0Df/LlF5764z/%2b4sfe8Y53fPSxxx77ro9%2b9KNfetivsV22Cmg7ZD5n5sNMD2YeyDoKMTnc9EAWvZQmVSE91WLiqRcd7E%2b7CGxTD3oQvLPHL3dwZb%2bFKwdTePzSBC55D%2bnSBOBKB3CpA3h0ArDPYeWM7lt6vKD7ibqUPGjtFd6aCi9hpUJOq0DNFeI%2bCOA9xH0DcNgCTFcArYWrXQ/7kw7mMIVF52AxmQWPbNbGSurEUP6scWCOY/%2bp74A46bzSSAPTMAzGwKp10PXssTn4wz/43DOLvYMvvOc97/knv/mbv1lFH3fUKqDtkN26deufn5ycGA9gbeNZ%2brHdiHNoni7h82ZyC%2bDWwWzaBoqDB735xMBi4r2yFi55aoYPRbsGrsxMqF4GALk6i6B2dQqwmBBgaU%2bMwcx7aJ7StU8gdomAq6PXgECNQ059fwwAS7rxYwbAToWzS4D9mwDzWRzz1PUw6ybwDWBh6tu1sIXGdqHg4Fyknvi2KnAdEWkdNDChc%2bSgbfpw3pZrB11jYdXY2KrVGFidHHb/99O/9bPvfve73/Hbv/3bf%2bthv9520Sqg7ZCtVqunm8ZIL6N/3PoeyvCFjAAX%2bWAR3HyfpQ9BJ96ja3xlMAJeALnOwN4UYa9xcHkW8/swt7FyOVkD7DUA017lyGYq3PS3q3TrCMz2FYhNz3BSH4khZqwIEKC9BgA3PHQTuPFMgxlA2wM86nup5gDGV0mn8Gb0jVwOJqTWa8KYqhX0fQvOtlE%2bqW9Dd4A/F%2b26D%2bfruO3DD4G/Nat4Hg2dO89V%2b3%2b/%2b9z3fMu3fMuf%2b/znP/%2buh/2a2zWrgLZD1rbta3y0LPPDMj5SUwxfzvh6eAxxIlPTNkGWpw3Txl1QgHXUqO5aDx9xVia0lLgPhUoOCV0kkoXLxZJXNqfX5gR0MwV%2bZ7U5ref3eUSfYk6A%2bArtzxG4megUhtRbG2WKVgau9gb6tYHVGqBft7Bed7CeO%2bpfdeC8h9msZQSeMT0Y00EDVs5hY2x%2bLg3A81/4o2/z%2bcpPf/rT/%2bxhv%2b52yap80A7Z5cuXf4bFD0WZtpxNwnLZyGPrSBiR1GB7Um71IZdv7Pbyr/3KD09ZA9w8TrfeizU68qLWBF5rAh2%2bb1Re7E7BTFtL4SqD2SUKaZf0viq3NvOVV%2b%2bJ9QBt1BI/mEPoHJi3Nnihe52JucNwox7UacwxzruoFhKrw0Yqwpr20rXRw/3s7//%2bD/q85UN1ke24VQ9th8xTCzzN4Esv/PFTceo5hl5IL2DYOQO9M9D5HkmvOtFE5Ym%2bMaF/ctlb6EJ41YI59hI8PbRHJiTMPQXMe2q%2bunngY1O/4ks3AVZzgEdnAPPbBCwLynet6aTtEwjtqdBz73WcUEdh5hHdTmg/HiwP6T1tBLijdcS24Lz14XOuVxja473uWetvHqRWMbyetDaE3H3rqS0I1lM4bAO2RZjYNmwf8pDWgPPr%2bdfRgG0aWPcr4/OWAFDzaTtiFdB2zN72trf95Rs3bnzu5o3XFo2Jcyl9XmhtXMij%2bYodixt6GoMPq9q1DctCJbTv4WSJMPVf3GMI26JdhnFv65WDqysHV1ZraI/XACdLgJtzgEeOAd66R0DmPajrBDTf4ElqBEaWAG%2bf/EUGu/aUE%2bxoXysFZh7AngeA2/ScQtLVEuD2McAKAa6vAhl3tYwV1J701RywZBKIugbnHEOuMYTuBkxvwhi8kIck/TbfWdBaAz2H69Y3M6yeftivuV2yCmg7Zp4n9cwzz3zrZz/72c/duvGaRxCVT4u5oJhH6ME08c/bcD8lhZ%2b9wzCF3PdOHi8t3Jq3cNS3cP14CreWXofME3FXcOV4AdMbPcD1FuC1JcClGwCPHlAF4ZjyXJfo9hKBmKZyzAgAl6ry6ejGubklAeWKwMuD2DUCN86trQBuLAFuLSOQLfvQB%2bqWcejLzcN1UNg4Wdug7BEGqoRZnTwRnsPvpLq7zTgfedpwqmrnzyqg7aAxqH3hC1/4na//6Ve9i0QS1JxXa4KQI2IPdtJSG2UTQlEXuowaWK4RTtYIK%2bwCg/5waWF/buHm7RXcuDSBKwsbWoguLTrYO%2big627D9KADmN4EeLQDeGQaw9FLrypPbE6ANqfbjG49eWGPEFxosu1KAdosdW2UAAAGJklEQVTX4nJ3CNCQR7g%2bBji0AK8eAbx0AtbLCd1awbGXGTrqQ3vTjWMPwmu4sezh9nG8%2bdfD5wtzRzGq2PpwnMbfWVK3jfMFIuQ5i6Jqy/nJxWLxyYf9etslq72cO27vfOc7f%2bX5L/zRX0G3NkKuDcTahpRm4%2bM5dw9MW3nuG7o5aR56PacN7E/b0LC%2bN/E8tRYOPKBNGziYtLBYdLC/14Lx280bmC06mPhO8UUT26I8u3VGHQW%2bPco3rYf7Jo1bD1rZQFOEqWrhkcZjXr%2bO7pNXf7y9BjjuAU56cCuE9fEaTk4sLI/iQOTbN9Zw7L2zlYXbJxZuL%2bPt6LiHw5WNgLf0g5P7MDz5xBNqw/R4F577gojPK67Ccxc8vVUfSbZLUsC9/Mijxy%2b/8rXXkxSs9oCsemg7bs8999x3surGV778wlOhUGAb6J1PaiPMen/fhqbsZZjLGYFtOXVwMonM%2bfnKwtGyDVJDN7sG9k5amHW%2b77OFxWQNi2kDe9P43LdLebDzSrbTeRv4bF4vbeKf%2b/tZE6S5A5h5cOtIdYOlhSSg4/gXI6j5%2b6UL4NZ7wcclRmltnyfzgNMjrE6i3PbR2sLhCgNgHS6jN3a8dnB4EkHqKNw7OA5AFsFstQHM/LK1l%2bjuoxfnw1V/Dttuim9/6s/8jYf9%2bto1qx7aBTKvi/bKKy9/6CtfeuGpCXULcMN6pCgkj80vCwq0XewBDd0EnYlKtF1sevctVAt/PzXRo5t60DPJuws0iCjd49cPbPyJCYAWKoe%2bv7KN09JN6GoYnmsbmCMx5OtXMSz0IaKX5V6vMVJMvJfVY7gFkPJg5UHLInlfFpYrhON1BDIPWAG4gseFweM66fvweBVCUS8qiQRoyTPr6X6%2b2O%2b/%2bVv/7F//%2bMc/8Z8f9mtq16wC2gU077Fdu3bt5195%2bcX3Hh/d7nQoyo8nnREuVgA0aZmKwCZ9oZPohXVtG9qmZm0LnW%2bf6iIg%2bu6EWRt5XxPqMfX3Hd3HgSmxwthSlt13MgANBfZemqVZm5ErB6Fg4cHF30fPku49CHnPyoNUHwEveFu0PHhbpHzrPbJVAMEIZGuaHL%2bi3k3/uvfKeBmr5n7T25/%2bnTe96c1/tTap76ZVQLvg9p73vOcfvnrt2vd%2b7asvvd32Mc82mWjtNAa1hpQ74vOuTT2hXpqI15t4QAs9oxHkpm0Erym1EoV2qyZSIvzyhqqsTQMCaKr9XAjBOkkfaqChUhk9NH9ve59awwBEnlfnCcIeqLw350EtgCCBWAC13hGIRSDzHtm6T%2bElL2Ov7PE3v%2bX6W59824998pO1MX2XrQLaQ2Qe3G7euPFdN66/%2bs2exxZY8QRYLfd9ekCbxGWh4b1JTe8dAxo1xU%2bIUe9voae0bYInxs8Dl8sQ34umrjcjvSmeM4ZEq6DxA6HKGCc3UQjqIlF4zY8d57zo3jkBqABcNJszAhvSZHUUkUf/us%2bTvfmtT3zxsTc9/sM1vLwYVgHtITWfbzs6Ovzuw9u3/uJrr177xuOjw66jULEjOW8PYPFxSwAWSagMhAG0eDkDGpNYW5p13sR5nYZIrZu4XXwZBjIHjd7z/Zjsufn70AHhp7zb%2bNyDVxgs7CJYeUAMgBe8MRuAsKfZn5aAz4PcE2/7hleuXLn6a4u9/X9RQ8uLZRXQqgXzebfj46O/uzw5%2bfO3bl5/543r1x/p%2b5WJ3liSKmppQnpLQMehZAAwPT09DB6mRnnyzgwB2yZDl4ivjntWXcy1eY5d4NHRVHUPXIFDZuPszZ4mpYcw1UUAC72rDuHxt7zl%2bmJx8ML%2bwcH//NSnfqs2m19gq4BWbaN5kFsul9%2b5PDl5Zr1efdPR0e1vOj48PDg6ut1xSNlm4SWI15aBmImVTl6HTT%2bWJnv21Bw34buwzFI7UyTBDsmxPpT0YOfBa3/v4IXJdPrCdDb/aM2JPVxWAa3a67L3vve9f81a%2b4Tt1%2b9YrVdPe/C6ceP6Ow31kV5/7bVHVqulyYHNpLaiEU9NPDR%2bTmx99tbe/Ja3XkdqZXrk8pXn/OrzxeKTxpivTqezX6nhY7UKaNXui7G3x%2b91Wi6tbduXP/GJmqivdgcGAP8fzzchVv1ccdkAAAAASUVORK5CYII='/%3e%3c/defs%3e%3c/svg%3e";

    var img$a = "data:image/svg+xml,%3csvg width='89' height='92' viewBox='0 0 89 92' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_4318_351)'%3e%3cpath d='M66.3025 20.3267L61.3808 20.977C69.2141 26.4307 74.4018 35.4464 74.4905 45.7183C74.6383 62.5525 61.1148 76.3125 44.2806 76.4603C40.0388 76.5046 35.9744 75.6622 32.2942 74.1251L33.9939 70.0311L26.6336 70.9917L21.7119 71.6421L29.2496 81.5002L30.9493 77.3914C35.0581 79.1059 39.5807 80.037 44.325 79.9926C63.1101 79.8301 78.1855 64.4739 78.0229 45.6888C77.9342 35.5498 73.4116 26.4898 66.3173 20.3267H66.3025Z' fill='url(%23paint0_linear_4318_351)'/%3e%3c/g%3e%3cg filter='url(%23filter1_d_4318_351)'%3e%3cpath d='M58.7797 10.4835L57.0653 14.5923C52.9565 12.8779 48.4339 11.9467 43.7043 11.9911C24.9192 12.1537 9.82907 27.5098 10.0064 46.2949C10.0951 56.4339 14.6177 65.4791 21.6972 71.6423L26.6189 70.992C18.7856 65.5382 13.6127 56.5226 13.524 46.2506C13.3762 29.4164 26.8997 15.6565 43.7339 15.5087C47.9757 15.4643 52.0254 16.3068 55.7203 17.8439L54.0206 21.9379L61.381 20.9772L66.3026 20.3269H66.3174L58.7797 10.4688V10.4835Z' fill='url(%23paint1_linear_4318_351)'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_4318_351' x='11.7119' y='10.3267' width='76.3125' height='81.1733' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='5'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4318_351'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4318_351' result='shape'/%3e%3c/filter%3e%3cfilter id='filter1_d_4318_351' x='0.00488281' y='0.46875' width='76.3125' height='81.1733' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='5'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4318_351'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4318_351' result='shape'/%3e%3c/filter%3e%3clinearGradient id='paint0_linear_4318_351' x1='71.8306' y1='24.4421' x2='40.2832' y2='80.2084' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFB915'/%3e%3cstop offset='0.24' stop-color='%23BF8500'/%3e%3cstop offset='0.41' stop-color='%23FFE26A'/%3e%3cstop offset='0.46' stop-color='%23FFDD63'/%3e%3cstop offset='0.53' stop-color='%23FFCF51'/%3e%3cstop offset='0.58' stop-color='%23FFC13F'/%3e%3cstop offset='0.82' stop-color='%23FFB915'/%3e%3cstop offset='1' stop-color='%23FFF100'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear_4318_351' x1='17.448' y1='65.3064' x2='47.3802' y2='12.3922' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FFB915'/%3e%3cstop offset='0.24' stop-color='%23BF8500'/%3e%3cstop offset='0.41' stop-color='%23FFE26A'/%3e%3cstop offset='0.46' stop-color='%23FFDD63'/%3e%3cstop offset='0.53' stop-color='%23FFCF51'/%3e%3cstop offset='0.58' stop-color='%23FFC13F'/%3e%3cstop offset='0.82' stop-color='%23FFB915'/%3e%3cstop offset='1' stop-color='%23FFF100'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

    var img$9 = "data:image/svg+xml,%3csvg width='92' height='92' viewBox='0 0 92 92' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_4318_451)'%3e%3cpath d='M61.7341 10.0813L59.9148 14.3521C55.644 12.5328 50.9415 11.5152 45.9924 11.5152C26.3961 11.5152 10.5156 27.3957 10.5156 46.992C10.5156 57.5687 15.141 67.0507 22.48 73.5417L27.6296 72.9096C19.5043 67.1433 14.2005 57.692 14.2005 46.9765C14.2005 29.4155 28.4313 15.1847 45.9924 15.1847C50.4173 15.1847 54.6419 16.0943 58.4655 17.7287L56.6616 21.984L64.3398 21.0435L69.4894 20.4114H69.5048L61.7341 10.0659V10.0813Z' fill='url(%23paint0_linear_4318_451)'/%3e%3c/g%3e%3cg filter='url(%23filter1_d_4318_451)'%3e%3cpath d='M69.4892 20.4272L64.3396 21.0594C72.4648 26.8257 77.784 36.2769 77.784 46.9924C77.784 64.5535 63.5532 78.7843 45.9922 78.7843C41.5672 78.7843 37.3427 77.8746 33.5036 76.2403L35.3075 71.9849L27.614 72.9254L22.4644 73.5576L30.235 83.903L32.0543 79.6323C36.3251 81.4516 41.043 82.4692 45.9768 82.4692C65.573 82.4692 81.4535 66.5886 81.4535 46.9924C81.4535 36.4157 76.8281 26.9336 69.4737 20.4272H69.4892Z' fill='url(%23paint1_linear_4318_451)'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_4318_451' x='0.515625' y='0.065918' width='78.9893' height='83.4756' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='5'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4318_451'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4318_451' result='shape'/%3e%3c/filter%3e%3cfilter id='filter1_d_4318_451' x='2.46436' y='0.427246' width='98.9893' height='103.476' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='10'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4318_451'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4318_451' result='shape'/%3e%3c/filter%3e%3clinearGradient id='paint0_linear_4318_451' x1='40.0256' y1='11.1298' x2='40.0256' y2='63.4275' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23F8DA36'/%3e%3cstop offset='0.09' stop-color='%23F8C14C'/%3e%3cstop offset='0.28' stop-color='%23F88485'/%3e%3cstop offset='0.52' stop-color='%23FA2CD7'/%3e%3cstop offset='0.76' stop-color='%23987CDB'/%3e%3cstop offset='1' stop-color='%2333D0E0'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear_4318_451' x1='51.9743' y1='82.8546' x2='51.9743' y2='30.5877' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FEDC31'/%3e%3cstop offset='0.09' stop-color='%23FDC347'/%3e%3cstop offset='0.27' stop-color='%23FC8682'/%3e%3cstop offset='0.52' stop-color='%23FA2CD7'/%3e%3cstop offset='0.76' stop-color='%23987CDB'/%3e%3cstop offset='1' stop-color='%2333D0E0'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

    var img$8 = "data:image/svg+xml,%3csvg width='54' height='27' viewBox='0 0 54 27' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg filter='url(%23filter0_f_4318_348)'%3e %3cpath d='M9.98663 20.179C9.33863 20.179 8.74463 20.107 8.20463 19.963C7.67663 19.819 7.22663 19.627 6.85463 19.387V16.975C7.21463 17.167 7.56263 17.335 7.89863 17.479C8.24663 17.623 8.59463 17.737 8.94263 17.821C9.29063 17.893 9.64463 17.929 10.0046 17.929C10.3046 17.929 10.5806 17.905 10.8326 17.857C11.0846 17.797 11.3006 17.707 11.4806 17.587C11.6726 17.467 11.8226 17.323 11.9306 17.155C12.0386 16.975 12.0926 16.765 12.0926 16.525C12.0926 16.189 12.0266 15.907 11.8946 15.679C11.7626 15.451 11.5826 15.241 11.3546 15.049C11.1266 14.857 10.8566 14.653 10.5446 14.437C10.1846 14.173 9.83663 13.879 9.50063 13.555C9.16463 13.231 8.88863 12.853 8.67263 12.421C8.45663 11.977 8.34863 11.461 8.34863 10.873C8.34863 10.297 8.45063 9.77502 8.65463 9.30702C8.85863 8.82702 9.15263 8.41302 9.53663 8.06502C9.93263 7.71702 10.4006 7.44702 10.9406 7.25502C11.4806 7.06302 12.0866 6.96702 12.7586 6.96702C13.4306 6.96702 14.0486 7.03902 14.6126 7.18302C15.1766 7.32702 15.7226 7.54302 16.2506 7.83102L15.2966 9.88302C14.8406 9.66702 14.4026 9.50502 13.9826 9.39702C13.5746 9.28902 13.1666 9.23502 12.7586 9.23502C12.5186 9.23502 12.2966 9.27102 12.0926 9.34302C11.9006 9.40302 11.7266 9.49902 11.5706 9.63102C11.4266 9.75102 11.3126 9.90102 11.2286 10.081C11.1446 10.261 11.1026 10.459 11.1026 10.675C11.1026 10.975 11.1626 11.233 11.2826 11.449C11.4146 11.665 11.5946 11.869 11.8226 12.061C12.0626 12.241 12.3506 12.445 12.6866 12.673C13.1666 12.985 13.5626 13.321 13.8746 13.681C14.1866 14.029 14.4206 14.413 14.5766 14.833C14.7326 15.241 14.8106 15.697 14.8106 16.201C14.8106 16.873 14.6846 17.461 14.4326 17.965C14.1806 18.457 13.8326 18.871 13.3886 19.207C12.9446 19.531 12.4286 19.777 11.8406 19.945C11.2646 20.101 10.6466 20.179 9.98663 20.179ZM16.5076 19.999L19.2256 7.14702H22.8076C23.8516 7.14702 24.6856 7.30302 25.3096 7.61502C25.9456 7.92702 26.4016 8.36502 26.6776 8.92902C26.9656 9.49302 27.1096 10.147 27.1096 10.891C27.1096 11.659 26.9656 12.325 26.6776 12.889C26.4016 13.453 26.0116 13.927 25.5076 14.311C25.0036 14.683 24.4096 14.965 23.7256 15.157C23.0416 15.337 22.3036 15.427 21.5116 15.427H20.1436L19.1896 19.999H16.5076ZM21.7276 13.195C22.2676 13.195 22.7356 13.111 23.1316 12.943C23.5396 12.763 23.8516 12.505 24.0676 12.169C24.2956 11.833 24.4096 11.431 24.4096 10.963C24.4096 10.423 24.2656 10.027 23.9776 9.77502C23.6896 9.51102 23.2636 9.37902 22.6996 9.37902H21.4396L20.6296 13.195H21.7276ZM26.5039 19.999L26.8279 18.451L28.4659 17.731L30.2299 9.41502L28.8979 8.69502L29.2219 7.14702H34.9099L34.5859 8.69502L32.9119 9.41502L31.1479 17.731L32.5159 18.451L32.1919 19.999H26.5039ZM34.3845 19.999L37.1025 7.14702H40.2345L43.2225 16.615H43.2945C43.3305 16.423 43.3665 16.189 43.4025 15.913C43.4505 15.637 43.4985 15.343 43.5465 15.031C43.6065 14.707 43.6665 14.389 43.7265 14.077C43.7865 13.765 43.8405 13.483 43.8885 13.231L45.1845 7.14702H47.5965L44.8785 19.999H41.8725L38.7405 10.279H38.6505C38.6385 10.351 38.6145 10.525 38.5785 10.801C38.5425 11.065 38.4945 11.383 38.4345 11.755C38.3865 12.127 38.3265 12.511 38.2545 12.907C38.1945 13.291 38.1345 13.639 38.0745 13.951L36.7965 19.999H34.3845Z' fill='%23FFF8BA'/%3e %3c/g%3e %3cpath d='M9.98663 20.179C9.33863 20.179 8.74463 20.107 8.20463 19.963C7.67663 19.819 7.22663 19.627 6.85463 19.387V16.975C7.21463 17.167 7.56263 17.335 7.89863 17.479C8.24663 17.623 8.59463 17.737 8.94263 17.821C9.29063 17.893 9.64463 17.929 10.0046 17.929C10.3046 17.929 10.5806 17.905 10.8326 17.857C11.0846 17.797 11.3006 17.707 11.4806 17.587C11.6726 17.467 11.8226 17.323 11.9306 17.155C12.0386 16.975 12.0926 16.765 12.0926 16.525C12.0926 16.189 12.0266 15.907 11.8946 15.679C11.7626 15.451 11.5826 15.241 11.3546 15.049C11.1266 14.857 10.8566 14.653 10.5446 14.437C10.1846 14.173 9.83663 13.879 9.50063 13.555C9.16463 13.231 8.88863 12.853 8.67263 12.421C8.45663 11.977 8.34863 11.461 8.34863 10.873C8.34863 10.297 8.45063 9.77502 8.65463 9.30702C8.85863 8.82702 9.15263 8.41302 9.53663 8.06502C9.93263 7.71702 10.4006 7.44702 10.9406 7.25502C11.4806 7.06302 12.0866 6.96702 12.7586 6.96702C13.4306 6.96702 14.0486 7.03902 14.6126 7.18302C15.1766 7.32702 15.7226 7.54302 16.2506 7.83102L15.2966 9.88302C14.8406 9.66702 14.4026 9.50502 13.9826 9.39702C13.5746 9.28902 13.1666 9.23502 12.7586 9.23502C12.5186 9.23502 12.2966 9.27102 12.0926 9.34302C11.9006 9.40302 11.7266 9.49902 11.5706 9.63102C11.4266 9.75102 11.3126 9.90102 11.2286 10.081C11.1446 10.261 11.1026 10.459 11.1026 10.675C11.1026 10.975 11.1626 11.233 11.2826 11.449C11.4146 11.665 11.5946 11.869 11.8226 12.061C12.0626 12.241 12.3506 12.445 12.6866 12.673C13.1666 12.985 13.5626 13.321 13.8746 13.681C14.1866 14.029 14.4206 14.413 14.5766 14.833C14.7326 15.241 14.8106 15.697 14.8106 16.201C14.8106 16.873 14.6846 17.461 14.4326 17.965C14.1806 18.457 13.8326 18.871 13.3886 19.207C12.9446 19.531 12.4286 19.777 11.8406 19.945C11.2646 20.101 10.6466 20.179 9.98663 20.179ZM16.5076 19.999L19.2256 7.14702H22.8076C23.8516 7.14702 24.6856 7.30302 25.3096 7.61502C25.9456 7.92702 26.4016 8.36502 26.6776 8.92902C26.9656 9.49302 27.1096 10.147 27.1096 10.891C27.1096 11.659 26.9656 12.325 26.6776 12.889C26.4016 13.453 26.0116 13.927 25.5076 14.311C25.0036 14.683 24.4096 14.965 23.7256 15.157C23.0416 15.337 22.3036 15.427 21.5116 15.427H20.1436L19.1896 19.999H16.5076ZM21.7276 13.195C22.2676 13.195 22.7356 13.111 23.1316 12.943C23.5396 12.763 23.8516 12.505 24.0676 12.169C24.2956 11.833 24.4096 11.431 24.4096 10.963C24.4096 10.423 24.2656 10.027 23.9776 9.77502C23.6896 9.51102 23.2636 9.37902 22.6996 9.37902H21.4396L20.6296 13.195H21.7276ZM26.5039 19.999L26.8279 18.451L28.4659 17.731L30.2299 9.41502L28.8979 8.69502L29.2219 7.14702H34.9099L34.5859 8.69502L32.9119 9.41502L31.1479 17.731L32.5159 18.451L32.1919 19.999H26.5039ZM34.3845 19.999L37.1025 7.14702H40.2345L43.2225 16.615H43.2945C43.3305 16.423 43.3665 16.189 43.4025 15.913C43.4505 15.637 43.4985 15.343 43.5465 15.031C43.6065 14.707 43.6665 14.389 43.7265 14.077C43.7865 13.765 43.8405 13.483 43.8885 13.231L45.1845 7.14702H47.5965L44.8785 19.999H41.8725L38.7405 10.279H38.6505C38.6385 10.351 38.6145 10.525 38.5785 10.801C38.5425 11.065 38.4945 11.383 38.4345 11.755C38.3865 12.127 38.3265 12.511 38.2545 12.907C38.1945 13.291 38.1345 13.639 38.0745 13.951L36.7965 19.999H34.3845Z' fill='white'/%3e %3cdefs%3e %3cfilter id='filter0_f_4318_348' x='0.854492' y='0.966797' width='52.7422' height='25.2124' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3e %3cfeGaussianBlur stdDeviation='3' result='effect1_foregroundBlur_4318_348'/%3e %3c/filter%3e %3c/defs%3e%3c/svg%3e";

    var img$7 = "data:image/svg+xml,%3csvg width='250' height='250' viewBox='0 0 250 250' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath style='mix-blend-mode:multiply' d='M125 250C191.718 250 250 193.271 250 125C250 55.7438 191.718 0 125 0C55.296 0 0 55.7438 0 125C0 193.271 55.296 250 125 250Z' fill='url(%23paint0_radial_4318_321)'/%3e %3cdefs%3e %3cradialGradient id='paint0_radial_4318_321' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(125 125) scale(125 125)'%3e %3c!-- %3cstop offset='0.81' stop-color='white'/%3e %3cstop offset='0.87' stop-color='%23FCFCFD'/%3e %3cstop offset='0.91' stop-color='%23F3F4F6'/%3e %3cstop offset='0.94' stop-color='%23E9ECF0'/%3e %3cstop offset='0.97' stop-color='%23B9C3CE'/%3e %3cstop offset='1' stop-color='%23899BAD'/%3e --%3e %3cstop offset='0.41' stop-color='white'/%3e %3cstop offset='0.57' stop-color='%23FCFCFD'/%3e %3cstop offset='0.61' stop-color='%23F3F4F6'/%3e %3cstop offset='0.74' stop-color='%23E9ECF0'/%3e %3cstop offset='0.87' stop-color='%23B9C3CE'/%3e %3cstop offset='1' stop-color='%23899BAD'/%3e %3c/radialGradient%3e %3c/defs%3e%3c/svg%3e";

    var img$6 = "data:image/svg+xml,%3csvg width='68' height='71' viewBox='0 0 68 71' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M15.9866 42.1805C15.3386 42.1805 14.7446 42.1085 14.2046 41.9645C13.6766 41.8205 13.2266 41.6285 12.8546 41.3885V38.9765C13.2146 39.1685 13.5626 39.3365 13.8986 39.4805C14.2466 39.6245 14.5946 39.7385 14.9426 39.8225C15.2906 39.8945 15.6446 39.9305 16.0046 39.9305C16.3046 39.9305 16.5806 39.9065 16.8326 39.8585C17.0846 39.7985 17.3006 39.7085 17.4806 39.5885C17.6726 39.4685 17.8226 39.3245 17.9306 39.1565C18.0386 38.9765 18.0926 38.7665 18.0926 38.5265C18.0926 38.1905 18.0266 37.9085 17.8946 37.6805C17.7626 37.4525 17.5826 37.2425 17.3546 37.0505C17.1266 36.8585 16.8566 36.6545 16.5446 36.4385C16.1846 36.1745 15.8366 35.8805 15.5006 35.5565C15.1646 35.2325 14.8886 34.8545 14.6726 34.4225C14.4566 33.9785 14.3486 33.4625 14.3486 32.8745C14.3486 32.2985 14.4506 31.7765 14.6546 31.3085C14.8586 30.8285 15.1526 30.4145 15.5366 30.0665C15.9326 29.7185 16.4006 29.4485 16.9406 29.2565C17.4806 29.0645 18.0866 28.9685 18.7586 28.9685C19.4306 28.9685 20.0486 29.0405 20.6126 29.1845C21.1766 29.3285 21.7226 29.5445 22.2506 29.8325L21.2966 31.8845C20.8406 31.6685 20.4026 31.5065 19.9826 31.3985C19.5746 31.2905 19.1666 31.2365 18.7586 31.2365C18.5186 31.2365 18.2966 31.2725 18.0926 31.3445C17.9006 31.4045 17.7266 31.5005 17.5706 31.6325C17.4266 31.7525 17.3126 31.9025 17.2286 32.0825C17.1446 32.2625 17.1026 32.4605 17.1026 32.6765C17.1026 32.9765 17.1626 33.2345 17.2826 33.4505C17.4146 33.6665 17.5946 33.8705 17.8226 34.0625C18.0626 34.2425 18.3506 34.4465 18.6866 34.6745C19.1666 34.9865 19.5626 35.3225 19.8746 35.6825C20.1866 36.0305 20.4206 36.4145 20.5766 36.8345C20.7326 37.2425 20.8106 37.6985 20.8106 38.2025C20.8106 38.8745 20.6846 39.4625 20.4326 39.9665C20.1806 40.4585 19.8326 40.8725 19.3886 41.2085C18.9446 41.5325 18.4286 41.7785 17.8406 41.9465C17.2646 42.1025 16.6466 42.1805 15.9866 42.1805ZM22.5076 42.0005L25.2256 29.1485H28.8076C29.8516 29.1485 30.6856 29.3045 31.3096 29.6165C31.9456 29.9285 32.4016 30.3665 32.6776 30.9305C32.9656 31.4945 33.1096 32.1485 33.1096 32.8925C33.1096 33.6605 32.9656 34.3265 32.6776 34.8905C32.4016 35.4545 32.0116 35.9285 31.5076 36.3125C31.0036 36.6845 30.4096 36.9665 29.7256 37.1585C29.0416 37.3385 28.3036 37.4285 27.5116 37.4285H26.1436L25.1896 42.0005H22.5076ZM27.7276 35.1965C28.2676 35.1965 28.7356 35.1125 29.1316 34.9445C29.5396 34.7645 29.8516 34.5065 30.0676 34.1705C30.2956 33.8345 30.4096 33.4325 30.4096 32.9645C30.4096 32.4245 30.2656 32.0285 29.9776 31.7765C29.6896 31.5125 29.2636 31.3805 28.6996 31.3805H27.4396L26.6296 35.1965H27.7276ZM32.5039 42.0005L32.8279 40.4525L34.4659 39.7325L36.2299 31.4165L34.8979 30.6965L35.2219 29.1485H40.9099L40.5859 30.6965L38.9119 31.4165L37.1479 39.7325L38.5159 40.4525L38.1919 42.0005H32.5039ZM40.3845 42.0005L43.1025 29.1485H46.2345L49.2225 38.6165H49.2945C49.3305 38.4245 49.3665 38.1905 49.4025 37.9145C49.4505 37.6385 49.4985 37.3445 49.5465 37.0325C49.6065 36.7085 49.6665 36.3905 49.7265 36.0785C49.7865 35.7665 49.8405 35.4845 49.8885 35.2325L51.1845 29.1485H53.5965L50.8785 42.0005H47.8725L44.7405 32.2805H44.6505C44.6385 32.3525 44.6145 32.5265 44.5785 32.8025C44.5425 33.0665 44.4945 33.3845 44.4345 33.7565C44.3865 34.1285 44.3265 34.5125 44.2545 34.9085C44.1945 35.2925 44.1345 35.6405 44.0745 35.9525L42.7965 42.0005H40.3845Z' fill='url(%23paint0_linear_4318_395)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M67.7972 35.8053C67.7972 23.716 61.4542 13.1107 51.914 7.13533L46.866 0.567871L45.2409 3.9164C41.7221 2.67553 37.9362 2.00048 33.9924 2.00048C15.3197 2.00048 0.1875 17.1327 0.1875 35.8053C0.1875 46.7672 5.40255 56.5089 13.4874 62.6852L20.2741 70.5956L21.6632 67.2922C25.483 68.7887 29.6416 69.6102 33.9924 69.6102C52.665 69.6102 67.7972 54.478 67.7972 35.8053ZM23.2147 63.6027C26.557 64.8991 30.1915 65.6102 33.9924 65.6102C50.4559 65.6102 63.7972 52.2688 63.7972 35.8053C63.7972 25.1301 58.1879 15.7675 49.7552 10.5037L41.9996 10.5954L43.4813 7.54217C40.5009 6.54225 37.31 6.00048 33.9924 6.00048C17.5289 6.00048 4.1875 19.3418 4.1875 35.8053C4.1875 46.2587 9.56607 55.4534 17.7073 60.7734L24.5947 60.3211L23.2147 63.6027Z' fill='url(%23paint1_linear_4318_395)'/%3e%3cdefs%3e%3clinearGradient id='paint0_linear_4318_395' x1='45.1177' y1='24.4796' x2='38.6579' y2='50.2794' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23170C06'/%3e%3cstop offset='0.33125' stop-color='%23575757'/%3e%3cstop offset='1' stop-color='%23170C06'/%3e%3c/linearGradient%3e%3clinearGradient id='paint1_linear_4318_395' x1='53.4996' y1='4.71093' x2='25.378' y2='69.2576' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23170C06'/%3e%3cstop offset='0.33125' stop-color='%23575757'/%3e%3cstop offset='1' stop-color='%23170C06'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

    var img$5 = "data:image/svg+xml,%3csvg width='42' height='19' viewBox='0 0 42 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M7.47847 7.512C7.68647 6.728 7.79047 6.072 7.79047 5.544C7.79047 5.016 7.64647 4.584 7.35847 4.248C7.07047 3.896 6.69447 3.72 6.23047 3.72C5.78247 3.72 5.40647 3.944 5.10247 4.392C4.79847 4.84 4.64647 5.352 4.64647 5.928C4.64647 7.048 5.28647 8.008 6.56647 8.808C7.84647 9.64 8.71847 10.24 9.18247 10.608C9.64647 10.976 9.97447 11.312 10.1665 11.616C10.6465 12.4 10.8865 13.208 10.8865 14.04C10.8865 15.48 10.3985 16.632 9.42247 17.496C8.46247 18.344 7.37447 18.768 6.15847 18.768C4.71847 18.768 3.51047 18.16 2.53447 16.944C1.83047 16.064 1.18247 14.968 0.590469 13.656L2.91847 12.528C3.28647 13.488 3.74247 14.304 4.28647 14.976C4.84647 15.632 5.43847 15.96 6.06247 15.96C6.46247 15.96 6.82247 15.832 7.14247 15.576C7.46247 15.32 7.62247 14.936 7.62247 14.424C7.62247 13.896 7.42247 13.408 7.02247 12.96C6.62247 12.512 6.08647 12.056 5.41447 11.592C4.74247 11.128 4.22247 10.752 3.85447 10.464C3.48647 10.16 3.07847 9.776 2.63047 9.312C1.78247 8.416 1.35847 7.272 1.35847 5.88C1.35847 4.472 1.84647 3.296 2.82247 2.352C3.79847 1.392 4.95847 0.912 6.30247 0.912C7.64647 0.912 8.77447 1.432 9.68647 2.472C10.6145 3.512 11.0785 4.584 11.0785 5.688C11.0785 6.776 10.8705 7.712 10.4545 8.496L7.47847 7.512ZM13.2771 18.408C13.2131 16.6 13.1811 14.432 13.1811 11.904C13.1811 9.36 13.2611 5.968 13.4211 1.728C14.7651 1.232 16.1411 0.983999 17.5491 0.983999C18.9731 0.983999 20.2371 1.512 21.3411 2.568C22.4611 3.608 23.0211 4.928 23.0211 6.528C23.0211 8.112 22.4131 9.488 21.1971 10.656C19.9971 11.808 18.4211 12.656 16.4691 13.2C16.4691 14.992 16.4931 16.832 16.5411 18.72L13.2771 18.408ZM18.8451 8.952C19.4371 8.264 19.7331 7.496 19.7331 6.648C19.7331 5.8 19.5091 5.112 19.0611 4.584C18.6291 4.056 18.1411 3.792 17.5971 3.792C17.4531 3.792 17.1251 3.832 16.6131 3.912C16.5331 6.168 16.4851 8.352 16.4691 10.464C17.4771 10.144 18.2691 9.64 18.8451 8.952ZM28.3693 1.392C28.2253 3.92 28.1533 6.768 28.1533 9.936C28.1533 13.104 28.2573 15.992 28.4653 18.6L25.2253 18.312C25.0173 15.048 24.9133 12.104 24.9133 9.48C24.9133 6.84 24.9853 4.048 25.1293 1.104L28.3693 1.392ZM41.7148 1.104L41.7388 12.264C41.7388 14.104 41.6748 16.08 41.5468 18.192L38.8588 17.928C36.7948 13.24 35.1068 9.728 33.7948 7.392C33.8108 9.76 33.8188 13.536 33.8188 18.72L31.0108 18.408C30.9628 17.416 30.9388 16.456 30.9388 15.528C30.9388 11.656 31.1548 7.144 31.5868 1.992L34.7788 2.304C36.3628 6.672 37.7868 9.992 39.0508 12.264C38.9548 7.432 38.8428 3.624 38.7148 0.839999L41.7148 1.104Z' fill='white'/%3e%3c/svg%3e";

    var img$4 = "data:image/svg+xml,%3csvg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_4318_394)'%3e%3cpath d='M59.9924 30C43.5289 30 30.1875 43.3414 30.1875 59.8049C30.1875 76.2684 43.5289 89.6097 59.9924 89.6097C76.4559 89.6097 89.7972 76.2684 89.7972 59.8049C89.7972 43.3414 76.4559 30 59.9924 30Z' fill='url(%23paint0_linear_4318_394)'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_4318_394' x='0.1875' y='0' width='119.61' height='119.61' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='15'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4318_394'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4318_394' result='shape'/%3e%3c/filter%3e%3clinearGradient id='paint0_linear_4318_394' x1='48.9996' y1='102.5' x2='74.9996' y2='24.5' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0.0604165' stop-color='%23FFB915'/%3e%3cstop offset='0.2375' stop-color='%23C48A02'/%3e%3cstop offset='0.477083' stop-color='%23FFE067'/%3e%3cstop offset='0.721875' stop-color='%23FFB915'/%3e%3cstop offset='1' stop-color='%23FFF100'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

    var img$3 = "data:image/svg+xml,%3csvg width='42' height='46' viewBox='0 0 42 46' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_4318_419)'%3e%3cpath d='M21 38.0002L8.00962 8.00025L33.9904 8.00025L21 38.0002Z' fill='url(%23paint0_linear_4318_419)'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_4318_419' x='0.00976562' y='0.000244141' width='41.9805' height='46' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='4'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4318_419'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4318_419' result='shape'/%3e%3c/filter%3e%3clinearGradient id='paint0_linear_4318_419' x1='27.7905' y1='-3.26818' x2='6.23495' y2='34.4541' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0.0604165' stop-color='%23FFB915'/%3e%3cstop offset='0.2375' stop-color='%23C48A02'/%3e%3cstop offset='0.477083' stop-color='%23FFE067'/%3e%3cstop offset='0.721875' stop-color='%23FFB915'/%3e%3cstop offset='1' stop-color='%23FFF100'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

    var img$2 = "data:image/svg+xml,%3csvg width='48' height='63' viewBox='0 0 48 63' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_4318_464)'%3e%3cpath d='M24 55L8 29.0689L18.6577 29.0689L16.35 8L24 8L31.65 8L29.3423 29.0689L40 29.0689L24 55Z' fill='url(%23paint0_linear_4318_464)'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_4318_464' x='0' y='0' width='48' height='63' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='4'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4318_464'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4318_464' result='shape'/%3e%3c/filter%3e%3clinearGradient id='paint0_linear_4318_464' x1='23.9916' y1='8.77629' x2='23.9916' y2='47.4768' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23FEDC31'/%3e%3cstop offset='0.09' stop-color='%23FDC347'/%3e%3cstop offset='0.27' stop-color='%23FC8682'/%3e%3cstop offset='0.52' stop-color='%23FA2CD7'/%3e%3cstop offset='0.76' stop-color='%23987CDB'/%3e%3cstop offset='1' stop-color='%2333D0E0'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

    var img$1 = "data:image/svg+xml,%3csvg width='88' height='98' viewBox='0 0 88 98' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg filter='url(%23filter0_d_4318_567)'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M50.0901 20.5482L44.0001 10L37.9118 20.5453C22.1424 23.4087 10.188 37.2083 10.188 53.8049C10.188 72.4775 25.3202 87.6097 43.9928 87.6097C62.6655 87.6097 77.7977 72.4775 77.7977 53.8049C77.7977 37.214 65.8515 23.4181 50.0901 20.5482ZM43.9928 24C27.5293 24 14.188 37.3414 14.188 53.8049C14.188 70.2684 27.5293 83.6097 43.9928 83.6097C60.4564 83.6097 73.7977 70.2684 73.7977 53.8049C73.7977 37.3414 60.4564 24 43.9928 24Z' fill='url(%23paint0_linear_4318_567)'/%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_4318_567' x='0.187988' y='0' width='87.6099' height='97.6099' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset/%3e%3cfeGaussianBlur stdDeviation='5'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_4318_567'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_4318_567' result='shape'/%3e%3c/filter%3e%3clinearGradient id='paint0_linear_4318_567' x1='28.6893' y1='90.0708' x2='67.1459' y2='11.9006' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0.0604165' stop-color='%23FFB915'/%3e%3cstop offset='0.2375' stop-color='%23C48A02'/%3e%3cstop offset='0.477083' stop-color='%23FFE067'/%3e%3cstop offset='0.721875' stop-color='%23FFB915'/%3e%3cstop offset='1' stop-color='%23FFF100'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

    var img = "data:image/svg+xml,%3csvg width='28' height='24' viewBox='0 0 28 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M14 0L27.8564 24H0.143594L14 0Z' fill='url(%23paint0_linear_4318_563)'/%3e%3cdefs%3e%3clinearGradient id='paint0_linear_4318_563' x1='6.75676' y1='33.0147' x2='21.251' y2='-0.805239' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0.0604165' stop-color='%23FFB915'/%3e%3cstop offset='0.2375' stop-color='%23C48A02'/%3e%3cstop offset='0.477083' stop-color='%23FFE067'/%3e%3cstop offset='0.721875' stop-color='%23FFB915'/%3e%3cstop offset='1' stop-color='%23FFF100'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";

    const getSymmetricalPointFromScalar = (length) => ({
        x: length,
        y: length
    });
    const getPointOnCircle = (radius, angle, center) => {
        const centerPoint = getSymmetricalPointFromScalar(center);
        return {
            x: centerPoint.x + radius * Math.cos(angle),
            y: centerPoint.y + radius * Math.sin(angle)
        };
    };
    const getPoint = (num, length, r, rCenter) => {
        const arc = 360 / length;
        const psai = Math.PI / 180 * (-90 + arc * (num - 1 / 2));
        const rCenterPoint = getSymmetricalPointFromScalar(rCenter);
        const rPoint = getSymmetricalPointFromScalar(r);
        return {
            x: rCenterPoint.x + rPoint.x * Math.cos(psai),
            y: rCenterPoint.y + rPoint.y * Math.sin(psai)
        };
    };
    const getPointWithNext = (num, length, r1, r2) => {
        const getPointx = (num) => getPoint(num, length, r1, r2);
        return {
            point: getPointx(num),
            pointNext: getPointx(num + 1)
        };
    };
    const getTrianglePointsY = (height, isPointUp, yBase) => {
        return {
            y1: yBase,
            y2: isPointUp ? yBase - height : yBase + height,
            y3: yBase
        };
    };
    const getTwoPointsOfLineGradient = (radius, index, length, angle) => ({
        x1: radius,
        y1: radius,
        x2: radius * (1 + Math.cos(2 * Math.PI / length * index + angle)),
        y2: radius * (1 + Math.sin(2 * Math.PI / length * index + angle)),
    });
    const getTrianglePoints = (center, width, height, arrowMode, rCircleCenter) => {
        const pointCenter = getSymmetricalPointFromScalar(center);
        const getYAxisMatrix = () => {
            switch (arrowMode) {
                case ArrowMode.DownFromTop: return getTrianglePointsY(height, false, 0);
                case ArrowMode.DownFromCenter: return getTrianglePointsY(height, false, pointCenter.y + rCircleCenter);
                case ArrowMode.UpFromCenter: return getTrianglePointsY(height, true, pointCenter.y - rCircleCenter);
                case ArrowMode.UpFromBottom: return getTrianglePointsY(height, true, pointCenter.y * 2);
            }
        };
        const { y1, y2, y3 } = getYAxisMatrix();
        const points = [
            {
                x: pointCenter.x - width / 2,
                y: y1
            },
            {
                x: pointCenter.x,
                y: y2,
            },
            {
                x: pointCenter.x + width / 2,
                y: y3
            }
        ];
        const pointsValue = points.map(point => Object.keys(point).map(key => point[key]).join(' ')).join(', ');
        return pointsValue;
    };
    const getPartitionProps = (index, number, rRingInner, r) => {
        const rPoint = getSymmetricalPointFromScalar(r);
        const rRingInnerPoint = getSymmetricalPointFromScalar(rRingInner);
        const { point, pointNext } = getPointWithNext(index, number, rRingInner, r);
        const ds = [
            `M`,
            ...mapObjectValueToTuple(rPoint),
            `L`,
            ...mapObjectValueToTuple(point),
            `A`,
            ...mapObjectValueToTuple(rRingInnerPoint),
            `0 0 1`,
            ...mapObjectValueToTuple(pointNext),
            `Z`,
        ];
        return {
            d: ds.join(' ')
        };
    };
    const getRingImageProps = (index, length, rRingOuter, rRingInner, center, ratio) => {
        const aver = (rRingOuter + rRingInner) / 2;
        const diff = (rRingOuter - rRingInner) / 2 + 4 * ratio;
        const { point } = getPointWithNext(index, length, aver, center);
        const radius = diff * 2;
        return {
            x: point.x - diff,
            y: point.y - diff,
            width: radius,
            height: radius,
            // style: `stroke-width: ${radius * ratioGoldenMean(6)}px`,
            class: "RingImage",
            part: "RingImage",
        };
    };
    const getImageProps = (length, radius, center) => {
        const multiple = 1;
        const size = {
            width: multiple * 2 * radius * Math.sin(2 * Math.PI / length / 2),
            height: multiple * radius,
        };
        return Object.assign(Object.assign({ x: center, y: center }, size), { style: `transform: translate(${[
            size.width / 2,
            size.height
            // * (1 - 168/197)
        ].map(s => `${s * -1}px`).join(',')})` });
    };
    const angleTransform = (pointermode, arrowmode) => {
        switch (pointermode) {
            case PointerMode.Arrow:
                switch (arrowmode) {
                    case ArrowMode.DownFromTop:
                    case ArrowMode.UpFromCenter:
                        return -Math.PI / 2;
                    case ArrowMode.DownFromCenter:
                    case ArrowMode.UpFromBottom:
                        return Math.PI / 2;
                }
            case PointerMode.Partition:
                return -Math.PI / 2;
        }
    };
    var RotateDirection;
    (function (RotateDirection) {
        RotateDirection[RotateDirection["clockwise"] = 1] = "clockwise";
        RotateDirection[RotateDirection["anticlockwise"] = -1] = "anticlockwise";
    })(RotateDirection || (RotateDirection = {}));
    const pointMinus = (point1, point2) => ({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });
    const pointPlus = (point1, point2) => ({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
    const getPropsCommonTransform = (ratio, index, length, point, offset, direction) => {
        const angleSelf = 360 * index / length * direction - 90;
        const transformOrigin = pointPlus(point, offset);
        return {
            style: [
                `font-size: ${13 * ratio}px`,
                `transform: rotate(${angleSelf}deg)`,
                `transform-origin: ${transformOrigin.x}px ${transformOrigin.y}px`,
            ].join(';')
        };
    };
    const getPropsForPartitionInfo = (ratio, radius, center, index, length, pointermode, arrowmode, offset) => {
        const direction = RotateDirection.clockwise;
        const angle = angleTransform(pointermode, arrowmode) +
            direction * index * 2 * Math.PI / length;
        const point = getPointOnCircle(radius - 9 * ratio, angle, center + offset.center);
        return Object.assign(Object.assign({}, pointMinus(point, offset.position)), (pointermode === PointerMode.Arrow || true ?
            getPropsCommonTransform(ratio, index, length, point, offset.transform, direction)
            :
                {}));
    };

    const getSvgImageProps = (ratio, index, radius, center, length, pointermode, arrowmode) => {
        const sizeImage = radius / 8; // this.sizeImage
        const width = sizeImage;
        const height = sizeImage;
        const offset = {
            center: -1 * sizeImage / 2,
            transform: {
                x: sizeImage / 2,
                y: sizeImage / 2,
            },
            position: {
                x: 0,
                y: 0,
            }
        };
        return Object.assign(Object.assign({}, getPropsForPartitionInfo(ratio, radius, center, index, length, pointermode, arrowmode, offset)), { width,
            height });
    };
    const getSvgTextProps = (ratio, index, radius, center, length, pointermode, arrowmode) => {
        const offset = {
            center: 0,
            position: {
                x: 0,
                y: 0
            },
            transform: {
                x: 0,
                y: 0,
            }
        };
        return Object.assign({}, getPropsForPartitionInfo(ratio, radius, center, index, length, pointermode, arrowmode, offset));
    };
    const getColorSchema = (index, length, colorSchema) => {
        return colorSchema[index % Math.ceil(length / 2)];
    };

    const partitions1 = {
        colorSchema: [
            [
                {
                    color: '#009C9C',
                    offset: 0,
                },
                {
                    color: '#002634',
                    offset: 1,
                }
            ],
            [
                {
                    color: '#AA00BF',
                    offset: 0,
                },
                {
                    color: '#3B0031',
                    offset: 1,
                }
            ],
            [
                {
                    color: '#0068CD',
                    offset: 0,
                },
                {
                    color: '#150D42',
                    offset: 1,
                }
            ],
            [
                {
                    color: '#DA005B',
                    offset: 0,
                },
                {
                    color: '#400021',
                    offset: 1,
                }
            ],
        ]
    };
    const partitions2 = {
        colorSchema: [
            [
                {
                    color: '#006666',
                    offset: 0,
                },
                {
                    color: '#007F76',
                    offset: 0.13,
                },
                {
                    color: '#00B59B',
                    offset: 0.42,
                },
                {
                    color: '#00DDB5',
                    offset: 0.67,
                },
                {
                    color: '#00F6C6',
                    offset: 0.88,
                },
                {
                    color: '#00FFCC',
                    offset: 1,
                }
            ],
            [
                {
                    color: '#580065',
                    offset: 0.23,
                },
                {
                    color: '#D453FF',
                    offset: 0.91,
                }
            ],
            [
                {
                    color: '#FFE767',
                    offset: 0,
                },
                {
                    color: '#F28F00',
                    offset: 1,
                }
            ],
            [
                {
                    color: '#900A42',
                    offset: 1 / 100 * 22.59,
                },
                {
                    color: '#960A44',
                    offset: 1 / 100 * 23.94,
                },
                {
                    color: '#B60B53',
                    offset: 1 / 100 * 31.36,
                },
                {
                    color: '#D00C5E',
                    offset: 1 / 100 * 39.45,
                },
                {
                    color: '#E40D67',
                    offset: 1 / 100 * 48.22,
                },
                {
                    color: '#F30D6E',
                    offset: 1 / 100 * 57.66,
                },
                {
                    color: '#FB0D71',
                    offset: 1 / 100 * 69.8,
                },
                {
                    color: '#FE0E73',
                    offset: 1 / 100 * 90.03,
                },
            ]
        ]
    };
    const partitions3 = {
        colorSchema: [
            [
                {
                    color: '#3B0031',
                    offset: 0,
                },
                {
                    color: '#7E008E',
                    offset: 1,
                },
            ],
            [
                {
                    color: '#5A005F',
                    offset: 0,
                },
                {
                    color: '#EA53FF',
                    offset: 1,
                }
            ],
            [
                {
                    color: '#B300C3',
                    offset: 0,
                },
                {
                    color: '#4D003B',
                    offset: 1,
                }
            ],
            [
                {
                    color: '#59007B',
                    offset: 0,
                },
                {
                    color: '#B753FF',
                    offset: 1,
                },
            ]
        ]
    };

    const sizeSchema1 = {
        radius: 247,
        rRingInner: 253,
        rRingOuter: 294,
        rBg1: 300,
    };
    const sizeSchema2 = {
        radius: 253,
        rRingInner: 259,
        rRingOuter: 280,
        rBg1: 286,
    };
    const backgroundSchema1 = {
        isShowingBulb: false,
        base: {
            linearGradient: {
                steps: [
                    {
                        offset: 0,
                        color: '#FFB915',
                    },
                    {
                        offset: 0.24,
                        color: '#BF8500',
                    },
                    {
                        offset: 0.41,
                        color: '#FFE26A',
                    },
                    {
                        offset: 0.46,
                        color: '#FFDD63',
                    },
                    {
                        offset: 0.53,
                        color: '#FFCF51',
                    },
                    {
                        offset: 0.58,
                        color: '#FFC13F',
                    },
                    {
                        offset: 0.82,
                        color: '#FFB915',
                    },
                    {
                        offset: 1,
                        color: '#FFF100',
                    },
                ]
            }
        },
        small: {
            linearGradient: {
                steps: [
                    {
                        offset: 0.4,
                        color: "#303030",
                    },
                    {
                        offset: 1,
                        color: "#000604",
                    },
                ]
            }
        }
    };
    const backgroundSchema2 = {
        isShowingBulb: true,
        base: {
            linearGradient: {
                steps: [
                    {
                        offset: "0.00312487",
                        color: "#454545",
                    },
                    {
                        offset: "0.310417",
                    },
                    {
                        offset: "0.628125",
                        color: "#575757",
                    },
                    {
                        offset: "1",
                    },
                ]
            }
        },
        small: {
            linearGradient: {
                steps: [
                    {
                        offset: "0.0604165",
                        color: "#FFB915",
                    },
                    {
                        offset: "0.2375",
                        color: "#B6820A",
                    },
                    {
                        offset: "0.477083",
                        color: "#FFE685",
                    },
                    {
                        offset: "0.721875",
                        color: "#FFB915",
                    },
                    {
                        offset: "1",
                        color: "#FFD600",
                    },
                ]
            }
        }
    };
    const backgroundSchema3 = {
        isShowingBulb: false,
        base: {
            linearGradient: {
                steps: [
                    {
                        offset: 0,
                        color: '#FEDC31',
                    },
                    {
                        offset: 0.09,
                        color: '#FDC347',
                    },
                    {
                        offset: 0.27,
                        color: '#FC8682',
                    },
                    {
                        offset: 0.52,
                        color: '#FA2CD7',
                    },
                    {
                        offset: 0.76,
                        color: '#987CDB',
                    },
                    {
                        offset: 1,
                        color: '#33D0E0',
                    },
                ]
            }
        },
        small: {
            linearGradient: {
                steps: [
                    {
                        offset: 0.4,
                        color: "#303030",
                    },
                    {
                        offset: 1,
                        color: "#000604",
                    },
                ]
            }
        }
    };
    const themes = [
        {
            size: sizeSchema1,
            background: backgroundSchema1,
            partitions: partitions1,
        },
        {
            size: sizeSchema2,
            background: backgroundSchema2,
            partitions: partitions1,
        },
        {
            size: sizeSchema1,
            background: backgroundSchema3,
            partitions: partitions2,
        },
        {
            size: sizeSchema1,
            background: backgroundSchema1,
            partitions: partitions3,
        },
        {
            size: sizeSchema1,
            background: backgroundSchema1,
            partitions: partitions3,
        },
        {
            size: sizeSchema2,
            background: backgroundSchema2,
            partitions: partitions3,
        },
    ];

    const renderSvgImageProps = (center, href, size, offset = { x: 0, y: 0 }) => ({
        x: center - size.width / 2 - offset.x,
        y: center - size.height / 2 - offset.y,
        width: size.width,
        height: size.height,
        href,
    });

    var SpinStep;
    (function (SpinStep) {
        SpinStep["launch"] = "launch";
        SpinStep["loop"] = "loop";
        SpinStep["halt"] = "halt";
    })(SpinStep || (SpinStep = {}));
    var Easing;
    (function (Easing) {
        Easing["quad"] = "quad";
        Easing["cubic"] = "cubic";
        Easing["quart"] = "quart";
        Easing["quint"] = "quint";
        // 
        Easing["expo"] = "expo";
        Easing["sine"] = "sine";
        Easing["circ"] = "circ";
    })(Easing || (Easing = {}));
    const easing = {
        in: {
            quad: (x) => Math.pow(x, 2),
            cubic: (x) => Math.pow(x, 3),
            quart: (x) => Math.pow(x, 4),
            quint: (x) => Math.pow(x, 5),
            //
            sine: (x) => 1 - Math.cos((x * Math.PI) / 2),
            expo: (x) => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
            circ: (x) => 1 - Math.sqrt(1 - Math.pow(x, 2)),
        },
        out: {
            quad: (x) => 1 - Math.pow(1 - x, 2),
            cubic: (x) => 1 - Math.pow(1 - x, 3),
            quart: (x) => 1 - Math.pow(1 - x, 4),
            quint: (x) => 1 - Math.pow(1 - x, 5),
            //
            sine: (x) => Math.sin((x * Math.PI) / 2),
            expo: (x) => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
            circ: (x) => Math.sqrt(1 - Math.pow(x - 1, 2)),
        }
    };
    const easingGrad = {
        quad: 2,
        cubic: 3,
        quart: 4,
        quint: 5,
        sine: Math.PI / 2,
        expo: Math.LN2,
        circ: Infinity,
    };
    const easingGradX = {
        in: {
            quad: (x) => 2 * x,
            cubic: (x) => 3 * x ** 2,
            quart: (x) => 4 * x ** 3,
            quint: (x) => 5 * x ** 4,
            sine: (x) => Math.PI / 2 * Math.sin(Math.PI / 2 * x),
            expo: (x) => Math.LN2 * 10 * 2 ** (10 * x - 10),
            circ: (x) => -1 / 2 * (1 - x ** 2) ** (-1 / 2),
        },
        out: {
            cubic: (x) => 3 * x ** 2 - 6 * x + 3,
        }
    };
    const params = [
        // basic
        {
            launchTurns: 5,
            launchSpeed: 0.2,
            loopSpeed: 15,
            haltTurns: 2,
            haltSpeed: 0.16,
        },
        // faster
        {
            launchTurns: 2,
            launchSpeed: 0.5,
            loopSpeed: 20,
            haltTurns: 2,
            haltSpeed: 0.22,
        },
        // faster with more turns
        {
            launchTurns: 6,
            launchSpeed: 1.38,
            loopSpeed: 60,
            haltTurns: 6,
            haltSpeed: 0.50,
        },
    ];

    class Spinner {
        constructor() {
            this.deg = 0;
            // spinable: boolean = true
            this.degTarget = undefined;
            this.container = undefined;
            this.step = undefined;
            this.easingType = Easing.cubic;
            this.param = params[2];
            this.halt = (deg, cb = () => { }) => {
                this.shouldHalt = () => {
                    this.step = SpinStep.halt;
                    this.cb = () => {
                        cb();
                        this.setDeg(deg, 0);
                    };
                    this.degTarget = deg + 360 * this.param.haltTurns;
                    this.continueRepeat();
                };
            };
            this.continueRepeat = () => requestAnimationFrame(this.ticker);
            this.ticker = () => {
                const linkSpeed = this.param.loopSpeed;
                const easingDuration = (deg) => 30 * easingGrad[this.easingType] * deg / this.param.loopSpeed;
                const animations = {
                    launch: () => {
                        const t = easingDuration(360 * this.param.launchTurns - this.deg);
                        this.animate(t, this.deg, 360 * this.param.launchTurns - this.deg, easing.in[this.easingType], easingGradX.in[this.easingType]);
                    },
                    halt: () => {
                        const t = easingDuration(this.degTarget);
                        this.animate(t, 0, this.degTarget, easing.out[this.easingType], easingGradX.out[this.easingType]);
                    },
                    loop: () => {
                        this.setDeg((this.deg + linkSpeed) % 360, easingGrad[this.easingType]);
                        this.continueRepeat();
                    }
                };
                const stepSwitcher = {
                    [SpinStep.launch]: () => {
                        this.cb = () => {
                            this.step = SpinStep.loop;
                            this.setDeg(linkSpeed, easingGrad[this.easingType]);
                            this.continueRepeat();
                        };
                        animations.launch();
                    },
                    [SpinStep.loop]: () => {
                        if (this.shouldHalt && this.deg === 0) {
                            this.shouldHalt();
                        }
                        else {
                            animations.loop();
                        }
                    },
                    [SpinStep.halt]: () => {
                        if (this.deg === 360 - linkSpeed) {
                            animations.halt();
                        }
                        else {
                            animations.loop();
                        }
                    }
                };
                stepSwitcher[this.step]();
                // switch(this.step){
                //   case SpinStep.launch:
                //     break
                //   case SpinStep.loop:
                //     if(this.shouldHalt && this.deg === 0){
                //       this.shouldHalt()
                //     }else{
                //       this.setDeg((this.deg + linkSpeed) % 360, easingGrad[this.easingType])
                //       this.continueRepeat()
                //     }
                //     break
                //   case SpinStep.halt:
                //     if(this.deg === 360 - linkSpeed){
                //       const t = 30 * easingGrad[this.easingType] * this.degTarget / this.param.loopSpeed
                //       this.animate(t, 0, this.degTarget, easing.out[this.easingType], easingGradX.out[this.easingType])
                //     }else{
                //       this.setDeg((this.deg + linkSpeed) % 360, easingGrad[this.easingType])
                //       this.continueRepeat()
                //     }
                //     break
                // }
            };
            this.setDeg = (deg, speed) => {
                this.deg = deg;
                this.tick(deg, speed);
            };
            this.animate = (duration, startAngle, target, easing, _easingGrad) => {
                let animationId = null;
                window.cancelAnimationFrame(animationId);
                let start = null;
                const step = (timestamp) => {
                    if (!start) {
                        start = timestamp;
                    }
                    const progress = timestamp - start;
                    const translation = target * easing(progress / duration) + startAngle;
                    const speedCur = Math.abs(_easingGrad(progress / duration));
                    this.setDeg(translation, speedCur);
                    if (progress < duration) {
                        animationId = window.requestAnimationFrame(step);
                    }
                    else {
                        this.cb();
                    }
                };
                animationId = window.requestAnimationFrame(step);
            };
        }
        launch() {
            this.shouldHalt = undefined;
            this.step = SpinStep.launch;
            this.ticker();
        }
    }

    /* src/private.item.svg.svelte generated by Svelte v3.48.0 */

    const { Error: Error_1 } = globals;
    const file$2 = "src/private.item.svg.svelte";

    function get_each_context$1(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[42] = list[i];
    	child_ctx[44] = i;
    	return child_ctx;
    }

    function get_each_context_1(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[42] = list[i];
    	child_ctx[44] = i;
    	return child_ctx;
    }

    function get_each_context_2(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[42] = list[i];
    	child_ctx[44] = i;
    	return child_ctx;
    }

    function get_each_context_3(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[47] = list[i];
    	return child_ctx;
    }

    function get_each_context_4(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[50] = list[i];
    	child_ctx[44] = i;
    	return child_ctx;
    }

    function get_each_context_5(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[50] = list[i];
    	child_ctx[44] = i;
    	return child_ctx;
    }

    // (213:0) {#if size}
    function create_if_block$2(ctx) {
    	let svg_1;
    	let defs0;
    	let filter0;
    	let feFlood;
    	let feColorMatrix0;
    	let feOffset;
    	let feGaussianBlur0;
    	let feComposite;
    	let feColorMatrix1;
    	let feBlend0;
    	let feBlend1;
    	let g0;
    	let defs1;
    	let linearGradient0;
    	let circle0;
    	let defs2;
    	let linearGradient1;
    	let circle1;
    	let circle2;
    	let g3;
    	let g1;
    	let defs3;
    	let linearGradient2;
    	let stop0;
    	let stop1;
    	let stop2;
    	let stop3;
    	let g2;
    	let defs4;
    	let filter1;
    	let feGaussianBlur1;
    	let feGaussianBlur1_stdDeviation_value;
    	let image;
    	let g5;
    	let defs5;
    	let linearGradient3;
    	let stop4;
    	let stop5;
    	let g4;
    	let circle3;
    	let if_block1_anchor;
    	let if_block2_anchor;
    	let if_block3_anchor;
    	let if_block4_anchor;
    	let if_block6_anchor;
    	let svg_1_style_value;
    	let mounted;
    	let dispose;

    	let filter0_levels = [
    		{
    			width: /*size*/ ctx[1],
    			height: /*size*/ ctx[1],
    			x: 0,
    			y: 0
    		},
    		{ id: "BgHalo" },
    		{ filterUnits: "userSpaceOnUse" },
    		{ "color-interpolation-filters": "sRGB" }
    	];

    	let filter0_data = {};

    	for (let i = 0; i < filter0_levels.length; i += 1) {
    		filter0_data = assign(filter0_data, filter0_levels[i]);
    	}

    	let each_value_5 = /*theme*/ ctx[3].background.base.linearGradient.steps;
    	validate_each_argument(each_value_5);
    	let each_blocks_3 = [];

    	for (let i = 0; i < each_value_5.length; i += 1) {
    		each_blocks_3[i] = create_each_block_5(get_each_context_5(ctx, each_value_5, i));
    	}

    	let linearGradient0_levels = [
    		{
    			id: "BgRingBaseLinearGradient",
    			gradientTransform: "rotate(0)",
    			gradientUnits: "userSpaceOnUse"
    		}
    	];

    	let linearGradient0_data = {};

    	for (let i = 0; i < linearGradient0_levels.length; i += 1) {
    		linearGradient0_data = assign(linearGradient0_data, linearGradient0_levels[i]);
    	}

    	let circle0_levels = [
    		{
    			fill: `url(#BgRingBaseLinearGradient)`,
    			cx: /*center*/ ctx[5],
    			cy: /*center*/ ctx[5],
    			r: /*theme*/ ctx[3].size.rBg1 / 2 * /*ratio*/ ctx[2],
    			style: `transform-origin: ${/*center*/ ctx[5]}px ${/*center*/ ctx[5]}px; transform: rotate(135deg)`
    		}
    	];

    	let circle0_data = {};

    	for (let i = 0; i < circle0_levels.length; i += 1) {
    		circle0_data = assign(circle0_data, circle0_levels[i]);
    	}

    	let each_value_4 = /*theme*/ ctx[3].background.small.linearGradient.steps;
    	validate_each_argument(each_value_4);
    	let each_blocks_2 = [];

    	for (let i = 0; i < each_value_4.length; i += 1) {
    		each_blocks_2[i] = create_each_block_4(get_each_context_4(ctx, each_value_4, i));
    	}

    	let linearGradient1_levels = [
    		{
    			id: "BgRingSmallLinearGradient",
    			gradientTransform: "rotate(0)",
    			radientUnits: "userSpaceOnUse"
    		}
    	];

    	let linearGradient1_data = {};

    	for (let i = 0; i < linearGradient1_levels.length; i += 1) {
    		linearGradient1_data = assign(linearGradient1_data, linearGradient1_levels[i]);
    	}

    	let circle1_levels = [
    		{
    			fill: `url(#BgRingSmallLinearGradient)`,
    			cx: /*center*/ ctx[5],
    			cy: /*center*/ ctx[5],
    			r: /*rRingOuter*/ ctx[14]
    		}
    	];

    	let circle1_data = {};

    	for (let i = 0; i < circle1_levels.length; i += 1) {
    		circle1_data = assign(circle1_data, circle1_levels[i]);
    	}

    	let circle2_levels = [
    		{
    			fill: `url(#BgRingBaseLinearGradient)`,
    			cx: /*center*/ ctx[5],
    			cy: /*center*/ ctx[5],
    			r: /*rRingInner*/ ctx[15],
    			style: `transform-origin: ${/*center*/ ctx[5]}px ${/*center*/ ctx[5]}px; transform: rotate(45deg)`
    		}
    	];

    	let circle2_data = {};

    	for (let i = 0; i < circle2_levels.length; i += 1) {
    		circle2_data = assign(circle2_data, circle2_levels[i]);
    	}

    	let g0_levels = [classWithPart("BackgroundCircleGroup"), { filter: "url(#BgHalo)" }];
    	let g0_data = {};

    	for (let i = 0; i < g0_levels.length; i += 1) {
    		g0_data = assign(g0_data, g0_levels[i]);
    	}

    	let linearGradient2_levels = [
    		{ id: "LGPartitionStroke" },
    		{ gradientUnits: "userSpaceOnUse" },
    		{ gradientTransform: "rotate(45)" }
    	];

    	let linearGradient2_data = {};

    	for (let i = 0; i < linearGradient2_levels.length; i += 1) {
    		linearGradient2_data = assign(linearGradient2_data, linearGradient2_levels[i]);
    	}

    	let each_value_2 = /*options*/ ctx[7];
    	validate_each_argument(each_value_2);
    	let each_blocks_1 = [];

    	for (let i = 0; i < each_value_2.length; i += 1) {
    		each_blocks_1[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
    	}

    	let g1_levels = [classWithPart("PartitionsBackground")];
    	let g1_data = {};

    	for (let i = 0; i < g1_levels.length; i += 1) {
    		g1_data = assign(g1_data, g1_levels[i]);
    	}

    	let each_value_1 = /*options*/ ctx[7];
    	validate_each_argument(each_value_1);
    	let each_blocks = [];

    	for (let i = 0; i < each_value_1.length; i += 1) {
    		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
    	}

    	let image_levels = [
    		{
    			...classWithPart("PartitionShadow"),
    			...renderSvgImageProps(/*center*/ ctx[5], img$7, {
    				width: (/*rRingInner*/ ctx[15] - 3.2 * /*ratio*/ ctx[2]) * 2,
    				height: (/*rRingInner*/ ctx[15] - 3.2 * /*ratio*/ ctx[2]) * 2
    			})
    		}
    	];

    	let image_data = {};

    	for (let i = 0; i < image_levels.length; i += 1) {
    		image_data = assign(image_data, image_levels[i]);
    	}

    	let g3_levels = [classWithPart("Partitions"), /*propsSpinner*/ ctx[17]];
    	let g3_data = {};

    	for (let i = 0; i < g3_levels.length; i += 1) {
    		g3_data = assign(g3_data, g3_levels[i]);
    	}

    	let if_block0 = /*pointermode*/ ctx[11] === PointerMode.Partition && /*options*/ ctx[7][0] && create_if_block_11(ctx);

    	let circle3_levels = [
    		{
    			fill: `url(#LGCenterCircle)`,
    			cx: /*center*/ ctx[5],
    			cy: /*center*/ ctx[5],
    			r: 66 / 2 * /*ratio*/ ctx[2]
    		}
    	];

    	let circle3_data = {};

    	for (let i = 0; i < circle3_levels.length; i += 1) {
    		circle3_data = assign(circle3_data, circle3_levels[i]);
    	}

    	let g4_levels = [{}]; // filter: "url(#FilterCenterCircle)",
    	let g4_data = {};

    	for (let i = 0; i < g4_levels.length; i += 1) {
    		g4_data = assign(g4_data, g4_levels[i]);
    	}

    	let if_block1 = (/*themeIndex*/ ctx[6] === 0 || /*themeIndex*/ ctx[6] === 3) && create_if_block_10(ctx);
    	let if_block2 = (/*themeIndex*/ ctx[6] === 0 || /*themeIndex*/ ctx[6] === 3 || /*themeIndex*/ ctx[6] === 4 || /*themeIndex*/ ctx[6] === 5) && create_if_block_9(ctx);
    	let if_block3 = (/*themeIndex*/ ctx[6] === 4 || /*themeIndex*/ ctx[6] === 5) && create_if_block_8(ctx);
    	let if_block4 = /*themeIndex*/ ctx[6] === 1 && create_if_block_7(ctx);
    	let if_block5 = /*themeIndex*/ ctx[6] === 2 && create_if_block_6(ctx);
    	let g5_levels = [classWithPart("Center", /*spinable*/ ctx[9] ? '' : 'disabled')];
    	let g5_data = {};

    	for (let i = 0; i < g5_levels.length; i += 1) {
    		g5_data = assign(g5_data, g5_levels[i]);
    	}

    	let if_block6 = /*theme*/ ctx[3].background.isShowingBulb && create_if_block_5(ctx);
    	let if_block7 = /*pointermode*/ ctx[11] === PointerMode.Arrow && create_if_block_1$2(ctx);

    	const block = {
    		c: function create() {
    			svg_1 = svg_element("svg");
    			defs0 = svg_element("defs");
    			filter0 = svg_element("filter");
    			feFlood = svg_element("feFlood");
    			feColorMatrix0 = svg_element("feColorMatrix");
    			feOffset = svg_element("feOffset");
    			feGaussianBlur0 = svg_element("feGaussianBlur");
    			feComposite = svg_element("feComposite");
    			feColorMatrix1 = svg_element("feColorMatrix");
    			feBlend0 = svg_element("feBlend");
    			feBlend1 = svg_element("feBlend");
    			g0 = svg_element("g");
    			defs1 = svg_element("defs");
    			linearGradient0 = svg_element("linearGradient");

    			for (let i = 0; i < each_blocks_3.length; i += 1) {
    				each_blocks_3[i].c();
    			}

    			circle0 = svg_element("circle");
    			defs2 = svg_element("defs");
    			linearGradient1 = svg_element("linearGradient");

    			for (let i = 0; i < each_blocks_2.length; i += 1) {
    				each_blocks_2[i].c();
    			}

    			circle1 = svg_element("circle");
    			circle2 = svg_element("circle");
    			g3 = svg_element("g");
    			g1 = svg_element("g");
    			defs3 = svg_element("defs");
    			linearGradient2 = svg_element("linearGradient");
    			stop0 = svg_element("stop");
    			stop1 = svg_element("stop");
    			stop2 = svg_element("stop");
    			stop3 = svg_element("stop");

    			for (let i = 0; i < each_blocks_1.length; i += 1) {
    				each_blocks_1[i].c();
    			}

    			g2 = svg_element("g");
    			defs4 = svg_element("defs");
    			filter1 = svg_element("filter");
    			feGaussianBlur1 = svg_element("feGaussianBlur");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			image = svg_element("image");
    			if (if_block0) if_block0.c();
    			g5 = svg_element("g");
    			defs5 = svg_element("defs");
    			linearGradient3 = svg_element("linearGradient");
    			stop4 = svg_element("stop");
    			stop5 = svg_element("stop");
    			g4 = svg_element("g");
    			circle3 = svg_element("circle");
    			if (if_block1) if_block1.c();
    			if_block1_anchor = empty();
    			if (if_block2) if_block2.c();
    			if_block2_anchor = empty();
    			if (if_block3) if_block3.c();
    			if_block3_anchor = empty();
    			if (if_block4) if_block4.c();
    			if_block4_anchor = empty();
    			if (if_block5) if_block5.c();
    			if (if_block6) if_block6.c();
    			if_block6_anchor = empty();
    			if (if_block7) if_block7.c();
    			attr_dev(feFlood, "flood-opacity", "0");
    			attr_dev(feFlood, "result", "BackgroundImageFix");
    			add_location(feFlood, file$2, 279, 6, 10183);
    			attr_dev(feColorMatrix0, "in", "SourceAlpha");
    			attr_dev(feColorMatrix0, "type", "matrix");
    			attr_dev(feColorMatrix0, "values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0");
    			attr_dev(feColorMatrix0, "result", "hardAlpha");
    			add_location(feColorMatrix0, file$2, 280, 6, 10246);
    			add_location(feOffset, file$2, 281, 6, 10370);
    			attr_dev(feGaussianBlur0, "stdDeviation", "25");
    			add_location(feGaussianBlur0, file$2, 282, 6, 10388);
    			attr_dev(feComposite, "in2", "hardAlpha");
    			attr_dev(feComposite, "operator", "out");
    			add_location(feComposite, file$2, 283, 6, 10430);
    			attr_dev(feColorMatrix1, "type", "matrix");
    			attr_dev(feColorMatrix1, "values", "0 0 0 0 1 0 0 0 0 0.972917 0 0 0 0 0.729167 0 0 0 0.5 0");
    			add_location(feColorMatrix1, file$2, 284, 6, 10482);
    			attr_dev(feBlend0, "mode", "normal");
    			attr_dev(feBlend0, "in2", "BackgroundImageFix");
    			attr_dev(feBlend0, "result", "effect1_dropShadow_4318_310");
    			add_location(feBlend0, file$2, 285, 6, 10584);
    			attr_dev(feBlend1, "mode", "normal");
    			attr_dev(feBlend1, "in", "SourceGraphic");
    			attr_dev(feBlend1, "in2", "effect1_dropShadow_4318_310");
    			attr_dev(feBlend1, "result", "shape");
    			add_location(feBlend1, file$2, 286, 6, 10677);
    			set_svg_attributes(filter0, filter0_data);
    			add_location(filter0, file$2, 270, 4, 9988);
    			add_location(defs0, file$2, 269, 2, 9977);
    			set_svg_attributes(linearGradient0, linearGradient0_data);
    			add_location(linearGradient0, file$2, 293, 6, 10891);
    			add_location(defs1, file$2, 292, 4, 10878);
    			set_svg_attributes(circle0, circle0_data);
    			add_location(circle0, file$2, 303, 4, 11239);
    			set_svg_attributes(linearGradient1, linearGradient1_data);
    			add_location(linearGradient1, file$2, 312, 6, 11485);
    			add_location(defs2, file$2, 311, 4, 11472);
    			set_svg_attributes(circle1, circle1_data);
    			add_location(circle1, file$2, 322, 4, 11833);
    			set_svg_attributes(circle2, circle2_data);
    			add_location(circle2, file$2, 329, 4, 11966);
    			set_svg_attributes(g0, g0_data);
    			add_location(g0, file$2, 290, 2, 10799);
    			attr_dev(stop0, "stop-color", "#F28F00");
    			add_location(stop0, file$2, 349, 8, 12487);
    			attr_dev(stop1, "offset", "0.27");
    			attr_dev(stop1, "stop-color", "#F5A318");
    			add_location(stop1, file$2, 350, 8, 12524);
    			attr_dev(stop2, "offset", "0.85");
    			attr_dev(stop2, "stop-color", "#FCD755");
    			add_location(stop2, file$2, 351, 8, 12575);
    			attr_dev(stop3, "offset", "1");
    			attr_dev(stop3, "stop-color", "#FFE767");
    			add_location(stop3, file$2, 352, 8, 12626);
    			set_svg_attributes(linearGradient2, linearGradient2_data);
    			add_location(linearGradient2, file$2, 342, 6, 12316);
    			add_location(defs3, file$2, 341, 6, 12303);
    			set_svg_attributes(g1, g1_data);
    			add_location(g1, file$2, 340, 4, 12250);
    			attr_dev(feGaussianBlur1, "in", "SourceGraphic");

    			attr_dev(feGaussianBlur1, "stdDeviation", feGaussianBlur1_stdDeviation_value = /*pointermode*/ ctx[11] === PointerMode.Arrow
    			? 2 * /*speed*/ ctx[12]
    			: 0);

    			add_location(feGaussianBlur1, file$2, 385, 10, 13773);
    			attr_dev(filter1, "id", "f1");
    			attr_dev(filter1, "x", "0");
    			attr_dev(filter1, "y", "0");
    			add_location(filter1, file$2, 384, 8, 13734);
    			add_location(defs4, file$2, 383, 6, 13719);
    			attr_dev(g2, "id", "Images");
    			add_location(g2, file$2, 382, 4, 13697);
    			set_svg_attributes(image, image_data);
    			add_location(image, file$2, 407, 4, 14546);
    			set_svg_attributes(g3, g3_data);
    			add_location(g3, file$2, 339, 2, 12191);
    			attr_dev(stop4, "offset", "0.28");
    			attr_dev(stop4, "stop-color", "#303030");
    			add_location(stop4, file$2, 477, 6, 17127);
    			attr_dev(stop5, "offset", "1");
    			attr_dev(stop5, "stop-color", "#000604");
    			add_location(stop5, file$2, 478, 6, 17176);
    			attr_dev(linearGradient3, "id", "LGCenterCircle");
    			attr_dev(linearGradient3, "x1", "86.7076");
    			attr_dev(linearGradient3, "y1", "35.306");
    			attr_dev(linearGradient3, "x2", "24.1663");
    			attr_dev(linearGradient3, "y2", "97.8472");
    			attr_dev(linearGradient3, "gradientUnits", "userSpaceOnUse");
    			add_location(linearGradient3, file$2, 476, 6, 17002);
    			add_location(defs5, file$2, 459, 4, 16060);
    			set_svg_attributes(circle3, circle3_data);
    			add_location(circle3, file$2, 486, 6, 17340);
    			set_svg_attributes(g4, g4_data);
    			add_location(g4, file$2, 481, 4, 17256);
    			set_svg_attributes(g5, g5_data);
    			add_location(g5, file$2, 455, 2, 15958);
    			attr_dev(svg_1, "width", /*size*/ ctx[1]);
    			attr_dev(svg_1, "height", /*size*/ ctx[1]);
    			attr_dev(svg_1, "style", svg_1_style_value = [`${/*messageShown*/ ctx[13] ? 'opacity: .3' : ''}`].join(';'));
    			add_location(svg_1, file$2, 213, 0, 6985);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, svg_1, anchor);
    			append_dev(svg_1, defs0);
    			append_dev(defs0, filter0);
    			append_dev(filter0, feFlood);
    			append_dev(filter0, feColorMatrix0);
    			append_dev(filter0, feOffset);
    			append_dev(filter0, feGaussianBlur0);
    			append_dev(filter0, feComposite);
    			append_dev(filter0, feColorMatrix1);
    			append_dev(filter0, feBlend0);
    			append_dev(filter0, feBlend1);
    			append_dev(svg_1, g0);
    			append_dev(g0, defs1);
    			append_dev(defs1, linearGradient0);

    			for (let i = 0; i < each_blocks_3.length; i += 1) {
    				each_blocks_3[i].m(linearGradient0, null);
    			}

    			append_dev(g0, circle0);
    			append_dev(g0, defs2);
    			append_dev(defs2, linearGradient1);

    			for (let i = 0; i < each_blocks_2.length; i += 1) {
    				each_blocks_2[i].m(linearGradient1, null);
    			}

    			append_dev(g0, circle1);
    			append_dev(g0, circle2);
    			append_dev(svg_1, g3);
    			append_dev(g3, g1);
    			append_dev(g1, defs3);
    			append_dev(defs3, linearGradient2);
    			append_dev(linearGradient2, stop0);
    			append_dev(linearGradient2, stop1);
    			append_dev(linearGradient2, stop2);
    			append_dev(linearGradient2, stop3);

    			for (let i = 0; i < each_blocks_1.length; i += 1) {
    				each_blocks_1[i].m(g1, null);
    			}

    			append_dev(g3, g2);
    			append_dev(g2, defs4);
    			append_dev(defs4, filter1);
    			append_dev(filter1, feGaussianBlur1);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].m(g2, null);
    			}

    			append_dev(g3, image);
    			if (if_block0) if_block0.m(svg_1, null);
    			append_dev(svg_1, g5);
    			append_dev(g5, defs5);
    			append_dev(defs5, linearGradient3);
    			append_dev(linearGradient3, stop4);
    			append_dev(linearGradient3, stop5);
    			append_dev(g5, g4);
    			append_dev(g4, circle3);
    			if (if_block1) if_block1.m(g5, null);
    			append_dev(g5, if_block1_anchor);
    			if (if_block2) if_block2.m(g5, null);
    			append_dev(g5, if_block2_anchor);
    			if (if_block3) if_block3.m(g5, null);
    			append_dev(g5, if_block3_anchor);
    			if (if_block4) if_block4.m(g5, null);
    			append_dev(g5, if_block4_anchor);
    			if (if_block5) if_block5.m(g5, null);
    			if (if_block6) if_block6.m(svg_1, null);
    			append_dev(svg_1, if_block6_anchor);
    			if (if_block7) if_block7.m(svg_1, null);
    			/*svg_1_binding*/ ctx[34](svg_1);

    			if (!mounted) {
    				dispose = listen_dev(g5, "click", /*click_handler*/ ctx[33], false, false, false);
    				mounted = true;
    			}
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(filter0, filter0_data = get_spread_update(filter0_levels, [
    				dirty[0] & /*size*/ 2 && {
    					width: /*size*/ ctx[1],
    					height: /*size*/ ctx[1],
    					x: 0,
    					y: 0
    				},
    				{ id: "BgHalo" },
    				{ filterUnits: "userSpaceOnUse" },
    				{ "color-interpolation-filters": "sRGB" }
    			]));

    			if (dirty[0] & /*theme*/ 8) {
    				each_value_5 = /*theme*/ ctx[3].background.base.linearGradient.steps;
    				validate_each_argument(each_value_5);
    				let i;

    				for (i = 0; i < each_value_5.length; i += 1) {
    					const child_ctx = get_each_context_5(ctx, each_value_5, i);

    					if (each_blocks_3[i]) {
    						each_blocks_3[i].p(child_ctx, dirty);
    					} else {
    						each_blocks_3[i] = create_each_block_5(child_ctx);
    						each_blocks_3[i].c();
    						each_blocks_3[i].m(linearGradient0, null);
    					}
    				}

    				for (; i < each_blocks_3.length; i += 1) {
    					each_blocks_3[i].d(1);
    				}

    				each_blocks_3.length = each_value_5.length;
    			}

    			set_svg_attributes(linearGradient0, linearGradient0_data = get_spread_update(linearGradient0_levels, [
    				{
    					id: "BgRingBaseLinearGradient",
    					gradientTransform: "rotate(0)",
    					gradientUnits: "userSpaceOnUse"
    				}
    			]));

    			set_svg_attributes(circle0, circle0_data = get_spread_update(circle0_levels, [
    				dirty[0] & /*center, theme, ratio*/ 44 && {
    					fill: `url(#BgRingBaseLinearGradient)`,
    					cx: /*center*/ ctx[5],
    					cy: /*center*/ ctx[5],
    					r: /*theme*/ ctx[3].size.rBg1 / 2 * /*ratio*/ ctx[2],
    					style: `transform-origin: ${/*center*/ ctx[5]}px ${/*center*/ ctx[5]}px; transform: rotate(135deg)`
    				}
    			]));

    			if (dirty[0] & /*theme*/ 8) {
    				each_value_4 = /*theme*/ ctx[3].background.small.linearGradient.steps;
    				validate_each_argument(each_value_4);
    				let i;

    				for (i = 0; i < each_value_4.length; i += 1) {
    					const child_ctx = get_each_context_4(ctx, each_value_4, i);

    					if (each_blocks_2[i]) {
    						each_blocks_2[i].p(child_ctx, dirty);
    					} else {
    						each_blocks_2[i] = create_each_block_4(child_ctx);
    						each_blocks_2[i].c();
    						each_blocks_2[i].m(linearGradient1, null);
    					}
    				}

    				for (; i < each_blocks_2.length; i += 1) {
    					each_blocks_2[i].d(1);
    				}

    				each_blocks_2.length = each_value_4.length;
    			}

    			set_svg_attributes(linearGradient1, linearGradient1_data = get_spread_update(linearGradient1_levels, [
    				{
    					id: "BgRingSmallLinearGradient",
    					gradientTransform: "rotate(0)",
    					radientUnits: "userSpaceOnUse"
    				}
    			]));

    			set_svg_attributes(circle1, circle1_data = get_spread_update(circle1_levels, [
    				dirty[0] & /*center, rRingOuter*/ 16416 && {
    					fill: `url(#BgRingSmallLinearGradient)`,
    					cx: /*center*/ ctx[5],
    					cy: /*center*/ ctx[5],
    					r: /*rRingOuter*/ ctx[14]
    				}
    			]));

    			set_svg_attributes(circle2, circle2_data = get_spread_update(circle2_levels, [
    				dirty[0] & /*center, rRingInner*/ 32800 && {
    					fill: `url(#BgRingBaseLinearGradient)`,
    					cx: /*center*/ ctx[5],
    					cy: /*center*/ ctx[5],
    					r: /*rRingInner*/ ctx[15],
    					style: `transform-origin: ${/*center*/ ctx[5]}px ${/*center*/ ctx[5]}px; transform: rotate(45deg)`
    				}
    			]));

    			set_svg_attributes(g0, g0_data = get_spread_update(g0_levels, [classWithPart("BackgroundCircleGroup"), { filter: "url(#BgHalo)" }]));

    			set_svg_attributes(linearGradient2, linearGradient2_data = get_spread_update(linearGradient2_levels, [
    				{ id: "LGPartitionStroke" },
    				{ gradientUnits: "userSpaceOnUse" },
    				{ gradientTransform: "rotate(45)" }
    			]));

    			if (dirty[0] & /*options, radius, center, themeIndex, theme*/ 248) {
    				each_value_2 = /*options*/ ctx[7];
    				validate_each_argument(each_value_2);
    				let i;

    				for (i = 0; i < each_value_2.length; i += 1) {
    					const child_ctx = get_each_context_2(ctx, each_value_2, i);

    					if (each_blocks_1[i]) {
    						each_blocks_1[i].p(child_ctx, dirty);
    					} else {
    						each_blocks_1[i] = create_each_block_2(child_ctx);
    						each_blocks_1[i].c();
    						each_blocks_1[i].m(g1, null);
    					}
    				}

    				for (; i < each_blocks_1.length; i += 1) {
    					each_blocks_1[i].d(1);
    				}

    				each_blocks_1.length = each_value_2.length;
    			}

    			set_svg_attributes(g1, g1_data = get_spread_update(g1_levels, [classWithPart("PartitionsBackground")]));

    			if (dirty[0] & /*pointermode, speed*/ 6144 && feGaussianBlur1_stdDeviation_value !== (feGaussianBlur1_stdDeviation_value = /*pointermode*/ ctx[11] === PointerMode.Arrow
    			? 2 * /*speed*/ ctx[12]
    			: 0)) {
    				attr_dev(feGaussianBlur1, "stdDeviation", feGaussianBlur1_stdDeviation_value);
    			}

    			if (dirty[0] & /*ratio, radius, center, options, pointermode, arrowmode*/ 2229) {
    				each_value_1 = /*options*/ ctx[7];
    				validate_each_argument(each_value_1);
    				let i;

    				for (i = 0; i < each_value_1.length; i += 1) {
    					const child_ctx = get_each_context_1(ctx, each_value_1, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block_1(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(g2, null);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value_1.length;
    			}

    			set_svg_attributes(image, image_data = get_spread_update(image_levels, [
    				dirty[0] & /*center, rRingInner, ratio*/ 32804 && {
    					...classWithPart("PartitionShadow"),
    					...renderSvgImageProps(/*center*/ ctx[5], img$7, {
    						width: (/*rRingInner*/ ctx[15] - 3.2 * /*ratio*/ ctx[2]) * 2,
    						height: (/*rRingInner*/ ctx[15] - 3.2 * /*ratio*/ ctx[2]) * 2
    					})
    				}
    			]));

    			set_svg_attributes(g3, g3_data = get_spread_update(g3_levels, [
    				classWithPart("Partitions"),
    				dirty[0] & /*propsSpinner*/ 131072 && /*propsSpinner*/ ctx[17]
    			]));

    			if (/*pointermode*/ ctx[11] === PointerMode.Partition && /*options*/ ctx[7][0]) {
    				if (if_block0) {
    					if_block0.p(ctx, dirty);
    				} else {
    					if_block0 = create_if_block_11(ctx);
    					if_block0.c();
    					if_block0.m(svg_1, g5);
    				}
    			} else if (if_block0) {
    				if_block0.d(1);
    				if_block0 = null;
    			}

    			set_svg_attributes(circle3, circle3_data = get_spread_update(circle3_levels, [
    				dirty[0] & /*center, ratio*/ 36 && {
    					fill: `url(#LGCenterCircle)`,
    					cx: /*center*/ ctx[5],
    					cy: /*center*/ ctx[5],
    					r: 66 / 2 * /*ratio*/ ctx[2]
    				}
    			]));

    			set_svg_attributes(g4, g4_data = get_spread_update(g4_levels, [{}])); // filter: "url(#FilterCenterCircle)",

    			if (/*themeIndex*/ ctx[6] === 0 || /*themeIndex*/ ctx[6] === 3) {
    				if (if_block1) {
    					if_block1.p(ctx, dirty);
    				} else {
    					if_block1 = create_if_block_10(ctx);
    					if_block1.c();
    					if_block1.m(g5, if_block1_anchor);
    				}
    			} else if (if_block1) {
    				if_block1.d(1);
    				if_block1 = null;
    			}

    			if (/*themeIndex*/ ctx[6] === 0 || /*themeIndex*/ ctx[6] === 3 || /*themeIndex*/ ctx[6] === 4 || /*themeIndex*/ ctx[6] === 5) {
    				if (if_block2) {
    					if_block2.p(ctx, dirty);
    				} else {
    					if_block2 = create_if_block_9(ctx);
    					if_block2.c();
    					if_block2.m(g5, if_block2_anchor);
    				}
    			} else if (if_block2) {
    				if_block2.d(1);
    				if_block2 = null;
    			}

    			if (/*themeIndex*/ ctx[6] === 4 || /*themeIndex*/ ctx[6] === 5) {
    				if (if_block3) {
    					if_block3.p(ctx, dirty);
    				} else {
    					if_block3 = create_if_block_8(ctx);
    					if_block3.c();
    					if_block3.m(g5, if_block3_anchor);
    				}
    			} else if (if_block3) {
    				if_block3.d(1);
    				if_block3 = null;
    			}

    			if (/*themeIndex*/ ctx[6] === 1) {
    				if (if_block4) {
    					if_block4.p(ctx, dirty);
    				} else {
    					if_block4 = create_if_block_7(ctx);
    					if_block4.c();
    					if_block4.m(g5, if_block4_anchor);
    				}
    			} else if (if_block4) {
    				if_block4.d(1);
    				if_block4 = null;
    			}

    			if (/*themeIndex*/ ctx[6] === 2) {
    				if (if_block5) {
    					if_block5.p(ctx, dirty);
    				} else {
    					if_block5 = create_if_block_6(ctx);
    					if_block5.c();
    					if_block5.m(g5, null);
    				}
    			} else if (if_block5) {
    				if_block5.d(1);
    				if_block5 = null;
    			}

    			set_svg_attributes(g5, g5_data = get_spread_update(g5_levels, [
    				dirty[0] & /*spinable*/ 512 && classWithPart("Center", /*spinable*/ ctx[9] ? '' : 'disabled')
    			]));

    			if (/*theme*/ ctx[3].background.isShowingBulb) {
    				if (if_block6) {
    					if_block6.p(ctx, dirty);
    				} else {
    					if_block6 = create_if_block_5(ctx);
    					if_block6.c();
    					if_block6.m(svg_1, if_block6_anchor);
    				}
    			} else if (if_block6) {
    				if_block6.d(1);
    				if_block6 = null;
    			}

    			if (/*pointermode*/ ctx[11] === PointerMode.Arrow) {
    				if (if_block7) {
    					if_block7.p(ctx, dirty);
    				} else {
    					if_block7 = create_if_block_1$2(ctx);
    					if_block7.c();
    					if_block7.m(svg_1, null);
    				}
    			} else if (if_block7) {
    				if_block7.d(1);
    				if_block7 = null;
    			}

    			if (dirty[0] & /*size*/ 2) {
    				attr_dev(svg_1, "width", /*size*/ ctx[1]);
    			}

    			if (dirty[0] & /*size*/ 2) {
    				attr_dev(svg_1, "height", /*size*/ ctx[1]);
    			}

    			if (dirty[0] & /*messageShown*/ 8192 && svg_1_style_value !== (svg_1_style_value = [`${/*messageShown*/ ctx[13] ? 'opacity: .3' : ''}`].join(';'))) {
    				attr_dev(svg_1, "style", svg_1_style_value);
    			}
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(svg_1);
    			destroy_each(each_blocks_3, detaching);
    			destroy_each(each_blocks_2, detaching);
    			destroy_each(each_blocks_1, detaching);
    			destroy_each(each_blocks, detaching);
    			if (if_block0) if_block0.d();
    			if (if_block1) if_block1.d();
    			if (if_block2) if_block2.d();
    			if (if_block3) if_block3.d();
    			if (if_block4) if_block4.d();
    			if (if_block5) if_block5.d();
    			if (if_block6) if_block6.d();
    			if (if_block7) if_block7.d();
    			/*svg_1_binding*/ ctx[34](null);
    			mounted = false;
    			dispose();
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block$2.name,
    		type: "if",
    		source: "(213:0) {#if size}",
    		ctx
    	});

    	return block;
    }

    // (299:8) {#each theme.background.base.linearGradient.steps as step, index}
    function create_each_block_5(ctx) {
    	let stop;
    	let stop_offset_value;
    	let stop_stop_color_value;

    	const block = {
    		c: function create() {
    			stop = svg_element("stop");
    			attr_dev(stop, "offset", stop_offset_value = /*step*/ ctx[50].offset);
    			attr_dev(stop, "stop-color", stop_stop_color_value = /*step*/ ctx[50].color);
    			add_location(stop, file$2, 299, 10, 11129);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, stop, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty[0] & /*theme*/ 8 && stop_offset_value !== (stop_offset_value = /*step*/ ctx[50].offset)) {
    				attr_dev(stop, "offset", stop_offset_value);
    			}

    			if (dirty[0] & /*theme*/ 8 && stop_stop_color_value !== (stop_stop_color_value = /*step*/ ctx[50].color)) {
    				attr_dev(stop, "stop-color", stop_stop_color_value);
    			}
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(stop);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block_5.name,
    		type: "each",
    		source: "(299:8) {#each theme.background.base.linearGradient.steps as step, index}",
    		ctx
    	});

    	return block;
    }

    // (318:8) {#each theme.background.small.linearGradient.steps as step, index}
    function create_each_block_4(ctx) {
    	let stop;
    	let stop_offset_value;
    	let stop_stop_color_value;

    	const block = {
    		c: function create() {
    			stop = svg_element("stop");
    			attr_dev(stop, "offset", stop_offset_value = /*step*/ ctx[50].offset);
    			attr_dev(stop, "stop-color", stop_stop_color_value = /*step*/ ctx[50].color);
    			add_location(stop, file$2, 318, 10, 11723);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, stop, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty[0] & /*theme*/ 8 && stop_offset_value !== (stop_offset_value = /*step*/ ctx[50].offset)) {
    				attr_dev(stop, "offset", stop_offset_value);
    			}

    			if (dirty[0] & /*theme*/ 8 && stop_stop_color_value !== (stop_stop_color_value = /*step*/ ctx[50].color)) {
    				attr_dev(stop, "stop-color", stop_stop_color_value);
    			}
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(stop);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block_4.name,
    		type: "each",
    		source: "(318:8) {#each theme.background.small.linearGradient.steps as step, index}",
    		ctx
    	});

    	return block;
    }

    // (364:12) {#each getColorSchema(index, options.length, theme.partitions.colorSchema) as _colorSchema}
    function create_each_block_3(ctx) {
    	let stop;
    	let stop_offset_value;
    	let stop_stop_color_value;

    	const block = {
    		c: function create() {
    			stop = svg_element("stop");
    			attr_dev(stop, "offset", stop_offset_value = /*_colorSchema*/ ctx[47].offset);
    			attr_dev(stop, "stop-color", stop_stop_color_value = /*_colorSchema*/ ctx[47].color);
    			add_location(stop, file$2, 364, 14, 13091);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, stop, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty[0] & /*options, theme*/ 136 && stop_offset_value !== (stop_offset_value = /*_colorSchema*/ ctx[47].offset)) {
    				attr_dev(stop, "offset", stop_offset_value);
    			}

    			if (dirty[0] & /*options, theme*/ 136 && stop_stop_color_value !== (stop_stop_color_value = /*_colorSchema*/ ctx[47].color)) {
    				attr_dev(stop, "stop-color", stop_stop_color_value);
    			}
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(stop);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block_3.name,
    		type: "each",
    		source: "(364:12) {#each getColorSchema(index, options.length, theme.partitions.colorSchema) as _colorSchema}",
    		ctx
    	});

    	return block;
    }

    // (356:6) {#each options as option,index}
    function create_each_block_2(ctx) {
    	let defs;
    	let linearGradient;
    	let linearGradient_id_value;
    	let path;
    	let each_value_3 = getColorSchema(/*index*/ ctx[44], /*options*/ ctx[7].length, /*theme*/ ctx[3].partitions.colorSchema);
    	validate_each_argument(each_value_3);
    	let each_blocks = [];

    	for (let i = 0; i < each_value_3.length; i += 1) {
    		each_blocks[i] = create_each_block_3(get_each_context_3(ctx, each_value_3, i));
    	}

    	let linearGradient_levels = [
    		{
    			id: linearGradient_id_value = `grad${/*index*/ ctx[44]}`
    		},
    		getTwoPointsOfLineGradient(/*center*/ ctx[5], /*index*/ ctx[44], /*options*/ ctx[7].length, -1 * Math.PI / 2),
    		{ gradientUnits: "userSpaceOnUse" }
    	];

    	let linearGradient_data = {};

    	for (let i = 0; i < linearGradient_levels.length; i += 1) {
    		linearGradient_data = assign(linearGradient_data, linearGradient_levels[i]);
    	}

    	let path_levels = [
    		{
    			...classWithPart("PartitionBackground"),
    			...getPartitionProps(/*index*/ ctx[44], /*options*/ ctx[7].length, /*radius*/ ctx[4], /*center*/ ctx[5]),
    			fill: `url(#grad${/*index*/ ctx[44]})`,
    			strokeWidth: '0.5px',
    			'stroke-dasharray': `${/*radius*/ ctx[4]} ${getArcLength(/*radius*/ ctx[4], 360 / /*options*/ ctx[7].length)}`,
    			...(/*themeIndex*/ ctx[6] === 0 || /*themeIndex*/ ctx[6]) === 1
    			? { stroke: `url(#LGPartitionStroke)` }
    			: {}
    		}
    	];

    	let path_data = {};

    	for (let i = 0; i < path_levels.length; i += 1) {
    		path_data = assign(path_data, path_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			defs = svg_element("defs");
    			linearGradient = svg_element("linearGradient");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			path = svg_element("path");
    			set_svg_attributes(linearGradient, linearGradient_data);
    			add_location(linearGradient, file$2, 358, 10, 12774);
    			add_location(defs, file$2, 357, 8, 12757);
    			set_svg_attributes(path, path_data);
    			add_location(path, file$2, 368, 8, 13233);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, defs, anchor);
    			append_dev(defs, linearGradient);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].m(linearGradient, null);
    			}

    			insert_dev(target, path, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty[0] & /*options, theme*/ 136) {
    				each_value_3 = getColorSchema(/*index*/ ctx[44], /*options*/ ctx[7].length, /*theme*/ ctx[3].partitions.colorSchema);
    				validate_each_argument(each_value_3);
    				let i;

    				for (i = 0; i < each_value_3.length; i += 1) {
    					const child_ctx = get_each_context_3(ctx, each_value_3, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block_3(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(linearGradient, null);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value_3.length;
    			}

    			set_svg_attributes(linearGradient, linearGradient_data = get_spread_update(linearGradient_levels, [
    				{ id: linearGradient_id_value },
    				dirty[0] & /*center, options*/ 160 && getTwoPointsOfLineGradient(/*center*/ ctx[5], /*index*/ ctx[44], /*options*/ ctx[7].length, -1 * Math.PI / 2),
    				{ gradientUnits: "userSpaceOnUse" }
    			]));

    			set_svg_attributes(path, path_data = get_spread_update(path_levels, [
    				dirty[0] & /*options, radius, center, themeIndex*/ 240 && {
    					...classWithPart("PartitionBackground"),
    					...getPartitionProps(/*index*/ ctx[44], /*options*/ ctx[7].length, /*radius*/ ctx[4], /*center*/ ctx[5]),
    					fill: `url(#grad${/*index*/ ctx[44]})`,
    					strokeWidth: '0.5px',
    					'stroke-dasharray': `${/*radius*/ ctx[4]} ${getArcLength(/*radius*/ ctx[4], 360 / /*options*/ ctx[7].length)}`,
    					...(/*themeIndex*/ ctx[6] === 0 || /*themeIndex*/ ctx[6]) === 1
    					? { stroke: `url(#LGPartitionStroke)` }
    					: {}
    				}
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(defs);
    			destroy_each(each_blocks, detaching);
    			if (detaching) detach_dev(path);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block_2.name,
    		type: "each",
    		source: "(356:6) {#each options as option,index}",
    		ctx
    	});

    	return block;
    }

    // (398:31) 
    function create_if_block_13(ctx) {
    	let image;

    	let image_levels = [
    		{
    			...classWithPart("PartitionImage"),
    			...getSvgImageProps(/*ratio*/ ctx[2], /*index*/ ctx[44], /*radius*/ ctx[4], /*center*/ ctx[5], /*options*/ ctx[7].length, /*pointermode*/ ctx[11], /*arrowmode*/ ctx[0])
    		}
    	];

    	let image_data = {};

    	for (let i = 0; i < image_levels.length; i += 1) {
    		image_data = assign(image_data, image_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image = svg_element("image");
    			set_svg_attributes(image, image_data);
    			add_location(image, file$2, 398, 10, 14290);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image, image_data = get_spread_update(image_levels, [
    				dirty[0] & /*ratio, radius, center, options, pointermode, arrowmode*/ 2229 && {
    					...classWithPart("PartitionImage"),
    					...getSvgImageProps(/*ratio*/ ctx[2], /*index*/ ctx[44], /*radius*/ ctx[4], /*center*/ ctx[5], /*options*/ ctx[7].length, /*pointermode*/ ctx[11], /*arrowmode*/ ctx[0])
    				}
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_13.name,
    		type: "if",
    		source: "(398:31) ",
    		ctx
    	});

    	return block;
    }

    // (391:8) {#if option.name}
    function create_if_block_12(ctx) {
    	let text_1;
    	let t_value = /*option*/ ctx[42].name + "";
    	let t;

    	let text_1_levels = [
    		{ filter: "url(#f1)" },
    		{ "dominant-baseline": "central" },
    		{
    			...classWithPart("PartitionText"),
    			...getSvgTextProps(/*ratio*/ ctx[2], /*index*/ ctx[44], /*radius*/ ctx[4], /*center*/ ctx[5], /*options*/ ctx[7].length, /*pointermode*/ ctx[11], /*arrowmode*/ ctx[0])
    		}
    	];

    	let text_1_data = {};

    	for (let i = 0; i < text_1_levels.length; i += 1) {
    		text_1_data = assign(text_1_data, text_1_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			text_1 = svg_element("text");
    			t = text(t_value);
    			set_svg_attributes(text_1, text_1_data);
    			add_location(text_1, file$2, 391, 10, 13983);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, text_1, anchor);
    			append_dev(text_1, t);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty[0] & /*options*/ 128 && t_value !== (t_value = /*option*/ ctx[42].name + "")) set_data_dev(t, t_value);

    			set_svg_attributes(text_1, text_1_data = get_spread_update(text_1_levels, [
    				{ filter: "url(#f1)" },
    				{ "dominant-baseline": "central" },
    				dirty[0] & /*ratio, radius, center, options, pointermode, arrowmode*/ 2229 && {
    					...classWithPart("PartitionText"),
    					...getSvgTextProps(/*ratio*/ ctx[2], /*index*/ ctx[44], /*radius*/ ctx[4], /*center*/ ctx[5], /*options*/ ctx[7].length, /*pointermode*/ ctx[11], /*arrowmode*/ ctx[0])
    				}
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(text_1);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_12.name,
    		type: "if",
    		source: "(391:8) {#if option.name}",
    		ctx
    	});

    	return block;
    }

    // (389:6) {#each options as option,index}
    function create_each_block_1(ctx) {
    	let if_block_anchor;

    	function select_block_type(ctx, dirty) {
    		if (/*option*/ ctx[42].name) return create_if_block_12;
    		if (/*option*/ ctx[42].image) return create_if_block_13;
    	}

    	let current_block_type = select_block_type(ctx);
    	let if_block = current_block_type && current_block_type(ctx);

    	const block = {
    		c: function create() {
    			if (if_block) if_block.c();
    			if_block_anchor = empty();
    		},
    		m: function mount(target, anchor) {
    			if (if_block) if_block.m(target, anchor);
    			insert_dev(target, if_block_anchor, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
    				if_block.p(ctx, dirty);
    			} else {
    				if (if_block) if_block.d(1);
    				if_block = current_block_type && current_block_type(ctx);

    				if (if_block) {
    					if_block.c();
    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
    				}
    			}
    		},
    		d: function destroy(detaching) {
    			if (if_block) {
    				if_block.d(detaching);
    			}

    			if (detaching) detach_dev(if_block_anchor);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block_1.name,
    		type: "each",
    		source: "(389:6) {#each options as option,index}",
    		ctx
    	});

    	return block;
    }

    // (417:2) {#if pointermode === PointerMode.Partition && options[0]}
    function create_if_block_11(ctx) {
    	let g;
    	let image0;
    	let image1;
    	let defs;
    	let linearGradient;
    	let stop0;
    	let stop1;
    	let stop2;
    	let path;

    	let image0_levels = [
    		{
    			...classWithPart("HighLightAreaBackground"),
    			href: img$b,
    			...getImageProps(/*options*/ ctx[7].length, /*radius*/ ctx[4], /*center*/ ctx[5])
    		}
    	];

    	let image0_data = {};

    	for (let i = 0; i < image0_levels.length; i += 1) {
    		image0_data = assign(image0_data, image0_levels[i]);
    	}

    	let image1_levels = [
    		{
    			...classWithPart("HighLightArea"),
    			href: img$c,
    			...getImageProps(/*options*/ ctx[7].length, /*radius*/ ctx[4], /*center*/ ctx[5])
    		}
    	];

    	let image1_data = {};

    	for (let i = 0; i < image1_levels.length; i += 1) {
    		image1_data = assign(image1_data, image1_levels[i]);
    	}

    	let path_levels = [
    		{
    			...classWithPart("PointerPartitionFrame"),
    			...getPartitionProps(0, /*options*/ ctx[7].length, /*radius*/ ctx[4], /*center*/ ctx[5]),
    			fill: `transparent`,
    			stroke: `url(#GPointerPartitionFrame)`,
    			'stroke-width': /*isShowPrizeArea*/ ctx[10] ? '3px' : '0px',
    			'stroke-dasharray': `${/*radius*/ ctx[4]} ${getArcLength(/*radius*/ ctx[4], 360 / /*options*/ ctx[7].length)}`
    		}
    	];

    	let path_data = {};

    	for (let i = 0; i < path_levels.length; i += 1) {
    		path_data = assign(path_data, path_levels[i]);
    	}

    	let g_levels = [classWithPart("Pointer"), /*propsSpinner*/ ctx[17]];
    	let g_data = {};

    	for (let i = 0; i < g_levels.length; i += 1) {
    		g_data = assign(g_data, g_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			g = svg_element("g");
    			image0 = svg_element("image");
    			image1 = svg_element("image");
    			defs = svg_element("defs");
    			linearGradient = svg_element("linearGradient");
    			stop0 = svg_element("stop");
    			stop1 = svg_element("stop");
    			stop2 = svg_element("stop");
    			path = svg_element("path");
    			set_svg_attributes(image0, image0_data);
    			add_location(image0, file$2, 418, 4, 14904);
    			set_svg_attributes(image1, image1_data);
    			add_location(image1, file$2, 425, 4, 15080);
    			attr_dev(stop0, "stop-color", "#E7A60D");
    			add_location(stop0, file$2, 436, 6, 15400);
    			attr_dev(stop1, "offset", "0.378125");
    			attr_dev(stop1, "stop-color", "#FFDD64");
    			add_location(stop1, file$2, 437, 6, 15435);
    			attr_dev(stop2, "offset", "1");
    			attr_dev(stop2, "stop-color", "#FFF100");
    			add_location(stop2, file$2, 438, 6, 15488);
    			attr_dev(linearGradient, "id", "GPointerPartitionFrame");
    			attr_dev(linearGradient, "x1", "50.7564");
    			attr_dev(linearGradient, "y1", "-9.24463");
    			attr_dev(linearGradient, "x2", "50.7564");
    			attr_dev(linearGradient, "y2", "115.67");
    			attr_dev(linearGradient, "gradientUnits", "userSpaceOnUse");
    			add_location(linearGradient, file$2, 435, 6, 15266);
    			add_location(defs, file$2, 434, 4, 15253);
    			set_svg_attributes(path, path_data);
    			add_location(path, file$2, 441, 4, 15568);
    			set_svg_attributes(g, g_data);
    			add_location(g, file$2, 417, 2, 14848);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, g, anchor);
    			append_dev(g, image0);
    			append_dev(g, image1);
    			append_dev(g, defs);
    			append_dev(defs, linearGradient);
    			append_dev(linearGradient, stop0);
    			append_dev(linearGradient, stop1);
    			append_dev(linearGradient, stop2);
    			append_dev(g, path);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image0, image0_data = get_spread_update(image0_levels, [
    				dirty[0] & /*options, radius, center*/ 176 && {
    					...classWithPart("HighLightAreaBackground"),
    					href: img$b,
    					...getImageProps(/*options*/ ctx[7].length, /*radius*/ ctx[4], /*center*/ ctx[5])
    				}
    			]));

    			set_svg_attributes(image1, image1_data = get_spread_update(image1_levels, [
    				dirty[0] & /*options, radius, center*/ 176 && {
    					...classWithPart("HighLightArea"),
    					href: img$c,
    					...getImageProps(/*options*/ ctx[7].length, /*radius*/ ctx[4], /*center*/ ctx[5])
    				}
    			]));

    			set_svg_attributes(path, path_data = get_spread_update(path_levels, [
    				dirty[0] & /*options, radius, center, isShowPrizeArea*/ 1200 && {
    					...classWithPart("PointerPartitionFrame"),
    					...getPartitionProps(0, /*options*/ ctx[7].length, /*radius*/ ctx[4], /*center*/ ctx[5]),
    					fill: `transparent`,
    					stroke: `url(#GPointerPartitionFrame)`,
    					'stroke-width': /*isShowPrizeArea*/ ctx[10] ? '3px' : '0px',
    					'stroke-dasharray': `${/*radius*/ ctx[4]} ${getArcLength(/*radius*/ ctx[4], 360 / /*options*/ ctx[7].length)}`
    				}
    			]));

    			set_svg_attributes(g, g_data = get_spread_update(g_levels, [
    				classWithPart("Pointer"),
    				dirty[0] & /*propsSpinner*/ 131072 && /*propsSpinner*/ ctx[17]
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(g);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_11.name,
    		type: "if",
    		source: "(417:2) {#if pointermode === PointerMode.Partition && options[0]}",
    		ctx
    	});

    	return block;
    }

    // (496:4) {#if themeIndex === 0 || themeIndex === 3}
    function create_if_block_10(ctx) {
    	let image;

    	let image_levels = [
    		renderSvgImageProps(/*center*/ ctx[5], img$a, {
    			width: 96 * /*ratio*/ ctx[2],
    			height: 96 * /*ratio*/ ctx[2]
    		})
    	];

    	let image_data = {};

    	for (let i = 0; i < image_levels.length; i += 1) {
    		image_data = assign(image_data, image_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image = svg_element("image");
    			set_svg_attributes(image, image_data);
    			add_location(image, file$2, 497, 6, 17568);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image, image_data = get_spread_update(image_levels, [
    				dirty[0] & /*center, ratio*/ 36 && renderSvgImageProps(/*center*/ ctx[5], img$a, {
    					width: 96 * /*ratio*/ ctx[2],
    					height: 96 * /*ratio*/ ctx[2]
    				})
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_10.name,
    		type: "if",
    		source: "(496:4) {#if themeIndex === 0 || themeIndex === 3}",
    		ctx
    	});

    	return block;
    }

    // (504:4) {#if themeIndex === 0 || themeIndex === 3 || themeIndex === 4 || themeIndex === 5}
    function create_if_block_9(ctx) {
    	let image;

    	let image_levels = [
    		renderSvgImageProps(/*center*/ ctx[5], img$8, {
    			width: 1.3 * 42 * /*ratio*/ ctx[2],
    			height: 1.3 * 25 * /*ratio*/ ctx[2]
    		})
    	];

    	let image_data = {};

    	for (let i = 0; i < image_levels.length; i += 1) {
    		image_data = assign(image_data, image_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image = svg_element("image");
    			set_svg_attributes(image, image_data);
    			add_location(image, file$2, 505, 6, 17841);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image, image_data = get_spread_update(image_levels, [
    				dirty[0] & /*center, ratio*/ 36 && renderSvgImageProps(/*center*/ ctx[5], img$8, {
    					width: 1.3 * 42 * /*ratio*/ ctx[2],
    					height: 1.3 * 25 * /*ratio*/ ctx[2]
    				})
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_9.name,
    		type: "if",
    		source: "(504:4) {#if themeIndex === 0 || themeIndex === 3 || themeIndex === 4 || themeIndex === 5}",
    		ctx
    	});

    	return block;
    }

    // (511:4) {#if themeIndex === 4 || themeIndex === 5}
    function create_if_block_8(ctx) {
    	let image0;
    	let image1;

    	let image0_levels = [
    		renderSvgImageProps(
    			/*center*/ ctx[5],
    			img,
    			{
    				width: 28 * /*ratio*/ ctx[2],
    				height: 24 * /*ratio*/ ctx[2]
    			},
    			{ x: 0, y: 45 * /*ratio*/ ctx[2] }
    		)
    	];

    	let image0_data = {};

    	for (let i = 0; i < image0_levels.length; i += 1) {
    		image0_data = assign(image0_data, image0_levels[i]);
    	}

    	let image1_levels = [
    		renderSvgImageProps(
    			/*center*/ ctx[5],
    			img$1,
    			{
    				width: 88 * /*ratio*/ ctx[2],
    				height: 104 * /*ratio*/ ctx[2]
    			},
    			{ x: 0, y: 6 * /*ratio*/ ctx[2] }
    		)
    	];

    	let image1_data = {};

    	for (let i = 0; i < image1_levels.length; i += 1) {
    		image1_data = assign(image1_data, image1_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image0 = svg_element("image");
    			image1 = svg_element("image");
    			set_svg_attributes(image0, image0_data);
    			add_location(image0, file$2, 512, 6, 18037);
    			set_svg_attributes(image1, image1_data);
    			add_location(image1, file$2, 519, 6, 18219);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image0, anchor);
    			insert_dev(target, image1, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image0, image0_data = get_spread_update(image0_levels, [
    				dirty[0] & /*center, ratio*/ 36 && renderSvgImageProps(
    					/*center*/ ctx[5],
    					img,
    					{
    						width: 28 * /*ratio*/ ctx[2],
    						height: 24 * /*ratio*/ ctx[2]
    					},
    					{ x: 0, y: 45 * /*ratio*/ ctx[2] }
    				)
    			]));

    			set_svg_attributes(image1, image1_data = get_spread_update(image1_levels, [
    				dirty[0] & /*center, ratio*/ 36 && renderSvgImageProps(
    					/*center*/ ctx[5],
    					img$1,
    					{
    						width: 88 * /*ratio*/ ctx[2],
    						height: 104 * /*ratio*/ ctx[2]
    					},
    					{ x: 0, y: 6 * /*ratio*/ ctx[2] }
    				)
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image0);
    			if (detaching) detach_dev(image1);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_8.name,
    		type: "if",
    		source: "(511:4) {#if themeIndex === 4 || themeIndex === 5}",
    		ctx
    	});

    	return block;
    }

    // (528:4) {#if themeIndex === 1}
    function create_if_block_7(ctx) {
    	let image0;
    	let image1;

    	let image0_levels = [
    		renderSvgImageProps(/*center*/ ctx[5], img$4, {
    			width: 128 * /*ratio*/ ctx[2],
    			height: 128 * /*ratio*/ ctx[2]
    		})
    	];

    	let image0_data = {};

    	for (let i = 0; i < image0_levels.length; i += 1) {
    		image0_data = assign(image0_data, image0_levels[i]);
    	}

    	let image1_levels = [
    		renderSvgImageProps(/*center*/ ctx[5], img$6, {
    			width: 76 * /*ratio*/ ctx[2],
    			height: 76 * /*ratio*/ ctx[2]
    		})
    	];

    	let image1_data = {};

    	for (let i = 0; i < image1_levels.length; i += 1) {
    		image1_data = assign(image1_data, image1_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image0 = svg_element("image");
    			image1 = svg_element("image");
    			set_svg_attributes(image0, image0_data);
    			add_location(image0, file$2, 529, 6, 18471);
    			set_svg_attributes(image1, image1_data);
    			add_location(image1, file$2, 534, 6, 18654);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image0, anchor);
    			insert_dev(target, image1, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image0, image0_data = get_spread_update(image0_levels, [
    				dirty[0] & /*center, ratio*/ 36 && renderSvgImageProps(/*center*/ ctx[5], img$4, {
    					width: 128 * /*ratio*/ ctx[2],
    					height: 128 * /*ratio*/ ctx[2]
    				})
    			]));

    			set_svg_attributes(image1, image1_data = get_spread_update(image1_levels, [
    				dirty[0] & /*center, ratio*/ 36 && renderSvgImageProps(/*center*/ ctx[5], img$6, {
    					width: 76 * /*ratio*/ ctx[2],
    					height: 76 * /*ratio*/ ctx[2]
    				})
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image0);
    			if (detaching) detach_dev(image1);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_7.name,
    		type: "if",
    		source: "(528:4) {#if themeIndex === 1}",
    		ctx
    	});

    	return block;
    }

    // (540:4) {#if themeIndex === 2}
    function create_if_block_6(ctx) {
    	let image0;
    	let image1;

    	let image0_levels = [
    		renderSvgImageProps(/*center*/ ctx[5], img$9, {
    			width: 92 * /*ratio*/ ctx[2],
    			height: 92 * /*ratio*/ ctx[2]
    		})
    	];

    	let image0_data = {};

    	for (let i = 0; i < image0_levels.length; i += 1) {
    		image0_data = assign(image0_data, image0_levels[i]);
    	}

    	let image1_levels = [
    		renderSvgImageProps(/*center*/ ctx[5], img$5, {
    			width: 42 * /*ratio*/ ctx[2],
    			height: 25 * /*ratio*/ ctx[2]
    		})
    	];

    	let image1_data = {};

    	for (let i = 0; i < image1_levels.length; i += 1) {
    		image1_data = assign(image1_data, image1_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image0 = svg_element("image");
    			image1 = svg_element("image");
    			set_svg_attributes(image0, image0_data);
    			add_location(image0, file$2, 540, 6, 18823);
    			set_svg_attributes(image1, image1_data);
    			add_location(image1, file$2, 544, 6, 18956);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image0, anchor);
    			insert_dev(target, image1, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image0, image0_data = get_spread_update(image0_levels, [
    				dirty[0] & /*center, ratio*/ 36 && renderSvgImageProps(/*center*/ ctx[5], img$9, {
    					width: 92 * /*ratio*/ ctx[2],
    					height: 92 * /*ratio*/ ctx[2]
    				})
    			]));

    			set_svg_attributes(image1, image1_data = get_spread_update(image1_levels, [
    				dirty[0] & /*center, ratio*/ 36 && renderSvgImageProps(/*center*/ ctx[5], img$5, {
    					width: 42 * /*ratio*/ ctx[2],
    					height: 25 * /*ratio*/ ctx[2]
    				})
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image0);
    			if (detaching) detach_dev(image1);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_6.name,
    		type: "if",
    		source: "(540:4) {#if themeIndex === 2}",
    		ctx
    	});

    	return block;
    }

    // (553:2) {#if theme.background.isShowingBulb}
    function create_if_block_5(ctx) {
    	let g;
    	let each_value = /*options*/ ctx[7];
    	validate_each_argument(each_value);
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
    	}

    	const block = {
    		c: function create() {
    			g = svg_element("g");

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			attr_dev(g, "id", "RingCirclesGroup");
    			add_location(g, file$2, 553, 2, 19149);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, g, anchor);

    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].m(g, null);
    			}
    		},
    		p: function update(ctx, dirty) {
    			if (dirty[0] & /*options, rRingOuter, rRingInner, center, ratio*/ 49316) {
    				each_value = /*options*/ ctx[7];
    				validate_each_argument(each_value);
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context$1(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block$1(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(g, null);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value.length;
    			}
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(g);
    			destroy_each(each_blocks, detaching);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_5.name,
    		type: "if",
    		source: "(553:2) {#if theme.background.isShowingBulb}",
    		ctx
    	});

    	return block;
    }

    // (555:4) {#each options as option,index}
    function create_each_block$1(ctx) {
    	let image0;
    	let image1;

    	let image0_levels = [
    		{ href: img$d },
    		getRingImageProps(/*index*/ ctx[44], /*options*/ ctx[7].length, /*rRingOuter*/ ctx[14], /*rRingInner*/ ctx[15], /*center*/ ctx[5], /*ratio*/ ctx[2])
    	];

    	let image0_data = {};

    	for (let i = 0; i < image0_levels.length; i += 1) {
    		image0_data = assign(image0_data, image0_levels[i]);
    	}

    	let image1_levels = [
    		{ href: img$d },
    		getRingImageProps(/*index*/ ctx[44] + 1 / 2, /*options*/ ctx[7].length, /*rRingOuter*/ ctx[14], /*rRingInner*/ ctx[15], /*center*/ ctx[5], /*ratio*/ ctx[2])
    	];

    	let image1_data = {};

    	for (let i = 0; i < image1_levels.length; i += 1) {
    		image1_data = assign(image1_data, image1_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image0 = svg_element("image");
    			image1 = svg_element("image");
    			set_svg_attributes(image0, image0_data);
    			add_location(image0, file$2, 555, 6, 19217);
    			set_svg_attributes(image1, image1_data);
    			add_location(image1, file$2, 563, 6, 19402);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image0, anchor);
    			insert_dev(target, image1, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image0, image0_data = get_spread_update(image0_levels, [
    				{ href: img$d },
    				dirty[0] & /*options, rRingOuter, rRingInner, center, ratio*/ 49316 && getRingImageProps(/*index*/ ctx[44], /*options*/ ctx[7].length, /*rRingOuter*/ ctx[14], /*rRingInner*/ ctx[15], /*center*/ ctx[5], /*ratio*/ ctx[2])
    			]));

    			set_svg_attributes(image1, image1_data = get_spread_update(image1_levels, [
    				{ href: img$d },
    				dirty[0] & /*options, rRingOuter, rRingInner, center, ratio*/ 49316 && getRingImageProps(/*index*/ ctx[44] + 1 / 2, /*options*/ ctx[7].length, /*rRingOuter*/ ctx[14], /*rRingInner*/ ctx[15], /*center*/ ctx[5], /*ratio*/ ctx[2])
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image0);
    			if (detaching) detach_dev(image1);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block$1.name,
    		type: "each",
    		source: "(555:4) {#each options as option,index}",
    		ctx
    	});

    	return block;
    }

    // (577:2) {#if pointermode === PointerMode.Arrow}
    function create_if_block_1$2(ctx) {
    	let g;

    	function select_block_type_1(ctx, dirty) {
    		if (/*themeIndex*/ ctx[6] === 1) return create_if_block_2$1;
    		if (/*themeIndex*/ ctx[6] === 2) return create_if_block_3;
    		if (/*themeIndex*/ ctx[6] === 4 || /*themeIndex*/ ctx[6] === 5) return create_if_block_4;
    		return create_else_block$1;
    	}

    	let current_block_type = select_block_type_1(ctx);
    	let if_block = current_block_type(ctx);
    	let g_levels = [classWithPart("Pointer"), /*propsSpinner*/ ctx[17]];
    	let g_data = {};

    	for (let i = 0; i < g_levels.length; i += 1) {
    		g_data = assign(g_data, g_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			g = svg_element("g");
    			if_block.c();
    			set_svg_attributes(g, g_data);
    			add_location(g, file$2, 577, 2, 19662);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, g, anchor);
    			if_block.m(g, null);
    		},
    		p: function update(ctx, dirty) {
    			if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block) {
    				if_block.p(ctx, dirty);
    			} else {
    				if_block.d(1);
    				if_block = current_block_type(ctx);

    				if (if_block) {
    					if_block.c();
    					if_block.m(g, null);
    				}
    			}

    			set_svg_attributes(g, g_data = get_spread_update(g_levels, [
    				classWithPart("Pointer"),
    				dirty[0] & /*propsSpinner*/ 131072 && /*propsSpinner*/ ctx[17]
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(g);
    			if_block.d();
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_1$2.name,
    		type: "if",
    		source: "(577:2) {#if pointermode === PointerMode.Arrow}",
    		ctx
    	});

    	return block;
    }

    // (607:6) {:else}
    function create_else_block$1(ctx) {
    	let polygon;

    	let polygon_levels = [
    		{
    			...classWithPart("PointerArrow"),
    			points: /*arrowPoints*/ ctx[16],
    			fill: 'blue'
    		}
    	];

    	let polygon_data = {};

    	for (let i = 0; i < polygon_levels.length; i += 1) {
    		polygon_data = assign(polygon_data, polygon_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			polygon = svg_element("polygon");
    			set_svg_attributes(polygon, polygon_data);
    			add_location(polygon, file$2, 607, 8, 20512);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, polygon, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(polygon, polygon_data = get_spread_update(polygon_levels, [
    				dirty[0] & /*arrowPoints*/ 65536 && {
    					...classWithPart("PointerArrow"),
    					points: /*arrowPoints*/ ctx[16],
    					fill: 'blue'
    				}
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(polygon);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_else_block$1.name,
    		type: "else",
    		source: "(607:6) {:else}",
    		ctx
    	});

    	return block;
    }

    // (604:53) 
    function create_if_block_4(ctx) {
    	const block = { c: noop, m: noop, p: noop, d: noop };

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_4.name,
    		type: "if",
    		source: "(604:53) ",
    		ctx
    	});

    	return block;
    }

    // (591:33) 
    function create_if_block_3(ctx) {
    	let image;

    	let image_levels = [
    		renderSvgImageProps(
    			/*center*/ ctx[5],
    			img$2,
    			{
    				width: 2.8 * 32 / 2 * /*ratio*/ ctx[2],
    				height: 2.8 * 48 / 2 * /*ratio*/ ctx[2]
    			},
    			{
    				x: 0,
    				y: (/*rRingOuter*/ ctx[14] + /*rRingInner*/ ctx[15]) / 2
    			}
    		),
    		{ ...classWithPart("PointerArrow") }
    	];

    	let image_data = {};

    	for (let i = 0; i < image_levels.length; i += 1) {
    		image_data = assign(image_data, image_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image = svg_element("image");
    			set_svg_attributes(image, image_data);
    			add_location(image, file$2, 591, 8, 20093);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image, image_data = get_spread_update(image_levels, [
    				dirty[0] & /*center, ratio, rRingOuter, rRingInner*/ 49188 && renderSvgImageProps(
    					/*center*/ ctx[5],
    					img$2,
    					{
    						width: 2.8 * 32 / 2 * /*ratio*/ ctx[2],
    						height: 2.8 * 48 / 2 * /*ratio*/ ctx[2]
    					},
    					{
    						x: 0,
    						y: (/*rRingOuter*/ ctx[14] + /*rRingInner*/ ctx[15]) / 2
    					}
    				),
    				{ ...classWithPart("PointerArrow") }
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_3.name,
    		type: "if",
    		source: "(591:33) ",
    		ctx
    	});

    	return block;
    }

    // (580:6) {#if themeIndex === 1}
    function create_if_block_2$1(ctx) {
    	let image;

    	let image_levels = [
    		{
    			...classWithPart("PointerArrow"),
    			href: img$3,
    			x: /*center*/ ctx[5] - 60 / 2 / 2 * /*ratio*/ ctx[2],
    			y: /*center*/ ctx[5] - (/*rRingOuter*/ ctx[14] + /*rRingInner*/ ctx[15]) / 2 - 80 / 2 / 2 * /*ratio*/ ctx[2],
    			width: 60 / 2 * /*ratio*/ ctx[2],
    			height: 80 / 2 * /*ratio*/ ctx[2]
    		}
    	];

    	let image_data = {};

    	for (let i = 0; i < image_levels.length; i += 1) {
    		image_data = assign(image_data, image_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			image = svg_element("image");
    			set_svg_attributes(image, image_data);
    			add_location(image, file$2, 580, 6, 19750);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, image, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_svg_attributes(image, image_data = get_spread_update(image_levels, [
    				dirty[0] & /*center, ratio, rRingOuter, rRingInner*/ 49188 && {
    					...classWithPart("PointerArrow"),
    					href: img$3,
    					x: /*center*/ ctx[5] - 60 / 2 / 2 * /*ratio*/ ctx[2],
    					y: /*center*/ ctx[5] - (/*rRingOuter*/ ctx[14] + /*rRingInner*/ ctx[15]) / 2 - 80 / 2 / 2 * /*ratio*/ ctx[2],
    					width: 60 / 2 * /*ratio*/ ctx[2],
    					height: 80 / 2 * /*ratio*/ ctx[2]
    				}
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(image);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_2$1.name,
    		type: "if",
    		source: "(580:6) {#if themeIndex === 1}",
    		ctx
    	});

    	return block;
    }

    function create_fragment$2(ctx) {
    	let if_block_anchor;
    	let if_block = /*size*/ ctx[1] && create_if_block$2(ctx);

    	const block = {
    		c: function create() {
    			if (if_block) if_block.c();
    			if_block_anchor = empty();
    			this.c = noop;
    		},
    		l: function claim(nodes) {
    			throw new Error_1("options.hydrate only works if the component was compiled with the `hydratable: true` option");
    		},
    		m: function mount(target, anchor) {
    			if (if_block) if_block.m(target, anchor);
    			insert_dev(target, if_block_anchor, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (/*size*/ ctx[1]) {
    				if (if_block) {
    					if_block.p(ctx, dirty);
    				} else {
    					if_block = create_if_block$2(ctx);
    					if_block.c();
    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
    				}
    			} else if (if_block) {
    				if_block.d(1);
    				if_block = null;
    			}
    		},
    		i: noop,
    		o: noop,
    		d: function destroy(detaching) {
    			if (if_block) if_block.d(detaching);
    			if (detaching) detach_dev(if_block_anchor);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_fragment$2.name,
    		type: "component",
    		source: "",
    		ctx
    	});

    	return block;
    }

    function instance$2($$self, $$props, $$invalidate) {
    	let size;
    	let lotteryProgramForPlayer;
    	let themeIndex;
    	let theme;
    	let propsSpinner;
    	let rCircleCenter;
    	let arrowPoints;
    	let center;
    	let centerPoint;
    	let ratio;
    	let radius;
    	let rRingInner;
    	let rRingOuter;
    	let { $$slots: slots = {}, $$scope } = $$props;
    	validate_slots('lottery-program-wof-private-item-svg', slots, []);
    	let { lang = Lang.en } = $$props;
    	let { endpoint = '' } = $$props;
    	let { session = '' } = $$props;
    	let { lotteryprogramforplayer = undefined } = $$props;
    	let { themeindex = '0' } = $$props;
    	let { arrowmode = ArrowMode.DownFromTop } = $$props;
    	let { spinduration = '3' } = $$props;
    	let { spinrotation = '3' } = $$props;
    	let { id = undefined } = $$props;
    	let { sizeraw = '0' } = $$props;
    	let { optionsraw = '[]' } = $$props;
    	let options = [];

    	// binds
    	let svg;

    	// states
    	let spinable = true;

    	let isShowPrizeArea = false;
    	let pointermode = PointerMode.Partition;
    	let spinner = new Spinner();
    	let shownFirstCheck = false;
    	let speed = 0;
    	let messageShown = false;

    	const setMessage$1 = entry => {
    		setMessage(id, entry);
    		$$invalidate(13, messageShown = true);
    	};

    	const checkSpinable = () => {
    		if (shownFirstCheck) return;
    		shownFirstCheck = true;

    		if (spinable) {
    			if (getSpinCondition(lotteryProgramForPlayer)) {
    				setMessage$1({ mode: 'spin-failed' });
    			} else if (getSpinCondition(lotteryProgramForPlayer) && !lotteryProgramForPlayer.next) {
    				setMessage$1(`You don't have any spins available. Please check T&C`);
    			}
    		} // hasQueuedMessage = true
    	};

    	const getDeg = index => findDegWithPointerMode(index || options.length - 1, options.length, pointermode);

    	const drawer = async (guid, frequency = 0) => {
    		let index;

    		const stage = {
    			success: message => {
    				_postMessage({
    					id,
    					type: 'wof-private-message-spin-before'
    				});

    				const cb = () => {
    					setTimeout(
    						() => {
    							_postMessage({
    								id,
    								type: 'wof-private-message-spin-after'
    							});

    							$$invalidate(10, isShowPrizeArea = true);
    							setMessage$1(message);
    						},
    						1000
    					);
    				};

    				spinner.halt(getDeg(index), cb);
    			},
    			failed: () => {
    				_postMessage({
    					id,
    					type: 'wof-private-message-spin-before'
    				});

    				const cb = () => {
    					setTimeout(
    						() => {
    							setMessage$1('There was a problem to grant the reward. Please contact support');

    							_postMessage({
    								id,
    								type: 'wof-private-message-spin-after'
    							});
    						},
    						1000
    					);
    				};

    				spinner.halt(getDeg(index), cb);
    			}
    		};

    		try {
    			const { data, message, index: _index } = await api.draw(endpoint, session, id, guid, options, pointermode);
    			index = _index;
    			if (!data.success) throw new Error();
    			if (data.item.state === "drawn") throw new Error();
    			stage.success(message);
    		} catch(e) {
    			if (frequency < 4) {
    				drawer(guid, frequency + 1);
    			} else {
    				stage.failed();
    			}
    		}
    	};

    	let container;

    	const setDeg = (deg, _speed) => {
    		setProps(container, { transform: `rotate(${deg})` });
    		$$invalidate(12, speed = _speed * 0.5);
    	};

    	spinner.tick = setDeg;

    	// events
    	const eventSpin = async () => {
    		if (!spinable) return;

    		if (!lotteryProgramForPlayer.current.remainingTimes) {
    			if (lotteryProgramForPlayer.next) {
    				setMessage$1({
    					mode: 'show-next',
    					modeValue: lotteryProgramForPlayer.next
    				});
    			} else {
    				setMessage$1(`You don't have any spins available. Please check T&C`);
    			}

    			return;
    		}

    		$$invalidate(9, spinable = false);
    		$$invalidate(10, isShowPrizeArea = false);
    		$$invalidate(29, container = svg.querySelector(getSpinContainerSelector(pointermode)));
    		spinner.launch();
    		const guid = `userid-${id}-${new Date().getTime()}`;
    		drawer(guid);
    	};

    	onMountMessageLifeCycle({
    		'wof-private-message-close': data => {
    			if (data.id !== id) return;
    			$$invalidate(9, spinable = true);
    			$$invalidate(13, messageShown = false);
    		}
    	});

    	const writable_props = [
    		'lang',
    		'endpoint',
    		'session',
    		'lotteryprogramforplayer',
    		'themeindex',
    		'arrowmode',
    		'spinduration',
    		'spinrotation',
    		'id',
    		'sizeraw',
    		'optionsraw'
    	];

    	Object.keys($$props).forEach(key => {
    		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<lottery-program-wof-private-item-svg> was created with unknown prop '${key}'`);
    	});

    	const click_handler = () => eventSpin();

    	function svg_1_binding($$value) {
    		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
    			svg = $$value;
    			$$invalidate(8, svg);
    		});
    	}

    	$$self.$$set = $$props => {
    		if ('lang' in $$props) $$invalidate(19, lang = $$props.lang);
    		if ('endpoint' in $$props) $$invalidate(20, endpoint = $$props.endpoint);
    		if ('session' in $$props) $$invalidate(21, session = $$props.session);
    		if ('lotteryprogramforplayer' in $$props) $$invalidate(22, lotteryprogramforplayer = $$props.lotteryprogramforplayer);
    		if ('themeindex' in $$props) $$invalidate(23, themeindex = $$props.themeindex);
    		if ('arrowmode' in $$props) $$invalidate(0, arrowmode = $$props.arrowmode);
    		if ('spinduration' in $$props) $$invalidate(24, spinduration = $$props.spinduration);
    		if ('spinrotation' in $$props) $$invalidate(25, spinrotation = $$props.spinrotation);
    		if ('id' in $$props) $$invalidate(26, id = $$props.id);
    		if ('sizeraw' in $$props) $$invalidate(27, sizeraw = $$props.sizeraw);
    		if ('optionsraw' in $$props) $$invalidate(28, optionsraw = $$props.optionsraw);
    	};

    	$$self.$capture_state = () => ({
    		lightSvg: img$d,
    		areaSvg: img$c,
    		areaSecSvg: img$b,
    		centerArrowSvg: img$a,
    		centerArrow3Svg: img$9,
    		spinSvg: img$8,
    		backgroundShadowSvg: img$7,
    		centerPackSvg: img$6,
    		centerText3Svg: img$5,
    		centerBackground2Svg: img$4,
    		pointerArrowSvg: img$3,
    		pointerArrow3Svg: img$2,
    		centerCircleSvg: img$1,
    		centerArrowBgSvg: img,
    		ArrowMode,
    		PointerMode,
    		Lang,
    		findDegWithPointerMode,
    		getSpinCondition,
    		getSpinContainerSelector,
    		setMessageBase: setMessage,
    		getColorSchema,
    		getSvgImageProps,
    		getSvgTextProps,
    		api,
    		convertArcToDeg,
    		getArcLength,
    		getTrianglePoints,
    		getPartitionProps,
    		getRingImageProps,
    		getImageProps,
    		getTwoPointsOfLineGradient,
    		getSymmetricalPointFromScalar,
    		onMountMessageLifeCycle,
    		_postMessage,
    		themes,
    		renderSvgImageProps,
    		classWithPart,
    		setProps,
    		Spinner,
    		lang,
    		endpoint,
    		session,
    		lotteryprogramforplayer,
    		themeindex,
    		arrowmode,
    		spinduration,
    		spinrotation,
    		id,
    		sizeraw,
    		optionsraw,
    		options,
    		svg,
    		spinable,
    		isShowPrizeArea,
    		pointermode,
    		spinner,
    		shownFirstCheck,
    		speed,
    		messageShown,
    		setMessage: setMessage$1,
    		checkSpinable,
    		getDeg,
    		drawer,
    		container,
    		setDeg,
    		eventSpin,
    		size,
    		ratio,
    		theme,
    		rRingOuter,
    		rRingInner,
    		radius,
    		center,
    		centerPoint,
    		rCircleCenter,
    		arrowPoints,
    		propsSpinner,
    		lotteryProgramForPlayer,
    		themeIndex
    	});

    	$$self.$inject_state = $$props => {
    		if ('lang' in $$props) $$invalidate(19, lang = $$props.lang);
    		if ('endpoint' in $$props) $$invalidate(20, endpoint = $$props.endpoint);
    		if ('session' in $$props) $$invalidate(21, session = $$props.session);
    		if ('lotteryprogramforplayer' in $$props) $$invalidate(22, lotteryprogramforplayer = $$props.lotteryprogramforplayer);
    		if ('themeindex' in $$props) $$invalidate(23, themeindex = $$props.themeindex);
    		if ('arrowmode' in $$props) $$invalidate(0, arrowmode = $$props.arrowmode);
    		if ('spinduration' in $$props) $$invalidate(24, spinduration = $$props.spinduration);
    		if ('spinrotation' in $$props) $$invalidate(25, spinrotation = $$props.spinrotation);
    		if ('id' in $$props) $$invalidate(26, id = $$props.id);
    		if ('sizeraw' in $$props) $$invalidate(27, sizeraw = $$props.sizeraw);
    		if ('optionsraw' in $$props) $$invalidate(28, optionsraw = $$props.optionsraw);
    		if ('options' in $$props) $$invalidate(7, options = $$props.options);
    		if ('svg' in $$props) $$invalidate(8, svg = $$props.svg);
    		if ('spinable' in $$props) $$invalidate(9, spinable = $$props.spinable);
    		if ('isShowPrizeArea' in $$props) $$invalidate(10, isShowPrizeArea = $$props.isShowPrizeArea);
    		if ('pointermode' in $$props) $$invalidate(11, pointermode = $$props.pointermode);
    		if ('spinner' in $$props) spinner = $$props.spinner;
    		if ('shownFirstCheck' in $$props) shownFirstCheck = $$props.shownFirstCheck;
    		if ('speed' in $$props) $$invalidate(12, speed = $$props.speed);
    		if ('messageShown' in $$props) $$invalidate(13, messageShown = $$props.messageShown);
    		if ('container' in $$props) $$invalidate(29, container = $$props.container);
    		if ('size' in $$props) $$invalidate(1, size = $$props.size);
    		if ('ratio' in $$props) $$invalidate(2, ratio = $$props.ratio);
    		if ('theme' in $$props) $$invalidate(3, theme = $$props.theme);
    		if ('rRingOuter' in $$props) $$invalidate(14, rRingOuter = $$props.rRingOuter);
    		if ('rRingInner' in $$props) $$invalidate(15, rRingInner = $$props.rRingInner);
    		if ('radius' in $$props) $$invalidate(4, radius = $$props.radius);
    		if ('center' in $$props) $$invalidate(5, center = $$props.center);
    		if ('centerPoint' in $$props) $$invalidate(30, centerPoint = $$props.centerPoint);
    		if ('rCircleCenter' in $$props) $$invalidate(31, rCircleCenter = $$props.rCircleCenter);
    		if ('arrowPoints' in $$props) $$invalidate(16, arrowPoints = $$props.arrowPoints);
    		if ('propsSpinner' in $$props) $$invalidate(17, propsSpinner = $$props.propsSpinner);
    		if ('lotteryProgramForPlayer' in $$props) $$invalidate(32, lotteryProgramForPlayer = $$props.lotteryProgramForPlayer);
    		if ('themeIndex' in $$props) $$invalidate(6, themeIndex = $$props.themeIndex);
    	};

    	if ($$props && "$$inject" in $$props) {
    		$$self.$inject_state($$props.$$inject);
    	}

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty[0] & /*sizeraw*/ 134217728) {
    			$$invalidate(1, size = Number(sizeraw) || 0);
    		}

    		if ($$self.$$.dirty[0] & /*optionsraw*/ 268435456) {
    			$$invalidate(7, options = JSON.parse(optionsraw));
    		}

    		if ($$self.$$.dirty[0] & /*lotteryprogramforplayer*/ 4194304) {
    			$$invalidate(32, lotteryProgramForPlayer = lotteryprogramforplayer && JSON.parse(lotteryprogramforplayer));
    		}

    		if ($$self.$$.dirty[0] & /*themeindex*/ 8388608) {
    			$$invalidate(6, themeIndex = Number(themeindex));
    		}

    		if ($$self.$$.dirty[0] & /*themeIndex*/ 64) {
    			$$invalidate(11, pointermode = (() => {
    				switch (themeIndex) {
    					case 0:
    						return PointerMode.Partition;
    					case 1:
    						return PointerMode.Arrow;
    					case 2:
    						return PointerMode.Arrow;
    					case 3:
    						return PointerMode.Partition;
    					case 4:
    						return PointerMode.Arrow;
    					case 5:
    						return PointerMode.Arrow;
    				}
    			})());
    		}

    		if ($$self.$$.dirty[0] & /*themeIndex*/ 64) {
    			$$invalidate(3, theme = themes[themeIndex]);
    		}

    		if ($$self.$$.dirty[1] & /*lotteryProgramForPlayer*/ 2) {
    			lotteryProgramForPlayer && checkSpinable();
    		}

    		if ($$self.$$.dirty[0] & /*size*/ 2) {
    			$$invalidate(5, center = size / 2);
    		}

    		if ($$self.$$.dirty[0] & /*center*/ 32) {
    			$$invalidate(30, centerPoint = getSymmetricalPointFromScalar(center));
    		}

    		if ($$self.$$.dirty[0] & /*centerPoint*/ 1073741824) {
    			$$invalidate(17, propsSpinner = {
    				transform: `rotate(${convertArcToDeg(0)})`,
    				"transform-origin": `${centerPoint.x} ${centerPoint.y}`
    			});
    		}

    		if ($$self.$$.dirty[0] & /*size*/ 2) {
    			// ratio
    			$$invalidate(2, ratio = size / 375);
    		}

    		if ($$self.$$.dirty[0] & /*theme, ratio*/ 12) {
    			$$invalidate(4, radius = theme.size.radius / 2 * ratio);
    		}

    		if ($$self.$$.dirty[0] & /*radius*/ 16) {
    			$$invalidate(31, rCircleCenter = radius / 5);
    		}

    		if ($$self.$$.dirty[0] & /*size, arrowmode*/ 3 | $$self.$$.dirty[1] & /*rCircleCenter*/ 1) {
    			$$invalidate(16, arrowPoints = getTrianglePoints(size / 2, size / 20, size / 13, arrowmode, rCircleCenter));
    		}

    		if ($$self.$$.dirty[0] & /*theme, ratio*/ 12) {
    			$$invalidate(15, rRingInner = theme.size.rRingInner / 2 * ratio);
    		}

    		if ($$self.$$.dirty[0] & /*theme, ratio*/ 12) {
    			$$invalidate(14, rRingOuter = theme.size.rRingOuter / 2 * ratio);
    		}

    		if ($$self.$$.dirty[0] & /*size, container*/ 536870914) {
    			size && (() => {
    				// console.log('sizeraw changed');
    				setTimeout(
    					() => {
    					},
    					50
    				);
    			})();
    		}
    	};

    	return [
    		arrowmode,
    		size,
    		ratio,
    		theme,
    		radius,
    		center,
    		themeIndex,
    		options,
    		svg,
    		spinable,
    		isShowPrizeArea,
    		pointermode,
    		speed,
    		messageShown,
    		rRingOuter,
    		rRingInner,
    		arrowPoints,
    		propsSpinner,
    		eventSpin,
    		lang,
    		endpoint,
    		session,
    		lotteryprogramforplayer,
    		themeindex,
    		spinduration,
    		spinrotation,
    		id,
    		sizeraw,
    		optionsraw,
    		container,
    		centerPoint,
    		rCircleCenter,
    		lotteryProgramForPlayer,
    		click_handler,
    		svg_1_binding
    	];
    }

    class Private_item_svg extends SvelteElement {
    	constructor(options) {
    		super();
    		this.shadowRoot.innerHTML = `<style>:host{font-family:system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'}*,*::before,*::after{margin:0;padding:0;list-style:none;text-decoration:none;outline:none;box-sizing:border-box}.LotteryProgramWof{background:var(--emfe-w-color-contrast, #07072A);display:flex;align-items:center;flex-direction:column;padding:20px 0}svg{transition:opacity 0.3s}.HighLightArea{mix-blend-mode:color-dodge}.HighLightAreaBackground{mix-blend-mode:screen;opacity:0.41}.HighLightAreaV1{background:radial-gradient(72.02% 62.64% at 50% 84.62%, rgba(255, 184, 47, 0.7) 0%, rgba(255, 184, 47, 0.384271) 30.52%, rgba(255, 184, 47, 0.165346) 52.4%, rgba(255, 184, 47, 0) 100%);filter:blur(9px)}.HighLightAreaV2{background:radial-gradient(87.18% 75.82% at 50% 84.62%, rgba(255, 248, 186, 0.7) 0%, rgba(255, 248, 186, 0.384271) 29.48%, rgba(255, 248, 186, 0) 100%);filter:blur(9px)}.FortuneContainer{width:100%;display:flex;align-items:center;flex-direction:column}.BackgroundCircle{fill:#FFFFFF;animation:color-animation 1s infinite linear alternate}.RingCirclesGroup .RingCircle{fill:#FFFFFF;stroke:#FFFFFF}.Center{cursor:pointer;transition:filter;transition-duration:1s}.Center.disabled{filter:grayscale(80%)}.Center .CenterCircle{fill:#3CE4BB;stroke:#963658;stroke-width:2px;cursor:pointer;transition:fill;transition-duration:1s}.Center .CenterText{fill:#FFFFFF}.PointerPartition{opacity:0.3;fill:lightgoldenrodyellow;stroke:red;stroke-width:6px;stroke-dasharray:12}.Current{color:#FFFFFF}.PartitionText{fill:#FFFFFF;font-style:normal;font-weight:700;text-anchor:end;text-shadow:0px 3px #000}.PartitionShadow{background-blend-mode:multiply;mix-blend-mode:multiply}</style>`;

    		init(
    			this,
    			{
    				target: this.shadowRoot,
    				props: attribute_to_object(this.attributes),
    				customElement: true
    			},
    			instance$2,
    			create_fragment$2,
    			safe_not_equal,
    			{
    				lang: 19,
    				endpoint: 20,
    				session: 21,
    				lotteryprogramforplayer: 22,
    				themeindex: 23,
    				arrowmode: 0,
    				spinduration: 24,
    				spinrotation: 25,
    				id: 26,
    				sizeraw: 27,
    				optionsraw: 28
    			},
    			null,
    			[-1, -1]
    		);

    		if (options) {
    			if (options.target) {
    				insert_dev(options.target, this, options.anchor);
    			}

    			if (options.props) {
    				this.$set(options.props);
    				flush();
    			}
    		}
    	}

    	static get observedAttributes() {
    		return [
    			"lang",
    			"endpoint",
    			"session",
    			"lotteryprogramforplayer",
    			"themeindex",
    			"arrowmode",
    			"spinduration",
    			"spinrotation",
    			"id",
    			"sizeraw",
    			"optionsraw"
    		];
    	}

    	get lang() {
    		return this.$$.ctx[19];
    	}

    	set lang(lang) {
    		this.$$set({ lang });
    		flush();
    	}

    	get endpoint() {
    		return this.$$.ctx[20];
    	}

    	set endpoint(endpoint) {
    		this.$$set({ endpoint });
    		flush();
    	}

    	get session() {
    		return this.$$.ctx[21];
    	}

    	set session(session) {
    		this.$$set({ session });
    		flush();
    	}

    	get lotteryprogramforplayer() {
    		return this.$$.ctx[22];
    	}

    	set lotteryprogramforplayer(lotteryprogramforplayer) {
    		this.$$set({ lotteryprogramforplayer });
    		flush();
    	}

    	get themeindex() {
    		return this.$$.ctx[23];
    	}

    	set themeindex(themeindex) {
    		this.$$set({ themeindex });
    		flush();
    	}

    	get arrowmode() {
    		return this.$$.ctx[0];
    	}

    	set arrowmode(arrowmode) {
    		this.$$set({ arrowmode });
    		flush();
    	}

    	get spinduration() {
    		return this.$$.ctx[24];
    	}

    	set spinduration(spinduration) {
    		this.$$set({ spinduration });
    		flush();
    	}

    	get spinrotation() {
    		return this.$$.ctx[25];
    	}

    	set spinrotation(spinrotation) {
    		this.$$set({ spinrotation });
    		flush();
    	}

    	get id() {
    		return this.$$.ctx[26];
    	}

    	set id(id) {
    		this.$$set({ id });
    		flush();
    	}

    	get sizeraw() {
    		return this.$$.ctx[27];
    	}

    	set sizeraw(sizeraw) {
    		this.$$set({ sizeraw });
    		flush();
    	}

    	get optionsraw() {
    		return this.$$.ctx[28];
    	}

    	set optionsraw(optionsraw) {
    		this.$$set({ optionsraw });
    		flush();
    	}
    }

    customElements.define("lottery-program-wof-private-item-svg", Private_item_svg);

    /* src/private.item.svelte generated by Svelte v3.48.0 */
    const file$1 = "src/private.item.svelte";

    // (89:0) {#if lotteryProgramForPlayer}
    function create_if_block$1(ctx) {
    	let div1;
    	let div0;
    	let main_1;
    	let t0;
    	let lottery_program_wof_private_message_panel;
    	let t1;
    	let if_block0 = /*size*/ ctx[3] && create_if_block_2(ctx);

    	let lottery_program_wof_private_message_panel_levels = [
    		{
    			id: /*id*/ ctx[9],
    			r: /*radius*/ ctx[8] || /*mainWidth*/ ctx[4] / 2,
    			h: /*main*/ ctx[6]?.clientHeight
    		}
    	];

    	let lottery_program_wof_private_message_panel_data = {};

    	for (let i = 0; i < lottery_program_wof_private_message_panel_levels.length; i += 1) {
    		lottery_program_wof_private_message_panel_data = assign(lottery_program_wof_private_message_panel_data, lottery_program_wof_private_message_panel_levels[i]);
    	}

    	let main_1_levels = [classWithPart("Main")];
    	let main_1_data = {};

    	for (let i = 0; i < main_1_levels.length; i += 1) {
    		main_1_data = assign(main_1_data, main_1_levels[i]);
    	}

    	let if_block1 = /*lotteryProgramForPlayer*/ ctx[5].current && create_if_block_1$1(ctx);
    	let div0_levels = [classWithPart("FortuneContainer")];
    	let div0_data = {};

    	for (let i = 0; i < div0_levels.length; i += 1) {
    		div0_data = assign(div0_data, div0_levels[i]);
    	}

    	let div1_levels = [classWithPart("LotteryProgramWof")];
    	let div1_data = {};

    	for (let i = 0; i < div1_levels.length; i += 1) {
    		div1_data = assign(div1_data, div1_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			div1 = element("div");
    			div0 = element("div");
    			main_1 = element("main");
    			if (if_block0) if_block0.c();
    			t0 = space();
    			lottery_program_wof_private_message_panel = element("lottery-program-wof-private-message-panel");
    			t1 = space();
    			if (if_block1) if_block1.c();
    			set_attributes(lottery_program_wof_private_message_panel, lottery_program_wof_private_message_panel_data);
    			add_location(lottery_program_wof_private_message_panel, file$1, 106, 8, 3169);
    			set_attributes(main_1, main_1_data);
    			add_location(main_1, file$1, 93, 6, 2764);
    			set_attributes(div0, div0_data);
    			add_location(div0, file$1, 92, 4, 2713);
    			set_attributes(div1, div1_data);
    			add_location(div1, file$1, 90, 2, 2652);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div1, anchor);
    			append_dev(div1, div0);
    			append_dev(div0, main_1);
    			if (if_block0) if_block0.m(main_1, null);
    			append_dev(main_1, t0);
    			append_dev(main_1, lottery_program_wof_private_message_panel);
    			/*main_1_binding*/ ctx[16](main_1);
    			append_dev(div0, t1);
    			if (if_block1) if_block1.m(div0, null);
    		},
    		p: function update(ctx, dirty) {
    			if (/*size*/ ctx[3]) {
    				if (if_block0) {
    					if_block0.p(ctx, dirty);
    				} else {
    					if_block0 = create_if_block_2(ctx);
    					if_block0.c();
    					if_block0.m(main_1, t0);
    				}
    			} else if (if_block0) {
    				if_block0.d(1);
    				if_block0 = null;
    			}

    			set_attributes(lottery_program_wof_private_message_panel, lottery_program_wof_private_message_panel_data = get_spread_update(lottery_program_wof_private_message_panel_levels, [
    				dirty & /*id, radius, mainWidth, main*/ 848 && {
    					id: /*id*/ ctx[9],
    					r: /*radius*/ ctx[8] || /*mainWidth*/ ctx[4] / 2,
    					h: /*main*/ ctx[6]?.clientHeight
    				}
    			]));

    			set_attributes(main_1, main_1_data = get_spread_update(main_1_levels, [classWithPart("Main")]));

    			if (/*lotteryProgramForPlayer*/ ctx[5].current) {
    				if (if_block1) {
    					if_block1.p(ctx, dirty);
    				} else {
    					if_block1 = create_if_block_1$1(ctx);
    					if_block1.c();
    					if_block1.m(div0, null);
    				}
    			} else if (if_block1) {
    				if_block1.d(1);
    				if_block1 = null;
    			}

    			set_attributes(div0, div0_data = get_spread_update(div0_levels, [classWithPart("FortuneContainer")]));
    			set_attributes(div1, div1_data = get_spread_update(div1_levels, [classWithPart("LotteryProgramWof")]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div1);
    			if (if_block0) if_block0.d();
    			/*main_1_binding*/ ctx[16](null);
    			if (if_block1) if_block1.d();
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block$1.name,
    		type: "if",
    		source: "(89:0) {#if lotteryProgramForPlayer}",
    		ctx
    	});

    	return block;
    }

    // (96:8) {#if size}
    function create_if_block_2(ctx) {
    	let lottery_program_wof_private_item_svg;

    	let lottery_program_wof_private_item_svg_levels = [
    		{
    			id: /*id*/ ctx[9],
    			endpoint: /*endpoint*/ ctx[0],
    			session: /*session*/ ctx[1],
    			sizeraw: /*size*/ ctx[3],
    			themeindex: /*theme*/ ctx[2],
    			optionsraw: JSON.stringify(/*options*/ ctx[7]),
    			lotteryprogramforplayer: JSON.stringify(/*lotteryProgramForPlayer*/ ctx[5])
    		}
    	];

    	let lottery_program_wof_private_item_svg_data = {};

    	for (let i = 0; i < lottery_program_wof_private_item_svg_levels.length; i += 1) {
    		lottery_program_wof_private_item_svg_data = assign(lottery_program_wof_private_item_svg_data, lottery_program_wof_private_item_svg_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			lottery_program_wof_private_item_svg = element("lottery-program-wof-private-item-svg");
    			set_attributes(lottery_program_wof_private_item_svg, lottery_program_wof_private_item_svg_data);
    			add_location(lottery_program_wof_private_item_svg, file$1, 96, 10, 2853);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, lottery_program_wof_private_item_svg, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_attributes(lottery_program_wof_private_item_svg, lottery_program_wof_private_item_svg_data = get_spread_update(lottery_program_wof_private_item_svg_levels, [
    				dirty & /*id, endpoint, session, size, theme, options, lotteryProgramForPlayer*/ 687 && {
    					id: /*id*/ ctx[9],
    					endpoint: /*endpoint*/ ctx[0],
    					session: /*session*/ ctx[1],
    					sizeraw: /*size*/ ctx[3],
    					themeindex: /*theme*/ ctx[2],
    					optionsraw: JSON.stringify(/*options*/ ctx[7]),
    					lotteryprogramforplayer: JSON.stringify(/*lotteryProgramForPlayer*/ ctx[5])
    				}
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(lottery_program_wof_private_item_svg);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_2.name,
    		type: "if",
    		source: "(96:8) {#if size}",
    		ctx
    	});

    	return block;
    }

    // (116:6) {#if lotteryProgramForPlayer.current}
    function create_if_block_1$1(ctx) {
    	let div;
    	let p0;
    	let t0;
    	let t1_value = getCurrentInfo(/*lotteryProgramForPlayer*/ ctx[5], 'active') + "";
    	let t1;
    	let t2;
    	let p1;
    	let t3;
    	let t4_value = getCurrentInfo(/*lotteryProgramForPlayer*/ ctx[5], 'implicit') + "";
    	let t4;
    	let t5;
    	let p2;
    	let t6;
    	let t7_value = getCurrentInfo(/*lotteryProgramForPlayer*/ ctx[5], 'remainingTimes') + "";
    	let t7;
    	let div_levels = [classWithPart("Current")];
    	let div_data = {};

    	for (let i = 0; i < div_levels.length; i += 1) {
    		div_data = assign(div_data, div_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			div = element("div");
    			p0 = element("p");
    			t0 = text("Active tickets: ");
    			t1 = text(t1_value);
    			t2 = space();
    			p1 = element("p");
    			t3 = text("Implicit tickets: ");
    			t4 = text(t4_value);
    			t5 = space();
    			p2 = element("p");
    			t6 = text("Remaining Times: ");
    			t7 = text(t7_value);
    			add_location(p0, file$1, 117, 8, 3443);
    			add_location(p1, file$1, 118, 8, 3526);
    			add_location(p2, file$1, 119, 8, 3613);
    			set_attributes(div, div_data);
    			add_location(div, file$1, 116, 6, 3399);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div, anchor);
    			append_dev(div, p0);
    			append_dev(p0, t0);
    			append_dev(p0, t1);
    			append_dev(div, t2);
    			append_dev(div, p1);
    			append_dev(p1, t3);
    			append_dev(p1, t4);
    			append_dev(div, t5);
    			append_dev(div, p2);
    			append_dev(p2, t6);
    			append_dev(p2, t7);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty & /*lotteryProgramForPlayer*/ 32 && t1_value !== (t1_value = getCurrentInfo(/*lotteryProgramForPlayer*/ ctx[5], 'active') + "")) set_data_dev(t1, t1_value);
    			if (dirty & /*lotteryProgramForPlayer*/ 32 && t4_value !== (t4_value = getCurrentInfo(/*lotteryProgramForPlayer*/ ctx[5], 'implicit') + "")) set_data_dev(t4, t4_value);
    			if (dirty & /*lotteryProgramForPlayer*/ 32 && t7_value !== (t7_value = getCurrentInfo(/*lotteryProgramForPlayer*/ ctx[5], 'remainingTimes') + "")) set_data_dev(t7, t7_value);
    			set_attributes(div, div_data = get_spread_update(div_levels, [classWithPart("Current")]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_1$1.name,
    		type: "if",
    		source: "(116:6) {#if lotteryProgramForPlayer.current}",
    		ctx
    	});

    	return block;
    }

    function create_fragment$1(ctx) {
    	let if_block_anchor;
    	let if_block = /*lotteryProgramForPlayer*/ ctx[5] && create_if_block$1(ctx);

    	const block = {
    		c: function create() {
    			if (if_block) if_block.c();
    			if_block_anchor = empty();
    			this.c = noop;
    		},
    		l: function claim(nodes) {
    			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
    		},
    		m: function mount(target, anchor) {
    			if (if_block) if_block.m(target, anchor);
    			insert_dev(target, if_block_anchor, anchor);
    		},
    		p: function update(ctx, [dirty]) {
    			if (/*lotteryProgramForPlayer*/ ctx[5]) {
    				if (if_block) {
    					if_block.p(ctx, dirty);
    				} else {
    					if_block = create_if_block$1(ctx);
    					if_block.c();
    					if_block.m(if_block_anchor.parentNode, if_block_anchor);
    				}
    			} else if (if_block) {
    				if_block.d(1);
    				if_block = null;
    			}
    		},
    		i: noop,
    		o: noop,
    		d: function destroy(detaching) {
    			if (if_block) if_block.d(detaching);
    			if (detaching) detach_dev(if_block_anchor);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_fragment$1.name,
    		type: "component",
    		source: "",
    		ctx
    	});

    	return block;
    }

    function instance$1($$self, $$props, $$invalidate) {
    	let id;
    	let ratio;
    	let radius;
    	let { $$slots: slots = {}, $$scope } = $$props;
    	validate_slots('lottery-program-wof-private-item', slots, []);
    	var _a;
    	let { lang = Lang.en } = $$props;
    	let { endpoint = '' } = $$props;
    	let { session = '' } = $$props;
    	let { theme = '0' } = $$props;
    	let { lotteryprogramforplayer = undefined } = $$props;
    	let { spinduration = '3' } = $$props;
    	let { spinrotation = '3' } = $$props;

    	// binds
    	let main;

    	// states
    	let size = 0;

    	let mainWidth = 0;
    	let options = [];
    	let lotteryProgramForPlayer;
    	let lotteryProgramForPlayerNew;

    	// lifecycles
    	const init = async () => {
    		await fetcher();

    		// if(getSpinCondition(lotteryProgramForPlayer)){
    		//   setMessage(id, {
    		//     mode: 'spin-failed'
    		//   })
    		// }
    		$$invalidate(4, mainWidth = main === null || main === void 0
    		? void 0
    		: main.clientWidth);
    	};

    	const refetcher = async () => {
    		const LotteryProgramsForPlayer = await api.lotteries(endpoint, session);
    		return LotteryProgramsForPlayer.filter(l => l.program.id === id)[0];
    	};

    	const fetcher = async () => {
    		try {
    			if (!lotteryProgramForPlayer) return;

    			if (!options.length) {
    				$$invalidate(7, options = await getOptions(lotteryProgramForPlayer.program.wheelOfFortune.partitions, lang));
    			}

    			render();
    		} catch(e) {
    			setMessage(id, e.message);
    		}
    	};

    	const render = () => {
    		if (!main) return;
    	};

    	onMount(() => {
    		window.addEventListener('resize', render);
    		return () => window.removeEventListener('resize', render);
    	});

    	onMountMessageLifeCycle({
    		'wof-private-message-spin-after': data => {
    			if (data.id !== id) return;
    			$$invalidate(5, lotteryProgramForPlayer = lotteryProgramForPlayerNew);
    		},
    		'wof-private-message-spin-before': async data => {
    			if (data.id !== id) return;
    			lotteryProgramForPlayerNew = await refetcher();
    		}
    	});

    	const writable_props = [
    		'lang',
    		'endpoint',
    		'session',
    		'theme',
    		'lotteryprogramforplayer',
    		'spinduration',
    		'spinrotation'
    	];

    	Object.keys($$props).forEach(key => {
    		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<lottery-program-wof-private-item> was created with unknown prop '${key}'`);
    	});

    	function main_1_binding($$value) {
    		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
    			main = $$value;
    			$$invalidate(6, main);
    		});
    	}

    	$$self.$$set = $$props => {
    		if ('lang' in $$props) $$invalidate(10, lang = $$props.lang);
    		if ('endpoint' in $$props) $$invalidate(0, endpoint = $$props.endpoint);
    		if ('session' in $$props) $$invalidate(1, session = $$props.session);
    		if ('theme' in $$props) $$invalidate(2, theme = $$props.theme);
    		if ('lotteryprogramforplayer' in $$props) $$invalidate(11, lotteryprogramforplayer = $$props.lotteryprogramforplayer);
    		if ('spinduration' in $$props) $$invalidate(12, spinduration = $$props.spinduration);
    		if ('spinrotation' in $$props) $$invalidate(13, spinrotation = $$props.spinrotation);
    	};

    	$$self.$capture_state = () => ({
    		_a,
    		onMount,
    		Lang,
    		getCurrentInfo,
    		setMessage,
    		getOptions,
    		api,
    		onMountMessageLifeCycle,
    		classWithPart,
    		lang,
    		endpoint,
    		session,
    		theme,
    		lotteryprogramforplayer,
    		spinduration,
    		spinrotation,
    		main,
    		size,
    		mainWidth,
    		options,
    		lotteryProgramForPlayer,
    		lotteryProgramForPlayerNew,
    		init,
    		refetcher,
    		fetcher,
    		render,
    		ratio,
    		radius,
    		id
    	});

    	$$self.$inject_state = $$props => {
    		if ('_a' in $$props) $$invalidate(14, _a = $$props._a);
    		if ('lang' in $$props) $$invalidate(10, lang = $$props.lang);
    		if ('endpoint' in $$props) $$invalidate(0, endpoint = $$props.endpoint);
    		if ('session' in $$props) $$invalidate(1, session = $$props.session);
    		if ('theme' in $$props) $$invalidate(2, theme = $$props.theme);
    		if ('lotteryprogramforplayer' in $$props) $$invalidate(11, lotteryprogramforplayer = $$props.lotteryprogramforplayer);
    		if ('spinduration' in $$props) $$invalidate(12, spinduration = $$props.spinduration);
    		if ('spinrotation' in $$props) $$invalidate(13, spinrotation = $$props.spinrotation);
    		if ('main' in $$props) $$invalidate(6, main = $$props.main);
    		if ('size' in $$props) $$invalidate(3, size = $$props.size);
    		if ('mainWidth' in $$props) $$invalidate(4, mainWidth = $$props.mainWidth);
    		if ('options' in $$props) $$invalidate(7, options = $$props.options);
    		if ('lotteryProgramForPlayer' in $$props) $$invalidate(5, lotteryProgramForPlayer = $$props.lotteryProgramForPlayer);
    		if ('lotteryProgramForPlayerNew' in $$props) lotteryProgramForPlayerNew = $$props.lotteryProgramForPlayerNew;
    		if ('ratio' in $$props) $$invalidate(15, ratio = $$props.ratio);
    		if ('radius' in $$props) $$invalidate(8, radius = $$props.radius);
    		if ('id' in $$props) $$invalidate(9, id = $$props.id);
    	};

    	if ($$props && "$$inject" in $$props) {
    		$$self.$inject_state($$props.$$inject);
    	}

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty & /*lotteryprogramforplayer*/ 2048) {
    			$$invalidate(5, lotteryProgramForPlayer = lotteryprogramforplayer && JSON.parse(lotteryprogramforplayer));
    		}

    		if ($$self.$$.dirty & /*lotteryProgramForPlayer, _a*/ 16416) {
    			$$invalidate(9, id = $$invalidate(14, _a = lotteryProgramForPlayer === null || lotteryProgramForPlayer === void 0
    			? void 0
    			: lotteryProgramForPlayer.program) === null || _a === void 0
    			? void 0
    			: _a.id);
    		}

    		if ($$self.$$.dirty & /*lotteryProgramForPlayer*/ 32) {
    			// reactives
    			lotteryProgramForPlayer && init();
    		}

    		if ($$self.$$.dirty & /*mainWidth*/ 16) {
    			//
    			$$invalidate(3, size = mainWidth);
    		}

    		if ($$self.$$.dirty & /*size*/ 8) {
    			// ratio
    			$$invalidate(15, ratio = size / 375);
    		}

    		if ($$self.$$.dirty & /*ratio*/ 32768) {
    			$$invalidate(8, radius = 247 / 2 * ratio);
    		}
    	};

    	return [
    		endpoint,
    		session,
    		theme,
    		size,
    		mainWidth,
    		lotteryProgramForPlayer,
    		main,
    		options,
    		radius,
    		id,
    		lang,
    		lotteryprogramforplayer,
    		spinduration,
    		spinrotation,
    		_a,
    		ratio,
    		main_1_binding
    	];
    }

    class Private_item extends SvelteElement {
    	constructor(options) {
    		super();
    		this.shadowRoot.innerHTML = `<style>lottery-program-wof-private-message-panel{position:absolute}:host{font-family:system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'}*,*::before,*::after{margin:0;padding:0;list-style:none;text-decoration:none;outline:none;box-sizing:border-box}.LotteryProgramWof{display:flex;align-items:center;flex-direction:column;padding:20px 0}main{max-width:600px;width:100%;display:flex;justify-content:space-around;min-height:200px}.Main{position:relative}.HighLightArea{mix-blend-mode:color-dodge}.HighLightAreaBackground{mix-blend-mode:screen;opacity:0.41}.HighLightAreaV1{background:radial-gradient(72.02% 62.64% at 50% 84.62%, rgba(255, 184, 47, 0.7) 0%, rgba(255, 184, 47, 0.384271) 30.52%, rgba(255, 184, 47, 0.165346) 52.4%, rgba(255, 184, 47, 0) 100%);filter:blur(9px)}.HighLightAreaV2{background:radial-gradient(87.18% 75.82% at 50% 84.62%, rgba(255, 248, 186, 0.7) 0%, rgba(255, 248, 186, 0.384271) 29.48%, rgba(255, 248, 186, 0) 100%);filter:blur(9px)}.FortuneContainer{width:100%;display:flex;align-items:center;flex-direction:column}.BackgroundCircle{fill:#FFFFFF;animation:color-animation 1s infinite linear alternate}.RingCirclesGroup .RingCircle{fill:#FFFFFF;stroke:#FFFFFF}.Center{transition:filter;transition-duration:1s}.Center.disabled{filter:grayscale(80%)}.Center .CenterCircle{fill:#3CE4BB;stroke:#963658;stroke-width:2px;cursor:pointer;transition:fill;transition-duration:1s}.Center .CenterText{cursor:pointer;fill:#FFFFFF}.PointerPartition{opacity:0.3;fill:lightgoldenrodyellow;stroke:red;stroke-width:6px;stroke-dasharray:12}.PointerArrow{fill:#064CA0}.Current{color:#FFFFFF}.PartitionText{fill:#FFFFFF;font-style:normal;font-weight:700;text-anchor:end;text-shadow:0px 2px #000}.PartitionShadow{background-blend-mode:multiply;mix-blend-mode:multiply}</style>`;

    		init(
    			this,
    			{
    				target: this.shadowRoot,
    				props: attribute_to_object(this.attributes),
    				customElement: true
    			},
    			instance$1,
    			create_fragment$1,
    			safe_not_equal,
    			{
    				lang: 10,
    				endpoint: 0,
    				session: 1,
    				theme: 2,
    				lotteryprogramforplayer: 11,
    				spinduration: 12,
    				spinrotation: 13
    			},
    			null
    		);

    		if (options) {
    			if (options.target) {
    				insert_dev(options.target, this, options.anchor);
    			}

    			if (options.props) {
    				this.$set(options.props);
    				flush();
    			}
    		}
    	}

    	static get observedAttributes() {
    		return [
    			"lang",
    			"endpoint",
    			"session",
    			"theme",
    			"lotteryprogramforplayer",
    			"spinduration",
    			"spinrotation"
    		];
    	}

    	get lang() {
    		return this.$$.ctx[10];
    	}

    	set lang(lang) {
    		this.$$set({ lang });
    		flush();
    	}

    	get endpoint() {
    		return this.$$.ctx[0];
    	}

    	set endpoint(endpoint) {
    		this.$$set({ endpoint });
    		flush();
    	}

    	get session() {
    		return this.$$.ctx[1];
    	}

    	set session(session) {
    		this.$$set({ session });
    		flush();
    	}

    	get theme() {
    		return this.$$.ctx[2];
    	}

    	set theme(theme) {
    		this.$$set({ theme });
    		flush();
    	}

    	get lotteryprogramforplayer() {
    		return this.$$.ctx[11];
    	}

    	set lotteryprogramforplayer(lotteryprogramforplayer) {
    		this.$$set({ lotteryprogramforplayer });
    		flush();
    	}

    	get spinduration() {
    		return this.$$.ctx[12];
    	}

    	set spinduration(spinduration) {
    		this.$$set({ spinduration });
    		flush();
    	}

    	get spinrotation() {
    		return this.$$.ctx[13];
    	}

    	set spinrotation(spinrotation) {
    		this.$$set({ spinrotation });
    		flush();
    	}
    }

    customElements.define("lottery-program-wof-private-item", Private_item);

    /* src/LotteryProgramWof.svelte generated by Svelte v3.48.0 */
    const file = "src/LotteryProgramWof.svelte";

    function get_each_context(ctx, list, i) {
    	const child_ctx = ctx.slice();
    	child_ctx[12] = list[i];
    	return child_ctx;
    }

    // (62:10) {:else}
    function create_else_block(ctx) {
    	let div;
    	let p;
    	let div_levels = [classWithPart("NoContent")];
    	let div_data = {};

    	for (let i = 0; i < div_levels.length; i += 1) {
    		div_data = assign(div_data, div_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			div = element("div");
    			p = element("p");
    			p.textContent = "You are not allowed to any lottery program.";
    			add_location(p, file, 63, 14, 1829);
    			set_attributes(div, div_data);
    			add_location(div, file, 62, 12, 1777);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div, anchor);
    			append_dev(div, p);
    		},
    		p: function update(ctx, dirty) {
    			set_attributes(div, div_data = get_spread_update(div_levels, [classWithPart("NoContent")]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_else_block.name,
    		type: "else",
    		source: "(62:10) {:else}",
    		ctx
    	});

    	return block;
    }

    // (52:10) {#if lotteryProgramsForPlayer.length}
    function create_if_block_1(ctx) {
    	let each_1_anchor;
    	let each_value = /*lotteryProgramsForPlayer*/ ctx[4];
    	validate_each_argument(each_value);
    	let each_blocks = [];

    	for (let i = 0; i < each_value.length; i += 1) {
    		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
    	}

    	const block = {
    		c: function create() {
    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].c();
    			}

    			each_1_anchor = empty();
    		},
    		m: function mount(target, anchor) {
    			for (let i = 0; i < each_blocks.length; i += 1) {
    				each_blocks[i].m(target, anchor);
    			}

    			insert_dev(target, each_1_anchor, anchor);
    		},
    		p: function update(ctx, dirty) {
    			if (dirty & /*lang, endpoint, session, theme, JSON, lotteryProgramsForPlayer*/ 31) {
    				each_value = /*lotteryProgramsForPlayer*/ ctx[4];
    				validate_each_argument(each_value);
    				let i;

    				for (i = 0; i < each_value.length; i += 1) {
    					const child_ctx = get_each_context(ctx, each_value, i);

    					if (each_blocks[i]) {
    						each_blocks[i].p(child_ctx, dirty);
    					} else {
    						each_blocks[i] = create_each_block(child_ctx);
    						each_blocks[i].c();
    						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
    					}
    				}

    				for (; i < each_blocks.length; i += 1) {
    					each_blocks[i].d(1);
    				}

    				each_blocks.length = each_value.length;
    			}
    		},
    		d: function destroy(detaching) {
    			destroy_each(each_blocks, detaching);
    			if (detaching) detach_dev(each_1_anchor);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block_1.name,
    		type: "if",
    		source: "(52:10) {#if lotteryProgramsForPlayer.length}",
    		ctx
    	});

    	return block;
    }

    // (49:8) {#if loading}
    function create_if_block(ctx) {
    	let div;

    	const block = {
    		c: function create() {
    			div = element("div");
    			div.textContent = "Loading...";
    			add_location(div, file, 49, 10, 1359);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div, anchor);
    		},
    		p: noop,
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_if_block.name,
    		type: "if",
    		source: "(49:8) {#if loading}",
    		ctx
    	});

    	return block;
    }

    // (53:12) {#each lotteryProgramsForPlayer as _l}
    function create_each_block(ctx) {
    	let lottery_program_wof_private_item;

    	let lottery_program_wof_private_item_levels = [
    		{
    			lang: /*lang*/ ctx[0],
    			endpoint: /*endpoint*/ ctx[1],
    			session: /*session*/ ctx[2],
    			theme: /*theme*/ ctx[3],
    			lotteryprogramforplayer: JSON.stringify(/*_l*/ ctx[12])
    		}
    	];

    	let lottery_program_wof_private_item_data = {};

    	for (let i = 0; i < lottery_program_wof_private_item_levels.length; i += 1) {
    		lottery_program_wof_private_item_data = assign(lottery_program_wof_private_item_data, lottery_program_wof_private_item_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			lottery_program_wof_private_item = element("lottery-program-wof-private-item");
    			set_attributes(lottery_program_wof_private_item, lottery_program_wof_private_item_data);
    			add_location(lottery_program_wof_private_item, file, 53, 14, 1510);
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, lottery_program_wof_private_item, anchor);
    		},
    		p: function update(ctx, dirty) {
    			set_attributes(lottery_program_wof_private_item, lottery_program_wof_private_item_data = get_spread_update(lottery_program_wof_private_item_levels, [
    				dirty & /*lang, endpoint, session, theme, lotteryProgramsForPlayer*/ 31 && {
    					lang: /*lang*/ ctx[0],
    					endpoint: /*endpoint*/ ctx[1],
    					session: /*session*/ ctx[2],
    					theme: /*theme*/ ctx[3],
    					lotteryprogramforplayer: JSON.stringify(/*_l*/ ctx[12])
    				}
    			]));
    		},
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(lottery_program_wof_private_item);
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_each_block.name,
    		type: "each",
    		source: "(53:12) {#each lotteryProgramsForPlayer as _l}",
    		ctx
    	});

    	return block;
    }

    function create_fragment(ctx) {
    	let div3;
    	let lottery_program_wof_private_tabs;
    	let div1;
    	let div0;
    	let t;
    	let div2;
    	let lottery_program_wof_private_outcomes;

    	function select_block_type(ctx, dirty) {
    		if (/*loading*/ ctx[5]) return create_if_block;
    		if (/*lotteryProgramsForPlayer*/ ctx[4].length) return create_if_block_1;
    		return create_else_block;
    	}

    	let current_block_type = select_block_type(ctx);
    	let if_block = current_block_type(ctx);
    	let div0_levels = [classWithPart('CommonContainer')];
    	let div0_data = {};

    	for (let i = 0; i < div0_levels.length; i += 1) {
    		div0_data = assign(div0_data, div0_levels[i]);
    	}

    	let lottery_program_wof_private_outcomes_levels = [
    		{
    			endpoint: /*endpoint*/ ctx[1],
    			session: /*session*/ ctx[2],
    			partitions: (/*lotteryProgram*/ ctx[6]?.wheelOfFortune.partitions)
    			? JSON.stringify(/*lotteryProgram*/ ctx[6]?.wheelOfFortune.partitions)
    			: '[]'
    		}
    	];

    	let lottery_program_wof_private_outcomes_data = {};

    	for (let i = 0; i < lottery_program_wof_private_outcomes_levels.length; i += 1) {
    		lottery_program_wof_private_outcomes_data = assign(lottery_program_wof_private_outcomes_data, lottery_program_wof_private_outcomes_levels[i]);
    	}

    	let div3_levels = [classWithPart("Root")];
    	let div3_data = {};

    	for (let i = 0; i < div3_levels.length; i += 1) {
    		div3_data = assign(div3_data, div3_levels[i]);
    	}

    	const block = {
    		c: function create() {
    			div3 = element("div");
    			lottery_program_wof_private_tabs = element("lottery-program-wof-private-tabs");
    			div1 = element("div");
    			div0 = element("div");
    			if_block.c();
    			t = space();
    			div2 = element("div");
    			lottery_program_wof_private_outcomes = element("lottery-program-wof-private-outcomes");
    			this.c = noop;
    			set_attributes(div0, div0_data);
    			add_location(div0, file, 47, 6, 1283);
    			attr_dev(div1, "slot", "tab-Program");
    			add_location(div1, file, 46, 4, 1252);
    			set_attributes(lottery_program_wof_private_outcomes, lottery_program_wof_private_outcomes_data);
    			add_location(lottery_program_wof_private_outcomes, file, 70, 6, 1988);
    			attr_dev(div2, "slot", "tab-History");
    			add_location(div2, file, 69, 4, 1957);
    			add_location(lottery_program_wof_private_tabs, file, 45, 2, 1213);
    			set_attributes(div3, div3_data);
    			add_location(div3, file, 43, 0, 1177);
    		},
    		l: function claim(nodes) {
    			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
    		},
    		m: function mount(target, anchor) {
    			insert_dev(target, div3, anchor);
    			append_dev(div3, lottery_program_wof_private_tabs);
    			append_dev(lottery_program_wof_private_tabs, div1);
    			append_dev(div1, div0);
    			if_block.m(div0, null);
    			append_dev(lottery_program_wof_private_tabs, t);
    			append_dev(lottery_program_wof_private_tabs, div2);
    			append_dev(div2, lottery_program_wof_private_outcomes);
    		},
    		p: function update(ctx, [dirty]) {
    			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
    				if_block.p(ctx, dirty);
    			} else {
    				if_block.d(1);
    				if_block = current_block_type(ctx);

    				if (if_block) {
    					if_block.c();
    					if_block.m(div0, null);
    				}
    			}

    			set_attributes(div0, div0_data = get_spread_update(div0_levels, [classWithPart('CommonContainer')]));

    			set_attributes(lottery_program_wof_private_outcomes, lottery_program_wof_private_outcomes_data = get_spread_update(lottery_program_wof_private_outcomes_levels, [
    				dirty & /*endpoint, session*/ 6 && {
    					endpoint: /*endpoint*/ ctx[1],
    					session: /*session*/ ctx[2],
    					partitions: (/*lotteryProgram*/ ctx[6]?.wheelOfFortune.partitions)
    					? JSON.stringify(/*lotteryProgram*/ ctx[6]?.wheelOfFortune.partitions)
    					: '[]'
    				}
    			]));

    			set_attributes(div3, div3_data = get_spread_update(div3_levels, [classWithPart("Root")]));
    		},
    		i: noop,
    		o: noop,
    		d: function destroy(detaching) {
    			if (detaching) detach_dev(div3);
    			if_block.d();
    		}
    	};

    	dispatch_dev("SvelteRegisterBlock", {
    		block,
    		id: create_fragment.name,
    		type: "component",
    		source: "",
    		ctx
    	});

    	return block;
    }

    function instance($$self, $$props, $$invalidate) {
    	let { $$slots: slots = {}, $$scope } = $$props;
    	validate_slots('undefined', slots, []);
    	let { lang = Lang.en } = $$props;
    	let { endpoint = '' } = $$props;
    	let { session = '' } = $$props;
    	let { theme = '0' } = $$props;
    	let { spinduration = '3' } = $$props;
    	let { spinrotation = '3' } = $$props;
    	let isMounted = false;

    	onMount(() => {
    		$$invalidate(9, isMounted = true);
    		return () => $$invalidate(9, isMounted = false);
    	});

    	let lotteryProgramsForPlayer = [];
    	let lotteryProgram;
    	let loading = true;

    	const init = async () => {
    		if (!isMounted || !lang || !session || !endpoint) return;
    		$$invalidate(5, loading = true);
    		await fetcher();
    		$$invalidate(5, loading = false);
    	};

    	const fetcher = async () => {
    		$$invalidate(4, lotteryProgramsForPlayer = await api.lotteries(endpoint, session));

    		_postMessage({
    			type: 'wof-private-message-lotteryProgramsForPlayer',
    			lotteryProgramsForPlayer
    		});
    	};

    	const writable_props = ['lang', 'endpoint', 'session', 'theme', 'spinduration', 'spinrotation'];

    	Object.keys($$props).forEach(key => {
    		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<undefined> was created with unknown prop '${key}'`);
    	});

    	$$self.$$set = $$props => {
    		if ('lang' in $$props) $$invalidate(0, lang = $$props.lang);
    		if ('endpoint' in $$props) $$invalidate(1, endpoint = $$props.endpoint);
    		if ('session' in $$props) $$invalidate(2, session = $$props.session);
    		if ('theme' in $$props) $$invalidate(3, theme = $$props.theme);
    		if ('spinduration' in $$props) $$invalidate(7, spinduration = $$props.spinduration);
    		if ('spinrotation' in $$props) $$invalidate(8, spinrotation = $$props.spinrotation);
    	};

    	$$self.$capture_state = () => ({
    		onMount,
    		Lang,
    		api,
    		_postMessage,
    		classWithPart,
    		lang,
    		endpoint,
    		session,
    		theme,
    		spinduration,
    		spinrotation,
    		isMounted,
    		lotteryProgramsForPlayer,
    		lotteryProgram,
    		loading,
    		init,
    		fetcher
    	});

    	$$self.$inject_state = $$props => {
    		if ('lang' in $$props) $$invalidate(0, lang = $$props.lang);
    		if ('endpoint' in $$props) $$invalidate(1, endpoint = $$props.endpoint);
    		if ('session' in $$props) $$invalidate(2, session = $$props.session);
    		if ('theme' in $$props) $$invalidate(3, theme = $$props.theme);
    		if ('spinduration' in $$props) $$invalidate(7, spinduration = $$props.spinduration);
    		if ('spinrotation' in $$props) $$invalidate(8, spinrotation = $$props.spinrotation);
    		if ('isMounted' in $$props) $$invalidate(9, isMounted = $$props.isMounted);
    		if ('lotteryProgramsForPlayer' in $$props) $$invalidate(4, lotteryProgramsForPlayer = $$props.lotteryProgramsForPlayer);
    		if ('lotteryProgram' in $$props) $$invalidate(6, lotteryProgram = $$props.lotteryProgram);
    		if ('loading' in $$props) $$invalidate(5, loading = $$props.loading);
    	};

    	if ($$props && "$$inject" in $$props) {
    		$$self.$inject_state($$props.$$inject);
    	}

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty & /*isMounted*/ 512) {
    			isMounted && init();
    		}

    		if ($$self.$$.dirty & /*session*/ 4) {
    			session && init();
    		}

    		if ($$self.$$.dirty & /*endpoint*/ 2) {
    			endpoint && init();
    		}
    	};

    	return [
    		lang,
    		endpoint,
    		session,
    		theme,
    		lotteryProgramsForPlayer,
    		loading,
    		lotteryProgram,
    		spinduration,
    		spinrotation,
    		isMounted
    	];
    }

    class LotteryProgramWof extends SvelteElement {
    	constructor(options) {
    		super();
    		this.shadowRoot.innerHTML = `<style>lottery-program-wof-private-item{width:480px;display:inline-block}:host{font-family:system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'}*,*::before,*::after{margin:0;padding:0;list-style:none;text-decoration:none;outline:none;box-sizing:border-box}.Root{display:flex;align-items:center;flex-direction:column;padding:20px 0;background:var(--emfe-w-color-contrast, #07072A)}.NoContent{color:white;min-height:300px;display:flex;justify-content:center;align-items:center;font-size:16px}.CommonContainer{display:flex;flex-wrap:wrap;justify-content:center}</style>`;

    		init(
    			this,
    			{
    				target: this.shadowRoot,
    				props: attribute_to_object(this.attributes),
    				customElement: true
    			},
    			instance,
    			create_fragment,
    			safe_not_equal,
    			{
    				lang: 0,
    				endpoint: 1,
    				session: 2,
    				theme: 3,
    				spinduration: 7,
    				spinrotation: 8
    			},
    			null
    		);

    		if (options) {
    			if (options.target) {
    				insert_dev(options.target, this, options.anchor);
    			}

    			if (options.props) {
    				this.$set(options.props);
    				flush();
    			}
    		}
    	}

    	static get observedAttributes() {
    		return ["lang", "endpoint", "session", "theme", "spinduration", "spinrotation"];
    	}

    	get lang() {
    		return this.$$.ctx[0];
    	}

    	set lang(lang) {
    		this.$$set({ lang });
    		flush();
    	}

    	get endpoint() {
    		return this.$$.ctx[1];
    	}

    	set endpoint(endpoint) {
    		this.$$set({ endpoint });
    		flush();
    	}

    	get session() {
    		return this.$$.ctx[2];
    	}

    	set session(session) {
    		this.$$set({ session });
    		flush();
    	}

    	get theme() {
    		return this.$$.ctx[3];
    	}

    	set theme(theme) {
    		this.$$set({ theme });
    		flush();
    	}

    	get spinduration() {
    		return this.$$.ctx[7];
    	}

    	set spinduration(spinduration) {
    		this.$$set({ spinduration });
    		flush();
    	}

    	get spinrotation() {
    		return this.$$.ctx[8];
    	}

    	set spinrotation(spinrotation) {
    		this.$$set({ spinrotation });
    		flush();
    	}
    }

    // @ts-ignore
    !customElements.get('lottery-program-wof') && customElements.define('lottery-program-wof', LotteryProgramWof);

    return LotteryProgramWof;

}));
